webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gps__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_crypto_js__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_crypto_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_modules_initdata__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_js_cookie__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_json_bigint_xk__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_json_bigint_xk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_json_bigint_xk__);










var Toucth = {
  slide: function slide(dom, Fn) {
    dom.addEventListener('touchstart', function (event) {
      var left = event.targetTouches[0].clientX;
      var top = event.targetTouches[0].clientY;
      var state = true;
      var direction = '';
      if (left > 30 && left < document.body.offsetWidth - 30) {
        dom.addEventListener('touchmove', function (event) {
          if (state) {
            var Xstate = left - event.targetTouches[0].clientX;
            var Ystate = top - event.targetTouches[0].clientY;
            if (Xstate < -50 && Ystate < 15 && Ystate > -15) {
              state = false;
              direction = 'right';
              if (Fn) {
                Fn(direction);
              }
            } else if (Xstate > 50 && Ystate < 15 && Ystate > -15) {
              state = false;
              direction = 'left';
              if (Fn) {
                Fn(direction);
              }
            } else if (Ystate > 50 && Xstate < 15 && Xstate > -15) {
              state = false;
              direction = 'up';
              if (Fn) {
                Fn(direction);
              }
            } else if (Ystate < -50 && Xstate < 30 && Xstate > -30) {
              state = false;
              direction = 'down';
              if (Fn) {
                Fn(direction);
              }
            }
          }
        }, true);
      }
    }, true);
  },
  getCookie: function getCookie(name) {
    var arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'));
    if (arr != null) {
      return unescape(arr[2]);
    }
    return null;
  },
  setCookie: function setCookie(name, value, time) {
    var Days = time;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 60 * 60 * 1000);
    if (typeof value === 'string' && value.length > 0) {
      document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString();
    } else {
      var _exp = new Date();
      _exp.setTime(_exp.getTime() - 1);
      var cval = this.getCookie(name);
      if (cval != null) document.cookie = name + '=' + cval + ';expires=' + _exp.toGMTString();
    }
  },
  delCookie: function delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = this.getCookie(name);
    if (cval != null) document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString();
  },

  touchstart: function touchstart(dom, Fn) {
    dom.addEventListener('touchstart', function (event) {
      Fn(event);
    });
  },
  touchmove: function touchmove(dom, Fn) {
    dom.addEventListener('touchmove', function (event) {
      Fn(event);
    });
  },
  gainStyle: function gainStyle(mod, val, replaceText) {
    var computedStyle = window.getComputedStyle(mod);
    var result = computedStyle[val];
    if (replaceText) {
      result = result.replace(replaceText, '');
    }
    return result;
  },
  checkPhone: function checkPhone(Phone) {
    var myreg = /^\d{11}$/;
    if (!myreg.test(Phone)) {
      return false;
    } else {
      return true;
    }
  },
  AcquireUrlParameter: function AcquireUrlParameter() {
    var url = location.hash;
    var UrlObj = {};
    if (url.indexOf('?') !== -1) {
      url = url.split('?')[1];
      url = url.replace('?', '');
      url = url.split('&');

      var _loop = function _loop(i) {
        (function () {
          var index = i;
          var urls = url[index];
          UrlObj[urls.split('=')[0]] = urls.split('=')[1];
        })();
      };

      for (var i = 0; i < url.length; i++) {
        _loop(i);
      }
    } else {
      UrlObj = '当前URL无传参！';
    }
    return UrlObj;
  },
  TimestampDate: function TimestampDate(stringTimestamp) {
    if (typeof stringTimestamp === 'string') {
      stringTimestamp = stringTimestamp.replace('-', '/');
      stringTimestamp = stringTimestamp.replace('-', '/');
    }
    if (String(stringTimestamp).length === 10) {
      stringTimestamp *= 1000;
    }
    var time = new Date(stringTimestamp);

    var Check = function Check(obj) {
      if (obj < 10) {
        return '0' + obj;
      }
      return obj;
    };

    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    var h = time.getHours();
    var mm = time.getMinutes();

    var DataText = y + '-' + Check(m) + '-' + Check(d) + ' ' + Check(h) + ':' + Check(mm);
    return DataText;
  },
  GoogleEncrypt: function GoogleEncrypt(positioning) {
    var gcjLat = positioning.lat;
    var gcjLon = positioning.lng;

    function outOfChina(lat, lon) {
      if (lon < 72.004 || lon > 137.8347) {
        return true;
      }
      if (lat < 0.8293 || lat > 55.8271) {
        return true;
      }
      return false;
    }

    if (outOfChina(gcjLat, gcjLon)) {
      return { 'lat': gcjLat, 'lng': gcjLon };
    }
    var d = this.delta(gcjLat, gcjLon);
    return { 'lat': gcjLat - d.lat, 'lng': gcjLon - d.lon };
  },
  amapCoordinateFn: __WEBPACK_IMPORTED_MODULE_3__gps__["a" /* default */].gcj_encrypt,
  ismobile: function ismobile(test) {
    var u = navigator.userAgent;

    if (/AppleWebKit.*Mobile/i.test(navigator.userAgent) || /MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(navigator.userAgent)) {
      if (window.location.href.indexOf('?mobile') < 0) {
        try {
          if (/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)) {
            return '0';
          } else {
            return '1';
          }
        } catch (e) {}
      }
    } else if (u.indexOf('iPad') > -1) {
      return '0';
    } else {
      return '1';
    }
  },
  IndividuationDate: function IndividuationDate(stringTimestamp) {
    var stringTimestampS = stringTimestamp.length === 11 ? stringTimestamp * 1000 : stringTimestamp;
    var date = new Date(stringTimestampS);

    if (date.valueOf() - stringTimestampS <= 1800000) {
      return '刚刚';
    }
  },
  objKeySort: function objKeySort(url, obj) {
    var params = {};
    for (var key in obj) {
      if (!key || key === 'fn' || key === 'app_key' || key === 'ad_code' || key === 'city_code' || key === 'timestamp' || key === 'company_id' || key === 'company_name') {} else {
        params[key] = obj[key];
      }
    }
    if (obj.ad_code) {
      if (window.configure.location && window.configure.location.ad_code) {
        params['ad_code'] = window.configure.location.ad_code;
      } else {
        params['ad_code'] = '510100';
      }
    }
    if (obj.city_code) {
      if (window.configure.location && window.configure.location.city_code) {
        params['city_code'] = window.configure.location.city_code;
      } else {
        params['city_code'] = '028';
      }
    }
    var companyInfo = '';
    var passengerInfo = window.configure.passengerInfo;
    if (__WEBPACK_IMPORTED_MODULE_6_js_cookie___default.a.get('companyinfo')) {
      companyInfo = __WEBPACK_IMPORTED_MODULE_7_json_bigint_xk___default.a.parse(__WEBPACK_IMPORTED_MODULE_6_js_cookie___default.a.get('companyinfo'));
    } else if (window.configure.companyinfo) {
      companyInfo = window.configure.companyinfo;
    } else if (__WEBPACK_IMPORTED_MODULE_5__store_modules_initdata__["a" /* default */].state.companyInfo) {
      companyInfo = __WEBPACK_IMPORTED_MODULE_5__store_modules_initdata__["a" /* default */].state.companyInfo;
    }
    params['company_id'] = companyInfo.id;
    params['company_name'] = companyInfo.company_name;

    if (passengerInfo) {
      params['passenger_id'] = passengerInfo.id;
      params['passenger_name'] = passengerInfo.name;
      if (!params.company_id || !params.company_name) {
        params['company_id'] = passengerInfo.company_id;
        params['company_name'] = passengerInfo.company_name;
      }
    }
    params['app_key'] = window.configure.appKey;
    if (obj.timestamp) {
      params['timestamp'] = ~~(Date.now() / 1000);
    }
    if (obj.channel && obj.channel !== 'system' && obj.channel !== 5) {
      params['channel'] = 'wechat';
    }
    var newkey = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(params).sort();

    var newObj = {};
    for (var i = 0; i < newkey.length; i++) {
      newObj[newkey[i]] = params[newkey[i]];
    }

    return newObj;
  },
  objKeySync: function objKeySync() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var params = {
        companyInfor: '',
        location: '',
        passenger: '',
        app_key: '',
        timestamp: null,
        channel: ''
      };

      if (window.configure.companyinfo) {
        params.companyInfor = window.configure.companyinfo;
      } else if (__WEBPACK_IMPORTED_MODULE_5__store_modules_initdata__["a" /* default */].state.companyInfo) {
        params.companyInfor = __WEBPACK_IMPORTED_MODULE_5__store_modules_initdata__["a" /* default */].state.companyInfo;
      } else if (window.configure.passengerInfo) {
        params.companyInfor = window.configure.passengerInfo;
      } else {
        params.companyInfor = '';
      }

      if (window.configure.location) {
        params.location = window.configure.location;
      }

      if (window.configure.passengerInfo) {
        params.passenger = window.configure.passengerInfo;
      }

      params.app_key = window.configure.appKey;
      params.timestamp = ~~(Date.now() / 1000);
      params.channel = 'wechat';
      for (var key in params) {
        if (key && key !== '') {
          resolve(params);
        } else {
          reject(params);
        }
      }
    });
  },
  paramsAsync: function paramsAsync() {},
  aesEncryptCode: function aesEncryptCode(phone) {
    var key = __WEBPACK_IMPORTED_MODULE_4_crypto_js___default.a.enc.Utf8.parse('aaaaaaaaaaaaaaaa');

    var plaintText = phone + '';

    var encryptedData = __WEBPACK_IMPORTED_MODULE_4_crypto_js___default.a.AES.encrypt(plaintText, key, {
      iv: key,
      mode: __WEBPACK_IMPORTED_MODULE_4_crypto_js___default.a.mode.CBC,
      padding: __WEBPACK_IMPORTED_MODULE_4_crypto_js___default.a.pad.Pkcs7 });
    return encryptedData.toString();
  },
  aesDecryptCode: function aesDecryptCode(phone) {
    var key = __WEBPACK_IMPORTED_MODULE_4_crypto_js___default.a.enc.Utf8.parse('aaaaaaaaaaaaaaaa');

    var plaintText = phone + '';

    var encryptedData = __WEBPACK_IMPORTED_MODULE_4_crypto_js___default.a.AES.decrypt(plaintText, key, {
      iv: key,
      mode: __WEBPACK_IMPORTED_MODULE_4_crypto_js___default.a.mode.CBC,
      padding: __WEBPACK_IMPORTED_MODULE_4_crypto_js___default.a.pad.Pkcs7 });
    return encryptedData.toString(__WEBPACK_IMPORTED_MODULE_4_crypto_js___default.a.enc.Utf8).toString();
  },
  RandomNumBoth: function RandomNumBoth(Min, Max) {
    var Range = Max - Min;
    var Rand = Math.random();
    var num = Min + Math.round(Rand * Range);
    return num;
  },
  v5ZcOrderStatus: function v5ZcOrderStatus(name) {
    switch (name) {
      case 1:
        return '新单';
      case 5:
        return '已派单';
      case 10:
        return '已接单';
      case 15:
        return '前往预约地';
      case 20:
        return '到达预约地';
      case 25:
        return '前往目的地';
      case 28:
        return '中途等待';
      case 30:
        return '到达目的地';
      case 35:
        return '已结算';
      case 40:
        return '已评价';
      case 45:
        return '已销单';
      default:
        return '';
    }
  }
};

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$utils = Toucth;

/* harmony default export */ __webpack_exports__["a"] = (Toucth);

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(400)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(544),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(356)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(500),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var data = {
  appKey: window.configure.appKey,
  acKey: window.configure.acKey,
  WXappId: window.configure.WXappId,
  weixinUrl: window.configure.weixinUrl,
  serverUrl: window.configure.serverUrl,
  baiduKey: window.configure.baiduKey };
/* harmony default export */ __webpack_exports__["a"] = (data);

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(371)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(515),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAAAXNSR0IArs4c6QAAARZJREFUKBV1kT1Ow0AQhbNrK66o6Oi4QAraVEEEKUDBDdzYSp8qR0iF6O3GJwhCNERIPgENorOl5AKp0mAptvNe5FltHDzSat98743GP6pnVZIkl0VRvAA9NfjD87yZ7/tbiWkRaZq6CH+in9R1/cpDTUZPckbkef4IeKO1HgRB8MtAHMfLqqp+six7QPtOZjbAGKDfSJgmNTatIekdywwopfogfw23LzJPgKKIougaG+aQdzjPZFa9QX/hURdhGK4VwmOEV1agU2LoXiN81ZloGcyad2h5t+h5zsrFyyp8CdvYY3VGAF7iOLbpApykYZJNm4GTMJn5cWykMDAU3b7/HUBo1A5K7zqO812W5QbgQmDHvWP2ALN+cMkqnZhuAAAAAElFTkSuQmCC"

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_configure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_coordtransform__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_coordtransform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_coordtransform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_json_bigint_xk__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk__);








/* harmony default export */ __webpack_exports__["a"] = ({
  getWxAppId: function getWxAppId(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/wechat', params);

    var url = __WEBPACK_IMPORTED_MODULE_2__store_configure__["a" /* default */].serverUrl + '/wechat';
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(url, { params: params }, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  getjsApiTicket: function getjsApiTicket(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/jsApiTicket', params);

    var url = '/v1/jsApiTicket';
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(url, { params: params }, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  getNearDrivers: function getNearDrivers(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/getNearDrivers', params);

    var url = '/v1/getNearDrivers';
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(url, { params: params }, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  getInitInfo: function getInitInfo(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/company', params);

    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('/v1/company', { params: params }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.body)));
    });
  },
  getBusiness: function getBusiness(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/getBusiness', params);

    if (params.company_id) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('/v1/getBusiness', { params: params }).then(function (data) {
        callback(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(data.bodyText));
      });
    }
  },
  getNotice: function getNotice(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/notice', params);

    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('/v1/notice', { params: params }, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.body)));
    });
  },
  positioningApi: function positioningApi(obj, callback) {
    var url = '';
    var params = {
      key: window.configure.amapKey
    };
    var point = {
      lng: null,
      lat: null,
      country: null,
      detailedAddress: null,
      ad_code: null,
      city_code: null };

    function showPosition(position) {
      console.log('浏览器定位成功处理', position);
      var pos = __WEBPACK_IMPORTED_MODULE_3_coordtransform___default.a.wgs84togcj02(position.coords.longitude, position.coords.latitude);
      url = '/v3/geocode/regeo?';
      params = {
        key: window.configure.amapKey,
        location: pos[0].toFixed(6) + ',' + pos[1].toFixed(6),
        extensions: 'all',
        output: 'JSON'
      };
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(url, { params: params }, { emulateJSON: true }).then(function (data) {
        var Data = data.body.regeocode;

        var lng = null;
        var lat = null;
        var location = null;
        if (Data.addressComponent && Data.addressComponent.streetNumber && Data.addressComponent.streetNumber.location && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(Data.addressComponent.streetNumber.location) !== '' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(Data.addressComponent.streetNumber.location) !== '') {
          lng = Data.addressComponent.streetNumber.location.split(',')[0];
          lat = Data.addressComponent.streetNumber.location.split(',')[1];
        } else {
          if (Data.pois && Data.pois.length > 0) {
            location = Data.pois[0];

            lng = location.location.split(',')[0];
            lat = location.location.split(',')[1];
          } else {
            lng = pos[0].toFixed(6);
            lat = pos[1].toFixed(6);
          }
        }

        var city = null;
        if (Data.addressComponent.city && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(Data.addressComponent.city) !== '[]' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(Data.addressComponent.city) !== '') {
          city = Data.addressComponent.city;
        } else if (Data.formatted_address && Data.formatted_address !== '' && Data.formatted_address.indexOf('市') > 0) {
          city = Data.formatted_address.substring(Data.formatted_address.indexOf('省') + 1, Data.formatted_address.indexOf('市') + 1);
        } else if (Data.addressComponent.district) {
          city = Data.addressComponent.district;
        }
        point.lng = lng;
        point.lat = lat;
        point.city = city;
        point.name = Data.formatted_address;
        point.ad_code = Data.addressComponent.adcode ? Data.addressComponent.adcode : null;
        point.city_code = Data.addressComponent.citycode ? Data.addressComponent.citycode : null;
        point.detailedAddress = Data.formatted_address ? Data.formatted_address : '';
        console.log('initdata.js-getlocation-position', point);
        callback(point);
      });
    };

    function gaodeLocation() {
      console.log('高德IP定位');

      var url = '/v1/amap/geo/ip';
      var params = {
        key: window.configure.amapKey,
        app_key: __WEBPACK_IMPORTED_MODULE_2__store_configure__["a" /* default */].appKey
      };
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(url, { params: params }, { emulateJSON: true }).then(function (data) {
        var dataBody = data.body.geo;

        if (dataBody && Number(dataBody.status) === 1) {
          var Data = dataBody;
          var addr = (Data.province ? Data.province : null) + (Data.city ? Data.city : null);
          var url1 = '/v3/geocode/geo';
          var params1 = {
            key: window.configure.amapKey,
            address: addr,
            city: Data.city.replace('市', '')
          };
          __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(url1, { params: params1 }, { emulateJSON: true }).then(function (data) {
            var info = data.body;
            if (info.geocodes[0] && info.geocodes[0].location && info.geocodes[0].location !== '') {
              var res = info.geocodes[0].location.split(',');
              point.lng = res[0];
              point.lat = res[1];
              point.city = info.geocodes[0].city ? info.geocodes[0].city : '';
              point.name = info.geocodes[0].formatted_address ? info.geocodes[0].formatted_address : '';
              point.ad_code = info.geocodes[0].adcode ? info.geocodes[0].adcode : null;
              point.city_code = info.geocodes[0].citycode ? info.geocodes[0].citycode : null;
              point.detailedAddress = info.geocodes[0].formatted_address ? info.geocodes[0].formatted_address : '';
              callback(point);
            } else {
              callback('定位失败，请检查是否已开启定位');
            }
          });
        } else {
          callback('定位失败，请检查是否已开启定位');
        }
      });
    };

    function getLocation() {
      if (navigator.geolocation) {
        console.log('支持地理定位', navigator.geolocation);
        navigator.geolocation.getCurrentPosition(showPosition, gaodeLocation, { timeout: 3000 });
      } else {
        console.log('不支持地理定位');
        gaodeLocation();
      }
    }

    getLocation();
  },
  allOrder: function allOrder(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_2__store_configure__["a" /* default */].appKey,
      'serviceType': obj.serviceType,
      'passengerId': obj.passengerId,
      'page': obj.page,
      'rows': obj.rows
    };
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_2__store_configure__["a" /* default */].weixinUrl + '/v5/passenger/getOrders', { params: params }, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  unfilledOrder: function unfilledOrder(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/runingOrders', params);

    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('/v1/runingOrders', { params: params }, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  getCouponType: function getCouponType(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/api/v1/coupons', params);
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('/api/v1/coupons', { params: params }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  getBudgetPrice: function getBudgetPrice(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/budget', params);
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post('/v1/budget', params, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  systemConfig: function systemConfig(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/systemConfig', params);

    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('/v1/systemConfig', { params: params }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  postCreateOrder: function postCreateOrder(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/createOrder', params);

    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post('/v1/createOrder', params, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  getOrderFindOne: function getOrderFindOne(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/orderFindOne', params);

    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('/v1/orderFindOne', { params: params }, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  putFinishOrder: function putFinishOrder(params, callback) {
    console.log(3);
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/api/v1/finishOrder', params);

    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.put('/api/v1/finishOrder', params, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  putCancelOrder: function putCancelOrder(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/api/v1/cancelOrder', params);

    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.put('/v1/cancelOrder', params, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  getTags: function getTags(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/tags', params);

    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('/v1/tags', { params: params }, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  putRateOrder: function putRateOrder(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/rateOrder', params);

    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.put('/v1/rateOrder', params, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  routePlanning: function routePlanning(obj, callback) {
    var params = {
      key: window.configure.amapKey,
      strategy: 10,
      origin: obj.originLng + ',' + obj.originLat,
      destination: obj.destinationLng + ',' + obj.destinationLat,
      output: 'json'
    };
    var url = '/v3/direction/driving';
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.jsonp(url, { params: params }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  accredit: function accredit(obj, callback) {
    function isFromWx() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i)[0] === 'micromessenger') {
        return true;
      }
      return false;
    }

    function getQueryString() {
      var args = {};
      var query = location.search.substring(1);
      var pairs = query.split('&');
      for (var i = 0; i < pairs.length; i++) {
        var pos = pairs[i].indexOf('=');
        if (Number(pos) === -1) {
          continue;
        }
        var argname = pairs[i].substring(0, pos);
        var value = pairs[i].substring(pos + 1);
        value = decodeURIComponent(value);
        args[argname] = value;
      }
      return args;
    }

    var _obj = getQueryString();
    if (!isFromWx()) {
      callback({ wxState: false });
      return false;
    }
    if (isFromWx() && !_obj.code) {
      var baseURL = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + __WEBPACK_IMPORTED_MODULE_2__store_configure__["a" /* default */].WXappId + '&redirect_uri=' + encodeURIComponent(location.href) + '&response_type=code&scope=snsapi_base&state=null#wechat_redirect';
      window.location.replace(baseURL);
    } else {
      callback({ wxState: true, code: _obj.code });
    }
  },
  urlEnabled: function urlEnabled(obj, callback) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(obj.url).then(function (data) {
      callback(true);
    }, function (data) {
      callback(false);
    });
  },
  googleMapSite: function googleMapSite(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_2__store_configure__["a" /* default */].appKey,
      'name': obj.query
    };
    var url = window.configure.googleUrl + '/v5/zhuanche/queryAddressByGoogle';
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(url, { params: params }, { emulateJSON: true }).then(function (data) {
      if (data.body.errorMsg === '请求成功') {
        var result = [];
        if (data.body.data.length > 0) {
          for (var i = 0; i < data.body.data.length; i++) {
            var obj = data.body.data[i];
            result.push({
              name: obj.name,
              detailedAddress: obj.formatted_address,
              lng: obj.lng,
              lat: obj.lat
            });
          }
        } else {
          result = [];
        }
        callback(result);
      }
    });
  },
  amapMapSite: function amapMapSite(obj, callback) {
    var url = 'https://restapi.amap.com/v3/place/text';
    var params = {
      keywords: obj.query,
      city: obj.city || null,
      key: window.configure.amapKey,
      output: 'JSON',
      extensions: 'all'
    };
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.jsonp(url, { params: params }).then(function (response) {
      if (response.body.status === '1') {
        var result = [];
        var Data = response.body.pois;
        if (Data.length > 0) {
          Data.forEach(function (opt) {
            result.push({
              citycode: opt.citycode,
              adcode: opt.adcode,
              name: opt.name,
              city: opt.cityname,
              detailedAddress: opt.cityname + (opt.address || ''),
              lng: opt.location.split(',')[0],
              lat: opt.location.split(',')[1]
            });
          });
        }
        callback(result);
      }
    });
  },
  googleForLongitude: function googleForLongitude(obj, callback) {
    var url = window.configure.googleUrl + '/v5/zhuanche/addressInfoByLatLngForGoogle';
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_2__store_configure__["a" /* default */].appKey,
      'lat': obj.lat,
      'lng': obj.lng
    };
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(url, { params: params }, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  baiduForLongitude: function baiduForLongitude(obj, callback) {
    var url = 'https://api.map.baidu.com/geocoder/v2/?&output=json&pois=1';
    var params = {
      ak: __WEBPACK_IMPORTED_MODULE_2__store_configure__["a" /* default */].baiduKey,
      coordtype: 'wgs84ll',
      ret_coordtype: 'gcj02ll',
      location: obj.lat + ',' + obj.lng
    };
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.jsonp(url, { params: params }).then(function (data) {
      var chooseBestPoi = function chooseBestPoi(pois) {
        var best = null;

        if (pois.length > 0) {
          best = pois[0];

          for (var i = 0; i < pois.length; i++) {
            if (parseFloat(best.distance) > parseFloat(pois[i].distance)) {
              best = pois[i];
            }
          }
        }

        return best;
      };
      var sematicDescription = data.body.result.sematic_description;
      var add = null;
      var obj = null;
      if (data.body.result.pois.length > 0) {
        add = chooseBestPoi(data.body.result.pois);
        if (Number(add.distance) < 300) {
          obj = {
            name: sematicDescription,
            city: data.body.result.addressComponent.city,
            detailedAddress: data.body.result.addressComponent.province + data.body.result.addressComponent.city + data.body.result.addressComponent.district + add.addr + add.name,
            lng: add.point.x,
            lat: add.point.y
          };
        } else {
          add = data.body.result.addressComponent;
          obj = {
            name: sematicDescription,
            city: add.city,
            detailedAddress: add.province + add.city + add.district + add.street + add.street_number,
            lng: data.body.result.location.lng,
            lat: data.body.result.location.lat
          };
        }
      } else {
        add = data.body.result.addressComponent;
        obj = {
          name: sematicDescription,
          city: add.city,
          detailedAddress: add.province + add.city + add.district + add.street + add.street_number,
          lng: data.body.result.location.lng,
          lat: data.body.result.location.lat
        };
      }
      callback(obj);
    });
  },
  countLine: function countLine(obj, callback) {
    var url = 'https://api.map.baidu.com/direction/v1/?mode=driving&output=json';
    var params = {
      ak: __WEBPACK_IMPORTED_MODULE_2__store_configure__["a" /* default */].baiduKey,
      origin: obj.origin,
      destination_region: obj.destination_region,
      origin_region: obj.origin_region,
      destination: obj.destination
    };
    if (obj.waypoints) {
      params['waypoints'] = obj.waypoints;
    }
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.jsonp(url, { params: params }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  checkWX: function checkWX(obj, callback) {
    function isFromWx() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i)[0] === 'micromessenger') {
        return true;
      }
      return false;
    }

    callback(isFromWx());
  }
});

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(389)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(533),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(399)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(543),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(361)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(505),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(380)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(524),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(415)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(559),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(354)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(498),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(384)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(528),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(402)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(546),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_configure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_json_bigint_xk__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk__);






/* harmony default export */ __webpack_exports__["a"] = ({
  postLogin: function postLogin(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/loginPhone', params);
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post('/v1/loginPhone', params, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  postRegister: function postRegister(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/register', params);
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post('/v1/register', params, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  passengerWithOutLogin: function passengerWithOutLogin(params, callback) {
    console.log('免登接口');
    var headers = {
      sign: params.sign,
      clientId: params.clientId
    };
    delete params.sign;
    delete params.clientId;
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/passengerWithOutLogin', params);
    console.log(params);
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post('/v1/passengerWithOutLogin', params, { emulateJSON: true, headers: headers }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  updateLoginData: function updateLoginData(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_2__store_configure__["a" /* default */].appKey,
      'passengerId': obj.passengerId
    };
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('/v5/passenger/getPassengerInfo', { params: params }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  logoutUser: function logoutUser(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_2__store_configure__["a" /* default */].appKey,
      'phone': obj.phone,
      'openId': obj.openId
    };
    var url = __WEBPACK_IMPORTED_MODULE_2__store_configure__["a" /* default */].weixinUrl + '/v5/passenger/logout';
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(url, params, { emulateJSON: true }).then(function (data) {
      return callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  getPassenger: function getPassenger(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/passenger', params);
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('/v1/passenger', { params: params }, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  putPassenger: function putPassenger(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/passenger', params);
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.put('/v1/passenger', params, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  getOpenId: function getOpenId(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_2__store_configure__["a" /* default */].appKey,
      'code': obj.jsCode,
      'wxAppId': obj.wxAppId
    };
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('/v1/weChatOpenId', { params: params }, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.body)));
    });
  },
  getWeChatToken: function getWeChatToken(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_2__store_configure__["a" /* default */].appKey,
      'wxAppId': obj.wxAppId
    };
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('/v1/weChatToken', { params: params }, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.body)));
    });
  },
  postloginOpenId: function postloginOpenId(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_2__store_configure__["a" /* default */].appKey,
      'open_id': obj.open_id,
      'timeStamp': Date.parse(new Date()) / 1000
    };
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post('/v1/loginOpenId', params, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.body)));
    });
  },
  getCheckUser: function getCheckUser(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/check', params);
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('/v1/check', { params: params }, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  getImgCode: function getImgCode(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/picCode', params);
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('/v1/picCode', { params: params }, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  postCheckCode: function postCheckCode(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/checkCode', params);
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post('/v1/checkCode', params, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  getSmsCode: function getSmsCode(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/smsCode', params);
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('/v1/smsCode', { params: params }, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  getUsePic: function getUsePic(params, fn) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.options.headers = {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    };
    params = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/block/pic', params);
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post('/v1/block/pic', params, { emulateJSON: true }).then(function (res) {
      fn(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(res.bodyText));
    });
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_banner__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_initdata__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_city__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_js_method__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_json_bigint_xk__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_json_bigint_xk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_json_bigint_xk__);










var state = {
  location: {
    name: '获取定位中...',
    city: '选择城市',
    ad_code: null,
    city_code: null,
    detailedAddress: null,
    lng: null,
    lat: null
  },
  servesType: {},
  servesTypeNav: [],
  banners: {
    daijia: [],
    paotui: [],
    zhuanche: [],
    zhuanxian: [],
    freight: []
  },
  companyInfo: null,
  infoData: '',
  unfilledOrder: [],
  unfilledOrderState: {
    paotui: true,
    zhuanche: true,
    daijia: true,
    zhuanxian: true,
    huoyun: true
  },
  OrderNav: [],
  mobile: {
    iPhone: false,
    Android: false,
    fromData: false
  },
  baiduMapSite: [],
  nearDrivers: 0,
  mapState: 'amap',
  addressRecord: {
    paotui: {},
    daijia: [],
    zhuanche: {},
    zhuanxian: {}
  },
  business: {
    daijia: {}
  }
};
var mutations = {
  getInitInfo: function getInitInfo(state, data) {
    var obj = data.obj;
    state.infoData = obj;
    state.companyInfo = obj.companyinfo;
    state.servesTypeNav = [];
    var servesNav = [];
    var orderNav = [];
    if (obj.business) {
      obj.business.forEach(function (business) {
        if (business.business === 'daijia') {
          business['name'] = '代驾';
          business['router'] = '/daijia?app_key=' + window.configure.appKey;
          business['OrderNavRouter'] = '/orderRecord/daijia';
          state.servesType[business.business] = business;
          var OrderNavObj = { name: business.name, url: business.OrderNavRouter };
          var servesNavObj = { name: business.name, url: business.router, business: business.business };
          servesNav.push(servesNavObj);
          orderNav.push(OrderNavObj);
        }
      });
    }
    state.servesTypeNav = servesNav;
    state.OrderNav = orderNav;
    if (data.fn) {
      data.fn(obj);
    }
  },
  positioningMutation: function positioningMutation(state, obj) {
    if (obj.result && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj.result).indexOf('失败') < 0) {
      var result = obj.result;
      var _city = '';
      if (result.city && typeof result.city === 'string') {
        _city = result.city;
      } else if (result.city && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(result.city) === Array && result.city.length > 0) {
        _city = result.city[0];
      } else if (result.detailedAddress.indexOf('市') !== -1) {
        _city = result.detailedAddress.substring(result.detailedAddress.indexOf('省') + 1, result.detailedAddress.indexOf('市') + 1);
      } else {
        _city = '选择城市';
      }
      state.location.name = result.name;

      state.location = {
        name: result.name,
        ad_code: result.ad_code,
        city_code: result.city_code,
        city: _city,
        detailedAddress: result.detailedAddress,
        lng: result.lng,
        lat: result.lat
      };

      window.configure.location = state.location;

      if (__WEBPACK_IMPORTED_MODULE_5__assets_js_method__["a" /* default */].ismobile(1) + '' === '0') {
        state.mobile.iPhone = true;
      } else {
        state.mobile.Android = true;
      }

      if (new FormData()) {
        state.mobile.fromData = true;
      }
      if (result && result.lng && result.lat && result.city_code && obj.fn) {
        obj.fn(true);
      }
    } else {
      obj.fn(false);
    }
  },
  banner: function banner(state, obj) {
    var banner = obj.banner;
    var type = obj.type;
    var data = [];
    for (var i = 0; i < banner.content.length; i++) {
      data.push({
        imgUrl: banner.content[i].image,
        htmlUrl: banner.content[i].link ? banner.content[i].link : banner.content[i].content
      });
    }
    state.banners[type] = data;
  },
  unfilledOrder: function unfilledOrder(state, obj) {
    if (obj.code === 1) {
      state.unfilledOrder = obj.orders || [];
    }
  },
  unfilledOrderState: function unfilledOrderState(state, obj) {
    switch (obj.type) {
      case 'paotui':
        state.unfilledOrderState.paotui = obj.state;
        break;
      case 'zhuanche':
        state.unfilledOrderState.zhuanche = obj.state;
        break;
      case 'daijia':
        state.unfilledOrderState.daijia = obj.state;
        break;
      case 'zhuanxian':
        state.unfilledOrderState.zhuanxian = obj.state;
        break;
      case 'huoyun':
        state.unfilledOrderState.huoyun = obj.state;
        break;
    }
  },
  addressRecord: function addressRecord(state, obj) {
    if (obj.address.lng !== '' && obj.address.lat !== '' && obj.type === 'daijia') {
      var check = true;
      var daijia = state.addressRecord.daijia;
      for (var i = 0; i < daijia.length; i++) {
        if (daijia[i].address.name === obj.address.name && daijia[i].address.detailedAddress === obj.address.detailedAddress && daijia[i].address.lng === obj.address.lng && daijia[i].address.lat === obj.address.lat) {
          if (i !== 0) {
            daijia[0] = [daijia[i], daijia[i] = daijia[0]][0];
          }
          check = false;
        }
      }
      if (check) {
        if (state.addressRecord.daijia.length < 5) {
          state.addressRecord.daijia.unshift({
            address: obj.address,
            recordTime: obj.recordTime
          });
        } else {
          state.addressRecord.daijia.unshift({
            address: obj.address,
            recordTime: obj.recordTime
          });
          state.addressRecord.daijia.pop();
        }
      }
    }
    if (obj.type === 'zhuanche') {
      if (!state.addressRecord.zhuanche[obj.sonType]) {
        state.addressRecord.zhuanche[obj.sonType] = [];
        state.addressRecord.zhuanche[obj.sonType].unshift({
          address: obj.address,
          recordTime: obj.recordTime
        });
      }
      if (state.addressRecord.zhuanche[obj.sonType]) {
        var _check = true;
        var zhuanche = state.addressRecord.zhuanche[obj.sonType];
        for (var _i = 0; _i < state.addressRecord.zhuanche[obj.sonType].length; _i++) {
          if (zhuanche[_i].address.name === obj.address.name && zhuanche[_i].address.detailedAddress === obj.address.detailedAddress && zhuanche[_i].address.lng === obj.address.lng && zhuanche[_i].address.lat === obj.address.lat) {
            if (_i !== 0) {
              zhuanche[0] = [zhuanche[_i], zhuanche[_i] = zhuanche[0]][0];
            }
            _check = false;
          }
        }
        if (_check) {
          if (state.addressRecord.zhuanche[obj.sonType].length < 5) {
            state.addressRecord.zhuanche[obj.sonType].unshift({
              address: obj.address,
              recordTime: obj.recordTime
            });
          } else {
            state.addressRecord.zhuanche[obj.sonType].unshift({
              address: obj.address,
              recordTime: obj.recordTime
            });
            state.addressRecord.zhuanche[obj.sonType].pop();
          }
        }
      }
    }
    localStorage.setItem('easyminaddressrecord', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.addressRecord));
    if (obj.fn) {
      obj.fn();
    }
  },
  getAddressRecord: function getAddressRecord(state, obj) {
    if (localStorage.getItem('easyminaddressrecord') !== 'undefined') {
      if (__WEBPACK_IMPORTED_MODULE_6_json_bigint_xk___default.a.parse(localStorage.getItem('easyminaddressrecord'))) {
        state.addressRecord = __WEBPACK_IMPORTED_MODULE_6_json_bigint_xk___default.a.parse(localStorage.getItem('easyminaddressrecord'));
      }
      if (obj.fn) {
        obj.fn();
      }
    }
  },
  getNearDrivers: function getNearDrivers(state, nearDrivers) {
    if (nearDrivers.code === 1) {
      var arr = [];
      if (nearDrivers.emploies) {
        nearDrivers.emploies.forEach(function (item) {
          if (item.status === '10') {
            arr.push(item);
          }
        });
      }
      state.nearDrivers = arr;
    }
  },
  getBusiness: function getBusiness(state, business) {
    if (business.code === 1 && business.categories && business.categories.length > 0) {
      state.business[business.business] = business.categories;
    }
  }
};

var getters = {
  daijiaBanner: function daijiaBanner(state) {
    return state.banners.daijia;
  },
  paotuiBanner: function paotuiBanner(state) {
    return state.banners.paotui;
  },
  zhuancheBanner: function zhuancheBanner(state) {
    return state.banners.zhuanche;
  },
  zhuanxianBanner: function zhuanxianBanner(state) {
    return state.banners.zhuanxian;
  },
  huoyunBanner: function huoyunBanner(state) {
    return state.banners.freight;
  },
  servesTypeNav: function servesTypeNav(state) {
    return state.servesTypeNav;
  },
  infoData: function infoData(state) {
    return state.infoData;
  },
  companyInfo: function companyInfo(state) {
    return state.companyInfo;
  },
  unfilledOrder: function unfilledOrder(state) {
    return state.unfilledOrder;
  },
  orderNav: function orderNav(state) {
    return state.OrderNav;
  },
  positioning: function positioning(state) {
    return state.location;
  },
  mobileState: function mobileState(state) {
    return state.mobile;
  },
  unfilledOrderState: function unfilledOrderState(state) {
    return state.unfilledOrderState;
  },
  mapState: function mapState(state) {
    return state.mapState;
  },
  addressRecord: function addressRecord(state) {
    return state.addressRecord;
  },
  getCity: function getCity(state) {
    return __WEBPACK_IMPORTED_MODULE_4__api_city__["a" /* default */];
  },
  getNearDrivers: function getNearDrivers(state) {
    return state.nearDrivers;
  },
  DJBusiness: function DJBusiness(state) {
    return state.business.daijia;
  } };

var actions = {
  getWxAppId: function getWxAppId(_ref, obj) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_3__api_initdata__["a" /* default */].getWxAppId(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  getjsApiTicket: function getjsApiTicket(_ref2, obj) {
    var commit = _ref2.commit;

    __WEBPACK_IMPORTED_MODULE_3__api_initdata__["a" /* default */].getjsApiTicket(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  getInitInfo: function getInitInfo(_ref3, obj) {
    var commit = _ref3.commit;

    __WEBPACK_IMPORTED_MODULE_3__api_initdata__["a" /* default */].getInitInfo(obj, function (data) {
      commit('getInitInfo', { fn: obj.fn, obj: data });
    });
  },
  positioningActions: function positioningActions(_ref4, obj) {
    var commit = _ref4.commit;

    __WEBPACK_IMPORTED_MODULE_3__api_initdata__["a" /* default */].positioningApi(obj, function (data) {
      console.log('获取定位--actions--positioning', data);
      if (data.lng && data.lat && data.ad_code && data.city_code) {
        commit('positioningMutation', { result: data, fn: obj.fn });
      } else {
        alert('抱歉，无法获取位置信息');
      }
    });
  },
  getNearDrivers: function getNearDrivers(_ref5, obj) {
    var commit = _ref5.commit;

    __WEBPACK_IMPORTED_MODULE_3__api_initdata__["a" /* default */].getNearDrivers(obj, function (data) {
      commit('getNearDrivers', data);
    });
  },
  banner: function banner(_ref6, obj) {
    var commit = _ref6.commit;

    __WEBPACK_IMPORTED_MODULE_2__api_banner__["a" /* default */].banner(obj, function (banner, type) {
      commit('banner', { banner: banner, type: type });
    });
  },
  unfilledOrder: function unfilledOrder(_ref7, obj) {
    var commit = _ref7.commit;

    __WEBPACK_IMPORTED_MODULE_3__api_initdata__["a" /* default */].unfilledOrder(obj, function (data) {
      commit('unfilledOrder', data);
    });
  },
  routePlanning: function routePlanning(_ref8, obj) {
    var commit = _ref8.commit;

    __WEBPACK_IMPORTED_MODULE_3__api_initdata__["a" /* default */].routePlanning(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  getBudgetPrice: function getBudgetPrice(_ref9, obj) {
    var commit = _ref9.commit;

    __WEBPACK_IMPORTED_MODULE_3__api_initdata__["a" /* default */].getBudgetPrice(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  getBusiness: function getBusiness(_ref10, obj) {
    var commit = _ref10.commit;

    __WEBPACK_IMPORTED_MODULE_3__api_initdata__["a" /* default */].getBusiness(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
      commit('getBusiness', data);
    });
  },
  getCouponType: function getCouponType(_ref11, obj) {
    var commit = _ref11.commit;

    __WEBPACK_IMPORTED_MODULE_3__api_initdata__["a" /* default */].getCouponType(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  postCreateOrder: function postCreateOrder(_ref12, obj) {
    var commit = _ref12.commit;

    __WEBPACK_IMPORTED_MODULE_3__api_initdata__["a" /* default */].postCreateOrder(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  systemConfig: function systemConfig(_ref13, obj) {
    var commit = _ref13.commit;

    __WEBPACK_IMPORTED_MODULE_3__api_initdata__["a" /* default */].systemConfig(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  getTags: function getTags(_ref14, obj) {
    var commit = _ref14.commit;

    __WEBPACK_IMPORTED_MODULE_3__api_initdata__["a" /* default */].getTags(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  urlEnabled: function urlEnabled(_ref15, obj) {
    var commit = _ref15.commit;

    __WEBPACK_IMPORTED_MODULE_3__api_initdata__["a" /* default */].urlEnabled(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(true);
      } else if (obj.fn) {
        obj.fn(false);
      }
    });
  },
  unfilledOrderState: function unfilledOrderState(_ref16, obj) {
    var commit = _ref16.commit;

    commit('unfilledOrderState', obj);
  },
  googleMapSite: function googleMapSite(_ref17, obj) {
    var commit = _ref17.commit;

    __WEBPACK_IMPORTED_MODULE_3__api_initdata__["a" /* default */].googleMapSite(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  amapMapSite: function amapMapSite(_ref18, obj) {
    var commit = _ref18.commit;

    __WEBPACK_IMPORTED_MODULE_3__api_initdata__["a" /* default */].amapMapSite(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  addressRecord: function addressRecord(_ref19, obj) {
    var commit = _ref19.commit;

    commit('addressRecord', obj);
  },
  getAddressRecord: function getAddressRecord(_ref20, obj) {
    var commit = _ref20.commit;

    commit('getAddressRecord', obj);
  },
  getNotice: function getNotice(_ref21, obj) {
    var commit = _ref21.commit;

    __WEBPACK_IMPORTED_MODULE_3__api_initdata__["a" /* default */].getNotice(obj, function (data) {
      if (obj.fn) {
        obj.fn(data);
      }
    });
  },
  countLine: function countLine(_ref22, obj) {
    var commit = _ref22.commit;

    __WEBPACK_IMPORTED_MODULE_3__api_initdata__["a" /* default */].countLine(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAyCAYAAAAus5mQAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkNBRjcwQTVDN0REMTExRTc5NzkxQTk4RjgwNkQ4RkRGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkNBRjcwQTVEN0REMTExRTc5NzkxQTk4RjgwNkQ4RkRGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6Q0FGNzBBNUE3REQxMTFFNzk3OTFBOThGODA2RDhGREYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6Q0FGNzBBNUI3REQxMTFFNzk3OTFBOThGODA2RDhGREYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7pV7yWAAACjklEQVR42rRZCW7DMAwzvXt7wv7/zXDrkA6Bp4NSsgBG2yRNbZqUKBUkP8cYT9/j8Xu8Hcb78v5jf31frr/ury/7+9t43j8/7eN5f/5tPBzG3AeM8XPcLnLYx/38/Qs0rh/PIXjv/cZIfvt39lweKn3ZOODcj+IE/yAYrRLF8yNAtnxM44Heild+WPfxxKRgfW86F46o8nBuWybBBg0i1GlNcF01Al4i2GqOfzimgZTHoXXSdNQ+HNrIwrAQRKDAzQk3CDh4WhwWgh5p70LajC1VQwhEDsJTsReIo4Adca+r4lAkEffGgmIWUthQNKMtHgEPtwSpf1GvFagZ3EMjUEchB1ctYgpQb5bLcBbFJDOpeZxRmIHDsa0RRlAQDz2zAFFVKCqy62TKHPS2zwrwZyaDjIORYRiBSJhwcDTCDCORSORNJnI2zUGZIJygrKDEq7cYIiJMDCauNAqWo4bBQTQowAZaVBDMXC4zBxwILpsM1JrkEqvetFthmKGIApI6+FL7P4UVIijg0eQYKhNUnDGFzkK2dehyMEPGyyRDVHknk5giyVZo9WIYWKyor1PqzSjKQxMtNmuWUndr/TE6qKMQZlocVNwFxOKoY/lDN8MgDjIxsFbRpTSjSm7G6xLQyc/DadtR3FJ0Uh2FKm02nAuaE04R9GIiHdGcKdwZcZDFAIqiarttkNQsKEh4jaRLzULWQlO9HAqLLJmFM8V2NWOUEZ6FVc0k33olaYeD5v8k68W1d7gVMo5aGrQMa9SDriq2YjAQmYUMBRhKRSNEtfwgEqQw4v9G2BCaXCpM8SGqAFQOZt3aNJNAQEat5DDqZSeyqo5Gllj/ClOKrW69woiDHgJWrFNzLrsq/hJgALg9BXZQp4VDAAAAAElFTkSuQmCC"

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAPRJREFUKBWdkdENgjAQhq1uQMoAJpCQsACPGlzC1VyAIYzBR8K7CW8OUHbA+0pLsEKiXtLQ+/t/3PWqhmHYbf6ILUyappckSa5FUei1f3CGBy8eC0rVvaxj3/e3JRiNMzx4J1BrfVZKPUTMQ3gG5XjwAiox2zsuGEoMrpKHyqZp+jeQZA5L2qFJZK7SBCFOFUkIYGPMXbYZuUQXx/HBVxolNxyf/PK1U/WAb1VyqtEqKwsHJtr4HGw8xGS5E+2x1qZtK4aQjNwOgnuxX4ItKK1UvpKH6IIAjqLoNIMrdAuK+JRVhxAGom1b4yrXeNE+ngPxm3gBnYm64hzJA8YAAAAASUVORK5CYII="

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(397)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(541),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(404)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(548),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(378)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(522),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(387)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(531),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(365)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(509),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(403)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(547),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(358)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(502),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(416)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(560),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(414)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(558),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(381)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(525),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(376)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(520),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(364)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(508),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(377)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(521),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(422)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(566),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(366)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(510),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(411)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(555),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(382)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(526),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(419)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(563),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  toast: function toast(_ref) {
    var text = _ref.text,
        _ref$timeout = _ref.timeout,
        timeout = _ref$timeout === undefined ? 2000 : _ref$timeout;

    var app = document.getElementById('app');
    var p = document.createElement('p');
    var t = document.createTextNode(text);
    p.appendChild(t);
    app.appendChild(p);

    p.style.backgroundColor = 'rgba(0,0,0,.5)';
    p.style.color = '#fff';
    p.style.fontSize = '12px';
    p.style.textAlign = 'center';
    p.style.maxWidth = '90%';
    p.style.minHeight = '20px';
    p.style.padding = '6px 10px';
    p.style.borderRadius = '4px';
    p.style.display = 'flex';
    p.style.alignItems = 'center';
    p.style.position = 'absolute';
    p.style.top = '360px';
    p.style.transition = 'all .5s';
    p.style.opacity = 0;
    app.style.display = 'flex';
    app.style.justifyContent = 'center';
    setTimeout(function () {
      p.style.opacity = 1;
    }, 300);
    setTimeout(function () {
      p.style.opacity = 0;
      setTimeout(function () {
        app.removeChild(p);
        app.style.display = '';
        app.style.justifyContent = '';
      }, 500);
    }, timeout - 500);
  }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_json_bigint_xk__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_json_bigint_xk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_json_bigint_xk__);










__WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$axios = {
  get: __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getAxios,
  put: __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].putAxios,
  post: __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].postAxios,
  delete: __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].deleteAxios
};
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.timeout = 30000;

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.transformResponse = [function (data) {
  try {
    console.log("大id转换：", __WEBPACK_IMPORTED_MODULE_7_json_bigint_xk___default.a.parse(data));
    return __WEBPACK_IMPORTED_MODULE_7_json_bigint_xk___default.a.parse(data);
  } catch (err) {
    return data;
  }
}];

var pending = [];
var CancelToken = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.CancelToken;
var removePending = function removePending(config) {
  for (var p in pending) {
    if (pending[p].u === config.url + '&' + config.method) {
      pending[p].f();
      pending.splice(p, 1);
    }
  }
};

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {
  removePending(config);
  config.cancelToken = new CancelToken(function (c) {
    pending.push({ u: config.url + '&' + config.method, f: c });
  });

  var cookieAppKey = __WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$Cookie.get('cookieAppKey') ? __WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$Cookie.get('cookieAppKey') : null;
  if (config.method === 'post' || config.method === 'put') {
    if (config.url === '/upImg') {
      config.headers['Content-Type'] = 'application/json';
    } else {
      config.data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, config.data, {
        app_key: cookieAppKey,
        timestamp: Date.parse(new Date()) / 1000
      });
      config.data = __WEBPACK_IMPORTED_MODULE_6_qs___default.a.stringify(config.data);
    }
  } else {
    config.params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, config.params, {
      app_key: cookieAppKey,
      timestamp: Date.parse(new Date()) / 1000
    });
  }


  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.response.use(function (response) {
  return response.data;
}, function (error) {
  console.log('response响应error:', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(JSON.parse(error)));
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);



var supplementZero = function supplementZero(num) {
  num = Number(num);
  return num < 10 ? '0' + num : num;
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('time', function (val) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'timeStamp';
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'YYYY-MM-DD HH:MM:SS';

  if (type === 'timeStamp') {
    var Dates = null;
    format = format || 'YYYY-MM-DD HH:MM:SS';
    if (!val) {
      return '无';
    }
    if (val instanceof Object) {
      Dates = new Date(val);
    } else if (Number(val)) {
      val = (val += '').length === 13 ? Number(val) : Number(val) * 1000;
      Dates = new Date(val);
    } else {
      return val;
    }
    var year = Dates.getFullYear();
    var month = supplementZero(Dates.getMonth() + 1);
    var date = supplementZero(Dates.getDate());
    var hour = supplementZero(Dates.getHours());
    var minute = supplementZero(Dates.getMinutes());
    var second = supplementZero(Dates.getSeconds());
    format = format.toUpperCase();
    format = format.replace(/YYYY/, year);
    format = format.replace(/MM/, month);
    format = format.replace(/DD/, date);
    format = format.replace(/HH/, hour);
    format = format.replace(/MM/, minute);
    format = format.replace(/SS/, second);
    return format;
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('orderStatusFilter', function (status) {
  var name = Number(status);
  switch (status) {
    case 1:
      name = '派单中';
      break;
    case 5:
      name = '已派单';
      break;
    case 10:
      name = '已接单';
      break;
    case 15:
      name = '前往预约地';
      break;
    case 20:
      name = '到达预约地';
      break;
    case 25:
      name = '前往目的地';
      break;
    case 28:
      name = '中途等待';
      break;
    case 30:
      name = '未支付';
      break;
    case 35:
      name = '待评价';
      break;
    case 40:
      name = '已评价';
      break;
    case 45:
      name = '已销单';
      break;
  }
  return name;
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_project_project__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_project_project___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_project_project__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_project_bannerContent__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_project_bannerContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_project_bannerContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_project_daijia_daijia__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_project_daijia_daijia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_project_daijia_daijia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_project_daijia_await__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_project_daijia_await___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_project_daijia_await__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_project_daijia_service__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_project_daijia_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_project_daijia_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_project_daijia_settlement__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_project_daijia_settlement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_project_daijia_settlement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_project_daijia_affirm__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_project_daijia_affirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_project_daijia_affirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_project_daijia_checkOrder__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_project_daijia_checkOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_project_daijia_checkOrder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_inform_inform__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_inform_inform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_inform_inform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_qrCode_qrCode__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_qrCode_qrCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_qrCode_qrCode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_friend_friend__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_friend_friend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_friend_friend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_settings_settings__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_settings_settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_settings_settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_settings_serviceAgreement__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_settings_serviceAgreement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_settings_serviceAgreement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_settings_servicePrice__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_settings_servicePrice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_settings_servicePrice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_compileNom_compileNom__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_compileNom_compileNom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_compileNom_compileNom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_mewallet_mewallet__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_mewallet_mewallet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_mewallet_mewallet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_mewallet_invoice_invoice__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_mewallet_invoice_invoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_mewallet_invoice_invoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_mewallet_invoice_invoiceApply__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_mewallet_invoice_invoiceApply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_mewallet_invoice_invoiceApply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_mewallet_invoice_invoiceRecord__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_mewallet_invoice_invoiceRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_mewallet_invoice_invoiceRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_mewallet_invoice_invoiceOrderRecord__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_mewallet_invoice_invoiceOrderRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_mewallet_invoice_invoiceOrderRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_mewallet_capitalRecord_capitalRecord__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_mewallet_capitalRecord_capitalRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_mewallet_capitalRecord_capitalRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_recharge_recharge__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_recharge_recharge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_recharge_recharge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_mewallet_coupon_coupon__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_mewallet_coupon_coupon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_mewallet_coupon_coupon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_mewallet_coupon_stale__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_mewallet_coupon_stale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_mewallet_coupon_stale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_mewallet_coupon_unused__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_mewallet_coupon_unused___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_mewallet_coupon_unused__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_mewallet_coupon_used__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_mewallet_coupon_used___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_mewallet_coupon_used__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_orderRecord_orderRecord__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_orderRecord_orderRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_orderRecord_orderRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_login_login__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_login_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_login_login__);































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Project',
    component: __WEBPACK_IMPORTED_MODULE_2__components_project_project___default.a,
    children: [{
      path: 'daijia',
      name: 'DaiJia',
      component: __WEBPACK_IMPORTED_MODULE_4__components_project_daijia_daijia___default.a
    }]
  }, {
    path: '/inform',
    name: 'Inform',
    component: __WEBPACK_IMPORTED_MODULE_10__components_inform_inform___default.a
  }, {
    path: '/qrCode',
    name: 'qrCode',
    component: __WEBPACK_IMPORTED_MODULE_11__components_qrCode_qrCode___default.a
  }, {
    path: '/friend',
    name: 'friend',
    component: __WEBPACK_IMPORTED_MODULE_12__components_friend_friend___default.a
  }, {
    path: '/settings',
    name: 'Settings',
    component: __WEBPACK_IMPORTED_MODULE_13__components_settings_settings___default.a
  }, {
    path: '/serviceAgreement',
    name: 'serviceAgreement',
    component: __WEBPACK_IMPORTED_MODULE_14__components_settings_serviceAgreement___default.a
  }, {
    path: '/servicePrice',
    name: 'servicePrice',
    component: __WEBPACK_IMPORTED_MODULE_15__components_settings_servicePrice___default.a
  }, {
    path: '/mewallet',
    name: 'MeWallet',
    component: __WEBPACK_IMPORTED_MODULE_17__components_mewallet_mewallet___default.a
  }, {
    path: '/invoice',
    name: 'Invoice',
    component: __WEBPACK_IMPORTED_MODULE_18__components_mewallet_invoice_invoice___default.a
  }, {
    path: '/invoiceRecord',
    name: 'InvoiceRecord',
    component: __WEBPACK_IMPORTED_MODULE_20__components_mewallet_invoice_invoiceRecord___default.a
  }, {
    path: '/invoiceApply',
    name: 'invoiceApply',
    component: __WEBPACK_IMPORTED_MODULE_19__components_mewallet_invoice_invoiceApply___default.a
  }, {
    path: '/invoiceOrderRecord',
    name: 'invoiceOrderRecord',
    component: __WEBPACK_IMPORTED_MODULE_21__components_mewallet_invoice_invoiceOrderRecord___default.a
  }, {
    path: '/coupon',
    name: 'coupon',
    component: __WEBPACK_IMPORTED_MODULE_24__components_mewallet_coupon_coupon___default.a,
    children: [{
      path: 'stale',
      name: 'CouponStale',
      component: __WEBPACK_IMPORTED_MODULE_25__components_mewallet_coupon_stale___default.a
    }, {
      path: 'used',
      name: 'CouponUsed',
      component: __WEBPACK_IMPORTED_MODULE_27__components_mewallet_coupon_used___default.a
    }, {
      path: 'nused',
      name: 'CouponUnused',
      component: __WEBPACK_IMPORTED_MODULE_26__components_mewallet_coupon_unused___default.a
    }]
  }, {
    path: '/compileNom',
    name: 'CompileNom',
    component: __WEBPACK_IMPORTED_MODULE_16__components_compileNom_compileNom___default.a
  }, {
    path: '/capitalRecord',
    name: 'CapitalRecord',
    component: __WEBPACK_IMPORTED_MODULE_22__components_mewallet_capitalRecord_capitalRecord___default.a
  }, {
    path: '/recharge',
    name: 'Recharge',
    component: __WEBPACK_IMPORTED_MODULE_23__components_recharge_recharge___default.a
  }, {
    path: '/daijia/await',
    name: 'DaiJiaAwait',
    component: __WEBPACK_IMPORTED_MODULE_5__components_project_daijia_await___default.a
  }, {
    path: '/daijia/service',
    name: 'DaiJiaService',
    component: __WEBPACK_IMPORTED_MODULE_6__components_project_daijia_service___default.a
  }, {
    path: '/daijia/settlement',
    name: 'DaiJiaSettlement',
    component: __WEBPACK_IMPORTED_MODULE_7__components_project_daijia_settlement___default.a
  }, {
    path: '/daijia/affirm',
    name: 'DaiJiaAffirm',
    component: __WEBPACK_IMPORTED_MODULE_8__components_project_daijia_affirm___default.a
  }, {
    path: '/daijia/checkOrder',
    name: 'DaiJiaCheckOrder',
    component: __WEBPACK_IMPORTED_MODULE_9__components_project_daijia_checkOrder___default.a
  }, {
    path: '/orderRecord',
    name: 'OrderRecord',
    component: __WEBPACK_IMPORTED_MODULE_28__components_orderRecord_orderRecord___default.a
  }, {
    path: '/bannerContent',
    name: 'BannerContent',
    component: __WEBPACK_IMPORTED_MODULE_3__components_project_bannerContent___default.a
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_29__components_login_login___default.a
  }, { path: '*', redirect: '/' }]
}));

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_initdata__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_mc__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_daijia_daijia__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_userCenter__ = __webpack_require__(283);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  modules: {
    initdata: __WEBPACK_IMPORTED_MODULE_2__modules_initdata__["a" /* default */],
    mc: __WEBPACK_IMPORTED_MODULE_3__modules_mc__["a" /* default */],
    daijia: __WEBPACK_IMPORTED_MODULE_4__modules_daijia_daijia__["a" /* default */],
    userCenter: __WEBPACK_IMPORTED_MODULE_5__modules_userCenter__["a" /* default */]
  }
}));

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_module_tagitem__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_module_star__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_module_textarea__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_module_waiter__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_module_hintBox__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_module_add__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_module_detailsBox__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_module_tabs__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_module_couponMod__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_module_rollBanner__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_module_siteInput__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_module_input__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_module_circuitMod__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_module_sideMenus__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_module_typeTabs__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_module_modalMod__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_module_carType__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_module_alertBox__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_module_inputBox__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_module_datePickerMod__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_module_couponSelect__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_module_recordOrderMod__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_module_unfilledOrderMod__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_module_uploadMod__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_module_informTimeMod__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_module_couponNav__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_module_capitalRecordList__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_module_upImg__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_module_upAvatar__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_module_homeBut__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_module_lineSelect__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_module_numberSelect__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_module_navTbas__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_module_invoiceRecordMod__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_module_badge__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_module_carTypeScroll__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_module_checkInput__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_module_imgCode__ = __webpack_require__(257);







































var install = function install(Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (install.installed) return;
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__components_module_tagitem__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__components_module_tagitem__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__components_module_star__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__components_module_star__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__components_module_textarea__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__components_module_textarea__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_3__components_module_waiter__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__components_module_waiter__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_4__components_module_hintBox__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__components_module_hintBox__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_5__components_module_add__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__components_module_add__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_6__components_module_detailsBox__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__components_module_detailsBox__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_7__components_module_tabs__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_7__components_module_tabs__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_8__components_module_couponMod__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_8__components_module_couponMod__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_9__components_module_rollBanner__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_9__components_module_rollBanner__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_10__components_module_siteInput__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_10__components_module_siteInput__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_11__components_module_input__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_11__components_module_input__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_12__components_module_circuitMod__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_12__components_module_circuitMod__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_13__components_module_sideMenus__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_13__components_module_sideMenus__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_14__components_module_typeTabs__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_14__components_module_typeTabs__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_15__components_module_modalMod__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_15__components_module_modalMod__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_16__components_module_carType__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_16__components_module_carType__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_17__components_module_alertBox__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_17__components_module_alertBox__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_18__components_module_inputBox__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_18__components_module_inputBox__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_19__components_module_datePickerMod__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_19__components_module_datePickerMod__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_20__components_module_couponSelect__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_20__components_module_couponSelect__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_22__components_module_unfilledOrderMod__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_22__components_module_unfilledOrderMod__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_21__components_module_recordOrderMod__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_21__components_module_recordOrderMod__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_23__components_module_uploadMod__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_23__components_module_uploadMod__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_24__components_module_informTimeMod__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_24__components_module_informTimeMod__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_25__components_module_couponNav__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_25__components_module_couponNav__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_26__components_module_capitalRecordList__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_26__components_module_capitalRecordList__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_27__components_module_upImg__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_27__components_module_upImg__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_28__components_module_upAvatar__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_28__components_module_upAvatar__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_29__components_module_homeBut__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_29__components_module_homeBut__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_31__components_module_numberSelect__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_31__components_module_numberSelect__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_30__components_module_lineSelect__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_30__components_module_lineSelect__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_36__components_module_checkInput__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_36__components_module_checkInput__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_34__components_module_badge__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_34__components_module_badge__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_37__components_module_imgCode__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_37__components_module_imgCode__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_33__components_module_invoiceRecordMod__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_33__components_module_invoiceRecordMod__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_35__components_module_carTypeScroll__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_35__components_module_carTypeScroll__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_32__components_module_navTbas__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_32__components_module_navTbas__["a" /* default */]);
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  version: '1.0.0',
  install: install,
  TagItem: __WEBPACK_IMPORTED_MODULE_0__components_module_tagitem__["a" /* default */],
  Star: __WEBPACK_IMPORTED_MODULE_1__components_module_star__["a" /* default */],
  Textarea: __WEBPACK_IMPORTED_MODULE_2__components_module_textarea__["a" /* default */],
  XkWaiter: __WEBPACK_IMPORTED_MODULE_3__components_module_waiter__["a" /* default */],
  XkHintBox: __WEBPACK_IMPORTED_MODULE_4__components_module_hintBox__["a" /* default */],
  XkAdd: __WEBPACK_IMPORTED_MODULE_5__components_module_add__["a" /* default */],
  XkdetailsBox: __WEBPACK_IMPORTED_MODULE_6__components_module_detailsBox__["a" /* default */],
  XkTabs: __WEBPACK_IMPORTED_MODULE_7__components_module_tabs__["a" /* default */],
  XkcouponMod: __WEBPACK_IMPORTED_MODULE_8__components_module_couponMod__["a" /* default */],
  XkRollBanner: __WEBPACK_IMPORTED_MODULE_9__components_module_rollBanner__["a" /* default */],
  XkSiteInput: __WEBPACK_IMPORTED_MODULE_10__components_module_siteInput__["a" /* default */],
  XkInput: __WEBPACK_IMPORTED_MODULE_11__components_module_input__["a" /* default */],
  XkSideMenus: __WEBPACK_IMPORTED_MODULE_13__components_module_sideMenus__["a" /* default */],
  XkTypeTabs: __WEBPACK_IMPORTED_MODULE_14__components_module_typeTabs__["a" /* default */],
  XkModalMod: __WEBPACK_IMPORTED_MODULE_15__components_module_modalMod__["a" /* default */],
  XkCarType: __WEBPACK_IMPORTED_MODULE_16__components_module_carType__["a" /* default */],
  XkAlertBox: __WEBPACK_IMPORTED_MODULE_17__components_module_alertBox__["a" /* default */],
  XKinputBox: __WEBPACK_IMPORTED_MODULE_18__components_module_inputBox__["a" /* default */],
  XKdatePickerMod: __WEBPACK_IMPORTED_MODULE_19__components_module_datePickerMod__["a" /* default */],
  XKCouponSelect: __WEBPACK_IMPORTED_MODULE_20__components_module_couponSelect__["a" /* default */],
  XKRecordOrderMod: __WEBPACK_IMPORTED_MODULE_21__components_module_recordOrderMod__["a" /* default */],
  XKUnfilledOrderMod: __WEBPACK_IMPORTED_MODULE_22__components_module_unfilledOrderMod__["a" /* default */],
  XKuploadMod: __WEBPACK_IMPORTED_MODULE_23__components_module_uploadMod__["a" /* default */],
  XKimgcode: __WEBPACK_IMPORTED_MODULE_37__components_module_imgCode__["a" /* default */],
  XkInformTimeMod: __WEBPACK_IMPORTED_MODULE_24__components_module_informTimeMod__["a" /* default */],
  XkbadgeMod: __WEBPACK_IMPORTED_MODULE_34__components_module_badge__["a" /* default */],
  XkCouponNav: __WEBPACK_IMPORTED_MODULE_25__components_module_couponNav__["a" /* default */],
  XkCapitalRecordList: __WEBPACK_IMPORTED_MODULE_26__components_module_capitalRecordList__["a" /* default */],
  XkUpImgDom: __WEBPACK_IMPORTED_MODULE_27__components_module_upImg__["a" /* default */],
  XkhomeBut: __WEBPACK_IMPORTED_MODULE_29__components_module_homeBut__["a" /* default */],
  XkUpAvatar: __WEBPACK_IMPORTED_MODULE_28__components_module_upAvatar__["a" /* default */],
  XKnumberSelect: __WEBPACK_IMPORTED_MODULE_31__components_module_numberSelect__["a" /* default */],
  XKLineSelect: __WEBPACK_IMPORTED_MODULE_30__components_module_lineSelect__["a" /* default */],
  XKcarTypeScroll: __WEBPACK_IMPORTED_MODULE_35__components_module_carTypeScroll__["a" /* default */],
  XKcheckInput: __WEBPACK_IMPORTED_MODULE_36__components_module_checkInput__["a" /* default */],
  XKnavTabs: __WEBPACK_IMPORTED_MODULE_32__components_module_navTbas__["a" /* default */],
  XKinvoiceRecordMod: __WEBPACK_IMPORTED_MODULE_33__components_module_invoiceRecordMod__["a" /* default */],
  XkCircuitMod: __WEBPACK_IMPORTED_MODULE_12__components_module_circuitMod__["a" /* default */]
});

/***/ }),
/* 144 */,
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(421)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(565),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_weixin_js_sdk__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_weixin_js_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_module_uploadMod_src_uploadMod__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_module_uploadMod_src_uploadMod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_module_uploadMod_src_uploadMod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_module_homeBut_src_homeBut__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_module_homeBut_src_homeBut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_module_homeBut_src_homeBut__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_configure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_js_method_js__ = __webpack_require__(4);















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    XkHomeBut: __WEBPACK_IMPORTED_MODULE_9__components_module_homeBut_src_homeBut___default.a,
    XkUploadMod: __WEBPACK_IMPORTED_MODULE_8__components_module_uploadMod_src_uploadMod___default.a
  },
  name: 'app',
  data: function data() {
    return {
      loadState: false,
      phone: '',
      sign: null,
      timeStamp: null,
      clientId: null };
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])({
    loginData: 'loginData',
    infoData: 'infoData',
    login: 'login',
    positioning: 'positioning'
  })),
  methods: {
    getInitInfoFn: function getInitInfoFn() {
      var that = this;
      var init = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        that.$store.dispatch('getInitInfo', {
          city_code: true,
          ad_code: true,
          fn: function fn(data) {
            if (data && data.code === 1) {
              resolve(data);
            } else {
              reject(data);
            }
          }
        });
      });
      init.then(function (data) {
        if (that.phone && that.sign && that.clientId && that.timeStamp) {
          var passengerkey = window.configure.passengerKey;
          __WEBPACK_IMPORTED_MODULE_11__assets_js_method_js__["a" /* default */].delCookie(passengerkey);
          __WEBPACK_IMPORTED_MODULE_11__assets_js_method_js__["a" /* default */].delCookie('easyminaddressrecord');
          __WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a.remove(passengerkey);
          that.$store.dispatch('passengerWithOutLogin', {
            phone: that.phone,
            sign: that.sign,
            clientId: that.clientId,
            timeStamp: that.timeStamp,
            fn: function fn(data) {
              if (data && data.code === 1) {}
            }
          });
        } else {}
        window.configure['companyinfo'] = data.companyinfo;
        __WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a.set('companyinfo', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data.companyinfo));
        that.loadState = false;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getAmapKey: function getAmapKey() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, params, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = '/v1/systemConfig';
                params = {
                  app_key: _this.$route.query.app_key
                };
                _context.next = 4;
                return _this.$axios.get(url, params);

              case 4:
                data = _context.sent;

                if (data && data.code === 1) {
                  window.configure.amapKey = data.system.amap_key || '5e87734d0804fbc33ec68b5e69d052ec';
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  watch: {
    '$route': {
      handler: function handler(val) {
        console.log('路由监听', val);
        var appKey = this.$route.query.app_key || window.configure.appKey;
        if (val.path === '/') {
          this.$router.push({
            path: '/daijia?app_key=' + appKey
          });
        }
      },

      deep: true
    }
  },
  created: function created() {
    var cookieAppKey = __WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a.get('cookieAppKey') ? __WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a.get('cookieAppKey') : null;
    this.phone = this.$route.query.phone;
    this.timeStamp = this.$route.query.timeStamp;
    if (this.phone) this.phone = this.phone.replace(/ /g, '+');
    this.sign = this.$route.query.sign;
    this.clientId = this.$route.query.clientId;
    console.log('APP-created-cookieAppKey', cookieAppKey);
    var appKey = this.$route.query.app_key || cookieAppKey;
    if (this.$route.path === '/' || this.$route.path === '/daijia') {
      __WEBPACK_IMPORTED_MODULE_11__assets_js_method_js__["a" /* default */].setCookie('cookieAppKey', appKey);
    }
    if (appKey) {
      __WEBPACK_IMPORTED_MODULE_10__store_configure__["a" /* default */].appKey = window.configure.appKey = appKey;
      window.configure.passengerKey = 'passenger' + appKey;
    } else {
      alert('请配置微信AppKey!');
    }
  },

  mounted: function mounted() {
    var that = this;
    that.getAmapKey();
    that.loadState = true;
    that.$store.dispatch('positioningActions', {
      fn: function fn(state) {
        if (state) {
          that.getInitInfoFn();
          that.$store.dispatch('getWxAppId', {
            fn: function fn(data) {
              if (data && data.code === 1) {
                window.configure.WXappId = data.wechat.app_id;
                __WEBPACK_IMPORTED_MODULE_10__store_configure__["a" /* default */].WXappId = window.configure.WXappId;
                that.$store.dispatch('accredit', function (data) {
                  if (data.wxState && data.code) {
                    that.$store.dispatch('getOpenId', {
                      jsCode: data.code,
                      wxAppId: window.configure.WXappId,
                      fn: function fn(data) {
                        that.$store.dispatch('postloginOpenId', {
                          open_id: window.configure.open_id,
                          fn: function fn(data) {
                            console.log('APP-走loginOpenId', data);
                          }
                        });
                      }
                    });
                  }
                });
              }
            }
          });
        } else {
          that.$nextTick(function () {
            that.$store.dispatch('getWeChatToken', {
              wxAppId: window.configure.WXappId,
              fn: function fn(data) {
                if (data && data.code === 1) {
                  that.$store.dispatch('getjsApiTicket', {
                    url: window.location.href.split('#')[0],
                    fn: function fn(data) {
                      if (data && data.code === 1) {
                        __WEBPACK_IMPORTED_MODULE_6_weixin_js_sdk___default.a.config({
                          debug: false,
                          appId: window.configure.WXappId,
                          timestamp: data.timestamp,
                          nonceStr: data.noncestr,
                          signature: data.sign,
                          jsApiList: ['getLocation'] });
                      }
                    }
                  });
                }
              }
            });
            that.$nextTick(function () {});
          });
        }
      }
    });
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__module_hintBox_src_hintBox__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__module_hintBox_src_hintBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__module_hintBox_src_hintBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_method__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module_siteInput_src_siteInput__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module_siteInput_src_siteInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__module_siteInput_src_siteInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_upImg_src_upImg__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_upImg_src_upImg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__module_upImg_src_upImg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__module_upAvatar_src_upAvatar_vue__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__module_upAvatar_src_upAvatar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__module_upAvatar_src_upAvatar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__module_uploadMod_src_uploadMod__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__module_uploadMod_src_uploadMod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__module_uploadMod_src_uploadMod__);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    XkUploadMod: __WEBPACK_IMPORTED_MODULE_7__module_uploadMod_src_uploadMod___default.a,
    XkUpAvatar: __WEBPACK_IMPORTED_MODULE_6__module_upAvatar_src_upAvatar_vue___default.a,
    XkUpImgDom: __WEBPACK_IMPORTED_MODULE_5__module_upImg_src_upImg___default.a,
    XkSiteInput: __WEBPACK_IMPORTED_MODULE_4__module_siteInput_src_siteInput___default.a,
    XkHintBox: __WEBPACK_IMPORTED_MODULE_1__module_hintBox_src_hintBox___default.a
  },
  name: 'compileNom',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    loginData: 'loginData'
  }), {
    SaveFn: function SaveFn() {
      var that = this;
      that.BoxSave = true;
    },
    avatarFn: function avatarFn() {
      if (this.avatar) {
        return window.configure.imgUrl + this.avatar;
      } else {
        return false;
      }
    },

    alwaysAddShowFn: function alwaysAddShowFn() {
      if (this.loginData.passenger) {
        return this.loginData.passenger.other.memberUsual;
      }
    }
  }),
  data: function data() {
    return {
      gender: false,
      BoxSave: false,
      name: '',
      phone: '',
      memberEcn: null,
      memberEcp: null,
      avatar: null,
      upAvatarState: false,
      hintBox: {
        stateShow: false,
        state: 'yes',
        content: ''
      },
      version: null,
      headPortrait: null
    };
  },

  watch: {
    loginData: function loginData(val) {
      console.log('更新', val);
      var passenger = val.passenger;
      this.name = passenger.name;
      this.phone = passenger.phone;
      this.version = passenger.version;
      this.avatar = passenger.avatar;
      this.gender = passenger.gender === 1;
      this.memberEcn = passenger.urgent_name;
      this.memberEcp = passenger.urgent_phone;
    }
  },
  methods: {
    genderFn: function genderFn(type) {
      var that = this;
      switch (type) {
        case '男':
          that.gender = true;
          break;
        case '女':
          that.gender = false;
      }
    },
    amendPersonalData: function amendPersonalData() {
      var that = this;
      that.$store.dispatch('putPassenger', {
        id: window.configure.passengerInfo.id,
        'name': this.name,
        'gender': this.gender ? '1' : '0',
        'phone': this.phone,
        'urgent_name': this.memberEcn,
        'urgent_phone': this.memberEcp,
        'avatar': this.avatar || null,
        'version': this.version,
        fn: function fn(data) {
          that.BoxSave = false;
          if (data && data.code === 1) {
            that.hintBox = {
              stateShow: true,
              state: 'yes',
              content: '保存成功！'
            };
            that.getPassengerFn();
            setTimeout(function () {
              that.hintBox = false;
            }, 1500);
          }
        }
      });
    },
    SaveButFn: function SaveButFn() {
      var that = this;
      if (this.name !== '') {
        if (this.memberEcn === '') {
          that.hintBox = {
            stateShow: true,
            state: 'no',
            content: '紧急联系人不能为空'
          };
          setTimeout(function () {
            that.hintBox = false;
          }, 1500);
          return false;
        }
        if (this.memberEcp !== '') {
          if (!__WEBPACK_IMPORTED_MODULE_3__assets_js_method__["a" /* default */].checkPhone(this.memberEcp)) {
            that.hintBox = {
              stateShow: true,
              state: 'no',
              content: '请填写正确的紧急联系人电话'
            };
            setTimeout(function () {
              that.hintBox = false;
            }, 1500);
            return false;
          }
        } else {
          that.hintBox = {
            stateShow: true,
            state: 'no',
            content: '紧急联系人电话不能为空'
          };
          setTimeout(function () {
            that.hintBox = false;
          }, 1500);
          return false;
        }
        that.BoxSave = true;
        that.amendPersonalData();
      } else {
        that.hintBox = {
          stateShow: true,
          state: 'no',
          content: '姓名不能为空！'
        };
        setTimeout(function () {
          that.hintBox = false;
        }, 1500);
        return false;
      }
    },
    upAvatarFn: function upAvatarFn(success) {
      var that = this;
      if (success && success.code === 200) {
        that.avatar = success.fileId;
        that.hintBox = {
          stateShow: true,
          state: 'yes',
          content: '上传成功！'
        };
        setTimeout(function () {
          that.hintBox.stateShow = false;
        }, 1500);
        that.amendPersonalData();
      } else {
        that.hintBox = {
          stateShow: true,
          state: 'no',
          content: '上传失败！'
        };
        setTimeout(function () {
          that.hintBox.stateShow = false;
        }, 1500);
      }
      this.upAvatarState = false;
    },
    upAvatarStateFn: function upAvatarStateFn() {
      this.upAvatarState = true;
    },
    getPassengerFn: function getPassengerFn() {
      var that = this;
      that.$store.dispatch('getPassenger', {
        id: window.configure.passengerInfo.id
      });
    }
  },
  mounted: function mounted() {
    var that = this;
    that.$store.dispatch('checkLogin', function (state) {
      that.getPassengerFn();
    });
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tabs',
  props: {
    tabs: {
      default: function _default() {
        return [];
      }
    },
    active: {
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      value: this.active,
      width: ''
    };
  },

  watch: {
    active: function active(val) {
      this.value = val;
      console.log('激活的菜单变化', val);
      var index = this.tabs.findIndex(function (value) {
        return value.active === val;
      });
      this.lineStyleFn(index);
    }
  },
  methods: {
    touchstartFn: function touchstartFn(active, index) {
      this.value = active;
      this.$emit('update:active', active);
      this.$emit('activeFn', active);
      this.lineStyleFn(index);
    },
    lineStyleFn: function lineStyleFn(index) {
      var oStyle = document.getElementById('tabs-active-style');
      var oSpan = document.getElementById('tabs-active-style').getElementsByTagName('span')[0];
      var oStyleSpan = document.getElementsByClassName('boss-tabs-item-span')[index];
      oSpan.style.width = oStyleSpan.offsetWidth ? oStyleSpan.offsetWidth + 'px' : '';
      var dis = this.width * index;
      oStyle.style.transform = 'translateX(' + dis + 'px)';
    },
    touchLeftRight: function touchLeftRight(el) {
      var _this = this;

      var startX = 0;
      var startY = 0;
      var endX = 0;
      var endY = 0;
      el.ontouchstart = function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      };
      el.ontouchend = function (e) {
        endX = e.changedTouches[0].clientX;
        endY = e.changedTouches[0].clientY;
        var index = _this.tabs.findIndex(function (value) {
          return value.active === _this.active;
        });
        var x = endX - startX;

        var tan = Math.abs(endY - startY) / Math.abs(endX - startX);
        var a = Math.atan(tan) * (180 / Math.PI);
        if (Math.abs(endX - startX) > 10) {
          if (a < 30) {
            if (x < 0) {
              var len = _this.tabs.length - 1;
              if (index < len) {
                _this.value = _this.tabs[index + 1].active;
                _this.$emit('update:active', _this.value);
                _this.$emit('activeFn', _this.value);
              }
            }
            if (x > 0) {
              if (index > 0) {
                _this.value = _this.tabs[index - 1].active;
                _this.$emit('update:active', _this.value);
                _this.$emit('activeFn', _this.value);
              }
            }
          }
        }
      };
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      console.log(_this2.$el.parentNode);
      var oUl = document.getElementsByTagName('ul')[0];
      _this2.width = oUl.offsetWidth / _this2.tabs.length;
      var index = _this2.tabs.findIndex(function (value) {
        return value.active === _this2.active;
      });
      _this2.lineStyleFn(index);
      var el = _this2.$el.parentNode;
      _this2.touchLeftRight(el);
    });
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_json_bigint_xk__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'affirm',
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    loginData: 'loginData'
  })),
  data: function data() {
    return {
      rows: 10,
      page: 1,
      total: 0,
      content: [] };
  },

  methods: {
    scrollFn: function scrollFn(e) {
      var scrollTop = e.currentTarget.scrollTop;
      var scrollHeight = e.currentTarget.scrollHeight;
      var offsetHeight = e.currentTarget.offsetHeight;
      var top = Number(scrollTop + offsetHeight);
      if (top === scrollHeight) {
        if (this.content.length < this.total) {
          this.page++;
          this.getListFn();
        }
      }
    },
    getListFn: function getListFn() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, cookieAppKey, passengerKey, passenger, params, data, content;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = '/v1/queryMyRelation';
                cookieAppKey = _this.$Cookie.get('cookieAppKey') ? _this.$Cookie.get('cookieAppKey') : null;

                console.log('loginData', _this.loginData);
                passengerKey = 'passenger' + cookieAppKey;
                passenger = _this.$Cookie.get(passengerKey) ? __WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(_this.$Tool.aesDecryptCode(_this.$Cookie.get(passengerKey))) : null;
                params = {
                  phone: passenger.passenger.phone,
                  referee_id: passenger.passenger.id,
                  referee_type: 2,
                  limit: _this.rows,
                  page: _this.page
                };
                _context.next = 8;
                return _this.$axios.get(url, params);

              case 8:
                data = _context.sent;

                if (data && data.code === 1) {
                  _this.total = data.total || 0;
                  content = data.relation || [];

                  if (_this.page === 1) {
                    _this.content = content;
                  } else if (_this.page > 1) {
                    _this.orderList = _this.orderList.concat(content);
                  }
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    this.getListFn();
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_informTimeMod_src_informTimeMod__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_informTimeMod_src_informTimeMod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__module_informTimeMod_src_informTimeMod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_pull_to__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_pull_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_pull_to__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { XkInformTimeMod: __WEBPACK_IMPORTED_MODULE_2__module_informTimeMod_src_informTimeMod___default.a, PullTo: __WEBPACK_IMPORTED_MODULE_4_vue_pull_to___default.a },
  name: 'Inform',
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    loginData: 'loginData'
  })),
  data: function data() {
    return {
      page: 1,
      rows: 10,
      content: []
    };
  },

  methods: {
    loadDataButFn: function loadDataButFn(_fn, type) {
      var that = this;
      that.$store.dispatch('getNotice', {
        'passengerId': that.loginData.passenger.id,
        'page': that.page,
        'limit': that.rows,
        fn: function fn(data) {
          if (_fn) {
            _fn();
          }
          if (data && data.code === 1) {
            if (type) {
              that.content = data.noticeRecords || [];
            } else {
              that.content = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(that.content), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.noticeRecords));
            }
          }
        }
      });
    },
    bottomChangeFn: function bottomChangeFn(loaded) {
      this.page++;
      this.loadDataButFn(function () {
        loaded('done');
      });
    },
    topChangeFn: function topChangeFn(loaded) {
      this.page = 1;
      this.loadDataButFn(function () {
        loaded('done');
      }, true);
    }
  },
  mounted: function mounted() {
    var that = this;
    that.$store.dispatch('checkLogin', function (state) {
      if (state) {
        that.loadDataButFn();
      }
    });
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_mc__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'slideVerify',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    phone: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
    companyInfo: 'companyInfo'
  })),
  data: function data() {
    return {
      showModle: false,
      url: window.configure.imgUrl,
      imgObj: {},
      progressValue: 0,
      startTime: 0,
      startX: 0
    };
  },

  watch: {
    visible: {
      handler: function handler() {
        this.showModle = this.visible;
        this.showModle && this.initPic();
      },

      deep: true,
      immediate: true
    }
  },
  mounted: function mounted() {},

  methods: {
    initPic: function initPic() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_3__api_mc__["a" /* default */].getUsePic({
                  phone: _this.phone,
                  type: 2,
                  app_key: _this.companyInfo.app_key,
                  company_id: _this.companyInfo.id
                }, function (_ref) {
                  var code = _ref.code,
                      Pic = _ref.Pic;

                  console.log(code, 222);
                  if (code === 1) {
                    _this.imgObj = Pic;
                    _this.initValue();
                  }
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    sliderDown: function sliderDown(event) {
      console.log(event, 'sliderDown');
    },
    touchStartEvent: function touchStartEvent(event) {
      this.startTime = Date.now();
      this.startX = event.changedTouches[0].pageX;
    },
    outModel: function outModel() {
      this.$emit('update:visible', false);
    },
    handleMoveEvent: function handleMoveEvent(event) {
      var x = event.changedTouches[0].pageX;
      if (x > this.startX) {
        if (x - this.startX > 261) {
          this.progressValue = 261;
        } else {
          this.progressValue = x - this.startX;
        }
      } else {
        this.progressValue = 0;
      }
    },
    initValue: function initValue() {
      this.progressValue = 0;
      this.startTime = 0;
    },
    handleMoveEndEvent: function handleMoveEndEvent(event) {
      var x = event.changedTouches[0].pageX;
      if (x > this.startX) {
        if (x - this.startX > 261) {
          this.progressValue = 261;
        } else {
          this.progressValue = x - this.startX;
        }
      } else {
        this.progressValue = 0;
      }
      var endTime = new Date().getTime();
      var proportion = this.progressValue / 305;
      this.$emit('dragEnd', {
        image_code: endTime - this.startTime + ',' + proportion
      });
    }
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_method__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_alertBox_src_alertBox__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_alertBox_src_alertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__module_alertBox_src_alertBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module_hintBox_src_hintBox__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module_hintBox_src_hintBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__module_hintBox_src_hintBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_slideVerify_vue__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_slideVerify_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_slideVerify_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    XkHintBox: __WEBPACK_IMPORTED_MODULE_4__module_hintBox_src_hintBox___default.a,
    XkAlertBox: __WEBPACK_IMPORTED_MODULE_3__module_alertBox_src_alertBox___default.a,
    slideVerify: __WEBPACK_IMPORTED_MODULE_6__components_slideVerify_vue___default.a
  },
  data: function data() {
    return {
      forgetState: false,
      phoneLength: '11',
      phoneRegion: '中国 +86',
      phoneRegionUl: false,
      phoneNo: '',
      phoneAes: null,
      smsCode: '',
      imgCode: '',
      password: '',
      imgCodeUrl: null,
      loginState: false,
      alertText: '',
      hintBox: {
        stateShow: false,
        state: 'yes',
        content: ''
      },
      time: '',
      country: '中国',
      phoneCodeText: '获取短信验证码',
      imgCodeState: false,
      newUserState: false,
      step: null,
      factor: null,
      hasPassword: true,
      showSmsInput: true,
      agree: true,
      visible: false,
      loading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    positioning: 'positioning',
    companyInfo: 'companyInfo',
    infoData: 'infoData',
    login: 'login',
    loginData: 'loginData'
  }), {
    imgUrlFn: function imgUrlFn() {
      this.$store.dispatch('validateState', { state: true, text: '获取验证码' });
    },
    numCodeButStateFn: function numCodeButStateFn() {
      if (__WEBPACK_IMPORTED_MODULE_1__assets_js_method__["a" /* default */].checkPhone(this.phoneNo)) {
        return true;
      }
      return false;
    }
  }),
  watch: {
    login: function login(val) {
      if (val) {
        var appKey = __WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a.get('cookieAppKey') ? __WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a.get('cookieAppKey') : window.configure.appKey;
        this.$router.push({ path: '/daijia', query: { app_key: appKey } });
      }
    }
  },
  mounted: function mounted() {
    if (this.$route.query.tel) {
      this.phoneNo = this.$route.query.tel;
      this.loginStateFn(1);
    }
  },

  methods: {
    loginButFn: function loginButFn() {
      if (!this.loginState) {
        return;
      }
      if (this.newUserState || this.forgetState) {
        this.postRegisterFn();
      } else {
        if (this.hasPassword) {
          this.postEmployLoginFn();
        } else {
          if (this.factor === 1) {
            this.postRegisterFn();
          } else {
            this.postEmployLoginFn();
          }
        }
      }
    },
    postEmployLoginFn: function postEmployLoginFn() {
      var that = this;
      var pw = null;
      if (that.password) {
        pw = that.$utils.aesEncryptCode(that.password);
      }
      that.$store.dispatch('postLogin', {
        phone: that.phoneAes,
        country: that.country,
        open_id: window.configure.open_id,
        password: pw,
        fn: function fn(state, code) {
          console.log(state, code);
          that.loginState = false;
          if (code === 20051 || code === 20048) {
            that.hintBox = {
              stateShow: true,
              state: 'no',
              content: '密码错误'
            };
            setTimeout(function () {
              that.hintBox.stateShow = false;
              return false;
            }, 1500);
            return false;
          }
          that.phoneNo = '';
          that.password = '';
          that.imgCode = '';
          that.smsCode = '';
          that.step = null;
          that.$router.push('/');
        }
      });
    },

    RegionButFn: function RegionButFn(val) {
      var that = this;
      if (typeof val === 'string') {
        that.phoneRegion = val;
      }
      that.phoneRegionUl = !that.phoneRegionUl;
    },
    getSmsCodeFn: function getSmsCodeFn(row) {
      var that = this;
      if (that.phoneCodeText !== '获取短信验证码') {
        that.hintBox = {
          stateShow: true,
          state: 'no',
          content: '您登陆过于频繁，请两分钟后再登陆'
        };
        setTimeout(function () {
          that.hintBox.stateShow = false;
        }, 10000);
        that.showSmsInput = false;
        return;
      }
      that.showSmsInput = true;
      console.log(that.companyInfo);
      that.$store.dispatch('getSmsCode', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        country: that.country,
        phone: that.phoneAes,
        company_id: that.companyInfo.id
      }, row, {
        fn: function fn(data) {
          if (data && data.code === 1) {
            that.phoneCodeTextFn(120);
            that.visible = false;
          } else if (data.code === 121199) {
            that.visible = true;
          } else if (data.code === 121205 || data.code === 121203) {
            that.$refs.slideVerify.initPic();
          } else if (data.code === 121209) {
            that.visible = false;
          } else {
            that.$refs.slideVerify.initValue();
          }
          var msgCode = {
            121200: '您操作的太快啦,请重试',
            121201: '您操作的太慢啦,请重试',
            121202: '验证错误,请重试',
            121209: '短信验证码获取频繁，请稍后重试',
            121205: "已过期,请重试",
            121203: "已过期,请重试"
          };
          if (msgCode[data.code]) {
            that.hintBox = {
              stateShow: true,
              state: 'no',
              content: msgCode[data.code]
            };
            setTimeout(function () {
              that.hintBox.stateShow = false;
              return false;
            }, 1000);
          }
        }
      }));
    },
    phoneCodeTextFn: function phoneCodeTextFn(num) {
      var that = this;
      var countFn = function countFn() {
        num--;
        if (num <= 0) {
          that.phoneCodeText = '获取短信验证码';
        } else {
          that.phoneCodeText = num + 's';
          setTimeout(function () {
            countFn(num);
          }, 1000);
        }
      };
      countFn(num);
    },
    postCheckCodeFn: function postCheckCodeFn(code, codeType) {
      var that = this;
      that.$store.dispatch('postCheckCode', {
        country: that.country,
        phone: that.phoneAes,
        code: code,
        code_type: codeType,
        fn: function fn(data) {
          if (data && data.code === 1) {
            if (codeType === 'pic') {
              that.imgCodeState = true;
              that.getSmsCodeFn();
              if (that.showSmsInput) {
                that.step = 2;
              }
            }
            if (codeType === 'sms') {
              if (that.newUserState) {
                that.loginState = true;
              }
              if (!that.newUserState) {
                if (that.hasPassword) {
                  that.loginState = true;
                }
                if (!that.hasPassword) {
                  if (that.factor === 1 || that.forgetState) {
                    that.step = 5;
                  } else {
                    that.loginState = true;
                  }
                }
              }
            }
          } else {
            that.hintBox = {
              stateShow: true,
              state: 'no',
              content: '验证码错误'
            };
            setTimeout(function () {
              that.hintBox.stateShow = false;
            }, 1000);
          }
        }
      });
    },
    getCheckUserFn: function getCheckUserFn() {
      var that = this;
      that.$store.dispatch('getCheckUser', {
        phone: that.phoneAes,
        country: that.country,
        fn: function fn(data) {
          if (data.code === 50013 || data.code === 50014) {
            that.newUserState = false;
            if (data.msg.indexOf('has password') !== -1) {
              that.hasPassword = true;
              if (data.factor === 1) {
                that.step = 3;
              } else {
                that.step = 6;
              }
            } else {
              that.hasPassword = false;
              that.step = 2;
            }
          } else if (data.code === 30044) {
            that.step = 2;

            that.newUserState = true;
          }
          that.factor = data.factor;
        }
      });
    },
    postRegisterFn: function postRegisterFn() {
      var that = this;
      var pw = null;
      var appKey = __WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a.get('cookieAppKey') ? __WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a.get('cookieAppKey') : window.configure.appKey;
      if (that.password && that.password !== '') {
        pw = that.$utils.aesEncryptCode(that.password);
      }
      that.$store.dispatch('postRegister', {
        password: pw,
        phone: that.phoneAes,
        channel: 'wechat',
        country: that.country,
        open_id: window.configure.open_id,
        fn: function fn(data) {
          if (data && data.code === 1) {
            that.forgetState = false;
            that.loginState = false;
            that.step = null;
            that.phoneNo = '';
            that.password = '';
            that.imgCode = '';
            that.smsCode = '';
            that.$router.push({ path: '/daijia', query: { app_key: appKey } });
          } else {
            console.log("111111111");
            that.hintBox = {
              stateShow: true,
              state: 'no',
              content: data.msg
            };
            setTimeout(function () {
              that.hintBox.stateShow = false;
              return false;
            }, 1000);
          }
        }
      });
    },
    forgetFn: function forgetFn() {
      this.forgetState = true;
      this.step = 1;
      this.getImgCodeFn();
      this.newUserState = true;
    },

    loginStateFn: function loginStateFn(num) {
      var that = this;
      switch (num) {
        case 1:
          if (that.$utils.checkPhone(that.phoneNo)) {
            that.phoneAes = that.$utils.aesEncryptCode(that.phoneNo);
            that.getCheckUserFn();
          } else {
            that.step = null;
          }
          break;
        case 2:
          if (that.imgCodeUrl === that.imgCode) {
            that.postCheckCodeFn(that.$utils.aesEncryptCode(that.imgCode), 'pic');
          } else {
            that.imgCodeState = false;
          }
          break;
        case 3:
          if (that.smsCode.length === 4) {
            that.postCheckCodeFn(that.$utils.aesEncryptCode(that.smsCode), 'sms');
          } else {
            that.imgCodeState = false;
          }
          break;
        case 4:
          break;
        case 5:
          if (that.password.length >= 6) {
            that.loginState = true;
          } else {
            that.loginState = false;
          }
          break;
        case 6:
          if (that.password.length >= 6) {
            that.loginState = true;
          } else {
            that.loginState = false;
          }
          break;
      }
    },
    nextStep: function nextStep() {
      var that = this;
      if (that.password.length >= 6) {
        if (that.newUserState) {
          that.loginState = true;
        }
        if (!that.newUserState) {
          if (that.hasPassword) {
            if (that.factor === 1) {
              that.step = 1;

              that.getImgCodeFn();
            } else {
              that.loginState = true;
            }
          }
          if (!that.hasPassword) {
            that.loginState = true;
          }
        }
      } else {
        that.loginState = false;
      }
    },

    userxieyiFn: function userxieyiFn() {
      this.$store.dispatch('loginAction', { state: true });
      this.$router.push('/serviceAgreement');
    },
    getImgCodeFn: function getImgCodeFn() {
      var that = this;
      that.imgCode = null;
      this.$store.dispatch('getImgCode', {
        phone: that.$utils.aesEncryptCode(that.phoneNo),
        country: that.country,
        fn: function fn(data) {
          if (data && data.code === 1) {
            that.imgCodeUrl = that.$utils.aesDecryptCode(data.data);
          }
        }
      });
    },
    cancleFn: function cancleFn() {
      this.$router.go(-1);
    },
    changeToUnAgreeFn: function changeToUnAgreeFn() {
      this.agree = false;
    },
    changeToAgreenFn: function changeToAgreenFn() {
      this.agree = true;
    }
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__module_capitalRecordList_src_capitalRecordList__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__module_capitalRecordList_src_capitalRecordList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__module_capitalRecordList_src_capitalRecordList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_method__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module_uploadMod_src_uploadMod__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module_uploadMod_src_uploadMod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__module_uploadMod_src_uploadMod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_alertBox_src_alertBox__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_alertBox_src_alertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__module_alertBox_src_alertBox__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    XkAlertBox: __WEBPACK_IMPORTED_MODULE_5__module_alertBox_src_alertBox___default.a,
    XkUploadMod: __WEBPACK_IMPORTED_MODULE_4__module_uploadMod_src_uploadMod___default.a,
    XkCapitalRecordList: __WEBPACK_IMPORTED_MODULE_1__module_capitalRecordList_src_capitalRecordList___default.a
  },
  name: 'affirm',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    loginData: 'loginData',
    capitalRecords: 'capitalRecords'
  }), {
    listFn: function listFn() {
      var that = this;
      var content = that.capitalRecords.content;
      for (var i = 0; i < content.length; i++) {
        if (typeof content[i].recordCreatedStr !== 'string') {
          content[i].recordCreatedStr = __WEBPACK_IMPORTED_MODULE_2__assets_js_method__["a" /* default */].TimestampDate(content[i].recordCreatedStr);
        }
      }
      return content;
    }
  }),
  data: function data() {
    return {
      page: 1,
      rows: 20,
      loadState: false,
      customerPreSaveSerials: [],
      text: ''
    };
  },

  methods: {
    loadButFn: function loadButFn() {
      var that = this;
      that.page++;
      that.loadFn();
    },
    loadFn: function loadFn() {
      var that = this;
      that.$store.dispatch('checkLogin', function (state) {
        if (state) {
          that.loadState = true;
          that.$store.dispatch('getCustomerPreSaveSerials', {
            'cid': that.loginData.passenger.id,
            'page': that.page,
            'limit': that.rows,
            fn: function fn(data) {
              that.loadState = false;
              if (data && data.code === 1) {
                that.customerPreSaveSerials = data.customerPreSaveSerials;
              }
            }
          });
        }
      });
    },
    actionFn: function actionFn(val) {
      var _this = this;

      if (val && val !== '') {
        this.text = val;
      } else {
        this.text = '暂无信息';
      }
      setTimeout(function () {
        _this.text = '';
      }, 1500);
    }
  },
  watch: {},
  mounted: function mounted() {
    var that = this;
    that.$store.dispatch('checkLogin', function (state) {
      if (state) {
        that.loadFn();
      }
    });
  }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__module_couponNav_src_couponNav__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__module_couponNav_src_couponNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__module_couponNav_src_couponNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    XkCouponNav: __WEBPACK_IMPORTED_MODULE_1__module_couponNav_src_couponNav___default.a
  },
  name: '',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    allCouponsGetter: 'allCouponsGetter'
  }), {
    navDataFn: function navDataFn() {
      var that = this;
      return [{
        name: '未使用',
        num: that.unusedCoupons ? that.unusedCoupons.length : 0,
        router: '/coupon/nused'
      }, {
        name: '使用记录',
        num: that.usedCoupons ? that.usedCoupons.length : 0,
        router: '/coupon/used'
      }, {
        name: '已失效',
        num: that.expireCoupons ? that.expireCoupons.length : 0,
        router: '/coupon/stale'
      }];
    },
    v5zcCoupon: function v5zcCoupon() {
      var that = this;
      var allCoupons = this.allCouponsGetter ? this.allCouponsGetter : [];
      if (allCoupons && allCoupons.length > 0) {
        allCoupons.forEach(function (index, row) {
          console.log(index, row);
          if (row.state === 1) {
            that.unusedCoupons.push(row);
          } else if (row.state === 2) {
            that.usedCoupons.push(row);
          } else if (row.state === 3) {
            that.expireCoupons.push(row);
          }
        });
      }
    }
  }),
  data: function data() {
    return {
      unusedCoupons: [],
      usedCoupons: [],
      expireCoupons: []
    };
  },

  mounted: function mounted() {
    console.log('v5ZcCouponsGetter', this.v5ZcCouponsGetter);
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_method__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_hintBox_src_hintBox__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_hintBox_src_hintBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__module_hintBox_src_hintBox__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  components: {
    XkHintBox: __WEBPACK_IMPORTED_MODULE_3__module_hintBox_src_hintBox___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    expireCoupons: 'expireCoupons',
    expireCouponGetter: 'expireCouponGetter',
    loginData: 'loginData'
  }), {
    couponsFn: function couponsFn() {
      var that = this;
      var content = that.expireCouponGetter;
      var list = [];
      for (var i = 0; i < content.length; i++) {
        var obj = {
          type: 'daijia',
          title: '代驾专享',
          sum: 30,
          startTime: '2017-03-05',
          endTime: '2017-06-06',
          couponType: 'money',
          serviceType: ''
        };

        obj.title = content[i].title;
        obj.startTime = __WEBPACK_IMPORTED_MODULE_2__assets_js_method__["a" /* default */].TimestampDate(content[i].begin_time).split(' ')[0];
        obj.endTime = __WEBPACK_IMPORTED_MODULE_2__assets_js_method__["a" /* default */].TimestampDate(content[i].end_time).split(' ')[0].indexOf('1970-01-01') < 0 ? __WEBPACK_IMPORTED_MODULE_2__assets_js_method__["a" /* default */].TimestampDate(content[i].end_time).split(' ')[0] : '永久有效';
        obj.sum = content[i].deductible ? content[i].deductible.toFixed(1) : content[i].discount / 10;
        if (content[i].discount) {
          obj.couponType = 'discount';
        } else {
          obj.couponType = 'deduction';
        }
        if (content[i].main_service_type === 'daijia') {
          obj.serviceType = '代驾券';
        }
        list.push(obj);
      }
      return list;
    }
  }),
  data: function data() {
    return {
      page: 1,
      rows: 10,
      couponData: [],
      total: 0,
      hintBox: {
        stateShow: false,
        state: 'yes',
        content: ''
      }
    };
  },

  methods: {
    loadMoreButFn: function loadMoreButFn() {
      var that = this;
      that.page += 1;
      that.$store.dispatch('getCouponType', {
        channel: 'system',
        page: that.page,
        limit: 80,
        'fn': function fn(data) {
          that.loadState = false;
          if (data && data.code === 1) {
            that.total = data.total;
            var arr = [];
            if (data.coupon) {
              var _that$couponData;

              data.coupon.forEach(function (item) {
                if (item.state === 3) {
                  arr.push(item);
                }
              });
              that.couponData = (_that$couponData = that.couponData).concat.apply(_that$couponData, arr);
            } else {
              that.hintBox = {
                stateShow: true,
                state: 'no',
                content: '没有更多优惠券了喔~'
              };
              setTimeout(function () {
                that.hintBox.stateShow = false;
              }, 1000);
            }
          }
        }
      });
    },
    getCoupons: function getCoupons() {
      var that = this;
      that.$store.dispatch('checkLogin', function (state) {
        if (state) {
          that.$store.dispatch('getCouponType', {
            channel: 'system',
            page: that.page,
            limit: 80,
            'fn': function fn(data) {
              that.loadState = false;
              if (data && data.code === 1) {
                var _that$couponData2;

                that.total = data.total;
                var arr = [];
                data.coupon.forEach(function (item) {
                  if (item.state === 3) {
                    arr.push(item);
                  }
                });
                that.couponData = (_that$couponData2 = that.couponData).concat.apply(_that$couponData2, arr);
              }
            }
          });
        }
      });
    }
  },
  mounted: function mounted() {
    this.loadState = true;
    this.getCoupons();
  }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_method__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_couponMod_src_couponMod__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_couponMod_src_couponMod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__module_couponMod_src_couponMod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_inputBox_src_inputBox__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_inputBox_src_inputBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__module_inputBox_src_inputBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_uploadMod_src_uploadMod__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_uploadMod_src_uploadMod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__module_uploadMod_src_uploadMod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__module_hintBox_src_hintBox__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__module_hintBox_src_hintBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__module_hintBox_src_hintBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_cookie__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_json_bigint_xk__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_json_bigint_xk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_json_bigint_xk__);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    XkHintBox: __WEBPACK_IMPORTED_MODULE_6__module_hintBox_src_hintBox___default.a,
    XkUploadMod: __WEBPACK_IMPORTED_MODULE_5__module_uploadMod_src_uploadMod___default.a,
    XkInputBox: __WEBPACK_IMPORTED_MODULE_3__module_inputBox_src_inputBox___default.a,
    XkCouponMod: __WEBPACK_IMPORTED_MODULE_2__module_couponMod_src_couponMod___default.a
  },
  name: '',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
    unusedCoupons: 'unusedCoupons',
    loginData: 'loginData'
  }), {
    couponsFn: function couponsFn() {
      var that = this;
      var content = that.couponData;
      console.log("sssssss", content);

      var list = [];
      for (var i = 0; i < content.length; i++) {
        var obj = {
          type: '',
          title: '代驾专享',
          sum: 30,
          startTime: '2017-03-05',
          endTime: '2017-06-06',
          overdueTime: '2',
          couponType: '',
          servicetype: ''
        };
        var date = new Date();
        var SZdate = new Date(content[i].end_time * 1000);
        obj.title = content[i].title;
        obj.startTime = __WEBPACK_IMPORTED_MODULE_1__assets_js_method__["a" /* default */].TimestampDate(content[i].begin_time).split(' ')[0];
        obj.endTime = __WEBPACK_IMPORTED_MODULE_1__assets_js_method__["a" /* default */].TimestampDate(content[i].end_time).split(' ')[0] !== '1970-01-01' ? __WEBPACK_IMPORTED_MODULE_1__assets_js_method__["a" /* default */].TimestampDate(content[i].end_time).split(' ')[0] : '永久有效';
        obj.sum = content[i].deductible ? content[i].deductible.toFixed(1) : content[i].discount;
        if (content[i].discount) {
          obj.couponType = 'discount';
        } else {
          obj.couponType = 'deduction';
        }
        if (content[i].end_time && __WEBPACK_IMPORTED_MODULE_1__assets_js_method__["a" /* default */].TimestampDate(content[i].end_time).split(' ')[0] !== '1970-01-01') {
          obj.overdueTime = SZdate.getFullYear() - date.getFullYear() > 0 ? SZdate.getFullYear() - date.getFullYear() + '年' : SZdate.getMonth() - date.getMonth() > 0 ? SZdate.getMonth() - date.getMonth() + '月' : SZdate.getDate() - date.getDate() > 0 ? SZdate.getDate() - date.getDate() + '天' : SZdate.getHours() - date.getHours() > 0 ? SZdate.getHours() - date.getHours() + '时' + (SZdate.getMinutes() - date.getMinutes()) + '分' : SZdate.getMinutes() - date.getMinutes() > 0 ? SZdate.getMinutes() - date.getMinutes() + '分' : null;
        } else {
          obj.overdueTime = '永久有效';
        }
        if (content[i].main_service_type === 'daijia') {
          obj.servicetype = '代驾券';
        }
        list.push(obj);
      }
      return list;
    }
  }),
  data: function data() {
    return {
      couponData: [],
      addStateBut: false,
      addState: false,
      couponNum: '',
      couponPassword: '',
      separator1: false,
      separator2: false,
      loadState: false,
      page: 1,
      rows: 100,
      hintBox: {
        stateShow: false,
        state: 'yes',
        router: ''
      }
    };
  },

  methods: {
    addCouponFn: function addCouponFn(state) {
      var that = this;
      if (!that.addState) {
        that.couponNum = '';
      }
      var cookieAppKey = __WEBPACK_IMPORTED_MODULE_7_js_cookie___default.a.get('cookieAppKey') ? __WEBPACK_IMPORTED_MODULE_7_js_cookie___default.a.get('cookieAppKey') : null;
      that.addState = true;
      var appKey = this.$Cookie.get('cookieAppKey');
      var passengerkey = 'passenger' + appKey;
      var passenger = this.$Cookie.get(passengerkey) ? __WEBPACK_IMPORTED_MODULE_8_json_bigint_xk___default.a.parse(this.$Tool.aesDecryptCode(this.$Cookie.get(passengerkey))) : null;
      var coupon_id = that.couponNum;
      var couponId = parseInt(coupon_id.slice(-6));
      var ruleNo = coupon_id.split(coupon_id.slice(-6))[0];
      if (state === 'affirm') {
        var content = '';
        if (that.couponNum === '') {
          content = '优惠券号不能为空！';
        }
        if (that.couponNum === '') {
          that.hintBox = {
            stateShow: true,
            state: 'no',
            content: content,
            router: null
          };
          setTimeout(function () {
            that.hintBox.stateShow = false;
          }, 1500);
          return;
        }
        if (couponId === 0 || isNaN(couponId)) {
          content = '请输入正确的优惠券编码！';
        }
        if (couponId === 0 || isNaN(couponId)) {
          that.hintBox = {
            stateShow: true,
            state: 'no',
            content: content,
            router: null
          };
          setTimeout(function () {
            that.hintBox.stateShow = false;
          }, 1500);
          return;
        }
        if (!ruleNo) {
          content = '请输入正确的优惠券编码！';
        }
        if (!ruleNo) {
          that.hintBox = {
            stateShow: true,
            state: 'no',
            content: content,
            router: null
          };
          setTimeout(function () {
            that.hintBox.stateShow = false;
          }, 1500);
          return;
        }
        that.loadState = true;
        that.$store.dispatch('addCoupon', {
          'passenger_id': passenger && passenger.passenger && passenger.passenger.id ? passenger.passenger.id : '',
          'rule_id': couponId,
          'num': 1,
          'rule_no': ruleNo,
          'channel': 5,
          'app_key': cookieAppKey,
          fn: function fn(data) {
            that.loadState = false;
            var content = '';
            var router = '';
            var state = '';
            if (data && data.code === 1) {
              content = '添加成功！';
              state = 'yes';
            } else if (data.code === 110521) {
              content = '\u4F18\u60E0\u5377\u7F16\u7801\u6709\u8BEF';state = 'no';
            } else if (data.code === 110402) {
              content = '\u4F18\u60E0\u5377\u89C4\u5219\u5DF2\u5931\u6548';state = 'no';
            } else if (data.code === 110501) {
              content = '\u4F18\u60E0\u5377\u5355\u4EBA\u9886\u53D6\u6570\u91CF\u8FBE\u4E0A\u9650';state = 'no';
            } else if (data.code === 110502) {
              content = '\u4F18\u60E0\u5377\u603B\u6570\u9886\u53D6\u6570\u91CF\u8FBE\u4E0A\u9650';state = 'no';
            } else if (data.code === 110503) {
              content = '\u4F18\u60E0\u5377\u5DF2\u4F7F\u7528';state = 'no';
            } else if (data.code === 110504) {
              content = '\u4F18\u60E0\u5377\u5DF2\u5931\u6548';state = 'no';
            } else if (data.code === 110505) {
              content = '\u4F18\u60E0\u5377\u6CA1\u5728\u65F6\u95F4\u8303\u56F4';state = 'no';
            } else if (data.code === 110506) {
              content = '\u4F18\u60E0\u5377\u4E0D\u5728\u6E20\u9053\u8303\u56F4';state = 'no';
            } else if (data.code === 110507) {
              content = '\u4F18\u60E0\u5238\u5DF2\u8FC7\u671F';state = 'no';
            } else if (data.code === 110520) {
              content = '\u8D60\u9001\u7684\u4F18\u60E0\u5377\u6570\u91CF\u8FBE\u4E0A\u9650';state = 'no';
            } else {
              content = '\u4F18\u60E0\u5238\u6DFB\u52A0\u5931\u8D25';state = 'no';
            }
            that.hintBox = {
              stateShow: true,
              state: state,
              content: content,
              router: router
            };
            that.queryCouponsFn();
            setTimeout(function () {
              that.hintBox.stateShow = false;
              that.addState = false;
              if (that.$route.query.addState) {
                window.history.go(-1);
              }
            }, 1500);
          }
        });
      }
      if (state === 'cancel') {
        that.addState = false;
        if (that.$route.query.addState) {
          window.history.go(-1);
        }
      }
    },
    couponNumFn: function couponNumFn(e) {
      var val = e.target.value;
      this.couponNum = val.toUpperCase();
    },
    queryCouponsFn: function queryCouponsFn() {
      var that = this;
      that.$store.dispatch('checkLogin', function (state) {
        if (state) {
          that.$store.dispatch('v5getCoupons', {
            channel: 5,
            page: 1,
            limit: 80,
            is_invalid: 2,
            state: 1,
            'fn': function fn(data) {
              that.loadState = false;
              if (data && data.code === 1) {
                var arr = [];
                data.coupon.forEach(function (item) {
                  if (item.state === 1) {
                    var endTime = item.expire_time;
                    if (endTime) {
                      if (new Date().valueOf() < endTime * 1000) {
                        arr.push(item);
                      }
                    } else {
                      arr.push(item);
                    }
                  }
                });
                that.couponData = arr;
              } else {
                that.hintBox = {
                  stateShow: true,
                  state: 'no',
                  content: data.msg
                };
              }
            }
          });
        }
      });
    }
  },
  mounted: function mounted() {
    var that = this;

    that.$store.dispatch('checkLogin', function (state) {
      if (state) {
        that.queryCouponsFn();
        if (that.$route.query.addState) {
          that.addCouponFn();
        }
      }
    });
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_method__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    usedCoupons: 'usedCoupons',
    usedCouponGetter: 'usedCouponGetter',
    loginData: 'loginData'
  }), {
    couponsFn: function couponsFn() {
      var that = this;
      var content = that.couponData;
      var len = content && content.length > 0 ? content.length : 0;
      this.total = len;
      var list = [];
      if (len > 0) {
        for (var i = 0; i < content.length; i++) {
          var obj = {
            type: 'daijia',
            title: '代驾专享',
            sum: 30,
            startTime: '2017-03-05',
            endTime: '2017-06-06',
            serviceType: ''
          };

          obj.title = content[i].title;
          obj.startTime = __WEBPACK_IMPORTED_MODULE_2__assets_js_method__["a" /* default */].TimestampDate(content[i].begin_time).split(' ')[0];
          obj.endTime = __WEBPACK_IMPORTED_MODULE_2__assets_js_method__["a" /* default */].TimestampDate(content[i].end_time).split(' ')[0].indexOf('1970-01-01') < 0 ? __WEBPACK_IMPORTED_MODULE_2__assets_js_method__["a" /* default */].TimestampDate(content[i].end_time).split(' ')[0] : '永久有效';
          obj.sum = content[i].deductible ? content[i].deductible.toFixed(1) : content[i].discount / 10;
          if (content[i].discount) {
            obj.couponType = 'discount';
          } else {
            obj.couponType = 'deduction';
          }
          if (content[i].main_service_type === 'daijia') {
            obj.serviceType = '代驾券';
          }
          console.log('pwqoroewireituiertrijuehgjfghj', obj);
          list.push(obj);
        }
      }
      return list;
    }
  }),
  data: function data() {
    return {
      page: 1,
      rows: 10,
      total: 0,
      couponData: []
    };
  },

  methods: {
    loadMoreButFn: function loadMoreButFn() {
      var that = this;
      that.page += 1;
      that.$store.dispatch('getCouponType', {
        channel: 5,
        page: that.page,
        limit: 80,
        'fn': function fn(data) {
          that.loadState = false;
          if (data && data.code === 1) {
            var _that$couponData;

            that.total = data.total;
            var arr = [];
            data.coupon.forEach(function (item) {
              if (item.state === 2) {
                arr.push(item);
              }
            });
            that.couponData = (_that$couponData = that.couponData).concat.apply(_that$couponData, arr);
          }
        }
      });
    }
  },
  mounted: function mounted() {
    var that = this;
    that.loadState = true;
    that.$store.dispatch('checkLogin', function (state) {
      if (state) {
        that.$store.dispatch('v5getCoupons', {
          channel: 'system',
          page: 1,
          limit: 80,
          'fn': function fn(data) {
            that.loadState = false;
            if (data && data.code === 1) {
              that.total = data.total;
              var arr = [];
              data.coupon.forEach(function (item) {
                console.log(item);
                if (Number(item.state) === 2) {
                  arr.push(item);
                }
              });

              that.couponData = arr;
            } else {
              that.hintBox = {
                stateShow: true,
                state: 'no',
                content: data.msg
              };
            }
          }
        });
      }
    });
  }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_navTbas_src_navTabs_vue__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_navTbas_src_navTabs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__module_navTbas_src_navTabs_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { XkNavTabs: __WEBPACK_IMPORTED_MODULE_2__module_navTbas_src_navTabs_vue___default.a },
  name: 'invoice',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    servesTypeNav: 'servesTypeNav'
  })),
  data: function data() {
    return {
      ids: '',
      allState: false };
  },

  watch: {
    ids: function ids(_ids) {
      var state = true;
      var servesTypeNav = this.servesTypeNav;
      servesTypeNav.forEach(function (row) {
        if (!_ids.includes(row.business)) {
          state = false;
        }
      });
      this.allState = state;
    }
  },
  methods: {
    routerAcFn: function routerAcFn(path) {
      this.$router.push(path);
    },
    typeColAcFn: function typeColAcFn(id) {
      var ids = this.ids;
      if (ids) {
        if (ids.includes(id)) {
          this.ids = ids.replace(id + ',', '');
        }
      } else {
        this.ids += id + ',';
      }
    },
    typeColAllAcFn: function typeColAllAcFn() {
      var _this = this;

      var servesTypeNav = this.servesTypeNav;
      this.ids = '';
      if (!this.allState) {
        this.ids = '';
        servesTypeNav.forEach(function (row) {
          _this.ids += row.business + ',';
        });
      }
    },
    invoicePayFn: function invoicePayFn() {
      if (this.ids) {
        this.$router.push({ path: '/invoiceOrderRecord', query: { business: this.ids } });
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_hintBox_src_hintBox_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_hintBox_src_hintBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__module_hintBox_src_hintBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_pull_to__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_pull_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_pull_to__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { XkHintBox: __WEBPACK_IMPORTED_MODULE_2__module_hintBox_src_hintBox_vue___default.a, PullTo: __WEBPACK_IMPORTED_MODULE_3_vue_pull_to___default.a },
  name: 'invoiceApply',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    loginData: 'loginData'
  })),
  data: function data() {
    return {
      hintBox: {
        stateShow: false,
        state: 'yes',
        content: ''
      },
      form: {
        title: null,
        title_type: 1,
        invoices_type: 1,
        taxpayer_number: null,
        invoices_memo: null,
        invoices_amount: null,
        more_info: null,
        email: null,
        invoices_explain: null,
        addressee: null,
        telephone: null,
        area: null,
        address: null,
        postage: null,
        postage_pay_way: 1,
        invoices_amount_explain: null,
        driver_id: null,
        application_date: null,
        customer_id: null,
        order_type: null,
        customer_name: null }
    };
  },

  watch: {},
  methods: {
    applyFn: function applyFn() {
      var that = this;
      if (Number(this.Sum) <= Number(this.loginData.passenger.receiptMoney) && Number(this.Sum) > 0) {
        this.$store.dispatch('invoiceApply', {
          'phone': that.loginData.passenger.phone,
          'money': that.Sum,
          'type': '服务费',
          'memo': that.remark,
          fn: function fn(data) {
            that.$store.dispatch('updateLoginData', { passengerId: that.loginData.passenger.id });
            if (data.code === 0) {
              that.Sum = '';
              that.remark = '';
              that.hintBox = {
                stateShow: true,
                state: 'yes',
                content: '申请提交成功！'
              };
              setTimeout(function () {
                that.$store.dispatch('invoiceRecord', {
                  'phone': that.loginData && that.loginData.passenger ? that.loginData.passenger.phone : '',
                  'page': 1,
                  'rows': 10,
                  'type': 'upData'
                });
                that.hintBox.stateShow = false;
                that.$router.push('/invoice/record');
              }, 1500);
            }
          }
        });
      } else if (this.Sum === '') {
        that.hintBox = {
          stateShow: true,
          state: 'no',
          content: '发票额度不能为空'
        };
        setTimeout(function () {
          that.hintBox.stateShow = false;
        }, 1500);
      } else if (Number(this.Sum) === 0) {
        that.hintBox = {
          stateShow: true,
          state: 'no',
          content: '发票额度不能少于0元'
        };
        setTimeout(function () {
          that.hintBox.stateShow = false;
        }, 1500);
      } else {
        that.hintBox = {
          stateShow: true,
          state: 'no',
          content: '您的最大开票额度为' + that.loginData.passenger.receiptMoney + '元'
        };
        setTimeout(function () {
          that.hintBox.stateShow = false;
        }, 1500);
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_invoiceRecordMod_src_invoiceRecordMod_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_invoiceRecordMod_src_invoiceRecordMod_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__module_invoiceRecordMod_src_invoiceRecordMod_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_uploadMod_src_uploadMod_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_uploadMod_src_uploadMod_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__module_uploadMod_src_uploadMod_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_pull_to__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_pull_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_pull_to__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    XkUploadMod: __WEBPACK_IMPORTED_MODULE_3__module_uploadMod_src_uploadMod_vue___default.a,
    PullTo: __WEBPACK_IMPORTED_MODULE_4_vue_pull_to___default.a,
    XkInvoiceRecordMod: __WEBPACK_IMPORTED_MODULE_2__module_invoiceRecordMod_src_invoiceRecordMod_vue___default.a
  },
  name: 'invoiceRecord',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    loginData: 'loginData',
    invoiceRecord: 'invoiceRecord'
  })),
  data: function data() {
    return {
      page: 1,
      rows: 4,
      total: 0,
      content: [],
      ids: '',
      moneys: 0,
      nextButState: false,
      allButState: false,
      loadState: false
    };
  },

  watch: {
    ids: function ids(val) {
      var length = val.split(',').length - 1 || 0;
      if (length > 0) {
        this.nextButState = true;
      } else {
        this.nextButState = false;
        this.moneys = 0;
      }
      if (length === this.content.length) {
        this.allButState = true;
      } else {
        this.allButState = false;
      }
    }
  },
  methods: {
    loadDataButFn: function loadDataButFn(loaded, type) {
      var that = this;

      that.$store.dispatch('getInvoiceOrders', {
        'business': 'daijia',
        'page': that.page,
        'limit': that.rows,
        fn: function fn(data) {
          if (data && data.code === 1) {
            that.loadState = false;
            var Data = data.invoiceOrders;
            that.total = data.total;
            var content = that.content;
            if (type !== 'push') {
              content = [];
            }
            Data.forEach(function (row) {
              row.book_time = that.$utils.TimestampDate(row.book_time);
              content.push(row);
            });
            that.content = content;
            if (loaded) {
              loaded('done');
            }
          }
        }
      });
    },
    bottomRefreshFn: function bottomRefreshFn(loaded) {
      this.page++;
      this.loadDataButFn(loaded, 'push');
    },
    topRefreshFn: function topRefreshFn(loaded) {
      this.total = 1;
      this.ids = '';
      this.loadDataButFn(loaded);
    },
    orderClickFn: function orderClickFn(order) {
      var id = order.id;
      if (this.ids.includes(String(id))) {
        this.ids = this.ids.replace(String(id) + ',', '');
        this.moneys -= order.total || 0;
      } else {
        this.ids += id + ',';
        this.moneys += order.total || 0;
      }
    },
    allCheckFn: function allCheckFn() {
      var allButState = this.allButState;
      var content = this.content;
      if (allButState) {
        this.ids = '';
        this.moneys = 0;
      } else {
        var text = '';
        var moneys = 0;
        content.forEach(function (row) {
          text += row.id + ',';
          moneys += row.total || 0;
        });
        this.moneys = moneys;
        this.ids = text;
      }
    },
    nextClickFn: function nextClickFn() {
      var that = this;
      if (that.nextButState) {
        that.$router.push({ path: '/invoiceApply', query: { ids: that.ids, moneys: that.moneys } });
      }
    }
  },
  mounted: function mounted() {
    var that = this;
    that.$store.dispatch('checkLogin', function (state) {
      if (state) {
        that.loadDataButFn();
      }
    });
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_invoiceRecordMod_src_invoiceRecordMod_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_invoiceRecordMod_src_invoiceRecordMod_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__module_invoiceRecordMod_src_invoiceRecordMod_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_uploadMod_src_uploadMod_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_uploadMod_src_uploadMod_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__module_uploadMod_src_uploadMod_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_pull_to__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_pull_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_pull_to__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    XkUploadMod: __WEBPACK_IMPORTED_MODULE_3__module_uploadMod_src_uploadMod_vue___default.a,
    PullTo: __WEBPACK_IMPORTED_MODULE_4_vue_pull_to___default.a,
    XkInvoiceRecordMod: __WEBPACK_IMPORTED_MODULE_2__module_invoiceRecordMod_src_invoiceRecordMod_vue___default.a
  },
  name: 'invoiceRecord',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    loginData: 'loginData',
    invoiceRecord: 'invoiceRecord'
  })),
  data: function data() {
    return {
      page: 0,
      rows: 10,
      content: [],
      total: 10,
      loadState: false
    };
  },

  watch: {},
  methods: {
    loadDataButFn: function loadDataButFn(loaded, type) {
      var that = this;

      that.$store.dispatch('getInvoicesApply', {
        'order_type': 'daijia',
        'customer_id': that.loginData.passenger.id,
        'page': that.page,
        'limit': that.rows,
        fn: function fn(data) {
          if (data) {
            that.loadState = false;
            var Data = data.invoicesApplys;
            var content = that.content;
            if (type !== 'push') {
              content = [];
            }
            Data.forEach(function (row) {
              content.push(row);
            });
            that.content = content;
            if (loaded) {
              loaded('done');
            }
          }
        }
      });
    },
    bottomRefreshFn: function bottomRefreshFn(loaded) {
      this.total = 1;
      this.loadDataButFn(loaded);
    },
    topRefreshFn: function topRefreshFn(loaded) {
      this.page++;
      this.loadDataButFn(loaded, 'push');
    }
  },
  mounted: function mounted() {
    var that = this;
    that.$store.dispatch('checkLogin', function (state) {
      if (state) {
        that.loadDataButFn();
      }
    });
  }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'meWallet',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    loginData: 'loginData',
    wxState: 'wxState',
    postCustomerPreSave: 'postCustomerPreSave',
    unusedCoupons: 'unusedCoupons'
  })),
  data: function data() {
    return {
      couponData: []
    };
  },

  methods: {
    postCustomerPreSaveFn: function postCustomerPreSaveFn() {
      var that = this;
      that.$store.dispatch('postCustomerPreSave', {
        id: that.loginData.passenger.id
      });
    }
  },
  mounted: function mounted() {
    var that = this;
    that.$store.dispatch('checkLogin', function (state) {
      console.log(that.loginData);

      that.$store.dispatch('getCouponType', {
        channel: 'wechat',
        page: 1,
        limit: 80,
        fn: function fn(data) {
          if (data && data.code === 1) {
            var arr = [];
            if (data.coupon) {
              data.coupon.forEach(function (item) {
                if (item.state === 1) {
                  var endTime = item.end_time;
                  if (endTime) {
                    if (new Date().valueOf() < endTime * 1000) {
                      arr.push(item);
                    }
                  } else {
                    arr.push(item);
                  }
                }
              });
            }
            that.couponData = arr;
          }
        }
      });
      that.postCustomerPreSaveFn();
    });
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-Add',
  props: ['endPoint', 'origin', 'time', 'waypoint'],
  data: function data() {
    return {};
  }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-alertBox',
  props: ['text'],
  data: function data() {
    return {
      state: true
    };
  },

  mounted: function mounted() {}
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  props: ['text'],
  name: 'xk-badgeMod',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({})),
  data: function data() {
    return {};
  },

  watch: {},
  methods: {},
  mounted: function mounted() {}
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-capitalRecordList',
  props: ['time', 'type', 'sum'],
  computed: {},
  data: function data() {
    return {};
  },

  methods: {
    clickFn: function clickFn() {
      this.$emit('click');
    }
  },
  watch: {},
  mounted: function mounted() {}
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'xk-carType',
  props: ['data', 'radio'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    ZcQueryCar: 'ZcQueryCar'
  })),
  data: function data() {
    return {
      carInfo: this.$props.data,
      state: false,
      acNum: null
    };
  },

  methods: {
    selectFn: function selectFn(obj) {
      if (obj.type === 'reset') {
        this.acNum = null;
      }
      this.$store.dispatch('ZcCarTypeSelect', obj);
      this.$emit('click');
    },
    affirmFn: function affirmFn() {
      this.state = !this.state;
      this.$emit('click');
    },
    radioFn: function radioFn(obj) {
      var that = this;
      if (obj.radio) {
        that.$store.dispatch('ZcCarTypeSelect', obj);
        this.$emit('click');
        return false;
      }
      if (obj.type === 'radio' && obj.num < 1) {
        obj.type = 'plus';
        that.$store.dispatch('ZcCarTypeSelect', obj);
      }
      that.acNum = obj.index;
    }
  },
  mounted: function mounted() {
    this.$emit('click');
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'xk-carTypeScroll',
  props: ['data'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({}), {
    carTypeDataFn: function carTypeDataFn() {
      var data = this.$props.data;
      if (data.data && data.data.length > 0) {
        this.action = data.action;
        return data;
      }
    }
  }),
  data: function data() {
    return {
      action: 0
    };
  },

  watch: {},
  methods: {
    clickFn: function clickFn(type) {
      var action = this.action;
      switch (type) {
        case 'left':
          action--;
          if (action < 0) {
            action = this.$props.data.data.length - 1;
            this.action = action;
            this.$emit('click', { index: action, data: this.$props.data.data[action] });
            return false;
          }
          this.action = action;
          this.$emit('click', { index: action, data: this.$props.data.data[action] });
          break;
        case 'right':
          action++;
          if (action >= this.$props.data.data.length) {
            action = 0;
            this.action = action;
            this.$emit('click', { index: action, data: this.$props.data.data[action] });
            return false;
          }
          this.action = action;
          this.$emit('click', { index: action, data: this.$props.data.data[action] });
          break;
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-checkInput',
  props: ['val', 'forbid', 'showState', 'text'],
  computed: {
    stateFn: function stateFn() {
      if (this.$props.forbid) {
        return this.$props.showState;
      }
      return this.state;
    }
  },
  data: function data() {
    return {
      state: false
    };
  },

  methods: {
    checkInputAcFn: function checkInputAcFn(data) {
      if (!this.$props.forbid) {
        this.state = !this.state;
        this.$emit('click', { data: data, state: this.state });
      }
    }
  },
  watch: {},
  mounted: function mounted() {}
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-circuitMod',
  props: ['data'],
  data: function data() {
    return {
      circuitData: this.data
    };
  },

  methods: {
    clickFn: function clickFn() {
      this.$emit('click');
    }
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-couponMod',
  props: ['type', 'overdueTime', 'endTime', 'startTime', 'title', 'sum', 'status', 'useState', 'couponType', 'serviceType'],
  computed: {
    backgroundFn: function backgroundFn() {
      var bac = '';
      switch (this.type) {
        case 'daijia':
          bac = 'daijia';
          break;
        case 'zhuanche':
          bac = 'zhuanche';
          break;
        case 'zhuanxian':
          bac = 'zhuanxian';
          break;
        case 'paotui':
          bac = 'paotui';
          break;
      }
      return bac;
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-couponNav',
  props: ['data'],
  computed: {
    actionFn: function actionFn() {
      switch (this.$route.path) {
        case '/coupon/nused':
          return 0;
        case '/coupon/used':
          return 1;
        case '/coupon/stale':
          return 2;
      }
    }
  },
  data: function data() {
    return {};
  },

  methods: {},
  watch: {},
  mounted: function mounted() {}
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_method__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__uploadMod_src_uploadMod__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__uploadMod_src_uploadMod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__uploadMod_src_uploadMod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_json_bigint_xk__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_json_bigint_xk__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { XkUploadMod: __WEBPACK_IMPORTED_MODULE_2__uploadMod_src_uploadMod___default.a },
  name: 'xk-couponSelect',
  props: ['data', 'type'],
  data: function data() {
    return {
      state: false,
      staticState: false,
      showState: '',
      acNum: 0,

      showStateType: '',
      enterprise_id: '' };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    loginData: 'loginData'
  }), {
    counponDataFn: function counponDataFn() {
      var counponData = this.data;
      var obj = [];
      if (counponData && counponData.length > 0) {
        counponData.forEach(function (row) {
          var time = Date.parse(new Date()) / 1000;
          if (row.begin_time > time) {
            return false;
          }

          if (row.state === 1) {
            if (row.end_time) {
              if (row.end_time * 1000 > new Date().getTime()) {
                row.end_time = __WEBPACK_IMPORTED_MODULE_1__assets_js_method__["a" /* default */].TimestampDate(row.end_time * 1000);
                obj.push(row);
              }
            } else {
              row.end_time = '永久有效';
              obj.push(row);
            }
            if (!row.title || row.title === '') {
              if (row.main_service_type && row.main_service_type === 'daijia') {
                row['title'] = '代驾券';
              }
            }
          }
        });
      }
      return obj;
    }
  }),
  methods: {
    timeFn: function timeFn(val) {
      return new Date(parseInt(val) * 1000).toLocaleString().split(' ')[0];
    },

    stateFn: function stateFn(obj, type, index) {
      var _this = this;

      var that = this;
      this.$store.dispatch('checkLogin', function (state) {
        if (state && that.loginData && that.loginData.passenger) {
          _this.state = !_this.state;
        } else {
          that.couponStatic = false;
          that.$store.dispatch('loginAction', { state: false });
        }
      });
      this.$emit('click', { type: type, obj: obj });
      switch (type) {
        case 'nonuse':
          that.acNum = index;
          this.showState = '';
          this.showStateType = '';
          break;
        case 'action':
          that.acNum = index;
          this.showState = obj.deductible ? obj.deductible : obj.discount;
          this.showStateType = obj.deductible ? 'di' : 'zhe';
          break;
      }
    },
    defaultFn: function defaultFn(val) {
      this.showState = val.deductible ? this.$props.data[0].deductible : this.$props.data[0].discount;
      this.showStateType = this.$props.data[0].deductible ? 'di' : 'zhe';
      this.$emit('click', { type: 'action', obj: val });
    }
  },
  created: function created() {
    var passengerkey = window.configure.passengerKey;
    var passenger = this.$Cookie.get(passengerkey) ? __WEBPACK_IMPORTED_MODULE_4_json_bigint_xk___default.a.parse(this.$Tool.aesDecryptCode(this.$Cookie.get(passengerkey))) : null;
    if (passenger && passenger.passenger) {
      this.enterprise_id = passenger.passenger.enterprise_id;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    var that = this;
    setTimeout(function () {
      if (that.$props.data && that.$props.data.length > 0 && !_this2.enterprise_id) {
        that.defaultFn(that.$props.data[0]);
      }
    }, 200);
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_picker__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_better_picker__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-datePickerMod',
  props: ['title', 'delayed'],
  data: function data() {
    return {
      state: false,
      picker: null,
      day: [],
      hour: [],
      minute: [],
      clickState: true
    };
  },

  methods: {
    showFn: function showFn() {
      var _this = this;

      this.picker.show(function () {
        _this.picker.scrollColumn(0, 0);
        if (_this.delayed) {
          _this.picker.scrollColumn(1, 0);
        } else {
          _this.picker.scrollColumn(1, 1);
        }
        _this.picker.scrollColumn(2, 0);
      });
    },
    getCurrentMonthLast: function getCurrentMonthLast(date) {
      var currentMonth = date.getMonth();
      var nextMonth = ++currentMonth;
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      var oneDay = 1000 * 60 * 60 * 24;
      return new Date(nextMonthFirstDay - oneDay).getDate();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var that = this;
    var delayed = this.delayed ? this.delayed * 60 * 1000 : 0;
    var nowDate = new Date();
    if (delayed) {
      nowDate = new Date(nowDate.valueOf() + delayed);
    }
    var nowYear = Number(nowDate.getFullYear());
    var nowMonth = Number(nowDate.getMonth());
    var nowDay = Number(nowDate.getDate());
    var nowHour = Number(nowDate.getHours());
    var nowMinute = Number(nowDate.getMinutes());
    console.log('nowDay', nowDay);
    console.log('nowHour', nowHour);
    console.log('nowMinute', nowMinute);
    that.day = [];
    var dayNum = 0;
    that.hour = [];
    var hourNum = -1;
    if (delayed) {
      hourNum = 0;
    }
    that.minute = [];
    var minuteNum = 0;

    function dayFn(nowDay) {
      var countDay = nowDay + dayNum;
      var dayText = '';
      var dayVal = '';
      if (dayNum === 0) {
        dayText = '今天';
      }
      if (dayNum === 1) {
        dayText = '明天';
      }
      if (dayNum === 2) {
        dayText = '后天';
      }
      if (countDay <= that.getCurrentMonthLast(nowDate)) {
        dayVal = nowYear + ',' + (nowMonth + 1) + ',' + countDay;
      } else {
        var countMonth = nowMonth + 2;
        if (countMonth <= 11) {
          dayVal = nowYear + ',' + countMonth + ',' + (countDay - that.getCurrentMonthLast(nowDate));
        } else {
          dayVal = Number(nowYear) + 1 + ',' + (countMonth - nowMonth) + ',' + (countDay - that.getCurrentMonthLast(nowDate));
        }
      }
      that.day.push({
        text: dayText,
        value: dayVal
      });
      dayNum++;
      if (dayNum > 2) {
        return false;
      }
      dayFn(nowDay);
    }

    dayFn(nowDay);

    function hourFn(nowHour) {
      var countHour = nowHour + hourNum;
      var dayText = '';
      var dayVal = '';
      if (hourNum === -1 && !delayed) {
        dayText = '现在';
        dayVal = nowHour + ',' + nowMinute;
      } else {
        dayText = countHour < 10 ? '0' + countHour : countHour;
        dayVal = countHour < 10 ? '0' + countHour : countHour;
      }
      hourNum++;
      that.hour.push({
        text: dayText,
        value: dayVal
      });
      if (countHour >= 23) {
        return false;
      }
      hourFn(nowHour);
    }

    hourFn(nowHour);

    function minuteFn(nowMinute) {
      var countMinute = minuteNum * 10;
      if (nowMinute > 50) {
        that.hour = [];
        if (delayed) {
          hourNum = 0;
        } else {
          hourNum = -1;
        }
        hourFn(nowHour + 1);
        that.minute = [];
        minuteNum = 0;
        minuteFn(0);
        return;
      }
      if (countMinute - nowMinute >= 0 && countMinute - nowMinute <= 10) {
        for (var i = countMinute; i < 60; i += 10) {
          that.minute.push({
            text: i < 10 ? '0' + i : i,
            value: i
          });
        }
        return true;
      }
      minuteNum++;
      if (minuteNum > 5) {
        return false;
      }
      minuteFn(nowMinute);
    }

    minuteFn(nowMinute);

    var picker = new __WEBPACK_IMPORTED_MODULE_0_better_picker___default.a({
      data: [that.day, that.hour, that.minute],
      selectedIndex: [0, 1, 2],
      title: that.$props.title
    });
    that.picker = picker;
    var firstListIndex = 0;
    picker.on('picker.change', function (index, selectedIndex) {
      console.log(index, selectedIndex, firstListIndex);
      if (index === 0) {
        firstListIndex = selectedIndex;
        if (selectedIndex > 0) {
          hourNum = 0;
          minuteNum = 0;
          that.hour = [];
          that.minute = [];
          hourFn(0);
          minuteFn(0);
          picker.refillColumn(1, that.hour);
          picker.refillColumn(2, that.minute);
        } else {
          hourNum = 0 - 1;
          minuteNum = 0;
          that.hour = [];
          that.minute = [];
          hourFn(nowHour);
          minuteFn(nowMinute);
          console.log('selectedIndex<0', index, selectedIndex, that.hour, that.minute);
          picker.refillColumn(1, that.hour);
          picker.refillColumn(2, that.minute);
        }
      }
      if (index === 1) {
        if (firstListIndex === 0 && selectedIndex === 0) {
          if (delayed) {
            minuteNum = 0;
            that.minute = [];
            minuteFn(nowMinute);
            picker.refillColumn(2, that.minute);
          } else {
            that.minute = [];
            picker.refillColumn(2, that.minute);
          }
        }
        if (firstListIndex > 0 && selectedIndex === 0) {
          minuteNum = 0;
          that.minute = [];
          minuteFn(0);
          picker.refillColumn(2, that.minute);
        }
        if (selectedIndex === 1) {
          if (!delayed) {
            minuteNum = 0;
            that.minute = [];
            minuteFn(nowMinute);
            picker.refillColumn(2, that.minute);
          } else {
            minuteNum = 0;
            that.minute = [];
            minuteFn(0);
            picker.refillColumn(2, that.minute);
          }
        }
        if (selectedIndex > 1) {
          minuteNum = 0;
          that.minute = [];
          minuteFn(0);
          picker.refillColumn(2, that.minute);
        }
      }
    });
    picker.on('picker.select', function (index, selectedIndex) {
      if (that.clickState) {
        var name = '';
        var val = '';
        for (var i = 0; i < index.length; i++) {
          if (index[i] || index[i] === 0) {
            if (i === 0) {
              name = name + index[i].replace(',', '-').replace(',', '-') + ' ';
            }
            if (i === 1) {
              name = name + (index[2] >= 0 ? index[i] + ':' : index[i].replace(',', ':'));
            }
            if (i === 2) {
              name = name + (index[i] < 10 ? '0' + index[i] : index[i]);
            }
          }
        }
        if (selectedIndex[0] === 0 && selectedIndex[1] === 0 && !delayed) {
          name = '现在出发';
        }

        var year = '';
        var month = '';
        var day = '';
        var hour = '';
        var minute = '';
        if (that.day.length > 0 && that.hour.length > 0 && that.minute.length > 0) {
          year = that.day[selectedIndex[0]].value.split(',')[0];
          month = that.day[selectedIndex[0]].value.split(',')[1];
          day = that.day[selectedIndex[0]].value.split(',')[2];
          hour = that.hour[selectedIndex[1]].value;
          minute = that.minute[selectedIndex[2]].value;
          val = Date.parse(new Date(year, month - 1, day, hour, minute, 0));
        } else {
          year = that.day[selectedIndex[0]].value.split(',')[0];
          month = that.day[selectedIndex[0]].value.split(',')[1];
          day = that.day[selectedIndex[0]].value.split(',')[2];
          hour = that.hour[selectedIndex[1]].value.split(',')[0];
          minute = that.hour[selectedIndex[1]].value.split(',')[1];
          val = Date.parse(new Date(year, month - 1, day, hour, minute, 0));
        }

        var obj = {
          name: name,
          val: val
        };
        _this2.$emit('click', obj);
        document.getElementsByClassName('picker')[0].remove();
      }
    });
    picker.on('picker.cancel', function () {
      document.getElementsByClassName('picker')[0].remove();
      _this2.$emit('click');
    });
    that.showFn();
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Xk-detailsBox',
  props: ['title'],
  computed: {},
  data: function data() {
    return {
      state: false
    };
  },

  methods: {
    switchFn: function switchFn() {
      this.state = !this.state;
    }
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-hintBox',
  props: ['state', 'time', 'router', 'content'],
  data: function data() {
    return {
      states: true
    };
  },

  mounted: function mounted() {
    var that = this;
    setTimeout(function () {
      that.states = false;
      if (that.$props.router) {
        that.$router.push(that.$props.router);
      }
      that.$emit('change', {});
    }, that.time ? that.time : 1000);
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-homeBut',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    servesTypeNav: 'servesTypeNav'
  })),
  data: function data() {
    return {
      hideState: true
    };
  },

  methods: {
    imgButFn: function imgButFn() {
      this.$router.push('/');
    }
  },
  watch: {
    '$route': {
      handler: function handler(val) {
        if (this.$route.path === '/' || this.$route.path === '/daijia' || this.$route.path === '/login' || val.fullPath.indexOf('/settlement') >= 0) {
          this.hideState = false;
        } else {
          this.hideState = true;
        }
      },

      deep: true,
      immediate: true
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-img-code',
  props: {
    code: {
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {};
  },

  watch: {
    code: function code(val) {
      if (val) {
        this.clickChange(val);
      }
    }
  },
  methods: {
    getColorFn: function getColorFn() {
      var colorValue = '0,1,2,3,4,5,6,7,8,9,a,b,c,d,e,f';

      var colorArray = colorValue.split(',');
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += colorArray[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    lineXFn: function lineXFn() {
      return Math.floor(Math.random() * 90);
    },
    lineYFn: function lineYFn() {
      return Math.floor(Math.random() * 40);
    },
    clickChange: function clickChange(code) {
      if (!code) {
        return;
      }
      var mycanvas = document.getElementById('canvas-img-code');
      var cxt = mycanvas.getContext('2d');
      cxt.fillStyle = this.getColorFn();
      cxt.fillRect(0, 0, 90, 40);

      for (var j = 0; j < Math.random() * 100; j++) {
        cxt.strokeStyle = this.getColorFn();
        cxt.beginPath();
        cxt.moveTo(this.lineXFn(), this.lineYFn());
        cxt.lineTo(this.lineXFn(), this.lineYFn());
        cxt.lineWidth = 0.5;
        cxt.closePath();
        cxt.stroke();
      }

      cxt.fillStyle = this.getColorFn();
      cxt.font = 'bold 20px Arial';
      cxt.fillText(code, 18, 25);
    }
  },
  mounted: function mounted() {
    this.clickChange();
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_method__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-informTimeMod',
  props: ['time', 'content'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    companyInfo: 'companyInfo'
  }), {
    timeFn: function timeFn() {
      return __WEBPACK_IMPORTED_MODULE_1__assets_js_method__["a" /* default */].TimestampDate(this.$props.time);
    }
  }),
  data: function data() {
    return {
      logo: ''
    };
  },

  methods: {},
  watch: {
    companyInfo: function companyInfo(val) {
      if (val) {
        this.logo = window.configure.imgUrl + val.logo;
      }
    }
  },
  mounted: function mounted() {
    this.logo = window.configure.imgUrl + this.companyInfo.logo;
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-input',
  props: ['placeholder', 'data', 'focus', 'type'],
  data: function data() {
    return {
      val: ''
    };
  },

  methods: {
    blurFn: function blurFn() {
      this.$emit('blur', {
        that: this,
        val: this.val
      });
    },
    changeFn: function changeFn() {
      this.$emit('change', {
        that: this,
        val: this.val
      });
    },
    inputFn: function inputFn() {
      this.$emit('change', {
        that: this,
        val: this.val
      });
    },
    closeFn: function closeFn() {
      if (this.val !== '') {
        this.val = '';
        this.$emit('close', {
          that: this,
          val: this.val
        });
      } else {
        this.$emit('close', {
          that: this,
          val: this.val
        });
      }
    }
  },
  mounted: function mounted() {
    var that = this;
    if (that.focus) {
      that.$refs.input.click();
    }
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-inputBox',
  props: {
    title: {
      default: function _default() {
        return '';
      }
    },
    closeState: {
      default: function _default() {
        return '';
      }
    },
    disabled: {
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      state: false,
      affState: true
    };
  },

  methods: {
    butFn: function butFn(state) {
      var that = this;
      switch (state) {
        case 'affirm':
          if (that.affState) {
            that.$emit('click', state);
            if (!that.$props.closeState) {
              that.state = false;
            }
          }
          break;
        case 'cancel':
          that.state = false;
          that.$emit('click', state);
          break;
      }
    },
    stateFn: function stateFn() {
      this.state = !this.state;
    },
    affStateFn: function affStateFn(state) {
      if (state) {
        this.affState = true;
      } else {
        this.affState = false;
      }
    }
  },
  mounted: function mounted() {
    var that = this;
    that.state = true;
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'xk-invoiceRecordMod',
  props: ['time', 'sum', 'memo', 'state', 'type'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({}), {
    timeFn: function timeFn() {
      return this.$props.time;
    },
    stateFn: function stateFn() {
      var state = '';
      if (this.$props.state === 0) {
        state = '待开';
      }
      if (this.$props.state === 1) {
        state = '已开';
      }
      return state !== '' ? state : '';
    }
  }),
  data: function data() {
    return {};
  },

  watch: {},
  methods: {},
  mounted: function mounted() {}
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_better_picker__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_better_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_better_picker__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-lineSelect',
  props: ['title', 'data'],
  computed: {},
  data: function data() {
    return {
      state: true,
      city: [],
      address: []
    };
  },

  watch: {
    data: 'addDateFn'
  },
  methods: {
    addDateFn: function addDateFn(val) {
      var that = this;
      that.city = [];
      that.address = [];
      var Data = that.$props.data;
      for (var i = 0; i < Data.length; i++) {
        that.city.push({ text: Data[i].city, value: Data[i].city });
        var address = Data[i].address;
        var addressObj = [];
        for (var j = 0; j < address.length; j++) {
          addressObj.push({
            text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(address[j]) === 'object' ? address[j].endAddress || address[j].startAddress : address[j],
            value: address[j]
          });
        }
        that.address.push(addressObj);
      }

      if (that.city.length > 0) {
        that.showFn(0);
      }
    },
    showFn: function showFn(index) {
      var that = this;
      var selectedNum = 0;
      if (that.state) {
        that.state = false;
        var picker = new __WEBPACK_IMPORTED_MODULE_1_better_picker___default.a({
          data: [that.city, that.address[index]],
          selectedIndex: [0, 1],
          title: that.$props.title
        });
        picker.show();
        setTimeout(function () {
          picker.scrollColumn(0, 0);
          picker.scrollColumn(1, 0);
        }, 0);
        picker.on('picker.change', function (index, selectedIndex) {
          if (index === 0) {
            selectedNum = selectedIndex;
            picker.refillColumn(1, that.address[selectedIndex]);
          }
        });
        picker.on('picker.select', function (selectedVal, selectedIndex) {
          that.state = true;
          that.$emit('click', {
            city: that.city[selectedIndex[0]].value,
            address: that.address[selectedNum][selectedIndex[1]].value
          });
          var body = document.getElementsByTagName('body')[0];
          var pickers = document.getElementsByClassName('picker');
          if (pickers && pickers.length > 0) {
            for (var i = 0; i < pickers.length; i++) {
              body.removeChild(pickers[i]);
            }
          }
        });
        picker.on('picker.cancel', function () {
          that.state = true;
          var body = document.getElementsByTagName('body')[0];
          var pickers = document.getElementsByClassName('picker');
          if (pickers && pickers.length > 0) {
            for (var i = 0; i < pickers.length; i++) {
              body.removeChild(pickers[i]);
            }
          }
          that.$emit('click');
        });
      }
    }
  },
  mounted: function mounted() {
    var that = this;
    that.addDateFn();
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-modal-Mod',
  props: ['zIndex', 'opacity'],
  data: function data() {
    return {
      modalModState: false
    };
  },

  methods: {
    modalModFn: function modalModFn() {
      this.modalModState = !this.modalModState;
      this.$emit('click', this.modalModState);
    }
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'myPicker',
  props: {
    title: {
      type: String,
      default: '请选择'
    },
    pickItem: {
      default: function _default() {
        var arr = [{ name: '2015', val: 2015 }, { name: '2016', val: 2016 }, { name: '2017', val: 2017 }, { name: '2018', val: 2018 }];
        return arr;
      }
    },
    showMyPicker: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({})),
  watch: {
    showMyPicker: function showMyPicker(val) {
      if (val) {
        this.showPicker = true;
        this.forbidBodyScroll();
      } else {
        this.showPicker = false;
        this.allowBodyScroll();
      }
    },
    pickItem: function pickItem(val) {
      var that = this;
      if (val) {
        that.slots[0].values = val;
      }
    }
  },
  created: function created() {},
  data: function data() {
    return {
      pickerValue: '',
      selected: '',
      showPicker: false,
      slots: [{
        flex: 1,
        values: [],
        className: 'slot1',
        textAlign: 'left'
      }]
    };
  },

  methods: {
    onValuesChange: function onValuesChange(picker, values) {
      this.selected = values;
    },
    sure: function sure() {
      var that = this;
      this.showPicker = false;
      this.$emit('sureAction', that.selected);
    },
    cancel: function cancel() {
      this.showPicker = false;
      this.$emit('cancelAction', this.showPicker);
    },
    openPicker: function openPicker() {
      this.$refs.picker.open();
    },
    bodyScroll: function bodyScroll(event) {
      event.preventDefault();
    },
    forbidBodyScroll: function forbidBodyScroll() {
      document.getElementsByClassName('projectContent')[0].addEventListener('touchmove', this.bodyScroll, false);
    },
    allowBodyScroll: function allowBodyScroll() {
      document.getElementsByClassName('projectContent')[0].removeEventListener('touchmove', this.bodyScroll, false);
    }
  },
  mounted: function mounted() {
    var that = this;
    setTimeout(function () {
      that.slots[0].values = that.pickItem;
    }, 500);
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_method__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  props: ['data'],
  name: 'xk-navTabs',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({}), {
    pathFn: function pathFn() {
      return this.$route.fullPath;
    }
  }),
  data: function data() {
    return {
      ulWidth: {
        width: '100%'
      },
      liWidth: {
        width: 'auto'
      }
    };
  },

  watch: {},
  methods: {
    actionFn: function actionFn(obj) {
      this.$emit('click', { data: obj });
    },
    styleFn: function styleFn() {
      var that = this;
      var Num = 0;
      if (that.$props.data.length > 0) {
        Num = that.$props.data.length;
      }
      if (Num > 0 && Num > 4) {
        that.liWidth = {
          width: 'auto'
        };
        var ulWidth = 0;
        var navTabsLiA = that.$refs.navTabsLi;
        for (var i = 0; i < navTabsLiA.length; i++) {
          var liW = Number(__WEBPACK_IMPORTED_MODULE_2__assets_js_method__["a" /* default */].gainStyle(navTabsLiA[i], 'width', 'px'));
          ulWidth += liW;
        }
        that.ulWidth = {
          width: ulWidth + 1 + 'px'
        };
      }
      if (Num > 0 && Num <= 4) {
        that.ulWidth = {
          width: '100%'
        };
        that.liWidth = {
          width: (100 / Num).toFixed(6) + '%'
        };
      }
    }
  },
  mounted: function mounted() {
    this.styleFn();
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_picker__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_better_picker__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-numberSelect',
  props: ['data', 'maxNum'],
  computed: {},
  data: function data() {
    return {
      action: 1
    };
  },

  methods: {},
  watch: {},
  mounted: function mounted() {
    var that = this;
    var data = that.$props.data;
    var obj = [];
    for (var i = 0; i < data; i++) {
      obj.push({ text: i + 1, value: i + 1 });
    }
    var picker = new __WEBPACK_IMPORTED_MODULE_0_better_picker___default.a({
      data: [obj],
      selectedIndex: [0],
      title: that.$props.title
    });
    picker.show();
    picker.on('picker.change', function (index, selectedIndex) {
      that.action = obj[selectedIndex].value;
    });
    picker.on('picker.select', function (index, selectedIndex) {
      that.$emit('click', { val: that.action });
      document.getElementsByClassName('picker')[0].remove();
    });
    picker.on('picker.cancel', function () {
      document.getElementsByClassName('picker')[0].remove();
      that.$emit('click');
    });
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qr_js__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qr_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qr_js__);




var update = function update() {
  this.update();
};
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-qr-code',
  props: {
    val: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 100
    },

    level: String,
    bgColor: {
      type: String,
      default: '#FFFFFF'
    },
    fgColor: {
      type: String,
      default: '#000000'
    }
  },
  beforeUpdate: update,
  mounted: update,
  methods: {
    update: function update() {
      var size = this.size;
      var bgColor = this.bgColor;
      var fgColor = this.fgColor;
      var $qr = this.$refs.qr;
      var qrcode = __WEBPACK_IMPORTED_MODULE_0_qr_js___default()(this.val);
      var ctx = $qr.getContext('2d');
      var cells = qrcode.modules;
      var tileW = size / cells.length;
      var tileH = size / cells.length;
      var scale = (window.devicePixelRatio || 1) / getBackingStorePixelRatio(ctx);
      $qr.height = $qr.width = size * scale;
      ctx.scale(scale, scale);
      cells.forEach(function (row, rdx) {
        row.forEach(function (cell, cdx) {
          ctx.fillStyle = cell ? fgColor : bgColor;
          var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
          var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
          ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
        });
      });
    }
  }
});

function getBackingStorePixelRatio(ctx) {
  return ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
}

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-recordOrderMod',
  props: ['startAddress', 'endAddress', 'serverTime', 'status', 'orderId', 'router'],
  computed: {},
  data: function data() {
    return {};
  },

  methods: {
    actionFn: function actionFn() {
      var router = this.$props.status.router;
      if (router) {
        if (this.$props.status.status !== 40) {
          this.$router.push({ path: router.path, query: router.query });
        }
      }
    }
  },
  mounted: function mounted() {
    console.log(this.$props.status);
  }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_method_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-rollBanner',
  props: ['data', 'touch'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    infoData: 'infoData'
  })),
  data: function data() {
    return {
      imgAcNum: 0
    };
  },

  watch: {
    infoData: function infoData() {
      this.animationFn();
    }
  },
  methods: {
    butFn: function butFn(index) {
      this.imgAcNum = index;
    },
    animationFn: function animationFn() {
      var that = this;
      if (that.$props.data && that.$props.data.length > 0) {
        (function () {
          var state = true;
          var setIn = void 0;

          function setInFn() {
            clearInterval(setIn);
            setIn = setInterval(function () {
              that.imgAcNum++;
              if (that.imgAcNum >= that.$props.data.length) {
                that.imgAcNum = 0;
              }
            }, 3000);
          }

          setInFn();
          if (state) {
            __WEBPACK_IMPORTED_MODULE_1__assets_js_method_js__["a" /* default */].slide(that.$el, function (val) {
              clearInterval(setIn);
              switch (val) {
                case 'right':
                  that.imgAcNum--;
                  if (that.imgAcNum < 0) {
                    that.imgAcNum = that.$props.data.length - 1;
                  }
                  break;
                case 'left':
                  that.imgAcNum++;
                  if (that.imgAcNum > that.$props.data.length - 1) {
                    that.imgAcNum = 0;
                  }
                  break;
              }
              setTimeout(function () {
                setInFn();
              }, 3000);
            });
          }
        })();
      }
    },
    imgListAcFn: function imgListAcFn(obj) {
      if (obj.htmlUrl) {
        window.location.href = obj.htmlUrl;
        return;
      }
      if (obj.htmlContent) {
        window.bannerContent = obj.htmlContent;
        this.$router.push('/bannerContent');
      }
    }
  },
  mounted: function mounted() {
    this.animationFn();
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__badge_src_badge_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__badge_src_badge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__badge_src_badge_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { XkBadgeMod: __WEBPACK_IMPORTED_MODULE_2__badge_src_badge_vue___default.a },
  name: 'xk-sideMenus',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    loginData: 'loginData',
    imformNum: 'imformNum',
    orderNav: 'orderNav'
  }), {
    upImgFn: function upImgFn() {
      if (this.loginData.passenger && this.loginData.passenger.avatar) {
        return window.configure.imgUrl + this.loginData.passenger.avatar;
      } else {
        return false;
      }
    }
  }),
  data: function data() {
    return {
      sideMenusState: false,
      headPortrait: null
    };
  },

  watch: {},
  methods: {
    sideMenusFn: function sideMenusFn() {
      console.log(1231231, this.loginData);
      var State = this.sideMenusState;
      this.sideMenusState = !State;
    },
    compileNomFn: function compileNomFn() {
      this.$router.push('/compileNom');
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-siteInput',
  props: ['placeholder', 'name', 'city', 'state', 'addressrecord', 'checkedlogin'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    mapState: 'mapState',
    getCity: 'getCity',
    positioning: 'positioning'
  }), {
    nameFn: function nameFn() {
      this.query = this.name;
      this.recordQuery = this.name;
    },
    getCityFn: function getCityFn() {}
  }),
  data: function data() {
    return {
      query: '',
      recordQuery: '',
      result: [],
      shortcutData: ['娱乐', '商城', '餐馆', '旅游', '学校'],
      shortcutAc: this.query || '娱乐',
      hotCity: ['北京', '广州', '上海', '深圳', '成都'],
      resultState: false,
      acCityIndex: 0,
      acCityState: false,
      cityShow: '',
      addsJL: null
    };
  },

  watch: {
    positioning: function positioning(val) {
      if (val && !this.$props.city) {
        this.cityShow = val.city ? val.city : '成都市';
      }
    },
    city: function city(val) {
      var that = this;
      if (val) {
        that.cityShow = val.replace('市', '');
      }
    }
  },
  methods: {
    mapFn: function mapFn(adds, type) {
      var that = this;
      if (type === 'input') {
        that.shortcutAc = '';
      }
      if (that.addsJL === adds) {
        return;
      }
      that.addsJL = adds;
      if (that.mapState === 'google') {
        that.$store.dispatch('googleMapSite', {
          query: adds || that.query,
          fn: function fn(data) {
            that.result = data;
          }
        });
      } else {
        that.$store.dispatch('amapMapSite', {
          query: adds || that.query,
          city: that.cityShow !== '选择城' ? that.cityShow : '',
          fn: function fn(data) {
            that.result = data;
          }
        });
      }
    },
    shortcutClickFn: function shortcutClickFn(adds) {
      this.shortcutAc = adds;
      this.query = '';
      this.mapFn(adds);
    },

    actionFn: function actionFn(obj) {
      this.resultState = false;
      this.query = obj.name;
      this.recordQuery = obj.name;
      this.$emit('onClick', obj);
    },
    moduleFn: function moduleFn() {
      this.resultState = false;
      this.query = this.recordQuery;
      this.acCityState = false;
    },
    queryShowFn: function queryShowFn() {
      var _this = this;

      var that = this;
      var fn = function fn() {
        if (!that.$props.state) {
          that.$emit('onClick');
          return false;
        }
        if (that.$props.name === '') {
          that.result = [];
        }
        if (that.query !== '') {
          that.shortcutAc = '';
        }
        document.body.scrollTop = 0;
        that.resultState = true;
        that.$refs.queryInput.focus();
        that.mapFn(that.query || that.shortcutAc);
      };
      if (this.checkedlogin || this.checkedlogin === '') {
        this.$store.dispatch('checkLogin', function (state) {
          if (state) {
            fn();
          } else {
            console.log('点击终点', _this.checkedlogin);
            that.$router.push('/login');
            that.$store.dispatch('loginAction', { state: false });
          }
        });
      } else {
        fn();
      }
    },
    resultFn: function resultFn() {
      this.$refs.queryInput.blur();
    },
    replaceCityListFn: function replaceCityListFn(e) {
      var that = this;
      var Y = e.touches[0].clientY;
      var Item = that.$refs.replaceCityItem;
      for (var i = 0; i < Item.length; i++) {
        if (Y >= Item[i].offsetTop + 110 && Item[i + 1] && Y < Item[i + 1].offsetTop + 110) {
          this.acCityIndex = i;
          that.cityModScorllFn();
          return;
        }
        if (!Item[i + 1] && Y >= Item[i].offsetTop + 110) {
          this.acCityIndex = i;
          that.cityModScorllFn();
        }
      }
    },
    vibrationFn: function vibrationFn(index) {
      var that = this;
      that.acCityIndex = index;
      that.cityModScorllFn();
    },
    cityModScorllFn: function cityModScorllFn() {
      var that = this;
      var cityMod = that.$refs.cityMod;
      var cityRowS = that.$refs.cityRow;
      if (cityRowS && cityRowS.length > 0) {
        for (var i = 0; i < cityRowS.length; i++) {
          if (that.acCityIndex === i) {
            cityMod.scrollTop = cityRowS[i].offsetTop;
          }
        }
      }
    },
    cityAcFn: function cityAcFn() {
      this.acCityState = !this.acCityState;
    },
    acCityFn: function acCityFn(city) {
      if (city && city.indexOf('市') > 0) {
        city = city.replace('市', '');
      }
      this.cityAcFn();
      this.cityShow = city + '市';
      this.mapFn(this.query || this.shortcutAc);
    }
  },
  mounted: function mounted() {
    var that = this;
    setTimeout(function () {
      if (that.$props.city) {
        that.cityShow = that.$props.city.replace('市', '');
      } else if (that.positioning && that.positioning.lat && that.positioning.lng) {
        that.cityShow = that.positioning.city ? that.positioning.city : '成都市';
      }
    }, 200);
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-star',
  props: {
    disabled: {
      default: function _default() {
        return true;
      }
    },
    isShow: {
      default: function _default() {
        return true;
      }
    },
    state: {
      default: function _default() {
        return '';
      }
    },
    defScore: {
      default: function _default() {
        return 5;
      }
    }
  },
  computed: {
    stateShowFn: function stateShowFn() {
      if (this.$props.state) {
        this.score = this.$props.defScore;
        this.msg = this.stars[this.score - 1].msg;
      }
    }
  },
  data: function data() {
    return {
      stars: [{
        score: 1,
        msg: '非常不满意'
      }, {
        score: 2,
        msg: '不满意'
      }, {
        score: 3,
        msg: '一般'
      }, {
        score: 4,
        msg: '满意'
      }, {
        score: 5,
        msg: '非常满意'
      }],
      msg: '请您对本次服务进行评价！',
      score: this.$props.defScore ? this.$props.defScore : 0,
      acState: this.$props.state === false ? this.$props.state : true
    };
  },

  methods: {
    starsFn: function starsFn(val) {
      if (this.disabled) {
        var that = this;
        if (this.acState) {
          that.score = val;
          switch (val) {
            case 1:
              that.msg = that.stars[val - 1].msg;
              break;
            case 2:
              that.msg = that.stars[val - 1].msg;
              break;
            case 3:
              that.msg = that.stars[val - 1].msg;
              break;
            case 4:
              that.msg = that.stars[val - 1].msg;
              break;
            case 5:
              that.msg = that.stars[val - 1].msg;
              break;
            default:
              that.msg = '请您对本次服务进行评价！';
          }
          that.$emit('clickChange', that.score);
        }
      }
    }
  },
  mounted: function mounted() {
    var that = this;
    if (this.$props.defScore && this.$props.defScore > 0) {
      this.msg = this.stars[this.$props.defScore - 1].msg;
    }
    if (this.acState) {
      switch (that.score) {
        case 1:
          that.msg = that.stars[that.score - 1].msg;
          break;
        case 2:
          that.msg = that.stars[that.score - 1].msg;
          break;
        case 3:
          that.msg = that.stars[that.score - 1].msg;
          break;
        case 4:
          that.msg = that.stars[that.score - 1].msg;
          break;
        case 5:
          that.msg = that.stars[that.score - 1].msg;
          break;
        default:
          that.msg = '请您对本次服务进行评价！';
      }
      that.$emit('clickChange', that.score);
    }
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Xk-tabs',
  props: ['data', 'acNum'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    servesTypeNav: 'servesTypeNav'
  }), {
    fullPath: function fullPath() {
      return this.$route.fullPath;
    }
  }),
  data: function data() {
    return {
      dataInfo: this.servesTypeNav,
      action: this.$props.acNum,
      ulWidth: '100%',
      ulScroll: 0,
      liWidth: '6rem',
      AllState: false
    };
  },

  watch: {
    servesTypeNav: function servesTypeNav(val) {
      var that = this;
      if (val && val.length < 4) {
        that.ulWidth = '100%';
        that.liWidth = 100 / val.length + '%';
      } else {
        that.ulWidth = 6 * val.length + 'rem';
        that.liWidth = '6rem';
      }

      function scroll() {
        var XKTabsContent = that.$refs.XKTabsContent;
        var maxscroll = 0;
        XKTabsContent.addEventListener('scroll', function (event) {
          var scrollLeft = XKTabsContent.scrollLeft;
          if (XKTabsContent.scrollWidth === XKTabsContent.clientWidth + scrollLeft) {
            maxscroll = scrollLeft;
          } else if (XKTabsContent.scrollWidth + 3 < XKTabsContent.clientWidth + scrollLeft) {
            var cha = scrollLeft - maxscroll;
            that.ulScroll = {
              transform: 'translate(-50%,-50%) rotate(' + cha * 5 + 'deg) ',
              opacity: 1 - cha * 0.01
            };
          } else {
            that.ulScroll = {
              transform: 'translate(-50%,-50%) rotate(0deg) ',
              opacity: 1
            };
          }
        });
      }

      scroll();
      if (val.length > 0 && that.$route.path === '/') {
        that.$router.push(val[0].url);
      }
    }
  },
  methods: {
    clickFn: function clickFn(index) {
      this.action = index;
      this.menusState = false;
      this.AllState = false;
      var li = this.$refs.lis[index];
      this.$refs.XKTabsContent.scrollLeft = li.offsetLeft - li.offsetWidth;
    },
    allBusinessButFn: function allBusinessButFn(state, index) {
      this.AllState = !this.AllState;
      if (index) {
        var li = this.$refs.lis[index];
        this.$refs.XKTabsContent.scrollLeft = li.offsetLeft - li.offsetWidth;
      }
    }
  },
  mounted: function mounted() {
    var that = this;
    var val = this.servesTypeNav;
    if (val && val.length < 4) {
      that.ulWidth = '100%';
      that.liWidth = 100 / val.length + '%';
    } else {
      that.ulWidth = 6 * val.length + 'rem';
      that.liWidth = '6rem';
    }

    if (val.length > 0 && that.$route.path === '/') {
      that.$router.push(val[0].url);
    }
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-tag-item',
  props: ['name', 'value', 'state', 'AcState'],
  data: function data() {
    return {
      acState: false,
      status: this.$props.AcState === false ? this.$props.AcState : true
    };
  },

  methods: {
    acStateFn: function acStateFn() {
      var that = this;
      if (this.status) {
        that.acState = !that.acState;
        that.$emit('clickChange', { state: that.acState, val: this.name });
      }
    }
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-textarea',
  props: {
    value: String,
    defaulttext: String
  },
  data: function data() {
    return {
      values: this.value
    };
  },

  methods: {
    inputFn: function inputFn() {
      this.$emit('input', this.values);
    }
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_method__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modalMod_src_modalMod__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modalMod_src_modalMod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modalMod_src_modalMod__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { XkModalMod: __WEBPACK_IMPORTED_MODULE_1__modalMod_src_modalMod___default.a },
  name: 'xk-type-tabs',
  props: ['cardata', 'bacColor', 'defaultmum'],
  computed: {},
  data: function data() {
    return {
      ulWidth: '100%',
      acNum: 0,
      menusState: false
    };
  },

  watch: {
    cardata: function cardata(val) {
      var that = this;
      if (val) {
        that.ulWidthFn();
      }
    }
  },
  methods: {
    menusFn: function menusFn(val) {
      this.menusState = !this.menusState;
    },

    clickFn: function clickFn(obj, index) {
      this.acNum = index;
      var li = this.$refs.lis[index];
      this.$refs.TabsContent.scrollLeft = li.offsetLeft - li.offsetWidth;
      console.log(obj);
      this.menusState = false;
      this.$emit('click', { index: index, data: obj, businessId: obj.id });
    },
    ulWidthFn: function ulWidthFn() {
      var that = this;
      var lis = that.$refs.lis;
      var liW = null;
      that.ulWidth = 0;
      if (lis && lis.length > 0) {
        for (var i = 0; i < lis.length; i++) {
          var liP = __WEBPACK_IMPORTED_MODULE_0__assets_js_method__["a" /* default */].gainStyle(lis[i], 'padding');
          liP = liP.replace('0px ', '');
          liP = liP.replace('px', '');
          liP = Number(liP) * 2;
          liW = Number(__WEBPACK_IMPORTED_MODULE_0__assets_js_method__["a" /* default */].gainStyle(lis[i], 'width', 'px'));
          that.ulWidth += liW;
          that.ulWidth += liP;
        }
        that.ulWidth += 'px';
      }
    }
  },
  mounted: function mounted() {
    var that = this;
    if (that.$props.cardata) {
      that.ulWidthFn();
    }
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__recordOrderMod_src_recordOrderMod__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__recordOrderMod_src_recordOrderMod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__recordOrderMod_src_recordOrderMod__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { XkRecordOrderMod: __WEBPACK_IMPORTED_MODULE_0__recordOrderMod_src_recordOrderMod___default.a },
  name: 'xk-unfilledOrderMod',
  props: ['data', 'title'],
  computed: {},
  data: function data() {
    return {};
  },

  watch: {},
  methods: {
    actionFn: function actionFn(orderId) {
      this.$emit('click', orderId);
    },
    modalFn: function modalFn() {
      this.$emit('close');
    }
  },
  mounted: function mounted() {
    console.log('未完成订单Mod', this.data);
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uploadMod_src_uploadMod__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uploadMod_src_uploadMod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__uploadMod_src_uploadMod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_exif_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_exif_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_exif_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lrz__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lrz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lrz__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { XkUploadMod: __WEBPACK_IMPORTED_MODULE_1__uploadMod_src_uploadMod___default.a },
  name: 'xk-upAvatar',
  props: ['phone', 'imgUrl'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    loginData: 'loginData',
    mobileState: 'mobileState'
  }), {
    imgUrlFn: function imgUrlFn() {
      if (this.imgUrl) {
        return window.configure.imgUrl + this.imgUrls;
      } else {
        return false;
      }
    }
  }),
  data: function data() {
    return {
      imgUrls: this.imgUrl,
      loadSate: false,
      headerImage: '',
      picValue: '',
      fileText: ''
    };
  },

  methods: {
    fileFn1: function fileFn1(e) {
      var that = this;
      that.loadSate = true;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      that.picValue = files[0];
      __WEBPACK_IMPORTED_MODULE_4_lrz___default()(files[0]).then(function (rst) {
        console.log(rst.file);
        that.imgPreview(rst.file);
      });
      that.fileText = e.target.value;
    },
    imgPreview: function imgPreview(file) {
      var self = this;
      var Orientation = void 0;

      __WEBPACK_IMPORTED_MODULE_3_exif_js___default.a.getData(file, function () {
        Orientation = __WEBPACK_IMPORTED_MODULE_3_exif_js___default.a.getTag(this, 'Orientation');
      });

      if (!file || !window.FileReader) return;

      if (/^image/.test(file.type)) {
        var reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onloadend = function () {
          var result = this.result;
          var img = new Image();
          img.src = result;

          if (this.result.length <= 100 * 1024) {
            self.headerImage = this.result;
            self.postImg();
          } else {
            img.onload = function () {
              var data = self.compress(img, Orientation);
              self.headerImage = data;
              self.postImg();
            };
          }
        };
      }
    },
    postImg: function postImg() {
      var that = this;
      var data = this.headerImage;
      data = data.split(',')[1];
      data = window.atob(data);
      var ia = new Uint8Array(data.length);
      for (var i = 0; i < data.length; i++) {
        ia[i] = data.charCodeAt(i);
      }

      var blob = new Blob([ia], {
        type: 'image/jpeg'
      });
      var fd = new FormData();
      console.log(that.loginData);
      fd.append('file', blob, that.fileText);
      fd.append('token', that.loginData.token.Qiniu);
      var xhr = new XMLHttpRequest();

      function onloadFn() {
        that.loadSate = false;
        that.moadlStateFn();
        var success = null;
        if (JSON.parse(xhr.responseText).hash) {
          success = { fileId: JSON.parse(xhr.responseText).hash, code: 200 };
        } else {
          success = JSON.parse(xhr.responseText);
        }
        that.$emit('change', success);
      }

      xhr.onload = onloadFn;

      function onerrorFn() {
        that.loadSate = false;
        that.moadlStateFn();
        that.$emit('change');
      }

      xhr.onerror = onerrorFn;
      xhr.open('POST', '/upImg');

      xhr.send(fd);
    },
    rotateImg: function rotateImg(img, direction, canvas) {
      var minStep = 0;
      var maxStep = 3;
      if (img == null) return;

      var height = img.height;
      var width = img.width;
      var step = 2;
      if (step == null) {
        step = minStep;
      }
      if (direction === 'right') {
        step++;

        step > maxStep && (step = minStep);
      } else {
        step--;
        step < minStep && (step = maxStep);
      }

      var degree = step * 90 * Math.PI / 180;
      var ctx = canvas.getContext('2d');
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },
    compress: function compress(img, Orientation) {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');

      var tCanvas = document.createElement('canvas');
      var tctx = tCanvas.getContext('2d');

      var width = img.width;
      var height = img.height;

      var ratio = void 0;
      if ((ratio = width * height / 400000000000000) > 1) {
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;

      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      var count = void 0;
      if ((count = width * height / 100000000000000) > 1) {
        count = ~~(Math.sqrt(count) + 1);
        var nw = ~~(width / count);
        var nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (var i = 0; i < count; i++) {
          for (var j = 0; j < count; j++) {
            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }

      if (Orientation !== '' && Orientation !== 1) {
        switch (Orientation) {
          case 6:
            this.rotateImg(img, 'left', canvas);
            break;
          case 8:
            this.rotateImg(img, 'right', canvas);
            break;
          case 3:
            this.rotateImg(img, 'right', canvas);
            this.rotateImg(img, 'right', canvas);
            break;
        }
      }

      var ndata = canvas.toDataURL('image/jpeg', 0.5);

      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },

    AddFn: function AddFn() {
      this.$refs.inputImg.click();
    },
    modalFn: function modalFn() {
      this.$emit('change');
    },
    moadlStateFn: function moadlStateFn() {
      this.loadState = !this.loadState;
    }
  },
  watch: {},
  mounted: function mounted() {}
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_configure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__uploadMod_src_uploadMod__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__uploadMod_src_uploadMod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__uploadMod_src_uploadMod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_exif_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_exif_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_exif_js__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { XkUploadMod: __WEBPACK_IMPORTED_MODULE_2__uploadMod_src_uploadMod___default.a },
  name: 'xk-upImgDom',
  props: ['actionUrl', 'maxNum'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    mobileState: 'mobileState'
  })),
  data: function data() {
    return {
      imgs: [],
      weixinUrl: __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].weixinUrl,
      showImgUrl: '',
      showMaxImgState: false,
      loadState: false,
      headerImage: '',
      picValue: '',
      fileText: ''
    };
  },

  methods: {
    fileFn1: function fileFn1(e) {
      var that = this;
      that.loadSate = true;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      that.picValue = files[0];
      that.fileText = e.target.value;
      that.imgPreview(this.picValue);
    },
    imgPreview: function imgPreview(file) {
      var self = this;
      var Orientation = void 0;

      __WEBPACK_IMPORTED_MODULE_4_exif_js___default.a.getData(file, function () {
        Orientation = __WEBPACK_IMPORTED_MODULE_4_exif_js___default.a.getTag(this, 'Orientation');
      });

      if (!file || !window.FileReader) return;

      if (/^image/.test(file.type)) {
        var reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onloadend = function () {
          var result = this.result;
          var img = new Image();
          img.src = result;

          if (this.result.length <= 100 * 1024) {
            self.headerImage = this.result;
            self.postImg();
          } else {
            img.onload = function () {
              var data = self.compress(img, Orientation);
              self.headerImage = data;
              self.postImg();
            };
          }
        };
      }
    },
    postImg: function postImg() {
      var that = this;
      var data = this.headerImage;
      data = data.split(',')[1];
      data = window.atob(data);
      var ia = new Uint8Array(data.length);
      for (var i = 0; i < data.length; i++) {
        ia[i] = data.charCodeAt(i);
      }

      var blob = new Blob([ia], {
        type: 'image/jpeg'
      });
      var fd = new FormData();
      fd.append('photo', blob, that.fileText);
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var data = JSON.parse(xhr.responseText);
        if (data.code === 0) {
          that.imgs.push('/' + data.data);
          that.loadState = false;
          that.$emit('change', that.imgs);
        } else {
          that.loadState = false;
        }
      };
      xhr.onerror = function () {};
      xhr.open('POST', __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].weixinUrl + '/v5/paotui/upload');
      xhr.send(fd);
    },
    rotateImg: function rotateImg(img, direction, canvas) {
      var minStep = 0;
      var maxStep = 3;
      if (img == null) return;

      var height = img.height;
      var width = img.width;
      var step = 2;
      if (step == null) {
        step = minStep;
      }
      if (direction === 'right') {
        step++;

        step > maxStep && (step = minStep);
      } else {
        step--;
        step < minStep && (step = maxStep);
      }

      var degree = step * 90 * Math.PI / 180;
      var ctx = canvas.getContext('2d');
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },
    compress: function compress(img, Orientation) {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');

      var tCanvas = document.createElement('canvas');
      var tctx = tCanvas.getContext('2d');

      var width = img.width;
      var height = img.height;

      var ratio = void 0;
      if ((ratio = width * height / 400000000000000) > 1) {
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;

      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      var count = void 0;
      if ((count = width * height / 100000000000000) > 1) {
        count = ~~(Math.sqrt(count) + 1);
        var nw = ~~(width / count);
        var nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (var i = 0; i < count; i++) {
          for (var j = 0; j < count; j++) {
            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }

      if (Orientation !== '' && Orientation !== 1) {
        switch (Orientation) {
          case 6:
            this.rotateImg(img, 'left', canvas);
            break;
          case 8:
            this.rotateImg(img, 'right', canvas);
            break;
          case 3:
            this.rotateImg(img, 'right', canvas);
            this.rotateImg(img, 'right', canvas);
            break;
        }
      }

      var ndata = canvas.toDataURL('image/jpeg', 0.5);

      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },

    AddFn: function AddFn() {
      this.$refs.inFile.click();
    },
    showImgFn: function showImgFn(url) {
      this.showMaxImgState = true;
      this.showImgUrl = url;
    },
    showMaxImgFn: function showMaxImgFn() {
      this.showMaxImgState = !this.showMaxImgState;
    }
  },
  watch: {},
  mounted: function mounted() {}
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-uploadMod',
  computed: {},
  props: ['state'],
  data: function data() {
    return {};
  },

  methods: {},
  watch: {},
  mounted: function mounted() {}
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xk-waiter',
  props: ['src', 'name', 'carNo', 'carName', 'carColor', 'carType', 'sex', 'location', 'phone', 'paotuiType', 'headImg'],
  computed: {
    headImgFn: function headImgFn() {
      if (this.$props.headImg) {
        return this.$props.headImg;
      }
    }
  },
  data: function data() {
    return {
      imgShowAddressFront: 'https://assets.xiaokayun.cn/',
      imgShowAddressEndFirst: '?imageView2/1',
      imgShowAddressEndSecond: navigator.userAgent.indexOf('Chrome') > -1 ? '/format/webp/q/75%7Cimageslim' : '/format/png/q/75%7Cimageslim'
    };
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_recordOrderMod_src_recordOrderMod__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_recordOrderMod_src_recordOrderMod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__module_recordOrderMod_src_recordOrderMod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_uploadMod_src_uploadMod__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_uploadMod_src_uploadMod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__module_uploadMod_src_uploadMod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tabs_tabs__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tabs_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_tabs_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_json_bigint_xk__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_json_bigint_xk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_json_bigint_xk__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    XkUploadMod: __WEBPACK_IMPORTED_MODULE_3__module_uploadMod_src_uploadMod___default.a,
    XkRecordOrderMod: __WEBPACK_IMPORTED_MODULE_2__module_recordOrderMod_src_recordOrderMod___default.a,
    V5MircoTabs: __WEBPACK_IMPORTED_MODULE_4__components_tabs_tabs___default.a
  },
  name: 'recordDaiJia',
  computed: {},
  data: function data() {
    return {
      page: 1,
      rows: 10,
      loadState: false,
      pageState: true,
      tabs: [{ active: 1, name: '服务中' }, { active: 2, name: '已完成' }, { active: 3, name: '已销单' }],
      orderList: [],
      total: 0,
      status: '1,5,10,15,20,25,28',
      active: 1 };
  },

  watch: {
    active: function active(val) {
      this.page = 1;
      switch (val) {
        case 1:
          this.status = '1,5,10,15,20,25,28';
          break;
        case 2:
          this.status = '35,40';
          break;
        case 3:
          this.status = '45';
          break;
      }
      this.getOrdersFn();
    }
  },
  methods: {
    getOrdersFn: function getOrdersFn() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var appKey, passengerkey, passenger, url, params, data, responseData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loadState = true;
                appKey = _this.$Cookie.get('cookieAppKey');
                passengerkey = 'passenger' + appKey;
                passenger = _this.$Cookie.get(passengerkey) ? __WEBPACK_IMPORTED_MODULE_5_json_bigint_xk___default.a.parse(_this.$Tool.aesDecryptCode(_this.$Cookie.get(passengerkey))) : null;

                console.log('appKey', appKey, 'passenger', passenger);
                url = '/v1/orders';
                params = {
                  'app_key': appKey,
                  'status': _this.status,
                  'passenger_id': passenger && passenger.passenger && passenger.passenger.id ? passenger.passenger.id : '',
                  'page': _this.page,
                  'limit': _this.rows
                };
                _context.next = 9;
                return _this.$axios.get(url, params);

              case 9:
                data = _context.sent;

                if (!(data && data.code === 1)) {
                  _context.next = 25;
                  break;
                }

                responseData = [];
                _context.t0 = _this.active;
                _context.next = _context.t0 === 1 ? 15 : _context.t0 === 2 ? 18 : _context.t0 === 3 ? 21 : 24;
                break;

              case 15:
                responseData = data.runOrders ? data.runOrders : [];
                _this.total = data.runTotal;
                return _context.abrupt('break', 24);

              case 18:
                responseData = data.finishOrders ? data.finishOrders : [];
                _this.total = data.finnishTotal;
                return _context.abrupt('break', 24);

              case 21:
                responseData = data.cancelOrders ? data.cancelOrders : [];
                _this.total = data.cancelTotal;
                return _context.abrupt('break', 24);

              case 24:
                if (_this.page === 1) {
                  _this.orderList = responseData;
                } else if (_this.page > 1) {
                  _this.orderList = _this.orderList.concat(responseData);
                }

              case 25:
                _this.loadState = false;

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    loadDataButFn: function loadDataButFn() {
      this.page++;
      this.getOrdersFn();
    },
    clickFn: function clickFn(item) {
      switch (item.status) {
        case 1:
          this.$router.push({ path: '/daijia/await', query: { order_id: item.id } });
          break;
        case 5:
          this.$router.push({ path: '/daijia/await', query: { order_id: item.id } });
          break;
        case 10:
          this.$router.push({ path: '/daijia/service', query: { order_id: item.id } });
          break;
        case 15:
          this.$router.push({ path: '/daijia/service', query: { order_id: item.id } });
          break;
        case 20:
          this.$router.push({ path: '/daijia/service', query: { order_id: item.id } });
          break;
        case 25:
          this.$router.push({ path: '/daijia/service', query: { order_id: item.id } });
          break;
        case 28:
          this.$router.push({ path: '/daijia/service', query: { order_id: item.id } });
          break;
        case 30:
          this.$router.push({ path: '/daijia/settlement', query: { order_id: item.id } });
          break;
        case 35:
          this.$router.push({ path: '/daijia/affirm', query: { order_id: item.id } });
          break;
        case 40:
          this.$router.push({ path: '/daijia/affirm', query: { order_id: item.id, status: item.status } });
          break;
        case 45:
          this.$router.push({ path: '/daijia/checkOrder', query: { order_id: item.id } });
          break;
      }
    }
  },
  created: function created() {
    this.active = this.$route.query.active || 1;
    this.getOrdersFn();
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bannerContent',
  computed: {
    bannerContentFn: function bannerContentFn() {
      return window.bannerContent;
    }
  },
  data: function data() {
    return {};
  },

  methods: {},
  watch: {},
  mounted: function mounted() {
    var url = window.location.origin;
    var imgs = document.getElementsByTagName('img');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].src = imgs[i].src.replace(url + '', window.configure.serverUrl) + '?time=' + new Date().valueOf();
    }
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module_uploadMod_src_uploadMod__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module_uploadMod_src_uploadMod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__module_uploadMod_src_uploadMod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_hintBox_src_hintBox__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_hintBox_src_hintBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__module_hintBox_src_hintBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__module_star_src_star__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__module_star_src_star___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__module_star_src_star__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    XkUploadMod: __WEBPACK_IMPORTED_MODULE_4__module_uploadMod_src_uploadMod___default.a,
    XkHintBox: __WEBPACK_IMPORTED_MODULE_5__module_hintBox_src_hintBox___default.a,
    XkStar: __WEBPACK_IMPORTED_MODULE_6__module_star_src_star___default.a
  },
  name: 'affirm',
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    DjOrderInfo: 'DjOrderInfo',
    loginData: 'loginData'
  })),
  data: function data() {
    return {
      disabled: true,
      isShow: false,
      score: '',
      tagsVal: [],
      tags: [],
      remark: '',
      loadState: false,
      order_id: '',
      status: '',
      hintBox: {
        state: false,
        showState: 'yes',
        content: ''
      } };
  },

  methods: {
    getOrderFn: function getOrderFn() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, params, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = '/v1/orderFindOne';
                params = {
                  'app_key': window.configure.appKey,
                  'order_id': _this.order_id
                };
                _context.next = 4;
                return _this.$axios.get(url, params);

              case 4:
                data = _context.sent;

                if (data && data.code === 1) {
                  _this.remark = data.order.rate_content || '';
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    starFn: function starFn(msg) {
      this.score = msg;
    },
    submitFn: function submitFn() {
      var that = this;
      if (that.score !== '' && that.score) {
        that.loadState = true;
        that.$store.dispatch('DjEvaluateOrder', {
          passenger_id: window.configure.passengerInfo.id,
          order_id: that.order_id,
          score: that.score,
          remark: that.remark,
          fn: function fn(data) {
            that.loadState = false;
            if (data && data.code === 1) {
              that.hintBox = {
                state: true,
                showState: 'yes',
                content: '评价成功！'
              };
              setTimeout(function () {
                that.hintBox = false;
                that.$store.dispatch('unfilledOrderState', { type: 'daijia', state: false });

                that.$router.replace({ path: '/orderRecord', query: { active: 2 } });
              }, 1500);
            }
          }
        });
      } else {
        that.hintBox = {
          state: true,
          showState: 'no',
          content: '请选择星级后评价！'
        };
        setTimeout(function () {
          that.hintBox = false;
        }, 1500);
      }
    }
  },
  mounted: function mounted() {
    this.order_id = this.$route.query.order_id;
    this.status = this.$route.query.status || '';
    if (this.status === 40) {
      this.disabled = false;
      this.getOrderFn();
    }
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__module_add_src_add_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__module_add_src_add_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__module_add_src_add_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_inputBox_src_inputBox__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_inputBox_src_inputBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__module_inputBox_src_inputBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module_uploadMod_src_uploadMod__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module_uploadMod_src_uploadMod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__module_uploadMod_src_uploadMod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_hintBox_src_hintBox__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_hintBox_src_hintBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__module_hintBox_src_hintBox__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    XkHintBox: __WEBPACK_IMPORTED_MODULE_5__module_hintBox_src_hintBox___default.a,
    XkUploadMod: __WEBPACK_IMPORTED_MODULE_4__module_uploadMod_src_uploadMod___default.a,
    XkInputBox: __WEBPACK_IMPORTED_MODULE_3__module_inputBox_src_inputBox___default.a,
    XkAdd: __WEBPACK_IMPORTED_MODULE_1__module_add_src_add_vue___default.a
  },
  name: 'daijiaAwait',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    loginData: 'loginData',
    DjOrderInfo: 'DjOrderInfo'
  })),
  data: function data() {
    return {
      rotateVal: 0,
      reson: {
        state: false,
        val: ''
      },
      loadState: false,
      hintBox: {
        stateShow: false,
        state: 'yes',
        content: ''
      },
      disabled: true };
  },

  watch: {
    DjOrderInfo: function DjOrderInfo(val) {
      var that = this;
      if (that.loginData.passenger && val && that.loginData.passenger.id !== val.passenger_id) {
        that.$router.push({ path: '/daijia?app_key=' + window.configure.appKey });
        return;
      }
      if (val.status === 1 || val.status === 5) {
        setTimeout(function () {
          if (that.$route.fullPath.split('?')[0] === '/daijia/await') {
            that.$store.dispatch('DjOrderInfo', { order_id: that.$route.query.order_id });
          }
        }, 3000);
      }
      if (val.status === 10 || val.status === 15 || val.status === 20) {
        that.$router.push({ path: '/daijia/service', query: { order_id: that.$route.query.order_id } });
      }
      if (val.status === 35) {
        that.hintBox = {
          stateShow: true,
          state: 'yes',
          content: '您的订单已完成！'
        };
        setTimeout(function () {
          that.hintBox = false;
          that.$router.push({ path: '/daijia/affirm', query: { order_id: that.$route.query.order_id } });
          return false;
        }, 1500);
        return;
      }
      if (val.status === 45) {
        that.hintBox = {
          stateShow: true,
          state: 'no',
          content: '您的订单已被销单！'
        };
        setTimeout(function () {
          that.hintBox = false;
          that.$router.push({ path: '/daijia?app_key=' + window.configure.appKey });
          return false;
        }, 1500);
        return;
      }
    }
  },
  methods: {
    cancelOrderFn: function cancelOrderFn(val) {
      var _this = this;

      var that = this;
      this.reson.state = !this.reson.state;
      if (val === 'affirm') {
        if (this.reson.val !== '') {
          that.loadState = true;
          this.$store.dispatch('putCancelOrder', {
            order_id: that.$route.query.order_id,
            remark: this.reson.val,
            fn: function fn(state) {
              that.loadState = false;
              if (state && state.code === 1) {
                _this.reson.state = false;
                that.hintBox = {
                  stateShow: true,
                  state: 'yes',
                  content: '销单成功！'
                };
                setTimeout(function () {
                  that.hintBox.stateShow = false;
                  that.$router.push({ path: '/daijia?app_key=' + window.configure.appKey });
                }, 1500);
              }
            }
          });
        } else {
          this.reson.state = true;
          that.hintBox = {
            stateShow: true,
            state: 'no',
            content: '请输入销单理由！'
          };
          setTimeout(function () {
            that.hintBox.stateShow = false;
          }, 1500);
        }
      }
    },
    inputContentFn: function inputContentFn() {
      if (this.reson.val) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    }
  },
  mounted: function mounted() {
    var that = this;

    function rotateFn() {
      setTimeout(function () {
        that.rotateVal = that.rotateVal + 8;
        rotateFn();
      }, 39);
    }

    that.$store.dispatch('checkLogin', function (sate) {
      if (sate) {
        that.$store.dispatch('DjOrderInfo', { order_id: that.$route.query.order_id });
      }
    });

    rotateFn();
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__module_waiter_src_waiter__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__module_waiter_src_waiter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__module_waiter_src_waiter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_method__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module_star_src_star__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module_star_src_star___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__module_star_src_star__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_tagitem_src_tagitem__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_tagitem_src_tagitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__module_tagitem_src_tagitem__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    XkTagItem: __WEBPACK_IMPORTED_MODULE_5__module_tagitem_src_tagitem___default.a,
    XkStar: __WEBPACK_IMPORTED_MODULE_4__module_star_src_star___default.a,
    XkWaiter: __WEBPACK_IMPORTED_MODULE_1__module_waiter_src_waiter___default.a
  },
  name: '',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    DjQueryReview: 'DjQueryReview',
    DjPayInfo: 'DjPayInfo',
    DjOrderInfo: 'DjOrderInfo',
    loginData: 'loginData'
  }), {
    payDataFn: function payDataFn() {
      var that = this;
      var obj = [];
      if (that.DjPayInfo) {
        if (that.DjPayInfo.payMoney) {
          obj.push({
            name: '服务费',
            val: (that.DjPayInfo.realCash - that.DjPayInfo.otherMoney - that.DjPayInfo.yuanchengMoney).toFixed(1)
          });
        }
        if (that.DjPayInfo.goodsCash) {
          obj.push({
            name: '商品价格',
            val: that.DjPayInfo.goodsCash.toFixed(1)
          });
        }
        if (that.DjPayInfo.guoluMoney) {
          obj.push({
            name: '过路费',
            val: that.DjPayInfo.guoluMoney.toFixed(1)
          });
        }
        if (that.DjPayInfo.otherMoney) {
          obj.push({
            name: '其他费用',
            val: that.DjPayInfo.otherMoney.toFixed(1)
          });
        }
        if (that.DjPayInfo.thanksCash) {
          obj.push({
            name: '感谢费',
            val: that.DjPayInfo.thanksCash.toFixed(1)
          });
        }
        if (that.DjPayInfo.yuanchengMoney) {
          obj.push({
            name: '远程费',
            val: that.DjPayInfo.yuanchengMoney.toFixed(1)
          });
        }
        if (that.DjPayInfo.couponMoney) {
          obj.push({
            name: '优惠券',
            red: true,
            val: -that.DjPayInfo.couponMoney + '.00'
          });
        }
      }
      return obj;
    }
  }),
  data: function data() {
    return {
      data: {
        costDetail: [{
          name: '服务费',
          val: '00'
        }, {
          name: '过路费',
          val: '00'
        }, {
          name: '远程费',
          val: '00'
        }, {
          name: '行驶时间费',
          val: '00',
          time: '0'
        }, {
          name: '等待时长费',
          val: '00',
          time: '0'
        }, {
          name: '其他（商品费，感谢费）',
          val: '00'
        }, {
          name: '优惠券',
          val: '00'
        }] }
    };
  },

  methods: {
    detailsBoxFn: function detailsBoxFn() {
      this.$refs.detailsBox.switchFn();
    }
  },
  watch: {
    DjPayInfo: function DjPayInfo(val) {
      if (val) {
        this.data.costDetail = [{
          name: '服务费',
          val: this.DjPayInfo.payMoney
        }, {
          name: '过路费',
          val: this.DjPayInfo.guoluMoney
        }, {
          name: '远程费',
          val: this.DjPayInfo.yuanchengMoney
        }, {
          name: '行驶时间费',
          val: this.DjPayInfo.runTimePrice,
          time: this.DjPayInfo.runTime
        }, {
          name: '等待时长费',
          val: this.DjPayInfo.waitPrice,
          time: this.DjPayInfo.midwayWait
        }, {
          name: '其他（商品费，感谢费）',
          val: this.DjPayInfo.otherMoney
        }, {
          name: '优惠券',
          val: this.DjPayInfo.couponMoney
        }];
      }
    },
    DjOrderInfo: function DjOrderInfo(val) {
      var that = this;
      if (val) {
        if (that.loginData.passenger && val && that.loginData.passenger.id !== that.DjOrderInfo.clientId) {
          that.$router.push('/daijia');
          return;
        }
      }
    }
  },
  mounted: function mounted() {
    var that = this;
    that.$store.dispatch('checkLogin', function (state) {
      if (state) {
        that.$store.dispatch('DjOrderInfo', { orderId: __WEBPACK_IMPORTED_MODULE_3__assets_js_method__["a" /* default */].AcquireUrlParameter().orderId });
        that.$store.dispatch('DjQueryReview', {
          passengerId: that.loginData.passenger.id,
          orderId: __WEBPACK_IMPORTED_MODULE_3__assets_js_method__["a" /* default */].AcquireUrlParameter().orderId
        });
        that.$store.dispatch('DjPayInfo', { orderId: __WEBPACK_IMPORTED_MODULE_3__assets_js_method__["a" /* default */].AcquireUrlParameter().orderId });
      }
    });
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_method__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__module_rollBanner_src_rollBanner__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__module_rollBanner_src_rollBanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__module_rollBanner_src_rollBanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__module_siteInput_src_siteInput__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__module_siteInput_src_siteInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__module_siteInput_src_siteInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__module_input_src_input__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__module_input_src_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__module_input_src_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__module_detailsBox_src_detailsBox__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__module_detailsBox_src_detailsBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__module_detailsBox_src_detailsBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__module_inputBox_src_inputBox__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__module_inputBox_src_inputBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__module_inputBox_src_inputBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__module_datePickerMod_src_datePickerMod__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__module_datePickerMod_src_datePickerMod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__module_datePickerMod_src_datePickerMod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__module_couponSelect_src_couponSelect__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__module_couponSelect_src_couponSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__module_couponSelect_src_couponSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__module_uploadMod_src_uploadMod__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__module_uploadMod_src_uploadMod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__module_uploadMod_src_uploadMod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__module_unfilledOrderMod_src_unfilledOrderMod__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__module_unfilledOrderMod_src_unfilledOrderMod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__module_unfilledOrderMod_src_unfilledOrderMod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__module_hintBox_src_hintBox__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__module_hintBox_src_hintBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__module_hintBox_src_hintBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__module_myPicker_myPicker__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__module_myPicker_myPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__module_myPicker_myPicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_mint_ui__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_js_cookie__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_json_bigint_xk__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_json_bigint_xk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_json_bigint_xk__);

























/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    XkHintBox: __WEBPACK_IMPORTED_MODULE_17__module_hintBox_src_hintBox___default.a,
    XkUnfilledOrderMod: __WEBPACK_IMPORTED_MODULE_16__module_unfilledOrderMod_src_unfilledOrderMod___default.a,
    XkUploadMod: __WEBPACK_IMPORTED_MODULE_15__module_uploadMod_src_uploadMod___default.a,
    XkCouponSelect: __WEBPACK_IMPORTED_MODULE_14__module_couponSelect_src_couponSelect___default.a,
    XkDatePickerMod: __WEBPACK_IMPORTED_MODULE_13__module_datePickerMod_src_datePickerMod___default.a,
    XkInputBox: __WEBPACK_IMPORTED_MODULE_12__module_inputBox_src_inputBox___default.a,
    XkDetailsBox: __WEBPACK_IMPORTED_MODULE_11__module_detailsBox_src_detailsBox___default.a,
    XkInput: __WEBPACK_IMPORTED_MODULE_10__module_input_src_input___default.a,
    XkSiteInput: __WEBPACK_IMPORTED_MODULE_9__module_siteInput_src_siteInput___default.a,
    XkRollBanner: __WEBPACK_IMPORTED_MODULE_8__module_rollBanner_src_rollBanner___default.a,
    xkMyPicker: __WEBPACK_IMPORTED_MODULE_18__module_myPicker_myPicker___default.a,
    Picker: __WEBPACK_IMPORTED_MODULE_19_mint_ui__["Picker"]
  },
  name: 'DaiJia',
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])({
    daijiaBanner: 'daijiaBanner',
    DjBudgetCost: 'DjBudgetCost',
    DJBusiness: 'DJBusiness',
    addressRecord: 'addressRecord',
    loginData: 'loginData',
    positioning: 'positioning',
    companyInfo: 'companyInfo',
    getNearDrivers: 'getNearDrivers',
    unfilledOrderState: 'unfilledOrderState',
    unfilledOrder: 'unfilledOrder',
    djCoupnsGetter: 'djCoupnsGetter',
    login: 'login'
  }), {
    unfilledOrderFn: function unfilledOrderFn() {
      var unfilledOrder = [];
      var daijiaData = [];
      if (this.unfilledOrder && this.unfilledOrder.length > 0) {
        this.unfilledOrder.forEach(function (row) {
          if (row.business === 'daijia') {
            daijiaData.push(row);
          }
        });
        if (daijiaData && daijiaData.length > 0) {
          var obj = {};
          for (var i = 0; i < daijiaData.length; i++) {
            obj = {
              startAddress: daijiaData[i].book_address,
              endAddress: daijiaData[i].destination,
              serverTime: __WEBPACK_IMPORTED_MODULE_6__assets_js_method__["a" /* default */].TimestampDate(daijiaData[i].book_time),
              orderId: daijiaData[i].id,
              status: ''
            };
            switch (daijiaData[i].status) {
              case 1:
                obj.status = {
                  name: '新单',
                  router: { path: '/daijia/await', query: { order_id: daijiaData[i].id } }
                };
                break;
              case 5:
                obj.status = {
                  name: '等待中',
                  router: { path: '/daijia/await', query: { order_id: daijiaData[i].id } }
                };
                break;
              case 10:
                obj.status = {
                  name: '已接单',
                  router: { path: '/daijia/service', query: { order_id: daijiaData[i].id } }
                };
                break;
              case 15:
                obj.status = {
                  name: '前往达预约地',
                  router: { path: '/daijia/service', query: { order_id: daijiaData[i].id } }
                };
                break;
              case 20:
                obj.status = {
                  name: '到达预约地',
                  router: { path: '/daijia/service', query: { order_id: daijiaData[i].id } }
                };
                break;
              case 25:
                obj.status = {
                  name: '前往目的地',
                  router: { path: '/daijia/service', query: { order_id: daijiaData[i].id } }
                };
                break;
              case 28:
                obj.status = {
                  name: '等待',
                  router: { path: '/daijia/service', query: { order_id: daijiaData[i].id } }
                };
                break;
              case 30:
                obj.status = {
                  name: '待结算',
                  router: { path: '/daijia/settlement', query: { order_id: daijiaData[i].id, app_key: this.app_key } }
                };
                this.$router.push({
                  path: '/daijia/settlement',
                  query: { order_id: daijiaData[i].id, app_key: this.app_key }
                });
                break;
              case 35:
                obj.status = {
                  name: '待评价',
                  router: { path: '/daijia/affirm', query: { order_id: daijiaData[i].id } }
                };
                break;
              case 45:
                obj.status = {
                  name: '已销单',
                  router: { path: '/daijia/checkOrder', query: { order_id: daijiaData[i].id } }
                };
                break;
            }
            unfilledOrder.push(obj);
          }
        }
      }
      return unfilledOrder;
    },
    addressRecordFn: function addressRecordFn() {
      if (this.addressRecord.daijia.length > 0) {
        return this.addressRecord.daijia;
      }
    }
  }),
  data: function data() {
    return {
      charge_id: 0, charge_type: 1,
      person_charge_id: 0, person_charge_type: 1,
      enterprise_charge_id: 0, enterprise_charge_type: 1, enterprise_budget_fee: 0,
      total_fee: 0, min_fee: 0, money: 0, companyId: null,
      ygcx: false, hasCoupon: false, is_fixed_price: 2, budget_distance: 0, budget_time: 0,
      adds: {
        startAdd: { beginAddress: '', beginAddressDetail: '', beginLat: '', beginLng: '' },
        endAdd: { endAddress: '', endAddressDetail: '', endLat: '', endLng: '' }
      },
      others: { showState: false, state: true, othersPhone: '', recordPhone: '' },
      startTime: { val: '', name: '现在出发' },
      loadState: false,
      couponMoney: { type: '', id: '', num: '' },
      hintBox: { stateShow: false, state: 'yes', content: '' },
      datePickerState: false,
      couponData: [],
      typeAll: { action: 0, data: [] },
      typeAcId: null,
      budgetFee: 0,
      feeObj: null,
      budgetFeeRemark: '',
      visible: false,
      slots: [1],
      driverNumber: 1,
      app_key: '',
      is_deduction: '',
      enterprise_id: '',
      enterprise_member_deduction: '',
      enterprise_name: '',
      enterpriseDisabled: false,
      distance: 0,
      time: 0,
      route: '',
      company_id: ''
    };
  },

  watch: {
    positioning: {
      handler: function handler(val) {
        if (!this.adds.startAdd.beginLat || !this.adds.startAdd.beginLng) {
          if (val && val.lng && val.lat) {
            this.adds.startAdd = {
              citycode: val.citycode,
              adcode: val.adcode,
              beginAddress: val.name,
              beginAddressDetail: val.detailedAddress,
              beginLat: val.lat,
              beginLng: val.lng,
              depart_address_detail: val.detailedAddress
            };
            console.log('监听定位信息', this.adds.startAdd);
          }
        }
      },

      deep: true
    },
    loginData: function loginData(val) {
      var that = this;
      if (that.loginData && that.loginData.passenger && that.others.othersPhone === '' && that.others.recordPhone === '') {
        that.unfilledOrderShowState = true;
      }
      if (that.loginData && that.loginData.passenger) {}
    },
    unfilledOrder: function unfilledOrder(val) {
      var that = this;
      if (val && val.length > 0) {
        val.forEach(function (row) {
          if (Number(row.status) === 30) {
            if (row.business === 'daijia') {
              that.$Util.toast({ text: '您有未支付的代驾订单！' });
              that.$router.push({ path: '/daijia/settlement', query: { order_id: row.id, app_key: that.app_key } });
            }
          }
        });
      }
    }
  },
  methods: {
    getCompanyFn: function getCompanyFn(citycode, adcode) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, params, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = '/v1/company';
                params = { ad_code: adcode, city_code: citycode };
                _context.next = 4;
                return _this.$axios.get(url, params);

              case 4:
                data = _context.sent;

                if (data && data.code === 1) {
                  _this.getBusinessFn(data.companyinfo.id);
                  _this.companyId = data.companyinfo.id;

                  _this.$Cookie.set('companyinfo', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(data.companyinfo));
                  _this.$store.dispatch('getNearDrivers', {
                    company_id: data.companyinfo.id,
                    lng: _this.adds.startAdd.beginLng, lat: _this.adds.startAdd.beginLat,
                    distance: 20, business: 'daijia'
                  });
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getBusinessFn: function getBusinessFn(companyId) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var url, params, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = '/v1/getBusiness';
                params = { company_id: companyId, business: 'daijia' };
                _context2.next = 4;
                return _this2.$axios.get(url, params);

              case 4:
                data = _context2.sent;

                if (data && data.code === 1) {
                  _this2.typeAll.data = data.categories || [];
                  if (_this2.typeAll.action == 0) {
                    console.log("vettttttttttttttt", _this2.typeAll);
                    _this2.$Cookie.set('typeAcId', _this2.typeAll.data[0].id);
                    _this2.typeAcId = data.categories[0].id;
                  } else {
                    if (_this2.$Cookie.get('typeAcId')) {
                      _this2.typeAcId = _this2.$Cookie.get('typeAcId');
                    } else {
                      _this2.typeAcId = data.categories[0].id;
                    }
                  }


                  if (!_this2.$Cookie.get('typeAcId')) {
                    if (_this2.typeAll.data[0].is_fixed_price) {
                      _this2.is_fixed_price = 1;
                    } else {
                      _this2.is_fixed_price = 2;
                    }
                  }
                  _this2.getBudgetPriceFn();
                }

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getBudgetPriceFn: function getBudgetPriceFn(enterprise_id) {
      var that = this;
      if (this.loginData.passenger) {
        that.$store.dispatch('getBudgetPrice', {
          'order_type': 1,
          'order_time': that.startTime.val,
          'ad_code': that.adds.startAdd.adcode,
          'company_id': that.companyId,
          'passenger_id': window.configure.passengerInfo ? window.configure.passengerInfo.id : null,
          'channel': 'wechat',
          'book_address_lat': that.adds.startAdd.beginLat,
          'book_address_lng': that.adds.startAdd.beginLng,
          'map': that.route || '',
          'distance': that.distance,
          'time': that.time,
          'enterprise_id': enterprise_id || '',
          'category_id': that.typeAcId,
          'search_platform': 'wechat',
          'sub_search_platform': enterprise_id ? 'enterprise' : 'onekey',
          fn: function fn(data) {
            if (data && data.code === 1 && data.applet_budget_fee) {
              if (enterprise_id) {
                if (data.applet_budget_fee.normal) {
                  that.money = data.applet_budget_fee.normal.budget_fee ? data.applet_budget_fee.normal.budget_fee / 100 : 0;
                  that.enterprise_budget_fee = data.applet_budget_fee.normal.total_fee ? data.applet_budget_fee.normal.total_fee / 100 : 0;
                }
                if (data.applet_budget_fee.fence) {
                  that.money = data.applet_budget_fee.fence.budget_fee ? data.applet_budget_fee.fence.budget_fee / 100 : 0;
                  that.enterprise_budget_fee = data.applet_budget_fee.fence.total_fee ? data.applet_budget_fee.fence.total_fee / 100 : 0;
                }
                that.enterprise_charge_id = data.applet_budget_fee.charge_id;
                that.enterprise_charge_type = data.applet_budget_fee.type;
              } else {
                if (data.applet_budget_fee.normal) {
                  that.budgetFee = data.applet_budget_fee.normal.budget_fee / 100;
                  that.total_fee = data.applet_budget_fee.normal.total_fee / 100;
                  that.min_fee = data.applet_budget_fee.normal.min_fee ? data.applet_budget_fee.normal.min_fee / 100 : 0;
                  that.feeObj = data.applet_budget_fee.normal;
                }
                if (data.applet_budget_fee.fence) {
                  that.budgetFee = data.applet_budget_fee.fence.budget_fee / 100;
                  that.total_fee = data.applet_budget_fee.fence.total_fee / 100;
                  that.min_fee = data.applet_budget_fee.fence.min_fee ? data.applet_budget_fee.fence.min_fee / 100 : 0;
                  that.feeObj = data.applet_budget_fee.fence;
                }
                that.person_charge_id = data.applet_budget_fee.charge_id;
                that.person_charge_type = data.applet_budget_fee.type;
                that.budget_time = Date.parse(new Date()) / 1000;
              }
            }
          }
        });
      }
    },
    getArticlebyaliasFn: function getArticlebyaliasFn() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var companyInfo, params, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                companyInfo = null;

                if (__WEBPACK_IMPORTED_MODULE_20_js_cookie___default.a.get('companyinfo')) {
                  companyInfo = __WEBPACK_IMPORTED_MODULE_21_json_bigint_xk___default.a.parse(__WEBPACK_IMPORTED_MODULE_20_js_cookie___default.a.get('companyinfo'));
                }
                params = _this3.$utils.objKeySort('/passenger/api/v1/articlebyalias', {
                  companyId: companyInfo.id || 0,
                  alias: 'CutomerPricingRules'
                });
                _context3.next = 5;
                return _this3.$http.get('/v1/articlebyalias', { params: params });

              case 5:
                data = _context3.sent.body;

                if (data && data.code === 1) {
                  _this3.budgetFeeRemark = data.article.contents;
                }

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getCouponTypeFn: function getCouponTypeFn() {
      var that = this;
      this.$store.dispatch('v5getCoupons', {
        limit: 80,
        page: 1,
        service_type: 1,
        channel: true,
        fn: function fn(data) {
          console.log("poooooooooo", data);
          if (data.code == 300000) {
            that.hintBox = {
              stateShow: true,
              state: 'no',
              content: data.msg
            };
          }
        }
      });
    },
    systemConfigFn: function systemConfigFn(auth) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var appkey, params, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                appkey = _this4.$route.query.app_key || window.configure.appKey;
                params = _this4.$utils.objKeySort('/passenger/api/v1/systemConfig', { 'app_key': appkey });
                _context4.next = 4;
                return _this4.$http.get('/v1/systemConfig', { params: params });

              case 4:
                data = _context4.sent.body;

                if (!(data && data.code === 1)) {
                  _context4.next = 9;
                  break;
                }

                return _context4.abrupt('return', true);

              case 9:
                _this4.loadState = true;
                _this4.hintBox = {
                  stateShow: true,
                  state: 'no',
                  content: data.msg
                };

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },

    startCityFn: function startCityFn(obj, val) {
      var that = this;
      this.adds.startAdd.citycode = obj.citycode;
      this.adds.startAdd.adcode = obj.adcode;
      this.adds.startAdd.beginAddress = obj.name;
      this.adds.startAdd.beginAddressDetail = obj.detailedAddress;
      this.adds.startAdd.beginLng = obj.lng;
      this.adds.startAdd.beginLat = obj.lat;
      this.adds.startAdd.depart_address_detail = obj.detailedAddress;
      this.getCompanyFn(obj.citycode, obj.adcode);
      console.log("llllllllll", this.loginData);
      if (this.loginData.passenger) {
        this.affirmFn();
      }
      setTimeout(function () {
        if (that.enterprise_id && that.adds.endAdd.endLng && that.is_fixed_price === 1) {
          that.getBudgetPriceFn();
        }
      }, 1000);
    },

    endCityFn: function endCityFn(obj) {
      var that = this;
      this.adds.endAdd.endAddress = obj.name;
      this.adds.endAdd.endAddressDetail = obj.detailedAddress;
      this.adds.endAdd.destination_address_detail = obj.detailedAddress;
      this.adds.endAdd.endLng = obj.lng;
      this.adds.endAdd.endLat = obj.lat;
      this.affirmFn();
      setTimeout(function () {
        if (that.enterprise_id && that.adds.endAdd.endLng && that.is_fixed_price === 1) {
          that.getBudgetPriceFn(that.enterprise_id);
        }
      }, 1000);
    },

    typeTabFn: function typeTabFn(obj) {
      var _this5 = this;

      this.typeAll.action = obj.index;
      this.typeAcId = obj.data.id;
      this.$Cookie.set('typeAcId', obj.data.id);
      var that = this;
      this.is_fixed_price = obj.data.is_fixed_price ? 1 : 2;

      that.$store.dispatch('checkLogin', function (state) {
        if (state && that.loginData && _this5.loginData.passenger) {
          if (that.enterprise_id && that.adds.endAdd.endLng && that.is_fixed_price === 1) {
            that.getBudgetPriceFn(that.enterprise_id);
          }
          if (that.adds.endAdd.endLng && that.adds.endAdd.endLng !== '') {
            that.affirmFn();
          } else {
            that.getBudgetPriceFn();
          }
        }
      });
    },

    affirmFn: function affirmFn() {
      var that = this;
      if (that.adds.endAdd.endLng && that.adds.endAdd.endLat) {
        var routesDataSet = {};
        var route = null;
        that.$store.dispatch('routePlanning', {
          originLng: that.adds.startAdd.beginLng,
          originLat: that.adds.startAdd.beginLat,
          destinationLng: that.adds.endAdd.endLng || '',
          destinationLat: that.adds.endAdd.endLat || '',
          fn: function fn(data) {
            if (data.status === '1') {
              var driving = data.route.paths;
              if (driving.length > 1) {
                var distanceArr = [];
                var sortClass1 = function sortClass1(sortData) {
                  var groupBy1 = function groupBy1(array, f) {
                    var groups1 = {};
                    array.forEach(function (o) {
                      var group1 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(f(o));
                      groups1[group1] = groups1[group1] || [];
                      groups1[group1].push(o);
                    });
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(groups1).map(function (group1) {
                      return groups1[group1];
                    });
                  };
                  var sorted1 = groupBy1(sortData, function (item) {
                    return item.distance;
                  });
                  return sorted1;
                };

                distanceArr = sortClass1(driving);
                if (distanceArr[0].length > 1) {
                  var timeArr = [];
                  var sortClass2 = function sortClass2(sortData) {
                    var groupBy2 = function groupBy2(array, f) {
                      var groups2 = {};
                      array.forEach(function (o) {
                        var group2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(f(o));
                        groups2[group2] = groups2[group2] || [];
                        groups2[group2].push(o);
                      });
                      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(groups2).map(function (group2) {
                        return groups2[group2];
                      });
                    };
                    var sorted2 = groupBy2(sortData, function (item) {
                      return item.duration;
                    });
                    return sorted2;
                  };

                  timeArr = sortClass2(distanceArr);
                  if (timeArr.length > 1) {
                    routesDataSet = timeArr[0];
                  } else {
                    routesDataSet = timeArr[0];
                  }
                } else {
                  routesDataSet = distanceArr[0];
                }
              } else {
                routesDataSet = driving[0];
              }
              var stepsRaws = Array.isArray(routesDataSet) ? routesDataSet[0].steps : routesDataSet.steps;
              var stepsRawsDiss = [],
                  stepsRawsDissObj = {};
              if (Array.isArray(routesDataSet)) {
                for (var i = 0; i < stepsRaws.length; i++) {
                  stepsRawsDissObj = {
                    distance: stepsRaws[i].distance,
                    duration: stepsRaws[i].duration,
                    polyline: stepsRaws[i].polyline
                  };
                  stepsRawsDiss.push(stepsRawsDissObj);
                }
                route = {
                  duration: routesDataSet[0].duration,
                  distance: routesDataSet[0].distance,
                  steps: stepsRawsDiss
                };
                route.duration = Number(route.duration);
                route.distance = Number(route.distance);
                route.steps.forEach(function (item) {
                  item.distance = Number(item.distance);
                  item.duration = Number(item.duration);
                });
                this.distance = routesDataSet[0].distance / 1000;
                this.time = Math.ceil(routesDataSet[0].duration / 60);
              } else {
                for (var _i = 0; _i < stepsRaws.length; _i++) {
                  stepsRawsDissObj = {
                    distance: stepsRaws.distance,
                    duration: stepsRaws.duration,
                    polyline: stepsRaws.polyline
                  };
                  stepsRawsDiss.push(stepsRawsDissObj);
                }
                route = {
                  duration: routesDataSet.duration,
                  distance: routesDataSet.distance,
                  steps: stepsRawsDiss
                };
                route.duration = Number(route.duration);
                route.distance = Number(route.distance);
                route.steps.forEach(function (item) {
                  item.distance = Number(item.distance);
                  item.duration = Number(item.duration);
                });
                this.distance = routesDataSet.distance / 1000;
                this.time = Math.ceil(routesDataSet.duration / 60);
              }
              if (!route) {
                this.route = '';
              } else {
                that.budget_distance = route.distance;
                that.distance = route.distance;
                that.time = route.duration;
                that.route = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(route);
              }
              that.getBudgetPriceFn();
            }
          }
        });
      } else {
        that.distance = '';
        that.time = '';
        that.getBudgetPriceFn();
      }
    },
    othersPhoneFn: function othersPhoneFn(obj) {
      var that = this;
      switch (obj) {
        case 'affirm':
          that.others.showState = false;
          if (that.others.othersPhone === '') {
            that.others.state = true;
            that.others.othersPhone = '';
            that.others.recordPhone = that.$store.state.mc.phoneNo;
            return false;
          }
          if (that.others.othersPhone !== that.$store.state.mc.phoneNo) {
            that.others.state = false;
            that.others.recordPhone = that.others.othersPhone;
          } else {
            that.others.state = true;
            that.others.recordPhone = that.others.othersPhone;
            that.others.othersPhone = '';
          }
          break;
        case 'cancel':
          that.others.showState = false;
          if (__WEBPACK_IMPORTED_MODULE_6__assets_js_method__["a" /* default */].checkPhone(that.others.othersPhone) && that.others.othersPhone === that.$store.state.mc.phoneNo) {
            that.others.state = true;
            that.others.othersPhone = '';
          }
          if (__WEBPACK_IMPORTED_MODULE_6__assets_js_method__["a" /* default */].checkPhone(that.others.othersPhone) && that.others.recordPhone !== that.others.othersPhone) {
            that.others.state = false;
            that.others.othersPhone = that.others.recordPhone;
          }
          if (!__WEBPACK_IMPORTED_MODULE_6__assets_js_method__["a" /* default */].checkPhone(that.others.othersPhone) && that.others.recordPhone !== that.others.othersPhone && that.others.recordPhone !== that.$store.state.mc.phoneNo) {
            that.others.state = false;
            that.others.othersPhone = that.others.recordPhone;
          }
          if (!__WEBPACK_IMPORTED_MODULE_6__assets_js_method__["a" /* default */].checkPhone(that.others.othersPhone) && that.others.recordPhone !== that.others.othersPhone && that.others.recordPhone === that.$store.state.mc.phoneNo) {
            that.others.state = true;
            that.others.othersPhone = '';
          }
          break;
        case 'show':
          that.others.showState = true;
          setTimeout(function () {
            if (__WEBPACK_IMPORTED_MODULE_6__assets_js_method__["a" /* default */].checkPhone(that.others.othersPhone) || that.others.othersPhone === '') {
              that.$refs.othersPhone.affStateFn(true);
            } else {
              that.$refs.othersPhone.affStateFn(false);
            }
          }, 0);
          break;
      }
    },
    othersStateFn: function othersStateFn() {
      if (this.others.othersPhone !== '' && this.others.state) {
        this.$refs.othersPhone.stateFn();
      } else {
        this.others.state = true;
      }
    },
    othersPhoneCheck: function othersPhoneCheck() {
      if (__WEBPACK_IMPORTED_MODULE_6__assets_js_method__["a" /* default */].checkPhone(this.others.othersPhone) || this.others.othersPhone === '') {
        this.$refs.othersPhone.affStateFn(true);
      } else {
        this.$refs.othersPhone.affStateFn(false);
      }
    },
    callCarFn: function callCarFn(type) {
      var _this6 = this;

      var that = this;
      that.loadState = true;
      that.$store.dispatch('checkLogin', function (state) {
        if (state) {
          if (!that.adds.startAdd.beginLat || !that.adds.startAdd.beginLng) {
            if (_this6.positioning && _this6.positioning.lng && _this6.positioning.lat) {
              _this6.adds.startAdd = {
                beginAddress: _this6.positioning.name,
                beginAddressDetail: _this6.positioning.detailedAddress,
                beginLat: _this6.positioning.lat,
                beginLng: _this6.positioning.lng
              };
            }
          }
          if (!that.adds.startAdd.beginLat || !that.adds.startAdd.beginLng || !that.adds.startAdd.beginAddress) {
            that.hintBox = {
              stateShow: true,
              state: 'no',
              content: '请选择起点'
            };
            setTimeout(function () {
              that.loadState = false;
              that.hintBox.stateShow = false;
            }, 1500);
            return false;
          }
          var bookTime = 0;
          if (that.startTime.name === '现在出发') {
            var timetamp = Date.parse(new Date()) / 1000;
            bookTime = that.startTime.val ? that.startTime.val : timetamp;
          } else {
            bookTime = that.startTime.val / 1000;
          }
          if (that.loginData && that.loginData.passenger && that.adds.startAdd.beginLat && that.adds.startAdd.beginLng) {
            var obj = {
              'order_person': that.loginData.passenger.name,
              'order_person_id': that.loginData.passenger.id,
              'number': that.driverNumber,
              'cid': that.typeAcId,
              'passenger_phone': that.loginData.passenger.phone,
              'channelName': 'wechat',
              'book_address': that.adds.startAdd.beginAddress,
              'startAddressDetail': that.adds.startAdd.beginAddressDetail,
              'book_address_lat': that.adds.startAdd.beginLat,
              'book_address_lng': that.adds.startAdd.beginLng,
              'user_phone': that.others.recordPhone,
              'destination': that.adds.endAdd.endAddress,
              'endAddressDetail': that.adds.endAdd.endAddressDetail,
              'destination_lat': that.adds.endAdd.endLat,
              'destination_lng': that.adds.endAdd.endLng,
              'book_time': bookTime,
              'budget_fee': that.total_fee || 0,
              'coupon_id': that.couponMoney.id,
              'ad_code': that.adds.startAdd.adcode,
              'order_type': 1, fn: function fn(data) {
                if (data && data.code === 1) {
                  that.$Cookie.set('typeAcId', '');
                  that.hintBox = {
                    stateShow: true,
                    state: 'yes',
                    content: '下单成功！'
                  };
                  setTimeout(function () {
                    that.loadState = false;
                    that.hintBox.stateShow = false;
                    that.$router.push({
                      path: '/daijia/await',
                      query: { order_id: data.ids[0] }
                    });
                  }, 1300);
                } else if (data.code === 31012) {
                  that.hintBox = {
                    stateShow: true,
                    state: 'no',
                    content: '选择多位司机时，不能使用优惠券！'
                  };
                  setTimeout(function () {
                    that.loadState = false;
                    that.hintBox.stateShow = false;
                  }, 1300);
                } else if (data.code === 30014) {
                  that.hintBox = {
                    stateShow: true,
                    state: 'no',
                    content: '你已被加入黑名单！'
                  };
                  setTimeout(function () {
                    that.loadState = false;
                    that.hintBox.stateShow = false;
                  }, 1300);
                } else if (data.code === 20091) {
                  that.hintBox = {
                    stateShow: true,
                    state: 'no',
                    content: '你的并行订单量已经达到上限！'
                  };
                  setTimeout(function () {
                    that.loadState = false;
                    that.hintBox.stateShow = false;
                  }, 1300);
                } else if (data.code === 120701) {
                  that.hintBox = {
                    stateShow: true,
                    state: 'no',
                    content: '业务受限，请刷新后重试！'
                  };
                  setTimeout(function () {
                    that.loadState = false;
                    that.hintBox.stateShow = false;
                  }, 1300);
                } else if (data.code === 120704) {
                  that.hintBox = {
                    stateShow: true, state: 'no',
                    content: data.msg
                  };
                  that.getBudgetPriceFn();
                  setTimeout(function () {
                    that.enterprise_id && that.getBudgetPriceFn();
                  }, 500);
                  setTimeout(function () {
                    that.loadState = false;
                    that.hintBox.stateShow = false;
                  }, 1300);
                } else if (data.code === 300000) {
                  that.hintBox = {
                    stateShow: true,
                    state: 'no',
                    content: data.msg
                  };
                  setTimeout(function () {
                    that.loadState = false;
                    that.hintBox.stateShow = false;
                  }, 1300);
                } else {
                  that.hintBox = {
                    stateShow: true,
                    state: 'no',
                    content: data.msg
                  };
                  setTimeout(function () {
                    that.loadState = false;
                    that.hintBox.stateShow = false;
                  }, 1300);
                }
              }
            };

            if (that.enterprise_id && type === 'official') {
              obj.enterprise_id = _this6.enterprise_id;
              obj.enterprise_member_deduction = _this6.enterprise_member_deduction;
              obj.order_type = 2;
              obj.budget_fee = that.enterprise_budget_fee || 0;
              that.charge_id = that.enterprise_charge_id;
              that.charge_type = that.enterprise_charge_type;
            } else {
              that.charge_id = that.person_charge_id;
              that.charge_type = that.person_charge_type;
            }
            if (that.is_fixed_price == 1) {
              if (!obj.destination_lat) {
                that.hintBox = {
                  stateShow: true,
                  state: 'no',
                  content: '一口价订单需选择目的地'
                };
                setTimeout(function () {
                  that.loadState = false;
                  that.hintBox.stateShow = false;
                }, 1300);
              } else {
                obj.is_fixed_price = that.is_fixed_price;
                obj.fixed_price = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
                  budget_time: that.budget_time,
                  budget_distance: that.budget_distance / 1000,
                  price: type === 'official' ? that.enterprise_budget_fee : that.total_fee,
                  min_fee: that.min_fee, charge_id: that.charge_id, charge_type: that.charge_type,
                  deduct: 0, deduct_type: 3
                });
                that.$store.dispatch('postCreateOrder', obj);
              }
            } else {
              that.$store.dispatch('postCreateOrder', obj);
            }
          }
        } else {
          _this6.$router.push('/login');
        }
      });
    },
    DatePickerFn: function DatePickerFn(time) {
      if (time) {
        console.log('时间选择', time);
        this.startTime.val = time.val;
        this.startTime.name = time.name;
      }
      this.datePickerState = false;
    },
    selectTimeFn: function selectTimeFn() {},
    couponSlelectFn: function couponSlelectFn(obj) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this7.systemConfigFn(10);

              case 2:
                _this7.hasCoupon = _context5.sent;

                if (!_this7.hasCoupon) {
                  _context5.next = 13;
                  break;
                }

                console.log("sssssssss", _this7.hasCoupon);

                if (!(obj.type === 'nonuse')) {
                  _context5.next = 9;
                  break;
                }

                if (_this7.enterprise_id) {
                  _this7.enterpriseDisabled = false;
                }
                _this7.couponMoney = {
                  type: '',
                  id: '',
                  num: ''
                };
                return _context5.abrupt('return', true);

              case 9:
                if (!(obj.type === 'action' && obj.obj && obj !== '')) {
                  _context5.next = 13;
                  break;
                }

                if (_this7.enterprise_id) {
                  _this7.$Util.toast({ text: '选择优惠券后，您将不可使用因公出行' });
                  _this7.enterpriseDisabled = true;
                }
                if (obj.obj.discount && obj.obj.discount !== '') {
                  _this7.couponMoney = {
                    type: 'dazhe',
                    val: obj.obj.discount,
                    id: obj.obj.id
                  };
                } else if (obj.obj.deductible && obj.obj.deductible !== '') {
                  _this7.couponMoney = {
                    type: 'dikou',
                    val: obj.obj.deductible,
                    id: obj.obj.id
                  };
                }
                return _context5.abrupt('return', true);

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },

    unfilledOrdercCloseFn: function unfilledOrdercCloseFn() {
      this.$store.dispatch('unfilledOrderState', { type: 'daijia', state: false });
    },
    detailsBoxFn: function detailsBoxFn() {
      if (this.$refs.detailsBox) {
        this.$refs.detailsBox.switchFn();
      }
    },
    chooseDriverFn: function chooseDriverFn() {
      var that = this;
      that.$store.dispatch('checkLogin', function (state) {
        console.log('选择司机个数', state, 'that.loginData', that.loginData);
        if (state && that.loginData && that.loginData.passenger) {
          that.visible = true;
        } else {
          that.$store.dispatch('loginAction', { state: false });
        }
      });
    },
    sureSelectCar: function sureSelectCar(val) {
      this.visible = false;
      this.driverNumber = val[0];
    },
    cancleSelectCar: function cancleSelectCar(val) {
      this.visible = false;
    },
    getPassengerDaijiaFn: function getPassengerDaijiaFn() {
      var that = this;
      var appkey = this.$route.query.app_key || window.configure.appKey;
      var passengerId = window.configure.passengerInfo ? window.configure.passengerInfo.id : null;
      this.$store.dispatch('getPassenger', {
        id: passengerId,
        app_key: appkey,
        fn: function fn(data) {
          console.log('获取个人信息', data);
          if (data.data.code === 1) {
            var singleOrder = Number(data.data.grade.single_order);
            if (singleOrder > 1) {
              that.slots = [];
              for (var i = 1; i <= singleOrder; i++) {
                that.slots.push(i);
              }
            }
          }
          var passengerkey = window.configure.passengerKey;
          var passenger = that.$Cookie.get(passengerkey) ? __WEBPACK_IMPORTED_MODULE_21_json_bigint_xk___default.a.parse(that.$Tool.aesDecryptCode(that.$Cookie.get(passengerkey))) : null;
          if (passenger && passenger.passenger) {
            that.enterprise_id = passenger.passenger.enterprise_id;
            that.enterprise_member_deduction = passenger.passenger.enterprise_member_deduction;
            that.enterprise_name = passenger.passenger.enterprise_name;
            that.is_deduction = passenger.passenger.is_deduction;
            if (passenger.passenger.is_deduction === 2) {
              that.enterpriseDisabled = true;
            }
          }
        }
      });
    }
  },
  created: function created() {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this8.systemConfigFn(2);

            case 2:
              _this8.ygcx = _context6.sent;

              _this8.app_key = _this8.$route.query.app_key;
              _this8.$store.dispatch('checkLogin', function (state) {
                if (state) {
                  _this8.getPassengerDaijiaFn();
                  if (_this8.loginData && _this8.loginData.passenger) {
                    _this8.$store.dispatch('unfilledOrder', { page: 1, limit: 100 });
                    _this8.unfilledOrderShowState = true;
                  }
                }
              });

            case 5:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this8);
    }))();
  },

  mounted: function mounted() {
    var that = this;


    if (this.$route.query.tel) {
      this.$store.dispatch('checkLogin', function (state) {
        if (state) {} else {
          that.$store.dispatch('loginAction', { state: false });
        }
      });
    }
    that.$store.dispatch('getBusiness', {
      business: 'daijia',
      company_id: 1,
      fn: function fn(data) {
        if (data && data.code === 1) {
          var business = data.categories;
          if (business && business.length > 0) {
            that.typeAcId = business[0].id;
            that.$Cookie.set('typeAcId', business[0].id);
            that.typeAll.data = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(business));
            if (business[0].is_fixed_price) {
              that.is_fixed_price = 1;
            } else {
              that.is_fixed_price = 2;
            }
          }
          that.getArticlebyaliasFn();
          that.getCouponTypeFn();
        }
      }
    });

    if (this.positioning && this.positioning.lng && this.positioning.lat) {
      this.adds.startAdd = {
        beginAddress: this.positioning.name,
        beginAddressDetail: this.positioning.detailedAddress,
        beginLat: this.positioning.lat,
        beginLng: this.positioning.lng
      };
    }
    var date = new Date();
    that.startTime.name = '现在出发';
    that.startTime.val = Date.parse(date) / 1000;
    var company = this.$Cookie.get('companyinfo');
    setTimeout(function () {
      if (window.configure.location) {
        that.$store.dispatch('getNearDrivers', {
          company_id: company.id,
          lng: window.configure.location.lng || null,
          lat: window.configure.location.lat || null,
          distance: 10,
          business: 'daijia'
        });
      }
    }, 1000);
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__module_waiter_src_waiter__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__module_waiter_src_waiter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__module_waiter_src_waiter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_add_src_add_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_add_src_add_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__module_add_src_add_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module_hintBox_src_hintBox__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module_hintBox_src_hintBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__module_hintBox_src_hintBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_inputBox_src_inputBox__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_inputBox_src_inputBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__module_inputBox_src_inputBox__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    XkInputBox: __WEBPACK_IMPORTED_MODULE_5__module_inputBox_src_inputBox___default.a,
    XkHintBox: __WEBPACK_IMPORTED_MODULE_4__module_hintBox_src_hintBox___default.a,
    XkWaiter: __WEBPACK_IMPORTED_MODULE_1__module_waiter_src_waiter___default.a,
    XkAdd: __WEBPACK_IMPORTED_MODULE_2__module_add_src_add_vue___default.a
  },
  name: '',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    loginData: 'loginData',
    DjOrderInfo: 'DjOrderInfo'
  })),
  watch: {
    DjOrderInfo: function DjOrderInfo(val) {
      var that = this;
      if (this.loginData.passenger && val && this.loginData.passenger.id !== val.passenger_id) {
        this.$router.push({ path: '/daijia?app_key=' + window.configure.appKey });
        return;
      }
      if (val.status === 10) {
        this.title = (val.gender === '男' ? '服务人员' : '服务人员') + '已接单';
        this.titleCont = '正在向您狂奔...';
        this.cancelState = true;
      } else if (val.status === 15) {
        this.title = (val.gender === '男' ? '服务人员' : '服务人员') + '正在前往预约地';
        this.titleCont = '请您耐心等待...';
        this.cancelState = true;
      } else if (val.status === 20) {
        this.title = (val.gender === '男' ? '服务人员' : '服务人员') + '已到达预约地';
        this.titleCont = '准备开车啦...';
        this.cancelState = true;
      } else if (val.status === 28) {
        this.title = '中途等待...';
        this.titleCont = '中途等待！';
        this.cancelState = false;
      } else if (val.status === 25) {
        this.title = '正在前往目的地...';
        this.titleCont = '请系上您的安全带，祝您旅途愉快！';
        this.cancelState = false;
      } else if (val.status === 30) {
        this.$router.push({ path: '/daijia/settlement', query: { order_id: that.$route.query.order_id } });
        this.cancelState = false;
        return false;
      } else if (val.status === 35) {
        this.cancelState = false;
        this.hintBox = {
          stateShow: true,
          state: 'yes',
          content: '您的订单已完成！'
        };
        setTimeout(function () {
          that.hintBox = false;
          that.$router.push({ path: '/daijia/affirm', query: { order_id: that.$route.query.order_id } });
        }, 1500);
        return;
      } else if (val.status === 45) {
        this.hintBox = {
          stateShow: true,
          state: 'no',
          content: '您的订单已被销单！'
        };
        setTimeout(function () {
          that.hintBox = false;
          that.$router.push({ path: '/daijia?app_key=' + window.configure.appKey });
        }, 1500);
        return;
      }
      console.log('订单状态', val);
    }
  },
  data: function data() {
    return {
      title: '',
      titleCont: '',
      hintBox: {
        stateShow: false,
        state: 'yes',
        content: ''
      },
      cancelState: false,
      reson: {
        state: false,
        val: ''
      },
      timer: null };
  },

  methods: {
    cancelOrderFn: function cancelOrderFn(val) {
      var _this = this;

      var that = this;
      this.reson.state = !this.reson.state;
      if (val === 'affirm') {
        if (this.reson.val !== '') {
          that.loadState = true;
          this.$store.dispatch('putCancelOrder', {
            order_id: that.$route.query.order_id,
            remark: this.reson.val,
            fn: function fn(state) {
              that.loadState = false;
              if (state && state.code === 1) {
                _this.reson.state = false;
                that.hintBox = {
                  stateShow: true,
                  state: 'yes',
                  content: '销单成功！'
                };
                setTimeout(function () {
                  that.hintBox.stateShow = false;
                  that.$router.push({ path: '/daijia?app_key=' + window.configure.appKey });
                }, 1500);
              }
            }
          });
        } else {
          this.reson.state = true;
          that.hintBox = {
            stateShow: true,
            state: 'no',
            content: '请输入销单理由！'
          };
          setTimeout(function () {
            that.hintBox.stateShow = false;
          }, 1500);
        }
      }
    }
  },
  mounted: function mounted() {
    var that = this;
    that.$store.dispatch('checkLogin', function (state) {
      if (state) {
        that.$store.dispatch('DjOrderInfo', { order_id: that.$route.query.order_id });
        that.timer = setInterval(function () {
          console.log('订单状态--定时器内部');
          that.$store.dispatch('DjOrderInfo', { order_id: that.$route.query.order_id });
        }, 3000);
      }
    });
  },
  destroyed: function destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_detailsBox_src_detailsBox_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_detailsBox_src_detailsBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__module_detailsBox_src_detailsBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module_uploadMod_src_uploadMod__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module_uploadMod_src_uploadMod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__module_uploadMod_src_uploadMod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_hintBox_src_hintBox__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_hintBox_src_hintBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__module_hintBox_src_hintBox__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    XkHintBox: __WEBPACK_IMPORTED_MODULE_5__module_hintBox_src_hintBox___default.a,
    XkUploadMod: __WEBPACK_IMPORTED_MODULE_4__module_uploadMod_src_uploadMod___default.a
  },
  component: {
    XkdetailsBox: __WEBPACK_IMPORTED_MODULE_2__module_detailsBox_src_detailsBox_vue___default.a
  },
  name: 'Settlement',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    DjPayInfo: 'DjPayInfo',
    loginData: 'loginData',
    DJOrderFee: 'DJOrderFee',
    wxState: 'wxState',
    postCustomerPreSave: 'postCustomerPreSave',
    DjOrderInfo: 'DjOrderInfo'
  }), {
    orderFeeDetail: function orderFeeDetail() {
      var DJOrderFee = this.DJOrderFee;
      var arr = [];
      var obj = { name: '', cost: '' };
      console.log('DJOrderFee', DJOrderFee);
      if (DJOrderFee && DJOrderFee.start_price) {
        obj = {
          name: '起步费',
          cost: DJOrderFee.start_price
        };
        arr.push(obj);
      }
      if (DJOrderFee && DJOrderFee.cross_fee) {
        obj = {
          name: '垫付费',
          cost: DJOrderFee.cross_fee
        };
        arr.push(obj);
      }
      if (DJOrderFee) {
        var otherCost = DJOrderFee.total_fee - (DJOrderFee.start_price ? DJOrderFee.start_price : 0) - (DJOrderFee.cross_fee ? DJOrderFee.cross_fee : 0);
        var cost = Math.round(otherCost * 10) / 10;
        obj = {
          name: '其他费用',
          cost: cost
        };
        arr.push(obj);
      }
      if (DJOrderFee && DJOrderFee.total_fee) {
        obj = {
          name: '订单总金额',
          cost: DJOrderFee.total_fee
        };
        arr.push(obj);
      }
      if (DJOrderFee && DJOrderFee.enterprise_member_deduction) {
        obj = {
          name: '企业优惠抵扣',
          cost: DJOrderFee.enterprise_member_deduction
        };
        arr.push(obj);
      }
      if (DJOrderFee && DJOrderFee.coupon_fee) {
        obj = {
          name: '优惠券金额',
          cost: DJOrderFee.coupon_fee
        };
        arr.push(obj);
      }
      if (DJOrderFee && DJOrderFee.min_cost) {
        obj = {
          name: '最低消费',
          cost: DJOrderFee.min_cost
        };
        arr.push(obj);
      }
      return arr;
    }
  }),
  data: function data() {
    return {
      data: {
        costDetail: [],
        payType: 1 },
      orderId: '',
      loadState: false,
      hintBox: {
        stateShow: false,
        state: 'yes',
        content: ''
      }
    };
  },

  watch: {
    DjOrderInfo: function DjOrderInfo(val) {
      var that = this;
      console.log('valxxxxxxxxxxxxxxxxxxx', val);
      if (that.loginData.passenger && val && that.loginData.passenger.id !== val.passenger_id) {
        that.$router.push('/daijia');
        return;
      }
      switch (val.status) {
        case 1:
          this.$router.push({ path: '/daijia/await', query: { order_id: this.orderId } });
          break;
        case 5:
          this.$router.push({ path: '/daijia/await', query: { order_id: this.orderId } });
          break;
        case 10:
          this.$router.push({ path: '/daijia/service', query: { order_id: this.orderId } });
          break;
        case 15:
          this.$router.push({ path: '/daijia/service', query: { order_id: this.orderId } });
          break;
        case 20:
          this.$router.push({ path: '/daijia/service', query: { order_id: this.orderId } });
          break;
        case 25:
          this.$router.push({ path: '/daijia/service', query: { order_id: this.orderId } });
          break;
        case 30:
          setTimeout(function () {
            if (that.$route.fullPath.split('?')[0] === '/daijia/settlement') {
              that.$store.dispatch('DjOrderInfo', { order_id: that.$route.query.order_id });
            }
          }, 3000);
          break;
        case 35:
          this.$router.push({ path: '/daijia/affirm', query: { order_id: this.orderId } });
          break;
        case 40:
          this.$router.replace('/');
          break;
        case 45:
          this.$router.replace('/');
          break;
      }
    }
  },
  methods: {
    detailsBoxFn: function detailsBoxFn() {
      this.$refs.detailsBox.switchFn();
    },
    payTypeFn: function payTypeFn(val) {
      var that = this;
      switch (val) {
        case 1:
          that.data.payType = 1;
          break;
        case 2:
          that.data.payType = 2;
          break;
        case 3:
          that.data.payType = 3;
          break;
      }
    },
    payFn: function payFn() {
      var state = this.data.payType;
      var that = this;
      that.loadState = true;
      if (state === 1 || state === 3) {
        var payType = state === 1 ? 'balance' : state === 3 ? 'sign' : '';
        console.log('1-1');
        that.$store.dispatch('DjBalancePay', {
          'id': that.$route.query.order_id,
          'who': 'member',
          'timeStamp': Date.parse(new Date()) / 1000,
          'pay_type': payType,
          fn: function fn(data) {
            that.loadState = false;
            if (data && data.code === 1) {
              that.hintBox = {
                stateShow: true,
                state: 'yes',
                content: '支付成功！'
              };
              setTimeout(function () {
                that.hintBox.stateShow = false;
                that.$router.push({ path: '/daijia/affirm', query: { order_id: that.$route.query.order_id } });
              }, 1500);
            }
            if (data.code === 20088) {
              that.hintBox = {
                stateShow: true,
                state: 'no',
                content: '余额不足'
              };
              setTimeout(function () {
                that.hintBox.stateShow = false;
              }, 1500);
            }
          }
        });
      }
      if (state === 2) {
        console.log('1-2');
        that.$store.dispatch('DjBalancePay', {
          'id': that.$route.query.order_id,
          'open_id': window.configure.open_id,
          'who': 'member',
          'timeStamp': Date.parse(new Date()) / 1000,
          'pay_type': 'weixin',
          fn: function fn(data) {
            that.loadState = false;
            if (data && data.code === 1) {
              var content = data.weixinResult;
              __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default.a.config({
                debug: false,
                appId: window.configure.WXappId,
                timeStamp: content.wx_app_ts,
                nonceStr: content.wx_app_nonce,
                signature: content.wx_app_sign,
                jsApiList: ['chooseWXPay']
              });

              __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default.a.ready(function () {
                __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default.a.chooseWXPay({
                  timestamp: content.wx_app_ts,
                  nonceStr: content.wx_app_nonce,
                  package: content.wx_app_pkg,
                  signType: content.wx_app_sign_type,
                  paySign: content.wx_app_sign,
                  success: function success(res) {
                    if (data && data.code === 1) {
                      that.hintBox = {
                        stateShow: true,
                        state: 'yes',
                        content: '支付成功！'
                      };
                      setTimeout(function () {
                        that.hintBox.stateShow = false;
                        that.$router.push({ path: '/daijia/affirm', query: { order_id: that.$route.query.order_id } });
                      }, 1500);
                    }
                  }
                });
              });
            }
          }
        });
      }
    }
  },
  mounted: function mounted() {
    var that = this;
    this.orderId = this.$route.query.order_id;
    that.$store.dispatch('checkLogin', function (state) {
      if (state) {
        that.$store.dispatch('DjPayInfo', { order_id: that.$route.query.order_id });
        that.$store.dispatch('DjOrderInfo', { order_id: that.$route.query.order_id });
        that.$store.dispatch('postCustomerPreSave', {
          id: that.loginData.passenger.id
        });
      }
    });
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__module_tabs_src_tabs__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__module_tabs_src_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__module_tabs_src_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_sideMenus_src_sideMenus__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_sideMenus_src_sideMenus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__module_sideMenus_src_sideMenus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    XkSideMenus: __WEBPACK_IMPORTED_MODULE_2__module_sideMenus_src_sideMenus___default.a,
    XkTabs: __WEBPACK_IMPORTED_MODULE_1__module_tabs_src_tabs___default.a
  },
  name: '',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    loginData: 'loginData'
  }), {
    navFn: function navFn() {
      var state = '';

      switch (this.$route.fullPath) {
        case '/daijia':
          state = 0;
          break;
        case '/zhuanche':
          state = 1;
          break;
        case '/paotui':
          state = 2;
          break;
        case '/zhuanxian':
          state = 3;
          break;
      }
      return state;
    }
  }),
  data: function data() {
    return {};
  },

  methods: {
    menuFn: function menuFn() {
      var _this = this;

      var that = this;
      console.log(1);
      that.$store.dispatch('checkLogin', function (state) {
        if (state && that.loginData && that.loginData.passenger) {
          window.clearTimeout(_this.tId);
          _this.tId = window.setTimeout(function () {
            that.$refs.sideMenus.sideMenusFn();
          }, 0);
        } else {
          _this.$router.push('/login');
        }
      });
    }
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_qrCode_src_qrCode__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_qrCode_src_qrCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__module_qrCode_src_qrCode__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'qrCode',
  components: { XkQrCode: __WEBPACK_IMPORTED_MODULE_2__module_qrCode_src_qrCode___default.a },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    loginData: 'loginData'
  })),
  data: function data() {
    return {
      url: ''
    };
  },

  mounted: function mounted() {
    var that = this;
    that.$store.dispatch('checkLogin', function (state) {
      if (state) {
        that.$store.dispatch('queryQrCode', {
          company_id: that.loginData.passenger.company_id,
          id: that.loginData.passenger.id,
          fn: function fn(data) {
            if (data && data.code === 1) {
              that.url = data.url;
            }
          }
        });
      }
    });
  }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_hintBox_src_hintBox_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_hintBox_src_hintBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__module_hintBox_src_hintBox_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { XkHintBox: __WEBPACK_IMPORTED_MODULE_2__module_hintBox_src_hintBox_vue___default.a },
  name: 'recharge',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    loginData: 'loginData',
    postCustomerPreSave: 'postCustomerPreSave'
  })),
  data: function data() {
    return {
      data: {
        userNo: '',
        userName: '' },
      hintBox: {
        stateShow: false,
        state: 'yes',
        content: ''
      },
      seletSum: [{
        name: '100元',
        val: '100'
      }, {
        name: '300元',
        val: '300'
      }, {
        name: '500元',
        val: '500'
      }, {
        name: '1000元',
        val: '1000'
      }],
      seletSumNum: 0,
      credit: '100',
      payTypeNum: 0 };
  },

  methods: {
    postCustomerPreSaveFn: function postCustomerPreSaveFn() {
      var that = this;
      that.$store.dispatch('postCustomerPreSave', {
        id: that.loginData.passenger.id
      });
    },

    selectSumFn: function selectSumFn(index, val) {
      this.seletSumNum = index;
      this.credit = val;
    },
    customSumFn: function customSumFn() {
      var that = this;
      for (var i = 0; i < that.seletSum.length; i++) {
        if (that.credit === that.seletSum[i].val) {
          that.seletSumNum = i;
          return;
        } else {
          that.seletSumNum = null;
        }
      }
    },
    payTypeFn: function payTypeFn(val) {
      this.payTypeNum = val;
    },
    userSumPayFn: function userSumPayFn() {
      var that = this;
      if (Number(that.credit) >= 100) {
        that.$store.dispatch('userSumPay', {
          'money': that.credit,
          'open_id': window.configure.open_id,
          fn: function fn(data) {
            if (data === '充值成功') {
              that.hintBox = {
                stateShow: true,
                state: 'yes',
                content: '充值成功！'
              };
              setTimeout(function () {
                that.hintBox.stateShow = false;
              }, 1500);
            } else {
              that.hintBox = {
                stateShow: true,
                state: 'no',
                content: '充值失败！'
              };
              setTimeout(function () {
                that.hintBox.stateShow = false;
              }, 1500);
            }
          }
        });
      } else {
        that.hintBox = {
          stateShow: true,
          state: 'no',
          content: '充值金额不能少于100元'
        };
        setTimeout(function () {
          that.hintBox.stateShow = false;
        }, 1500);
      }
    }
  },
  mounted: function mounted() {
    var that = this;
    that.$store.dispatch('checkLogin', function (state) {
      if (state) {
        that.data = {
          userNo: that.loginData.passenger.phone,
          userName: that.loginData.passenger.name
        };
        that.postCustomerPreSaveFn();
      }
    });
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'serviceAgreement',
  computed: {},
  data: function data() {
    return {
      infoData: ''
    };
  },

  methods: {
    ArticlebyaliasFn: function ArticlebyaliasFn() {
      var that = this;
      var params = {
        'alias': 'CustomerServiceAgreement',
        'app_key': window.configure.appKey,
        fn: function fn(data) {
          if (data && data.code === 1) {
            that.infoData = data.article.contents;
          }
        }
      };
      that.$store.dispatch('Articlebyalias', params);
    }
  },
  watch: {},
  mounted: function mounted() {
    this.ArticlebyaliasFn();
  }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'servicePrice',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    companyInfo: 'companyInfo'
  })),
  data: function data() {
    return {
      infoData: ''
    };
  },

  methods: {
    ArticlebyaliasFn: function ArticlebyaliasFn() {
      var that = this;
      var params = {
        'alias': 'CutomerPricingRules',
        'app_key': window.configure.appKey,
        'companyId': that.companyInfo.id,
        fn: function fn(data) {
          if (data && data.code === 1) {
            that.infoData = data.article.contents;
          }
        }
      };
      that.$store.dispatch('Articlebyalias', params);
    }
  },
  watch: {
    'companyInfo.id': function companyInfoId(val) {
      if (val) {
        this.ArticlebyaliasFn();
      }
    }
  },
  mounted: function mounted() {
    this.ArticlebyaliasFn();
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'settings',
  data: function data() {
    return {
      BoxLogout: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    infoData: 'infoData',
    servesTypeNav: 'servesTypeNav',
    positioning: 'positioning',
    loginData: 'loginData'
  })),
  methods: {
    BoxLogoutFn: function BoxLogoutFn(e) {
      var that = this;
      switch (e) {
        case 'ok':
          that.BoxLogout = false;
          this.loginOutFn();

          break;
        case 'on':
          that.BoxLogout = false;
          break;
        case 'show':
          that.BoxLogout = true;
          break;
      }
    },
    loginOutFn: function loginOutFn() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var id, url, params, data, passengerkey, passanger;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = window.configure.passengerInfo.id;
                url = '/v1/loginOut';
                params = {
                  id: id,
                  app_key: window.configure.appKey,
                  channel: 'weixin'
                };
                _context.next = 5;
                return _this.$axios.post(url, params);

              case 5:
                data = _context.sent;

                if (data && data.code === 1) {
                  passengerkey = window.configure.passengerKey;
                  passanger = __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get(passengerkey);

                  console.log('注销成功回到首页', passanger);
                  if (passanger) {
                    __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.remove(passengerkey);
                  }
                  _this.$store.dispatch('loginAction', { state: false });
                  _this.$router.push('/');
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('checkLogin');
    console.log(this.infoData);
  }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_configure__ = __webpack_require__(19);




/* harmony default export */ __webpack_exports__["a"] = ({
  banner: function banner(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].appKey,
      'serviceType': obj.type
    };
    var url = __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].serverUrl + '/news/weixin';
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(url, { params: params }).then(function (data) {
      callback(data.body, obj.type);
    });
  }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var city = [{
  'label': '北京Beijing010',
  'name': '北京',
  'pinyin': 'Beijing',
  'zip': '010'
}, {
  'label': '重庆Chongqing023',
  'name': '重庆',
  'pinyin': 'Chongqing',
  'zip': '023'
}, {
  'label': '上海Shanghai021',
  'name': '上海',
  'pinyin': 'Shanghai',
  'zip': '021'
}, {
  'label': '天津Tianjin022',
  'name': '天津',
  'pinyin': 'Tianjin',
  'zip': '022'
}, {
  'label': '长春Changchun0431',
  'name': '长春',
  'pinyin': 'Changchun',
  'zip': '0431'
}, {
  'label': '长沙Changsha0731',
  'name': '长沙',
  'pinyin': 'Changsha',
  'zip': '0731'
}, {
  'label': '常州Changzhou0519',
  'name': '常州',
  'pinyin': 'Changzhou',
  'zip': '0519'
}, {
  'label': '成都Chengdu028',
  'name': '成都',
  'pinyin': 'Chengdu',
  'zip': '028'
}, {
  'label': '大连Dalian0411',
  'name': '大连',
  'pinyin': 'Dalian',
  'zip': '0411'
}, {
  'label': '东莞Dongguan0769',
  'name': '东莞',
  'pinyin': 'Dongguan',
  'zip': '0769'
}, {
  'label': '佛山Foshan0757',
  'name': '佛山',
  'pinyin': 'Foshan',
  'zip': '0757'
}, {
  'label': '福州Fuzhou0591',
  'name': '福州',
  'pinyin': 'Fuzhou',
  'zip': '0591'
}, {
  'label': '广州Guangzhou020',
  'name': '广州',
  'pinyin': 'Guangzhou',
  'zip': '020'
}, {
  'label': '贵阳Guiyang0851',
  'name': '贵阳',
  'pinyin': 'Guiyang',
  'zip': '0851'
}, {
  'label': '哈尔滨Haerbin0451',
  'name': '哈尔滨',
  'pinyin': 'Haerbin',
  'zip': '0451'
}, {
  'label': '海口Haikou0898',
  'name': '海口',
  'pinyin': 'Haikou',
  'zip': '0898'
}, {
  'label': '邯郸Handan0310',
  'name': '邯郸',
  'pinyin': 'Handan',
  'zip': '0310'
}, {
  'label': '杭州Hangzhou0571',
  'name': '杭州',
  'pinyin': 'Hangzhou',
  'zip': '0571'
}, {
  'label': '合肥Hefei0551',
  'name': '合肥',
  'pinyin': 'Hefei',
  'zip': '0551'
}, {
  'label': '惠州Huizhou0752',
  'name': '惠州',
  'pinyin': 'Huizhou',
  'zip': '0752'
}, {
  'label': '焦作Jiaozuo0391',
  'name': '焦作',
  'pinyin': 'Jiaozuo',
  'zip': '0391'
}, {
  'label': '嘉兴Jiaxing0573',
  'name': '嘉兴',
  'pinyin': 'Jiaxing',
  'zip': '0573'
}, {
  'label': '吉林Jilin0423',
  'name': '吉林',
  'pinyin': 'Jilin',
  'zip': '0423'
}, {
  'label': '济南Jinan0531',
  'name': '济南',
  'pinyin': 'Jinan',
  'zip': '0531'
}, {
  'label': '昆明Kunming0871',
  'name': '昆明',
  'pinyin': 'Kunming',
  'zip': '0871'
}, {
  'label': '天门Tianmen1728',
  'name': '天门',
  'pinyin': 'Tianmen',
  'zip': '1728'
}, {
  'label': '兰州Lanzhou0931',
  'name': '兰州',
  'pinyin': 'Lanzhou',
  'zip': '0931'
}, {
  'label': '柳州Liuzhou0772',
  'name': '柳州',
  'pinyin': 'Liuzhou',
  'zip': '0772'
}, {
  'label': '洛阳Luoyang0379',
  'name': '洛阳',
  'pinyin': 'Luoyang',
  'zip': '0379'
}, {
  'label': '南昌Nanchang0791',
  'name': '南昌',
  'pinyin': 'Nanchang',
  'zip': '0791'
}, {
  'label': '南京Nanjing025',
  'name': '南京',
  'pinyin': 'Nanjing',
  'zip': '025'
}, {
  'label': '南宁Nanning0771',
  'name': '南宁',
  'pinyin': 'Nanning',
  'zip': '0771'
}, {
  'label': '南通Nantong0513',
  'name': '南通',
  'pinyin': 'Nantong',
  'zip': '0513'
}, {
  'label': '宁波Ningbo0574',
  'name': '宁波',
  'pinyin': 'Ningbo',
  'zip': '0574'
}, {
  'label': '青岛Qingdao0532',
  'name': '青岛',
  'pinyin': 'Qingdao',
  'zip': '0532'
}, {
  'label': '泉州Quanzhou0595',
  'name': '泉州',
  'pinyin': 'Quanzhou',
  'zip': '0595'
}, {
  'label': '沈阳Shenyang024',
  'name': '沈阳',
  'pinyin': 'Shenyang',
  'zip': '024'
}, {
  'label': '深圳Shenzhen0755',
  'name': '深圳',
  'pinyin': 'Shenzhen',
  'zip': '0755'
}, {
  'label': '石家庄Shijiazhuang0311',
  'name': '石家庄',
  'pinyin': 'Shijiazhuang',
  'zip': '0311'
}, {
  'label': '苏州Suzhou0512',
  'name': '苏州',
  'pinyin': 'Suzhou',
  'zip': '0512'
}, {
  'label': '台州Taizhou0576',
  'name': '台州',
  'pinyin': 'Taizhou',
  'zip': '0576'
}, {
  'label': '唐山Tangshan0315',
  'name': '唐山',
  'pinyin': 'Tangshan',
  'zip': '0315'
}, {
  'label': '潍坊Weifang0536',
  'name': '潍坊',
  'pinyin': 'Weifang',
  'zip': '0536'
}, {
  'label': '威海Weihai0631',
  'name': '威海',
  'pinyin': 'Weihai',
  'zip': '0631'
}, {
  'label': '武汉Wuhan027',
  'name': '武汉',
  'pinyin': 'Wuhan',
  'zip': '027'
}, {
  'label': '无锡Wuxi0510',
  'name': '无锡',
  'pinyin': 'Wuxi',
  'zip': '0510'
}, {
  'label': '厦门Xiamen0592',
  'name': '厦门',
  'pinyin': 'Xiamen',
  'zip': '0592'
}, {
  'label': '西安Xian029',
  'name': '西安',
  'pinyin': 'Xian',
  'zip': '029'
}, {
  'label': '许昌Xuchang0374',
  'name': '许昌',
  'pinyin': 'Xuchang',
  'zip': '0374'
}, {
  'label': '徐州Xuzhou0516',
  'name': '徐州',
  'pinyin': 'Xuzhou',
  'zip': '0516'
}, {
  'label': '仙桃',
  'name': '仙桃',
  'pinyin': 'XianTao',
  'zip': '0516'
}, {
  'label': '扬州Yangzhou0514',
  'name': '扬州',
  'pinyin': 'Yangzhou',
  'zip': '0514'
}, {
  'label': '烟台Yantai0535',
  'name': '烟台',
  'pinyin': 'Yantai',
  'zip': '0535'
}, {
  'label': '漳州Zhangzhou0596',
  'name': '漳州',
  'pinyin': 'Zhangzhou',
  'zip': '0596'
}, {
  'label': '郑州Zhengzhou0371',
  'name': '郑州',
  'pinyin': 'Zhengzhou',
  'zip': '0371'
}, {
  'label': '中山Zhongshan0760',
  'name': '中山',
  'pinyin': 'Zhongshan',
  'zip': '0760'
}, {
  'label': '珠海Zhuhai0756',
  'name': '珠海',
  'pinyin': 'Zhuhai',
  'zip': '0756'
}, {
  'label': '阿坝Aba0837',
  'name': '阿坝',
  'pinyin': 'Aba',
  'zip': '0837'
}, {
  'label': '阿克苏Akesu0997',
  'name': '阿克苏',
  'pinyin': 'Akesu',
  'zip': '0997'
}, {
  'label': '阿拉善盟Alashanmeng0483',
  'name': '阿拉善盟',
  'pinyin': 'Alashanmeng',
  'zip': '0483'
}, {
  'label': '阿勒泰Aletai0906',
  'name': '阿勒泰',
  'pinyin': 'Aletai',
  'zip': '0906'
}, {
  'label': '阿里Ali0897',
  'name': '阿里',
  'pinyin': 'Ali',
  'zip': '0897'
}, {
  'label': '安康Ankang0915',
  'name': '安康',
  'pinyin': 'Ankang',
  'zip': '0915'
}, {
  'label': '安庆Anqing0556',
  'name': '安庆',
  'pinyin': 'Anqing',
  'zip': '0556'
}, {
  'label': '鞍山Anshan0412',
  'name': '鞍山',
  'pinyin': 'Anshan',
  'zip': '0412'
}, {
  'label': '安顺Anshun0853',
  'name': '安顺',
  'pinyin': 'Anshun',
  'zip': '0853'
}, {
  'label': '安阳Anyang0372',
  'name': '安阳',
  'pinyin': 'Anyang',
  'zip': '0372'
}, {
  'label': '白城Baicheng0436',
  'name': '白城',
  'pinyin': 'Baicheng',
  'zip': '0436'
}, {
  'label': '百色Baise0776',
  'name': '百色',
  'pinyin': 'Baise',
  'zip': '0776'
}, {
  'label': '白山Baishan0439',
  'name': '白山',
  'pinyin': 'Baishan',
  'zip': '0439'
}, {
  'label': '白银Baiyin0943',
  'name': '白银',
  'pinyin': 'Baiyin',
  'zip': '0943'
}, {
  'label': '蚌埠Bangbu0552',
  'name': '蚌埠',
  'pinyin': 'Bangbu',
  'zip': '0552'
}, {
  'label': '保定Baoding0312',
  'name': '保定',
  'pinyin': 'Baoding',
  'zip': '0312'
}, {
  'label': '宝鸡Baoji0917',
  'name': '宝鸡',
  'pinyin': 'Baoji',
  'zip': '0917'
}, {
  'label': '保山Baoshan0875',
  'name': '保山',
  'pinyin': 'Baoshan',
  'zip': '0875'
}, {
  'label': '包头Baotou0472',
  'name': '包头',
  'pinyin': 'Baotou',
  'zip': '0472'
}, {
  'label': '巴彦淖尔Bayannaoer0478',
  'name': '巴彦淖尔',
  'pinyin': 'Bayannaoer',
  'zip': '0478'
}, {
  'label': '巴音郭楞Bayinguoleng0996',
  'name': '巴音郭楞',
  'pinyin': 'Bayinguoleng',
  'zip': '0996'
}, {
  'label': '巴中Bazhong0827',
  'name': '巴中',
  'pinyin': 'Bazhong',
  'zip': '0827'
}, {
  'label': '北海Beihai0779',
  'name': '北海',
  'pinyin': 'Beihai',
  'zip': '0779'
}, {
  'label': '本溪Benxi0414',
  'name': '本溪',
  'pinyin': 'Benxi',
  'zip': '0414'
}, {
  'label': '毕节Bijie0857',
  'name': '毕节',
  'pinyin': 'Bijie',
  'zip': '0857'
}, {
  'label': '滨州Binzhou0543',
  'name': '滨州',
  'pinyin': 'Binzhou',
  'zip': '0543'
}, {
  'label': '博尔塔拉Boertala0909',
  'name': '博尔塔拉',
  'pinyin': 'Boertala',
  'zip': '0909'
}, {
  'label': '亳州Bozhou0558',
  'name': '亳州',
  'pinyin': 'Bozhou',
  'zip': '0558'
}, {
  'label': '沧州Cangzhou0317',
  'name': '沧州',
  'pinyin': 'Cangzhou',
  'zip': '0317'
}, {
  'label': '常德Changde0736',
  'name': '常德',
  'pinyin': 'Changde',
  'zip': '0736'
}, {
  'label': '昌都Changdu0895',
  'name': '昌都',
  'pinyin': 'Changdu',
  'zip': '0895'
}, {
  'label': '昌吉Changji0997',
  'name': '昌吉',
  'pinyin': 'Changji',
  'zip': '0997'
}, {
  'label': '长治Changzhi0355',
  'name': '长治',
  'pinyin': 'Changzhi',
  'zip': '0355'
}, {
  'label': '巢湖Chaohu0565',
  'name': '巢湖',
  'pinyin': 'Chaohu',
  'zip': '0565'
}, {
  'label': '朝阳Chaoyang0421',
  'name': '朝阳',
  'pinyin': 'Chaoyang',
  'zip': '0421'
}, {
  'label': '潮州Chaozhou0768',
  'name': '潮州',
  'pinyin': 'Chaozhou',
  'zip': '0768'
}, {
  'label': '承德Chengde0314',
  'name': '承德',
  'pinyin': 'Chengde',
  'zip': '0314'
}, {
  'label': '郴州Chenzhou0735',
  'name': '郴州',
  'pinyin': 'Chenzhou',
  'zip': '0735'
}, {
  'label': '赤峰Chifeng0476',
  'name': '赤峰',
  'pinyin': 'Chifeng',
  'zip': '0476'
}, {
  'label': '池州Chizhou0566',
  'name': '池州',
  'pinyin': 'Chizhou',
  'zip': '0566'
}, {
  'label': '崇左Chongzuo0771',
  'name': '崇左',
  'pinyin': 'Chongzuo',
  'zip': '0771'
}, {
  'label': '楚雄Chuxiong0875',
  'name': '楚雄',
  'pinyin': 'Chuxiong',
  'zip': '0875'
}, {
  'label': '滁州Chuzhou0550',
  'name': '滁州',
  'pinyin': 'Chuzhou',
  'zip': '0550'
}, {
  'label': '大理Dali0872',
  'name': '大理',
  'pinyin': 'Dali',
  'zip': '0872'
}, {
  'label': '丹东Dandong0415',
  'name': '丹东',
  'pinyin': 'Dandong',
  'zip': '0415'
}, {
  'label': '大庆Daqing0459',
  'name': '大庆',
  'pinyin': 'Daqing',
  'zip': '0459'
}, {
  'label': '大同Datong0352',
  'name': '大同',
  'pinyin': 'Datong',
  'zip': '0352'
}, {
  'label': '大兴安岭Daxinganling0457',
  'name': '大兴安岭',
  'pinyin': 'Daxinganling',
  'zip': '0457'
}, {
  'label': '达州Dazhou0818',
  'name': '达州',
  'pinyin': 'Dazhou',
  'zip': '0818'
}, {
  'label': '德宏Dehong0692',
  'name': '德宏',
  'pinyin': 'Dehong',
  'zip': '0692'
}, {
  'label': '德阳Deyang0838',
  'name': '德阳',
  'pinyin': 'Deyang',
  'zip': '0838'
}, {
  'label': '德州Dezhou0534',
  'name': '德州',
  'pinyin': 'Dezhou',
  'zip': '0534'
}, {
  'label': '定西Dingxi0932',
  'name': '定西',
  'pinyin': 'Dingxi',
  'zip': '0932'
}, {
  'label': '迪庆Diqing0887',
  'name': '迪庆',
  'pinyin': 'Diqing',
  'zip': '0887'
}, {
  'label': '东营Dongying0546',
  'name': '东营',
  'pinyin': 'Dongying',
  'zip': '0546'
}, {
  'label': '鄂尔多斯Eerduosi0477',
  'name': '鄂尔多斯',
  'pinyin': 'Eerduosi',
  'zip': '0477'
}, {
  'label': '恩施Enshi0718',
  'name': '恩施',
  'pinyin': 'Enshi',
  'zip': '0718'
}, {
  'label': '鄂州Ezhou0711',
  'name': '鄂州',
  'pinyin': 'Ezhou',
  'zip': '0711'
}, {
  'label': '防城港Fangchenggang0770',
  'name': '防城港',
  'pinyin': 'Fangchenggang',
  'zip': '0770'
}, {
  'label': '抚顺Fushun0413',
  'name': '抚顺',
  'pinyin': 'Fushun',
  'zip': '0413'
}, {
  'label': '阜新Fuxin0418',
  'name': '阜新',
  'pinyin': 'Fuxin',
  'zip': '0418'
}, {
  'label': '阜阳Fuyang0558',
  'name': '阜阳',
  'pinyin': 'Fuyang',
  'zip': '0558'
}, {
  'label': '抚州Fuzhou0794',
  'name': '抚州',
  'pinyin': 'Fuzhou',
  'zip': '0794'
}, {
  'label': '甘南Gannan0941',
  'name': '甘南',
  'pinyin': 'Gannan',
  'zip': '0941'
}, {
  'label': '赣州Ganzhou0797',
  'name': '赣州',
  'pinyin': 'Ganzhou',
  'zip': '0797'
}, {
  'label': '甘孜Ganzi0836',
  'name': '甘孜',
  'pinyin': 'Ganzi',
  'zip': '0836'
}, {
  'label': '广安Guangan0826',
  'name': '广安',
  'pinyin': 'Guangan',
  'zip': '0826'
}, {
  'label': '广元Guangyuan0839',
  'name': '广元',
  'pinyin': 'Guangyuan',
  'zip': '0839'
}, {
  'label': '贵港Guigang0775',
  'name': '贵港',
  'pinyin': 'Guigang',
  'zip': '0775'
}, {
  'label': '桂林Guilin0773',
  'name': '桂林',
  'pinyin': 'Guilin',
  'zip': '0773'
}, {
  'label': '果洛Guoluo0975',
  'name': '果洛',
  'pinyin': 'Guoluo',
  'zip': '0975'
}, {
  'label': '固原Guyuan0954',
  'name': '固原',
  'pinyin': 'Guyuan',
  'zip': '0954'
}, {
  'label': '海北Haibei0970',
  'name': '海北',
  'pinyin': 'Haibei',
  'zip': '0970'
}, {
  'label': '海东Haidong0972',
  'name': '海东',
  'pinyin': 'Haidong',
  'zip': '0972'
}, {
  'label': '海南Hainan0974',
  'name': '海南',
  'pinyin': 'Hainan',
  'zip': '0974'
}, {
  'label': '海西Haixi0977',
  'name': '海西',
  'pinyin': 'Haixi',
  'zip': '0977'
}, {
  'label': '哈密Hami0902',
  'name': '哈密',
  'pinyin': 'Hami',
  'zip': '0902'
}, {
  'label': '汉中Hanzhong0916',
  'name': '汉中',
  'pinyin': 'Hanzhong',
  'zip': '0916'
}, {
  'label': '鹤壁Hebi0392',
  'name': '鹤壁',
  'pinyin': 'Hebi',
  'zip': '0392'
}, {
  'label': '河池Hechi0778',
  'name': '河池',
  'pinyin': 'Hechi',
  'zip': '0778'
}, {
  'label': '鹤岗Hegang0468',
  'name': '鹤岗',
  'pinyin': 'Hegang',
  'zip': '0468'
}, {
  'label': '黑河Heihe0456',
  'name': '黑河',
  'pinyin': 'Heihe',
  'zip': '0456'
}, {
  'label': '衡水Hengshui0318',
  'name': '衡水',
  'pinyin': 'Hengshui',
  'zip': '0318'
}, {
  'label': '衡阳Hengyang0734',
  'name': '衡阳',
  'pinyin': 'Hengyang',
  'zip': '0734'
}, {
  'label': '和田地Hetiandi0903',
  'name': '和田地',
  'pinyin': 'Hetiandi',
  'zip': '0903'
}, {
  'label': '河源Heyuan0762',
  'name': '河源',
  'pinyin': 'Heyuan',
  'zip': '0762'
}, {
  'label': '菏泽Heze0530',
  'name': '菏泽',
  'pinyin': 'Heze',
  'zip': '0530'
}, {
  'label': '贺州Hezhou0774',
  'name': '贺州',
  'pinyin': 'Hezhou',
  'zip': '0774'
}, {
  'label': '红河Honghe0873',
  'name': '红河',
  'pinyin': 'Honghe',
  'zip': '0873'
}, {
  'label': '淮安Huaian0517',
  'name': '淮安',
  'pinyin': 'Huaian',
  'zip': '0517'
}, {
  'label': '淮北Huaibei0561',
  'name': '淮北',
  'pinyin': 'Huaibei',
  'zip': '0561'
}, {
  'label': '怀化Huaihua0745',
  'name': '怀化',
  'pinyin': 'Huaihua',
  'zip': '0745'
}, {
  'label': '淮南Huainan0554',
  'name': '淮南',
  'pinyin': 'Huainan',
  'zip': '0554'
}, {
  'label': '黄冈Huanggang0713',
  'name': '黄冈',
  'pinyin': 'Huanggang',
  'zip': '0713'
}, {
  'label': '黄南Huangnan0973',
  'name': '黄南',
  'pinyin': 'Huangnan',
  'zip': '0973'
}, {
  'label': '黄山Huangshan0559',
  'name': '黄山',
  'pinyin': 'Huangshan',
  'zip': '0559'
}, {
  'label': '黄石Huangshi0714',
  'name': '黄石',
  'pinyin': 'Huangshi',
  'zip': '0714'
}, {
  'label': '呼和浩特Huhehaote0471',
  'name': '呼和浩特',
  'pinyin': 'Huhehaote',
  'zip': '0471'
}, {
  'label': '葫芦岛Huludao0429',
  'name': '葫芦岛',
  'pinyin': 'Huludao',
  'zip': '0429'
}, {
  'label': '呼伦贝尔Hulunbeier0470',
  'name': '呼伦贝尔',
  'pinyin': 'Hulunbeier',
  'zip': '0470'
}, {
  'label': '湖州Huzhou0572',
  'name': '湖州',
  'pinyin': 'Huzhou',
  'zip': '0572'
}, {
  'label': '佳木斯Jiamusi0454',
  'name': '佳木斯',
  'pinyin': 'Jiamusi',
  'zip': '0454'
}, {
  'label': '江门Jiangmen0750',
  'name': '江门',
  'pinyin': 'Jiangmen',
  'zip': '0750'
}, {
  'label': '吉安Jian0796',
  'name': '吉安',
  'pinyin': 'Jian',
  'zip': '0796'
}, {
  'label': '嘉峪关Jiayuguan0937',
  'name': '嘉峪关',
  'pinyin': 'Jiayuguan',
  'zip': '0937'
}, {
  'label': '揭阳Jieyang0663',
  'name': '揭阳',
  'pinyin': 'Jieyang',
  'zip': '0663'
}, {
  'label': '金昌Jinchang0935',
  'name': '金昌',
  'pinyin': 'Jinchang',
  'zip': '0935'
}, {
  'label': '晋城Jincheng0356',
  'name': '晋城',
  'pinyin': 'Jincheng',
  'zip': '0356'
}, {
  'label': '景德镇Jingdezhen0798',
  'name': '景德镇',
  'pinyin': 'Jingdezhen',
  'zip': '0798'
}, {
  'label': '荆门Jingmen0724',
  'name': '荆门',
  'pinyin': 'Jingmen',
  'zip': '0724'
}, {
  'label': '荆州Jingzhou0716',
  'name': '荆州',
  'pinyin': 'Jingzhou',
  'zip': '0716'
}, {
  'label': '金华Jinhua0579',
  'name': '金华',
  'pinyin': 'Jinhua',
  'zip': '0579'
}, {
  'label': '济宁Jining0537',
  'name': '济宁',
  'pinyin': 'Jining',
  'zip': '0537'
}, {
  'label': '晋中Jinzhong0354',
  'name': '晋中',
  'pinyin': 'Jinzhong',
  'zip': '0354'
}, {
  'label': '锦州Jinzhou0416',
  'name': '锦州',
  'pinyin': 'Jinzhou',
  'zip': '0416'
}, {
  'label': '九江Jiujiang0792',
  'name': '九江',
  'pinyin': 'Jiujiang',
  'zip': '0792'
}, {
  'label': '酒泉Jiuquan0937',
  'name': '酒泉',
  'pinyin': 'Jiuquan',
  'zip': '0937'
}, {
  'label': '鸡西Jixi0467',
  'name': '鸡西',
  'pinyin': 'Jixi',
  'zip': '0467'
}, {
  'label': '开封Kaifeng0378',
  'name': '开封',
  'pinyin': 'Kaifeng',
  'zip': '0378'
}, {
  'label': '喀什地Kashidi0998',
  'name': '喀什地',
  'pinyin': 'Kashidi',
  'zip': '0998'
}, {
  'label': '克拉玛依Kelamayi0990',
  'name': '克拉玛依',
  'pinyin': 'Kelamayi',
  'zip': '0990'
}, {
  'label': '克孜勒Kezile0908',
  'name': '克孜勒',
  'pinyin': 'Kezile',
  'zip': '0908'
}, {
  'label': '来宾Laibin0772',
  'name': '来宾',
  'pinyin': 'Laibin',
  'zip': '0772'
}, {
  'label': '莱芜Laiwu0634',
  'name': '莱芜',
  'pinyin': 'Laiwu',
  'zip': '0634'
}, {
  'label': '廊坊Langfang0316',
  'name': '廊坊',
  'pinyin': 'Langfang',
  'zip': '0316'
}, {
  'label': '拉萨Lasa0891',
  'name': '拉萨',
  'pinyin': 'Lasa',
  'zip': '0891'
}, {
  'label': '乐山Leshan0833',
  'name': '乐山',
  'pinyin': 'Leshan',
  'zip': '0833'
}, {
  'label': '凉山Liangshan0834',
  'name': '凉山',
  'pinyin': 'Liangshan',
  'zip': '0834'
}, {
  'label': '连云港Lianyungang0518',
  'name': '连云港',
  'pinyin': 'Lianyungang',
  'zip': '0518'
}, {
  'label': '聊城Liaocheng0635',
  'name': '聊城',
  'pinyin': 'Liaocheng',
  'zip': '0635'
}, {
  'label': '辽阳Liaoyang0419',
  'name': '辽阳',
  'pinyin': 'Liaoyang',
  'zip': '0419'
}, {
  'label': '辽源Liaoyuan0437',
  'name': '辽源',
  'pinyin': 'Liaoyuan',
  'zip': '0437'
}, {
  'label': '丽江Lijiang0888',
  'name': '丽江',
  'pinyin': 'Lijiang',
  'zip': '0888'
}, {
  'label': '临沧Lincang0883',
  'name': '临沧',
  'pinyin': 'Lincang',
  'zip': '0883'
}, {
  'label': '临汾Linfen0357',
  'name': '临汾',
  'pinyin': 'Linfen',
  'zip': '0357'
}, {
  'label': '临夏Linxia0930',
  'name': '临夏',
  'pinyin': 'Linxia',
  'zip': '0930'
}, {
  'label': '临沂Linyi0539',
  'name': '临沂',
  'pinyin': 'Linyi',
  'zip': '0539'
}, {
  'label': '林芝Linzhi0894',
  'name': '林芝',
  'pinyin': 'Linzhi',
  'zip': '0894'
}, {
  'label': '丽水Lishui0578',
  'name': '丽水',
  'pinyin': 'Lishui',
  'zip': '0578'
}, {
  'label': '六安Liuan0564',
  'name': '六安',
  'pinyin': 'Liuan',
  'zip': '0564'
}, {
  'label': '六盘水Liupanshui0858',
  'name': '六盘水',
  'pinyin': 'Liupanshui',
  'zip': '0858'
}, {
  'label': '陇南Longnan0939',
  'name': '陇南',
  'pinyin': 'Longnan',
  'zip': '0939'
}, {
  'label': '龙岩Longyan0597',
  'name': '龙岩',
  'pinyin': 'Longyan',
  'zip': '0597'
}, {
  'label': '娄底Loudi0738',
  'name': '娄底',
  'pinyin': 'Loudi',
  'zip': '0738'
}, {
  'label': '漯河Luohe0395',
  'name': '漯河',
  'pinyin': 'Luohe',
  'zip': '0395'
}, {
  'label': '泸州Luzhou0830',
  'name': '泸州',
  'pinyin': 'Luzhou',
  'zip': '0830'
}, {
  'label': '吕梁Lvliang0358',
  'name': '吕梁',
  'pinyin': 'Lvliang',
  'zip': '0358'
}, {
  'label': '马鞍山Maanshan0555',
  'name': '马鞍山',
  'pinyin': 'Maanshan',
  'zip': '0555'
}, {
  'label': '茂名Maoming0668',
  'name': '茂名',
  'pinyin': 'Maoming',
  'zip': '0668'
}, {
  'label': '眉山Meishan028',
  'name': '眉山',
  'pinyin': 'Meishan',
  'zip': '028'
}, {
  'label': '梅州Meizhou0753',
  'name': '梅州',
  'pinyin': 'Meizhou',
  'zip': '0753'
}, {
  'label': '绵阳Mianyang0816',
  'name': '绵阳',
  'pinyin': 'Mianyang',
  'zip': '0816'
}, {
  'label': '牡丹江Mudanjiang0453',
  'name': '牡丹江',
  'pinyin': 'Mudanjiang',
  'zip': '0453'
}, {
  'label': '南充Nanchong0817',
  'name': '南充',
  'pinyin': 'Nanchong',
  'zip': '0817'
}, {
  'label': '南平Nanping0599',
  'name': '南平',
  'pinyin': 'Nanping',
  'zip': '0599'
}, {
  'label': '南阳Nanyang0377',
  'name': '南阳',
  'pinyin': 'Nanyang',
  'zip': '0377'
}, {
  'label': '那曲Naqu0896',
  'name': '那曲',
  'pinyin': 'Naqu',
  'zip': '0896'
}, {
  'label': '内江Neijiang0832',
  'name': '内江',
  'pinyin': 'Neijiang',
  'zip': '0832'
}, {
  'label': '宁德Ningde0593',
  'name': '宁德',
  'pinyin': 'Ningde',
  'zip': '0593'
}, {
  'label': '怒江Nujiang0886',
  'name': '怒江',
  'pinyin': 'Nujiang',
  'zip': '0886'
}, {
  'label': '盘锦Panjin0427',
  'name': '盘锦',
  'pinyin': 'Panjin',
  'zip': '0427'
}, {
  'label': '攀枝花Panzhihua0812',
  'name': '攀枝花',
  'pinyin': 'Panzhihua',
  'zip': '0812'
}, {
  'label': '平顶山Pingdingshan0375',
  'name': '平顶山',
  'pinyin': 'Pingdingshan',
  'zip': '0375'
}, {
  'label': '平凉Pingliang0933',
  'name': '平凉',
  'pinyin': 'Pingliang',
  'zip': '0933'
}, {
  'label': '萍乡Pingxiang0799',
  'name': '萍乡',
  'pinyin': 'Pingxiang',
  'zip': '0799'
}, {
  'label': '普洱Puer0879',
  'name': '普洱',
  'pinyin': 'Puer',
  'zip': '0879'
}, {
  'label': '莆田Putian0594',
  'name': '莆田',
  'pinyin': 'Putian',
  'zip': '0594'
}, {
  'label': '濮阳Puyang0393',
  'name': '濮阳',
  'pinyin': 'Puyang',
  'zip': '0393'
}, {
  'label': '黔东Qiandong0855',
  'name': '黔东',
  'pinyin': 'Qiandong',
  'zip': '0855'
}, {
  'label': '黔南Qiannan0854',
  'name': '黔南',
  'pinyin': 'Qiannan',
  'zip': '0854'
}, {
  'label': '黔西南Qianxinan0859',
  'name': '黔西南',
  'pinyin': 'Qianxinan',
  'zip': '0859'
}, {
  'label': '庆阳Qingyang0934',
  'name': '庆阳',
  'pinyin': 'Qingyang',
  'zip': '0934'
}, {
  'label': '清远Qingyuan0763',
  'name': '清远',
  'pinyin': 'Qingyuan',
  'zip': '0763'
}, {
  'label': '秦皇岛Qinhuangdao0335',
  'name': '秦皇岛',
  'pinyin': 'Qinhuangdao',
  'zip': '0335'
}, {
  'label': '钦州Qinzhou0777',
  'name': '钦州',
  'pinyin': 'Qinzhou',
  'zip': '0777'
}, {
  'label': '齐齐哈尔Qiqihaer0452',
  'name': '齐齐哈尔',
  'pinyin': 'Qiqihaer',
  'zip': '0452'
}, {
  'label': '七台河Qitaihe0464',
  'name': '七台河',
  'pinyin': 'Qitaihe',
  'zip': '0464'
}, {
  'label': '曲靖Qujing0874',
  'name': '曲靖',
  'pinyin': 'Qujing',
  'zip': '0874'
}, {
  'label': '衢州Quzhou0570',
  'name': '衢州',
  'pinyin': 'Quzhou',
  'zip': '0570'
}, {
  'label': '潜江',
  'name': '潜江',
  'pinyin': 'QianJiang',
  'zip': '0570'
}, {
  'label': '日喀则Rikaze0892',
  'name': '日喀则',
  'pinyin': 'Rikaze',
  'zip': '0892'
}, {
  'label': '日照Rizhao0633',
  'name': '日照',
  'pinyin': 'Rizhao',
  'zip': '0633'
}, {
  'label': '三门峡Sanmenxia0398',
  'name': '三门峡',
  'pinyin': 'Sanmenxia',
  'zip': '0398'
}, {
  'label': '三明Sanming0598',
  'name': '三明',
  'pinyin': 'Sanming',
  'zip': '0598'
}, {
  'label': '三亚Sanya0899',
  'name': '三亚',
  'pinyin': 'Sanya',
  'zip': '0899'
}, {
  'label': '商洛Shangluo0914',
  'name': '商洛',
  'pinyin': 'Shangluo',
  'zip': '0914'
}, {
  'label': '商丘Shangqiu0370',
  'name': '商丘',
  'pinyin': 'Shangqiu',
  'zip': '0370'
}, {
  'label': '上饶Shangrao0793',
  'name': '上饶',
  'pinyin': 'Shangrao',
  'zip': '0793'
}, {
  'label': '山南Shannan0893',
  'name': '山南',
  'pinyin': 'Shannan',
  'zip': '0893'
}, {
  'label': '汕头Shantou0754',
  'name': '汕头',
  'pinyin': 'Shantou',
  'zip': '0754'
}, {
  'label': '汕尾Shanwei0660',
  'name': '汕尾',
  'pinyin': 'Shanwei',
  'zip': '0660'
}, {
  'label': '韶关Shaoguan0751',
  'name': '韶关',
  'pinyin': 'Shaoguan',
  'zip': '0751'
}, {
  'label': '绍兴Shaoxing0575',
  'name': '绍兴',
  'pinyin': 'Shaoxing',
  'zip': '0575'
}, {
  'label': '邵阳Shaoyang0739',
  'name': '邵阳',
  'pinyin': 'Shaoyang',
  'zip': '0739'
}, {
  'label': '十堰Shiyan0719',
  'name': '十堰',
  'pinyin': 'Shiyan',
  'zip': '0719'
}, {
  'label': '石嘴山Shizuishan0952',
  'name': '石嘴山',
  'pinyin': 'Shizuishan',
  'zip': '0952'
}, {
  'label': '双鸭山Shuangyashan0469',
  'name': '双鸭山',
  'pinyin': 'Shuangyashan',
  'zip': '0469'
}, {
  'label': '朔州Shuozhou0349',
  'name': '朔州',
  'pinyin': 'Shuozhou',
  'zip': '0349'
}, {
  'label': '四平Siping0434',
  'name': '四平',
  'pinyin': 'Siping',
  'zip': '0434'
}, {
  'label': '松原Songyuan0438',
  'name': '松原',
  'pinyin': 'Songyuan',
  'zip': '0438'
}, {
  'label': '绥化Suihua0455',
  'name': '绥化',
  'pinyin': 'Suihua',
  'zip': '0455'
}, {
  'label': '遂宁Suining0825',
  'name': '遂宁',
  'pinyin': 'Suining',
  'zip': '0825'
}, {
  'label': '随州Suizhou0722',
  'name': '随州',
  'pinyin': 'Suizhou',
  'zip': '0722'
}, {
  'label': '宿迁Suqian0527',
  'name': '宿迁',
  'pinyin': 'Suqian',
  'zip': '0527'
}, {
  'label': '宿州Suzhou0557',
  'name': '宿州',
  'pinyin': 'Suzhou',
  'zip': '0557'
}, {
  'label': '塔城地Tachengdi0901',
  'name': '塔城地',
  'pinyin': 'Tachengdi',
  'zip': '0901'
}, {
  'label': '泰安Taian0538',
  'name': '泰安',
  'pinyin': 'Taian',
  'zip': '0538'
}, {
  'label': '太原Taiyuan0351',
  'name': '太原',
  'pinyin': 'Taiyuan',
  'zip': '0351'
}, {
  'label': '泰州Taizhou0523',
  'name': '泰州',
  'pinyin': 'Taizhou',
  'zip': '0523'
}, {
  'label': '天水Tianshui0938',
  'name': '天水',
  'pinyin': 'Tianshui',
  'zip': '0938'
}, {
  'label': '铁岭Tieling0410',
  'name': '铁岭',
  'pinyin': 'Tieling',
  'zip': '0410'
}, {
  'label': '铜川Tongchuan0919',
  'name': '铜川',
  'pinyin': 'Tongchuan',
  'zip': '0919'
}, {
  'label': '通化Tonghua0435',
  'name': '通化',
  'pinyin': 'Tonghua',
  'zip': '0435'
}, {
  'label': '通辽Tongliao0475',
  'name': '通辽',
  'pinyin': 'Tongliao',
  'zip': '0475'
}, {
  'label': '铜陵Tongling0562',
  'name': '铜陵',
  'pinyin': 'Tongling',
  'zip': '0562'
}, {
  'label': '铜仁Tongren0856',
  'name': '铜仁',
  'pinyin': 'Tongren',
  'zip': '0856'
}, {
  'label': '吐鲁番Tulufan0995',
  'name': '吐鲁番',
  'pinyin': 'Tulufan',
  'zip': '0995'
}, {
  'label': '渭南Weinan0913',
  'name': '渭南',
  'pinyin': 'Weinan',
  'zip': '0913'
}, {
  'label': '文山Wenshan0876',
  'name': '文山',
  'pinyin': 'Wenshan',
  'zip': '0876'
}, {
  'label': '温州Wenzhou0577',
  'name': '温州',
  'pinyin': 'Wenzhou',
  'zip': '0577'
}, {
  'label': '乌海Wuhai0473',
  'name': '乌海',
  'pinyin': 'Wuhai',
  'zip': '0473'
}, {
  'label': '芜湖Wuhu0553',
  'name': '芜湖',
  'pinyin': 'Wuhu',
  'zip': '0553'
}, {
  'label': '乌兰察布Wulanchabu0474',
  'name': '乌兰察布',
  'pinyin': 'Wulanchabu',
  'zip': '0474'
}, {
  'label': '乌鲁木齐Wulumuqi0991',
  'name': '乌鲁木齐',
  'pinyin': 'Wulumuqi',
  'zip': '0991'
}, {
  'label': '武威Wuwei0935',
  'name': '武威',
  'pinyin': 'Wuwei',
  'zip': '0935'
}, {
  'label': '吴忠Wuzhong0953',
  'name': '吴忠',
  'pinyin': 'Wuzhong',
  'zip': '0953'
}, {
  'label': '梧州Wuzhou0774',
  'name': '梧州',
  'pinyin': 'Wuzhou',
  'zip': '0774'
}, {
  'label': '襄樊Xiangfan0710',
  'name': '襄樊',
  'pinyin': 'Xiangfan',
  'zip': '0710'
}, {
  'label': '湘潭Xiangtan0732',
  'name': '湘潭',
  'pinyin': 'Xiangtan',
  'zip': '0732'
}, {
  'label': '湘西Xiangxi0743',
  'name': '湘西',
  'pinyin': 'Xiangxi',
  'zip': '0743'
}, {
  'label': '咸宁Xianning0715',
  'name': '咸宁',
  'pinyin': 'Xianning',
  'zip': '0715'
}, {
  'label': '咸阳Xianyang029',
  'name': '咸阳',
  'pinyin': 'Xianyang',
  'zip': '029'
}, {
  'label': '孝感Xiaogan0712',
  'name': '孝感',
  'pinyin': 'Xiaogan',
  'zip': '0712'
}, {
  'label': '锡林郭勒盟Xilinguolemeng0479',
  'name': '锡林郭勒盟',
  'pinyin': 'Xilinguolemeng',
  'zip': '0479'
}, {
  'label': '兴安盟Xinganmeng0482',
  'name': '兴安盟',
  'pinyin': 'Xinganmeng',
  'zip': '0482'
}, {
  'label': '邢台Xingtai0319',
  'name': '邢台',
  'pinyin': 'Xingtai',
  'zip': '0319'
}, {
  'label': '西宁Xining0971',
  'name': '西宁',
  'pinyin': 'Xining',
  'zip': '0971'
}, {
  'label': '新乡Xinxiang0373',
  'name': '新乡',
  'pinyin': 'Xinxiang',
  'zip': '0373'
}, {
  'label': '信阳Xinyang0376',
  'name': '信阳',
  'pinyin': 'Xinyang',
  'zip': '0376'
}, {
  'label': '新余Xinyu0790',
  'name': '新余',
  'pinyin': 'Xinyu',
  'zip': '0790'
}, {
  'label': '忻州Xinzhou0350',
  'name': '忻州',
  'pinyin': 'Xinzhou',
  'zip': '0350'
}, {
  'label': '西双版纳Xishuangbanna0691',
  'name': '西双版纳',
  'pinyin': 'Xishuangbanna',
  'zip': '0691'
}, {
  'label': '宣城Xuancheng0563',
  'name': '宣城',
  'pinyin': 'Xuancheng',
  'zip': '0563'
}, {
  'label': '雅安Yaan0835',
  'name': '雅安',
  'pinyin': 'Yaan',
  'zip': '0835'
}, {
  'label': '延安Yanan0911',
  'name': '延安',
  'pinyin': 'Yanan',
  'zip': '0911'
}, {
  'label': '延边Yanbian0433',
  'name': '延边',
  'pinyin': 'Yanbian',
  'zip': '0433'
}, {
  'label': '盐城Yancheng0515',
  'name': '盐城',
  'pinyin': 'Yancheng',
  'zip': '0515'
}, {
  'label': '阳江Yangjiang0662',
  'name': '阳江',
  'pinyin': 'Yangjiang',
  'zip': '0662'
}, {
  'label': '阳泉Yangquan0353',
  'name': '阳泉',
  'pinyin': 'Yangquan',
  'zip': '0353'
}, {
  'label': '宜宾Yibin0831',
  'name': '宜宾',
  'pinyin': 'Yibin',
  'zip': '0831'
}, {
  'label': '宜昌Yichang0717',
  'name': '宜昌',
  'pinyin': 'Yichang',
  'zip': '0717'
}, {
  'label': '伊春Yichun0458',
  'name': '伊春',
  'pinyin': 'Yichun',
  'zip': '0458'
}, {
  'label': '宜春Yichun0795',
  'name': '宜春',
  'pinyin': 'Yichun',
  'zip': '0795'
}, {
  'label': '伊犁哈萨克Yilihasake0999',
  'name': '伊犁哈萨克',
  'pinyin': 'Yilihasake',
  'zip': '0999'
}, {
  'label': '银川Yinchuan0951',
  'name': '银川',
  'pinyin': 'Yinchuan',
  'zip': '0951'
}, {
  'label': '营口Yingkou0417',
  'name': '营口',
  'pinyin': 'Yingkou',
  'zip': '0417'
}, {
  'label': '鹰潭Yingtan0701',
  'name': '鹰潭',
  'pinyin': 'Yingtan',
  'zip': '0701'
}, {
  'label': '益阳Yiyang0737',
  'name': '益阳',
  'pinyin': 'Yiyang',
  'zip': '0737'
}, {
  'label': '永州Yongzhou0746',
  'name': '永州',
  'pinyin': 'Yongzhou',
  'zip': '0746'
}, {
  'label': '岳阳Yueyang0730',
  'name': '岳阳',
  'pinyin': 'Yueyang',
  'zip': '0730'
}, {
  'label': '玉林Yulin0775',
  'name': '玉林',
  'pinyin': 'Yulin',
  'zip': '0775'
}, {
  'label': '榆林Yulin0912',
  'name': '榆林',
  'pinyin': 'Yulin',
  'zip': '0912'
}, {
  'label': '运城Yuncheng0359',
  'name': '运城',
  'pinyin': 'Yuncheng',
  'zip': '0359'
}, {
  'label': '云浮Yunfu0766',
  'name': '云浮',
  'pinyin': 'Yunfu',
  'zip': '0766'
}, {
  'label': '玉树Yushu0976',
  'name': '玉树',
  'pinyin': 'Yushu',
  'zip': '0976'
}, {
  'label': '玉溪Yuxi0877',
  'name': '玉溪',
  'pinyin': 'Yuxi',
  'zip': '0877'
}, {
  'label': '枣庄Zaozhuang0623',
  'name': '枣庄',
  'pinyin': 'Zaozhuang',
  'zip': '0623'
}, {
  'label': '张家界Zhangjiajie0744',
  'name': '张家界',
  'pinyin': 'Zhangjiajie',
  'zip': '0744'
}, {
  'label': '张家口Zhangjiakou0313',
  'name': '张家口',
  'pinyin': 'Zhangjiakou',
  'zip': '0313'
}, {
  'label': '张掖Zhangye0936',
  'name': '张掖',
  'pinyin': 'Zhangye',
  'zip': '0936'
}, {
  'label': '湛江Zhanjiang0759',
  'name': '湛江',
  'pinyin': 'Zhanjiang',
  'zip': '0759'
}, {
  'label': '肇庆Zhaoqing0758',
  'name': '肇庆',
  'pinyin': 'Zhaoqing',
  'zip': '0758'
}, {
  'label': '昭通Zhaotong0870',
  'name': '昭通',
  'pinyin': 'Zhaotong',
  'zip': '0870'
}, {
  'label': '镇江Zhenjiang0511',
  'name': '镇江',
  'pinyin': 'Zhenjiang',
  'zip': '0511'
}, {
  'label': '中卫Zhongwei0955',
  'name': '中卫',
  'pinyin': 'Zhongwei',
  'zip': '0955'
}, {
  'label': '周口Zhoukou0394',
  'name': '周口',
  'pinyin': 'Zhoukou',
  'zip': '0394'
}, {
  'label': '舟山Zhoushan0580',
  'name': '舟山',
  'pinyin': 'Zhoushan',
  'zip': '0580'
}, {
  'label': '驻马店Zhumadian0396',
  'name': '驻马店',
  'pinyin': 'Zhumadian',
  'zip': '0396'
}, {
  'label': '株洲Zhuzhou0731',
  'name': '株洲',
  'pinyin': 'Zhuzhou',
  'zip': '0731'
}, {
  'label': '淄博Zibo0533',
  'name': '淄博',
  'pinyin': 'Zibo',
  'zip': '0533'
}, {
  'label': '自贡Zigong0813',
  'name': '自贡',
  'pinyin': 'Zigong',
  'zip': '0813'
}, {
  'label': '资阳Ziyang028',
  'name': '资阳',
  'pinyin': 'Ziyang',
  'zip': '028'
}, {
  'label': '遵义Zunyi0852',
  'name': '遵义',
  'pinyin': 'Zunyi',
  'zip': '0852'
}, {
  'label': '阿城Acheng0451',
  'name': '阿城',
  'pinyin': 'Acheng',
  'zip': '0451'
}, {
  'label': '安福Anfu0796',
  'name': '安福',
  'pinyin': 'Anfu',
  'zip': '0796'
}, {
  'label': '安吉Anji0572',
  'name': '安吉',
  'pinyin': 'Anji',
  'zip': '0572'
}, {
  'label': '安宁Anning0871',
  'name': '安宁',
  'pinyin': 'Anning',
  'zip': '0871'
}, {
  'label': '安丘Anqiu0536',
  'name': '安丘',
  'pinyin': 'Anqiu',
  'zip': '0536'
}, {
  'label': '安溪Anxi0595',
  'name': '安溪',
  'pinyin': 'Anxi',
  'zip': '0595'
}, {
  'label': '安义Anyi0791',
  'name': '安义',
  'pinyin': 'Anyi',
  'zip': '0791'
}, {
  'label': '安远Anyuan0797',
  'name': '安远',
  'pinyin': 'Anyuan',
  'zip': '0797'
}, {
  'label': '宝应Baoying0514',
  'name': '宝应',
  'pinyin': 'Baoying',
  'zip': '0514'
}, {
  'label': '巴彦Bayan0451',
  'name': '巴彦',
  'pinyin': 'Bayan',
  'zip': '0451'
}, {
  'label': '滨海Binhai0515',
  'name': '滨海',
  'pinyin': 'Binhai',
  'zip': '0515'
}, {
  'label': '宾县Binxian0451',
  'name': '宾县',
  'pinyin': 'Binxian',
  'zip': '0451'
}, {
  'label': '宾阳Binyang0771',
  'name': '宾阳',
  'pinyin': 'Binyang',
  'zip': '0771'
}, {
  'label': '璧山Bishan023',
  'name': '璧山',
  'pinyin': 'Bishan',
  'zip': '023'
}, {
  'label': '博爱Boai0391',
  'name': '博爱',
  'pinyin': 'Boai',
  'zip': '0391'
}, {
  'label': '博罗Boluo0752',
  'name': '博罗',
  'pinyin': 'Boluo',
  'zip': '0752'
}, {
  'label': '博兴Boxing0543',
  'name': '博兴',
  'pinyin': 'Boxing',
  'zip': '0543'
}, {
  'label': '苍南Cangnan0577',
  'name': '苍南',
  'pinyin': 'Cangnan',
  'zip': '0577'
}, {
  'label': '苍山Cangshan0539',
  'name': '苍山',
  'pinyin': 'Cangshan',
  'zip': '0539'
}, {
  'label': '曹县Caoxian0530',
  'name': '曹县',
  'pinyin': 'Caoxian',
  'zip': '0530'
}, {
  'label': '长岛Changdao0535',
  'name': '长岛',
  'pinyin': 'Changdao',
  'zip': '0535'
}, {
  'label': '长丰Changfeng0551',
  'name': '长丰',
  'pinyin': 'Changfeng',
  'zip': '0551'
}, {
  'label': '长海Changhai0411',
  'name': '长海',
  'pinyin': 'Changhai',
  'zip': '0411'
}, {
  'label': '长乐Changle0591',
  'name': '长乐',
  'pinyin': 'Changle',
  'zip': '0591'
}, {
  'label': '昌乐Changle0536',
  'name': '昌乐',
  'pinyin': 'Changle',
  'zip': '0536'
}, {
  'label': '常山Changshan0570',
  'name': '常山',
  'pinyin': 'Changshan',
  'zip': '0570'
}, {
  'label': '常熟Changshu0512',
  'name': '常熟',
  'pinyin': 'Changshu',
  'zip': '0512'
}, {
  'label': '长泰Changtai0596',
  'name': '长泰',
  'pinyin': 'Changtai',
  'zip': '0596'
}, {
  'label': '长汀Changting0597',
  'name': '长汀',
  'pinyin': 'Changting',
  'zip': '0597'
}, {
  'label': '长兴Changxing0572',
  'name': '长兴',
  'pinyin': 'Changxing',
  'zip': '0572'
}, {
  'label': '昌邑Changyi0536',
  'name': '昌邑',
  'pinyin': 'Changyi',
  'zip': '0536'
}, {
  'label': '潮安Chaoan0768',
  'name': '潮安',
  'pinyin': 'Chaoan',
  'zip': '0768'
}, {
  'label': '呈贡Chenggong0871',
  'name': '呈贡',
  'pinyin': 'Chenggong',
  'zip': '0871'
}, {
  'label': '城口Chengkou023',
  'name': '城口',
  'pinyin': 'Chengkou',
  'zip': '023'
}, {
  'label': '成武Chengwu0530',
  'name': '成武',
  'pinyin': 'Chengwu',
  'zip': '0530'
}, {
  'label': '茌平Chiping0635',
  'name': '茌平',
  'pinyin': 'Chiping',
  'zip': '0635'
}, {
  'label': '崇仁Chongren0794',
  'name': '崇仁',
  'pinyin': 'Chongren',
  'zip': '0794'
}, {
  'label': '崇义Chongyi0797',
  'name': '崇义',
  'pinyin': 'Chongyi',
  'zip': '0797'
}, {
  'label': '崇州Chongzhou028',
  'name': '崇州',
  'pinyin': 'Chongzhou',
  'zip': '028'
}, {
  'label': '淳安Chunan0571',
  'name': '淳安',
  'pinyin': 'Chunan',
  'zip': '0571'
}, {
  'label': '慈溪Cixi0574',
  'name': '慈溪',
  'pinyin': 'Cixi',
  'zip': '0574'
}, {
  'label': '从化Conghua020',
  'name': '从化',
  'pinyin': 'Conghua',
  'zip': '020'
}, {
  'label': '枞阳Congyang0556',
  'name': '枞阳',
  'pinyin': 'Congyang',
  'zip': '0556'
}, {
  'label': '大丰Dafeng0515',
  'name': '大丰',
  'pinyin': 'Dafeng',
  'zip': '0515'
}, {
  'label': '岱山Daishan0580',
  'name': '岱山',
  'pinyin': 'Daishan',
  'zip': '0580'
}, {
  'label': '砀山Dangshan0557',
  'name': '砀山',
  'pinyin': 'Dangshan',
  'zip': '0557'
}, {
  'label': '当涂Dangtu0555',
  'name': '当涂',
  'pinyin': 'Dangtu',
  'zip': '0555'
}, {
  'label': '单县Danxian0530',
  'name': '单县',
  'pinyin': 'Danxian',
  'zip': '0530'
}, {
  'label': '丹阳Danyang0511',
  'name': '丹阳',
  'pinyin': 'Danyang',
  'zip': '0511'
}, {
  'label': '大埔Dapu0753',
  'name': '大埔',
  'pinyin': 'Dapu',
  'zip': '0753'
}, {
  'label': '大田Datian0598',
  'name': '大田',
  'pinyin': 'Datian',
  'zip': '0598'
}, {
  'label': '大邑Dayi028',
  'name': '大邑',
  'pinyin': 'Dayi',
  'zip': '028'
}, {
  'label': '大余Dayu0797',
  'name': '大余',
  'pinyin': 'Dayu',
  'zip': '0797'
}, {
  'label': '大足Dazu023',
  'name': '大足',
  'pinyin': 'Dazu',
  'zip': '023'
}, {
  'label': '德安Dean0792',
  'name': '德安',
  'pinyin': 'Dean',
  'zip': '0792'
}, {
  'label': '德化Dehua0595',
  'name': '德化',
  'pinyin': 'Dehua',
  'zip': '0595'
}, {
  'label': '德惠Dehui0431',
  'name': '德惠',
  'pinyin': 'Dehui',
  'zip': '0431'
}, {
  'label': '登封Dengfeng0371',
  'name': '登封',
  'pinyin': 'Dengfeng',
  'zip': '0371'
}, {
  'label': '德清Deqing0572',
  'name': '德清',
  'pinyin': 'Deqing',
  'zip': '0572'
}, {
  'label': '德庆Deqing0758',
  'name': '德庆',
  'pinyin': 'Deqing',
  'zip': '0758'
}, {
  'label': '德兴Dexing0793',
  'name': '德兴',
  'pinyin': 'Dexing',
  'zip': '0793'
}, {
  'label': '电白Dianbai0668',
  'name': '电白',
  'pinyin': 'Dianbai',
  'zip': '0668'
}, {
  'label': '垫江Dianjiang023',
  'name': '垫江',
  'pinyin': 'Dianjiang',
  'zip': '023'
}, {
  'label': '定南Dingnan0797',
  'name': '定南',
  'pinyin': 'Dingnan',
  'zip': '0797'
}, {
  'label': '定陶Dingtao0530',
  'name': '定陶',
  'pinyin': 'Dingtao',
  'zip': '0530'
}, {
  'label': '定远Dingyuan0550',
  'name': '定远',
  'pinyin': 'Dingyuan',
  'zip': '0550'
}, {
  'label': '东阿Donga0635',
  'name': '东阿',
  'pinyin': 'Donga',
  'zip': '0635'
}, {
  'label': '东海Donghai0518',
  'name': '东海',
  'pinyin': 'Donghai',
  'zip': '0518'
}, {
  'label': '东明Dongming0530',
  'name': '东明',
  'pinyin': 'Dongming',
  'zip': '0530'
}, {
  'label': '东平Dongping0538',
  'name': '东平',
  'pinyin': 'Dongping',
  'zip': '0538'
}, {
  'label': '东山Dongshan0596',
  'name': '东山',
  'pinyin': 'Dongshan',
  'zip': '0596'
}, {
  'label': '东台Dongtai0515',
  'name': '东台',
  'pinyin': 'Dongtai',
  'zip': '0515'
}, {
  'label': '洞头Dongtou0577',
  'name': '洞头',
  'pinyin': 'Dongtou',
  'zip': '0577'
}, {
  'label': '东乡Dongxiang0794',
  'name': '东乡',
  'pinyin': 'Dongxiang',
  'zip': '0794'
}, {
  'label': '东阳Dongyang0579',
  'name': '东阳',
  'pinyin': 'Dongyang',
  'zip': '0579'
}, {
  'label': '东源Dongyuan0762',
  'name': '东源',
  'pinyin': 'Dongyuan',
  'zip': '0762'
}, {
  'label': '东至Dongzhi0566',
  'name': '东至',
  'pinyin': 'Dongzhi',
  'zip': '0566'
}, {
  'label': '都昌Duchang0792',
  'name': '都昌',
  'pinyin': 'Duchang',
  'zip': '0792'
}, {
  'label': '都江堰Dujiangyan028',
  'name': '都江堰',
  'pinyin': 'Dujiangyan',
  'zip': '028'
}, {
  'label': '恩平Enping0750',
  'name': '恩平',
  'pinyin': 'Enping',
  'zip': '0750'
}, {
  'label': '法库Faku024',
  'name': '法库',
  'pinyin': 'Faku',
  'zip': '024'
}, {
  'label': '繁昌Fanchang0553',
  'name': '繁昌',
  'pinyin': 'Fanchang',
  'zip': '0553'
}, {
  'label': '方正Fangzheng0451',
  'name': '方正',
  'pinyin': 'Fangzheng',
  'zip': '0451'
}, {
  'label': '肥城Feicheng0538',
  'name': '肥城',
  'pinyin': 'Feicheng',
  'zip': '0538'
}, {
  'label': '肥东Feidong0551',
  'name': '肥东',
  'pinyin': 'Feidong',
  'zip': '0551'
}, {
  'label': '肥西Feixi0551',
  'name': '肥西',
  'pinyin': 'Feixi',
  'zip': '0551'
}, {
  'label': '费县Feixian0539',
  'name': '费县',
  'pinyin': 'Feixian',
  'zip': '0539'
}, {
  'label': '丰城Fengcheng0795',
  'name': '丰城',
  'pinyin': 'Fengcheng',
  'zip': '0795'
}, {
  'label': '丰都Fengdu023',
  'name': '丰都',
  'pinyin': 'Fengdu',
  'zip': '023'
}, {
  'label': '奉化Fenghua0574',
  'name': '奉化',
  'pinyin': 'Fenghua',
  'zip': '0574'
}, {
  'label': '奉节Fengjie023',
  'name': '奉节',
  'pinyin': 'Fengjie',
  'zip': '023'
}, {
  'label': '封开Fengkai0758',
  'name': '封开',
  'pinyin': 'Fengkai',
  'zip': '0758'
}, {
  'label': '丰顺Fengshun0753',
  'name': '丰顺',
  'pinyin': 'Fengshun',
  'zip': '0753'
}, {
  'label': '凤台Fengtai0554',
  'name': '凤台',
  'pinyin': 'Fengtai',
  'zip': '0554'
}, {
  'label': '丰县Fengxian0516',
  'name': '丰县',
  'pinyin': 'Fengxian',
  'zip': '0516'
}, {
  'label': '奉新Fengxin0795',
  'name': '奉新',
  'pinyin': 'Fengxin',
  'zip': '0795'
}, {
  'label': '凤阳Fengyang0550',
  'name': '凤阳',
  'pinyin': 'Fengyang',
  'zip': '0550'
}, {
  'label': '分宜Fenyi0790',
  'name': '分宜',
  'pinyin': 'Fenyi',
  'zip': '0790'
}, {
  'label': '佛冈Fogang0763',
  'name': '佛冈',
  'pinyin': 'Fogang',
  'zip': '0763'
}, {
  'label': '福安Fuan0593',
  'name': '福安',
  'pinyin': 'Fuan',
  'zip': '0593'
}, {
  'label': '福鼎Fuding0593',
  'name': '福鼎',
  'pinyin': 'Fuding',
  'zip': '0593'
}, {
  'label': '浮梁Fuliang0798',
  'name': '浮梁',
  'pinyin': 'Fuliang',
  'zip': '0798'
}, {
  'label': '富民Fumin0871',
  'name': '富民',
  'pinyin': 'Fumin',
  'zip': '0871'
}, {
  'label': '阜南Funan0558',
  'name': '阜南',
  'pinyin': 'Funan',
  'zip': '0558'
}, {
  'label': '阜宁Funing0515',
  'name': '阜宁',
  'pinyin': 'Funing',
  'zip': '0515'
}, {
  'label': '福清Fuqing0591',
  'name': '福清',
  'pinyin': 'Fuqing',
  'zip': '0591'
}, {
  'label': '富阳Fuyang0571',
  'name': '富阳',
  'pinyin': 'Fuyang',
  'zip': '0571'
}, {
  'label': '赣县Ganxian0797',
  'name': '赣县',
  'pinyin': 'Ganxian',
  'zip': '0797'
}, {
  'label': '赣榆Ganyu0518',
  'name': '赣榆',
  'pinyin': 'Ganyu',
  'zip': '0518'
}, {
  'label': '高安Gaoan0795',
  'name': '高安',
  'pinyin': 'Gaoan',
  'zip': '0795'
}, {
  'label': '藁城Gaocheng0311',
  'name': '藁城',
  'pinyin': 'Gaocheng',
  'zip': '0311'
}, {
  'label': '高淳Gaochun025',
  'name': '高淳',
  'pinyin': 'Gaochun',
  'zip': '025'
}, {
  'label': '皋兰Gaolan0931',
  'name': '皋兰',
  'pinyin': 'Gaolan',
  'zip': '0931'
}, {
  'label': '高陵Gaoling029',
  'name': '高陵',
  'pinyin': 'Gaoling',
  'zip': '029'
}, {
  'label': '高密Gaomi0536',
  'name': '高密',
  'pinyin': 'Gaomi',
  'zip': '0536'
}, {
  'label': '高青Gaoqing0533',
  'name': '高青',
  'pinyin': 'Gaoqing',
  'zip': '0533'
}, {
  'label': '高唐Gaotang0635',
  'name': '高唐',
  'pinyin': 'Gaotang',
  'zip': '0635'
}, {
  'label': '高要Gaoyao0758',
  'name': '高要',
  'pinyin': 'Gaoyao',
  'zip': '0758'
}, {
  'label': '高邑Gaoyi0311',
  'name': '高邑',
  'pinyin': 'Gaoyi',
  'zip': '0311'
}, {
  'label': '高邮Gaoyou0514',
  'name': '高邮',
  'pinyin': 'Gaoyou',
  'zip': '0514'
}, {
  'label': '高州Gaozhou0668',
  'name': '高州',
  'pinyin': 'Gaozhou',
  'zip': '0668'
}, {
  'label': '巩义Gongyi0371',
  'name': '巩义',
  'pinyin': 'Gongyi',
  'zip': '0371'
}, {
  'label': '广昌Guangchang0794',
  'name': '广昌',
  'pinyin': 'Guangchang',
  'zip': '0794'
}, {
  'label': '广德Guangde0563',
  'name': '广德',
  'pinyin': 'Guangde',
  'zip': '0563'
}, {
  'label': '广丰Guangfeng0793',
  'name': '广丰',
  'pinyin': 'Guangfeng',
  'zip': '0793'
}, {
  'label': '广宁Guangning0758',
  'name': '广宁',
  'pinyin': 'Guangning',
  'zip': '0758'
}, {
  'label': '广饶Guangrao0546',
  'name': '广饶',
  'pinyin': 'Guangrao',
  'zip': '0546'
}, {
  'label': '光泽Guangze0599',
  'name': '光泽',
  'pinyin': 'Guangze',
  'zip': '0599'
}, {
  'label': '灌南Guannan0518',
  'name': '灌南',
  'pinyin': 'Guannan',
  'zip': '0518'
}, {
  'label': '冠县Guanxian0635',
  'name': '冠县',
  'pinyin': 'Guanxian',
  'zip': '0635'
}, {
  'label': '灌云Guanyun0518',
  'name': '灌云',
  'pinyin': 'Guanyun',
  'zip': '0518'
}, {
  'label': '贵溪Guixi0701',
  'name': '贵溪',
  'pinyin': 'Guixi',
  'zip': '0701'
}, {
  'label': '古田Gutian0593',
  'name': '古田',
  'pinyin': 'Gutian',
  'zip': '0593'
}, {
  'label': '固镇Guzhen0552',
  'name': '固镇',
  'pinyin': 'Guzhen',
  'zip': '0552'
}, {
  'label': '海安Haian0513',
  'name': '海安',
  'pinyin': 'Haian',
  'zip': '0513'
}, {
  'label': '海丰Haifeng0660',
  'name': '海丰',
  'pinyin': 'Haifeng',
  'zip': '0660'
}, {
  'label': '海门Haimen0513',
  'name': '海门',
  'pinyin': 'Haimen',
  'zip': '0513'
}, {
  'label': '海宁Haining0573',
  'name': '海宁',
  'pinyin': 'Haining',
  'zip': '0573'
}, {
  'label': '海盐Haiyan0573',
  'name': '海盐',
  'pinyin': 'Haiyan',
  'zip': '0573'
}, {
  'label': '海阳Haiyang0535',
  'name': '海阳',
  'pinyin': 'Haiyang',
  'zip': '0535'
}, {
  'label': '含山Hanshan0565',
  'name': '含山',
  'pinyin': 'Hanshan',
  'zip': '0565'
}, {
  'label': '合川Hechuan023',
  'name': '合川',
  'pinyin': 'Hechuan',
  'zip': '023'
}, {
  'label': '横峰Hengfeng0793',
  'name': '横峰',
  'pinyin': 'Hengfeng',
  'zip': '0793'
}, {
  'label': '横县Hengxian0771',
  'name': '横县',
  'pinyin': 'Hengxian',
  'zip': '0771'
}, {
  'label': '和平Heping0762',
  'name': '和平',
  'pinyin': 'Heping',
  'zip': '0762'
}, {
  'label': '鹤山Heshan0750',
  'name': '鹤山',
  'pinyin': 'Heshan',
  'zip': '0750'
}, {
  'label': '和县Hexian0565',
  'name': '和县',
  'pinyin': 'Hexian',
  'zip': '0565'
}, {
  'label': '洪泽Hongze0517',
  'name': '洪泽',
  'pinyin': 'Hongze',
  'zip': '0517'
}, {
  'label': '华安Huaan0596',
  'name': '华安',
  'pinyin': 'Huaan',
  'zip': '0596'
}, {
  'label': '桦甸Huadian0423',
  'name': '桦甸',
  'pinyin': 'Huadian',
  'zip': '0423'
}, {
  'label': '怀集Huaiji0758',
  'name': '怀集',
  'pinyin': 'Huaiji',
  'zip': '0758'
}, {
  'label': '怀宁Huaining0556',
  'name': '怀宁',
  'pinyin': 'Huaining',
  'zip': '0556'
}, {
  'label': '怀远Huaiyuan0552',
  'name': '怀远',
  'pinyin': 'Huaiyuan',
  'zip': '0552'
}, {
  'label': '桓台Huantai0533',
  'name': '桓台',
  'pinyin': 'Huantai',
  'zip': '0533'
}, {
  'label': '化州Huazhou0668',
  'name': '化州',
  'pinyin': 'Huazhou',
  'zip': '0668'
}, {
  'label': '惠安Huian0595',
  'name': '惠安',
  'pinyin': 'Huian',
  'zip': '0595'
}, {
  'label': '会昌Huichang0797',
  'name': '会昌',
  'pinyin': 'Huichang',
  'zip': '0797'
}, {
  'label': '惠东Huidong0752',
  'name': '惠东',
  'pinyin': 'Huidong',
  'zip': '0752'
}, {
  'label': '惠来Huilai0663',
  'name': '惠来',
  'pinyin': 'Huilai',
  'zip': '0663'
}, {
  'label': '惠民Huimin0543',
  'name': '惠民',
  'pinyin': 'Huimin',
  'zip': '0543'
}, {
  'label': '湖口Hukou0792',
  'name': '湖口',
  'pinyin': 'Hukou',
  'zip': '0792'
}, {
  'label': '呼兰Hulan0451',
  'name': '呼兰',
  'pinyin': 'Hulan',
  'zip': '0451'
}, {
  'label': '霍邱Huoqiu0564',
  'name': '霍邱',
  'pinyin': 'Huoqiu',
  'zip': '0564'
}, {
  'label': '霍山Huoshan0564',
  'name': '霍山',
  'pinyin': 'Huoshan',
  'zip': '0564'
}, {
  'label': '户县Huxian029',
  'name': '户县',
  'pinyin': 'Huxian',
  'zip': '029'
}, {
  'label': '建德Jiande0571',
  'name': '建德',
  'pinyin': 'Jiande',
  'zip': '0571'
}, {
  'label': '江都Jiangdu0514',
  'name': '江都',
  'pinyin': 'Jiangdu',
  'zip': '0514'
}, {
  'label': '江津Jiangjin023',
  'name': '江津',
  'pinyin': 'Jiangjin',
  'zip': '023'
}, {
  'label': '将乐Jiangle0598',
  'name': '将乐',
  'pinyin': 'Jiangle',
  'zip': '0598'
}, {
  'label': '江山Jiangshan0570',
  'name': '江山',
  'pinyin': 'Jiangshan',
  'zip': '0570'
}, {
  'label': '姜堰Jiangyan0523',
  'name': '姜堰',
  'pinyin': 'Jiangyan',
  'zip': '0523'
}, {
  'label': '江阴Jiangyin0510',
  'name': '江阴',
  'pinyin': 'Jiangyin',
  'zip': '0510'
}, {
  'label': '建湖Jianhu0515',
  'name': '建湖',
  'pinyin': 'Jianhu',
  'zip': '0515'
}, {
  'label': '建宁Jianning0598',
  'name': '建宁',
  'pinyin': 'Jianning',
  'zip': '0598'
}, {
  'label': '建瓯Jianou0599',
  'name': '建瓯',
  'pinyin': 'Jianou',
  'zip': '0599'
}, {
  'label': '建阳Jianyang0599',
  'name': '建阳',
  'pinyin': 'Jianyang',
  'zip': '0599'
}, {
  'label': '吉安Jian0796',
  'name': '吉安',
  'pinyin': 'Jian',
  'zip': '0796'
}, {
  'label': '蛟河Jiaohe0423',
  'name': '蛟河',
  'pinyin': 'Jiaohe',
  'zip': '0423'
}, {
  'label': '蕉岭Jiaoling0753',
  'name': '蕉岭',
  'pinyin': 'Jiaoling',
  'zip': '0753'
}, {
  'label': '胶南Jiaonan0532',
  'name': '胶南',
  'pinyin': 'Jiaonan',
  'zip': '0532'
}, {
  'label': '胶州Jiaozhou0532',
  'name': '胶州',
  'pinyin': 'Jiaozhou',
  'zip': '0532'
}, {
  'label': '嘉善Jiashan0573',
  'name': '嘉善',
  'pinyin': 'Jiashan',
  'zip': '0573'
}, {
  'label': '嘉祥Jiaxiang0537',
  'name': '嘉祥',
  'pinyin': 'Jiaxiang',
  'zip': '0537'
}, {
  'label': '揭东Jiedong0663',
  'name': '揭东',
  'pinyin': 'Jiedong',
  'zip': '0663'
}, {
  'label': '界首Jieshou0558',
  'name': '界首',
  'pinyin': 'Jieshou',
  'zip': '0558'
}, {
  'label': '揭西Jiexi0663',
  'name': '揭西',
  'pinyin': 'Jiexi',
  'zip': '0663'
}, {
  'label': '即墨Jimo0532',
  'name': '即墨',
  'pinyin': 'Jimo',
  'zip': '0532'
}, {
  'label': '靖安Jingan0795',
  'name': '靖安',
  'pinyin': 'Jingan',
  'zip': '0795'
}, {
  'label': '旌德Jingde0563',
  'name': '旌德',
  'pinyin': 'Jingde',
  'zip': '0563'
}, {
  'label': '井冈山Jinggangshan0796',
  'name': '井冈山',
  'pinyin': 'Jinggangshan',
  'zip': '0796'
}, {
  'label': '靖江Jingjiang0523',
  'name': '靖江',
  'pinyin': 'Jingjiang',
  'zip': '0523'
}, {
  'label': '景宁Jingning0578',
  'name': '景宁',
  'pinyin': 'Jingning',
  'zip': '0578'
}, {
  'label': '泾县Jingxian0563',
  'name': '泾县',
  'pinyin': 'Jingxian',
  'zip': '0563'
}, {
  'label': '井陉Jingxing0311',
  'name': '井陉',
  'pinyin': 'Jingxing',
  'zip': '0311'
}, {
  'label': '金湖Jinhu0517',
  'name': '金湖',
  'pinyin': 'Jinhu',
  'zip': '0517'
}, {
  'label': '晋江Jinjiang0595',
  'name': '晋江',
  'pinyin': 'Jinjiang',
  'zip': '0595'
}, {
  'label': '金门Jinmen0595',
  'name': '金门',
  'pinyin': 'Jinmen',
  'zip': '0595'
}, {
  'label': '晋宁Jinning0871',
  'name': '晋宁',
  'pinyin': 'Jinning',
  'zip': '0871'
}, {
  'label': '金坛Jintan0519',
  'name': '金坛',
  'pinyin': 'Jintan',
  'zip': '0519'
}, {
  'label': '金堂Jintang028',
  'name': '金堂',
  'pinyin': 'Jintang',
  'zip': '028'
}, {
  'label': '进贤Jinxian0791',
  'name': '进贤',
  'pinyin': 'Jinxian',
  'zip': '0791'
}, {
  'label': '金溪Jinxi0794',
  'name': '金溪',
  'pinyin': 'Jinxi',
  'zip': '0794'
}, {
  'label': '金乡Jinxiang0537',
  'name': '金乡',
  'pinyin': 'Jinxiang',
  'zip': '0537'
}, {
  'label': '缙云Jinyun0578',
  'name': '缙云',
  'pinyin': 'Jinyun',
  'zip': '0578'
}, {
  'label': '金寨Jinzhai0564',
  'name': '金寨',
  'pinyin': 'Jinzhai',
  'zip': '0564'
}, {
  'label': '晋州Jinzhou0311',
  'name': '晋州',
  'pinyin': 'Jinzhou',
  'zip': '0311'
}, {
  'label': '吉水Jishui0796',
  'name': '吉水',
  'pinyin': 'Jishui',
  'zip': '0796'
}, {
  'label': '九江Jiujiang0792',
  'name': '九江',
  'pinyin': 'Jiujiang',
  'zip': '0792'
}, {
  'label': '九台Jiutai0431',
  'name': '九台',
  'pinyin': 'Jiutai',
  'zip': '0431'
}, {
  'label': '绩溪Jixi0563',
  'name': '绩溪',
  'pinyin': 'Jixi',
  'zip': '0563'
}, {
  'label': '济阳Jiyang0531',
  'name': '济阳',
  'pinyin': 'Jiyang',
  'zip': '0531'
}, {
  'label': '济源Jiyuan0391',
  'name': '济源',
  'pinyin': 'Jiyuan',
  'zip': '0391'
}, {
  'label': '鄄城Juancheng0530',
  'name': '鄄城',
  'pinyin': 'Juancheng',
  'zip': '0530'
}, {
  'label': '莒南Junan0539',
  'name': '莒南',
  'pinyin': 'Junan',
  'zip': '0539'
}, {
  'label': '句容Jurong0511',
  'name': '句容',
  'pinyin': 'Jurong',
  'zip': '0511'
}, {
  'label': '莒县Juxian0633',
  'name': '莒县',
  'pinyin': 'Juxian',
  'zip': '0633'
}, {
  'label': '巨野Juye0530',
  'name': '巨野',
  'pinyin': 'Juye',
  'zip': '0530'
}, {
  'label': '开化Kaihua0570',
  'name': '开化',
  'pinyin': 'Kaihua',
  'zip': '0570'
}, {
  'label': '开平Kaiping0750',
  'name': '开平',
  'pinyin': 'Kaiping',
  'zip': '0750'
}, {
  'label': '开县Kaixian023',
  'name': '开县',
  'pinyin': 'Kaixian',
  'zip': '023'
}, {
  'label': '开阳Kaiyang0851',
  'name': '开阳',
  'pinyin': 'Kaiyang',
  'zip': '0851'
}, {
  'label': '康平Kangping024',
  'name': '康平',
  'pinyin': 'Kangping',
  'zip': '024'
}, {
  'label': '垦利Kenli0546',
  'name': '垦利',
  'pinyin': 'Kenli',
  'zip': '0546'
}, {
  'label': '昆山Kunshan0512',
  'name': '昆山',
  'pinyin': 'Kunshan',
  'zip': '0512'
}, {
  'label': '来安Laian0550',
  'name': '来安',
  'pinyin': 'Laian',
  'zip': '0550'
}, {
  'label': '莱西Laixi0532',
  'name': '莱西',
  'pinyin': 'Laixi',
  'zip': '0532'
}, {
  'label': '莱阳Laiyang0535',
  'name': '莱阳',
  'pinyin': 'Laiyang',
  'zip': '0535'
}, {
  'label': '莱州Laizhou0535',
  'name': '莱州',
  'pinyin': 'Laizhou',
  'zip': '0535'
}, {
  'label': '郎溪Langxi0563',
  'name': '郎溪',
  'pinyin': 'Langxi',
  'zip': '0563'
}, {
  'label': '蓝田Lantian029',
  'name': '蓝田',
  'pinyin': 'Lantian',
  'zip': '029'
}, {
  'label': '兰溪Lanxi0579',
  'name': '兰溪',
  'pinyin': 'Lanxi',
  'zip': '0579'
}, {
  'label': '乐安Lean0794',
  'name': '乐安',
  'pinyin': 'Lean',
  'zip': '0794'
}, {
  'label': '乐昌Lechang0751',
  'name': '乐昌',
  'pinyin': 'Lechang',
  'zip': '0751'
}, {
  'label': '雷州Leizhou0759',
  'name': '雷州',
  'pinyin': 'Leizhou',
  'zip': '0759'
}, {
  'label': '乐陵Leling0534',
  'name': '乐陵',
  'pinyin': 'Leling',
  'zip': '0534'
}, {
  'label': '乐平Leping0798',
  'name': '乐平',
  'pinyin': 'Leping',
  'zip': '0798'
}, {
  'label': '乐清Leqing0577',
  'name': '乐清',
  'pinyin': 'Leqing',
  'zip': '0577'
}, {
  'label': '乐亭Leting0315',
  'name': '乐亭',
  'pinyin': 'Leting',
  'zip': '0315'
}, {
  'label': '连城Liancheng0597',
  'name': '连城',
  'pinyin': 'Liancheng',
  'zip': '0597'
}, {
  'label': '梁平Liangping023',
  'name': '梁平',
  'pinyin': 'Liangping',
  'zip': '023'
}, {
  'label': '梁山Liangshan0537',
  'name': '梁山',
  'pinyin': 'Liangshan',
  'zip': '0537'
}, {
  'label': '莲花Lianhua0799',
  'name': '莲花',
  'pinyin': 'Lianhua',
  'zip': '0799'
}, {
  'label': '连江Lianjiang0591',
  'name': '连江',
  'pinyin': 'Lianjiang',
  'zip': '0591'
}, {
  'label': '廉江Lianjiang0759',
  'name': '廉江',
  'pinyin': 'Lianjiang',
  'zip': '0759'
}, {
  'label': '连南Liannan0763',
  'name': '连南',
  'pinyin': 'Liannan',
  'zip': '0763'
}, {
  'label': '连平Lianping0762',
  'name': '连平',
  'pinyin': 'Lianping',
  'zip': '0762'
}, {
  'label': '连山Lianshan0763',
  'name': '连山',
  'pinyin': 'Lianshan',
  'zip': '0763'
}, {
  'label': '涟水Lianshui0517',
  'name': '涟水',
  'pinyin': 'Lianshui',
  'zip': '0517'
}, {
  'label': '连州Lianzhou0763',
  'name': '连州',
  'pinyin': 'Lianzhou',
  'zip': '0763'
}, {
  'label': '辽中Liaozhong024',
  'name': '辽中',
  'pinyin': 'Liaozhong',
  'zip': '024'
}, {
  'label': '黎川Lichuan0794',
  'name': '黎川',
  'pinyin': 'Lichuan',
  'zip': '0794'
}, {
  'label': '利津Lijin0546',
  'name': '利津',
  'pinyin': 'Lijin',
  'zip': '0546'
}, {
  'label': '临安Linan0571',
  'name': '临安',
  'pinyin': 'Linan',
  'zip': '0571'
}, {
  'label': '灵璧Lingbi0557',
  'name': '灵璧',
  'pinyin': 'Lingbi',
  'zip': '0557'
}, {
  'label': '灵寿Lingshou0311',
  'name': '灵寿',
  'pinyin': 'Lingshou',
  'zip': '0311'
}, {
  'label': '陵县Lingxian0534',
  'name': '陵县',
  'pinyin': 'Lingxian',
  'zip': '0534'
}, {
  'label': '临海Linhai0576',
  'name': '临海',
  'pinyin': 'Linhai',
  'zip': '0576'
}, {
  'label': '临清Linqing0635',
  'name': '临清',
  'pinyin': 'Linqing',
  'zip': '0635'
}, {
  'label': '临泉Linquan0558',
  'name': '临泉',
  'pinyin': 'Linquan',
  'zip': '0558'
}, {
  'label': '临朐Linqu0536',
  'name': '临朐',
  'pinyin': 'Linqu',
  'zip': '0536'
}, {
  'label': '临沭Linshu0539',
  'name': '临沭',
  'pinyin': 'Linshu',
  'zip': '0539'
}, {
  'label': '临邑Linyi0534',
  'name': '临邑',
  'pinyin': 'Linyi',
  'zip': '0534'
}, {
  'label': '溧水Lishui025',
  'name': '溧水',
  'pinyin': 'Lishui',
  'zip': '025'
}, {
  'label': '柳城Liucheng0772',
  'name': '柳城',
  'pinyin': 'Liucheng',
  'zip': '0772'
}, {
  'label': '柳江Liujiang0772',
  'name': '柳江',
  'pinyin': 'Liujiang',
  'zip': '0772'
}, {
  'label': '浏阳Liuyang0731',
  'name': '浏阳',
  'pinyin': 'Liuyang',
  'zip': '0731'
}, {
  'label': '利辛Lixin0558',
  'name': '利辛',
  'pinyin': 'Lixin',
  'zip': '0558'
}, {
  'label': '溧阳Liyang0519',
  'name': '溧阳',
  'pinyin': 'Liyang',
  'zip': '0519'
}, {
  'label': '隆安Longan0771',
  'name': '隆安',
  'pinyin': 'Longan',
  'zip': '0771'
}, {
  'label': '龙川Longchuan0762',
  'name': '龙川',
  'pinyin': 'Longchuan',
  'zip': '0762'
}, {
  'label': '龙海Longhai0596',
  'name': '龙海',
  'pinyin': 'Longhai',
  'zip': '0596'
}, {
  'label': '龙口Longkou0535',
  'name': '龙口',
  'pinyin': 'Longkou',
  'zip': '0535'
}, {
  'label': '龙门Longmen0752',
  'name': '龙门',
  'pinyin': 'Longmen',
  'zip': '0752'
}, {
  'label': '龙南Longnan0797',
  'name': '龙南',
  'pinyin': 'Longnan',
  'zip': '0797'
}, {
  'label': '龙泉Longquan0578',
  'name': '龙泉',
  'pinyin': 'Longquan',
  'zip': '0578'
}, {
  'label': '龙游Longyou0570',
  'name': '龙游',
  'pinyin': 'Longyou',
  'zip': '0570'
}, {
  'label': '栾城Luancheng0311',
  'name': '栾城',
  'pinyin': 'Luancheng',
  'zip': '0311'
}, {
  'label': '栾川Luanchuan0379',
  'name': '栾川',
  'pinyin': 'Luanchuan',
  'zip': '0379'
}, {
  'label': '滦南Luannan0315',
  'name': '滦南',
  'pinyin': 'Luannan',
  'zip': '0315'
}, {
  'label': '滦县Luanxian0315',
  'name': '滦县',
  'pinyin': 'Luanxian',
  'zip': '0315'
}, {
  'label': '陆丰Lufeng0660',
  'name': '陆丰',
  'pinyin': 'Lufeng',
  'zip': '0660'
}, {
  'label': '陆河Luhe0660',
  'name': '陆河',
  'pinyin': 'Luhe',
  'zip': '0660'
}, {
  'label': '庐江Lujiang0565',
  'name': '庐江',
  'pinyin': 'Lujiang',
  'zip': '0565'
}, {
  'label': '罗定Luoding0766',
  'name': '罗定',
  'pinyin': 'Luoding',
  'zip': '0766'
}, {
  'label': '洛宁Luoning0379',
  'name': '洛宁',
  'pinyin': 'Luoning',
  'zip': '0379'
}, {
  'label': '罗源Luoyuan0591',
  'name': '罗源',
  'pinyin': 'Luoyuan',
  'zip': '0591'
}, {
  'label': '鹿泉Luquan0311',
  'name': '鹿泉',
  'pinyin': 'Luquan',
  'zip': '0311'
}, {
  'label': '禄劝Luquan0871',
  'name': '禄劝',
  'pinyin': 'Luquan',
  'zip': '0871'
}, {
  'label': '芦溪Luxi0799',
  'name': '芦溪',
  'pinyin': 'Luxi',
  'zip': '0799'
}, {
  'label': '鹿寨Luzhai0772',
  'name': '鹿寨',
  'pinyin': 'Luzhai',
  'zip': '0772'
}, {
  'label': '马山Mashan0771',
  'name': '马山',
  'pinyin': 'Mashan',
  'zip': '0771'
}, {
  'label': '梅县Meixian0753',
  'name': '梅县',
  'pinyin': 'Meixian',
  'zip': '0753'
}, {
  'label': '蒙城Mengcheng0558',
  'name': '蒙城',
  'pinyin': 'Mengcheng',
  'zip': '0558'
}, {
  'label': '孟津Mengjin0379',
  'name': '孟津',
  'pinyin': 'Mengjin',
  'zip': '0379'
}, {
  'label': '蒙阴Mengyin0539',
  'name': '蒙阴',
  'pinyin': 'Mengyin',
  'zip': '0539'
}, {
  'label': '孟州Mengzhou0391',
  'name': '孟州',
  'pinyin': 'Mengzhou',
  'zip': '0391'
}, {
  'label': '明光Mingguang0550',
  'name': '明光',
  'pinyin': 'Mingguang',
  'zip': '0550'
}, {
  'label': '明溪Mingxi0598',
  'name': '明溪',
  'pinyin': 'Mingxi',
  'zip': '0598'
}, {
  'label': '闽侯Minhou0591',
  'name': '闽侯',
  'pinyin': 'Minhou',
  'zip': '0591'
}, {
  'label': '闽清Minqing0591',
  'name': '闽清',
  'pinyin': 'Minqing',
  'zip': '0591'
}, {
  'label': '木兰Mulan0451',
  'name': '木兰',
  'pinyin': 'Mulan',
  'zip': '0451'
}, {
  'label': '南安Nanan0595',
  'name': '南安',
  'pinyin': 'Nanan',
  'zip': '0595'
}, {
  'label': '南澳Nanao0754',
  'name': '南澳',
  'pinyin': 'Nanao',
  'zip': '0754'
}, {
  'label': '南城Nancheng0794',
  'name': '南城',
  'pinyin': 'Nancheng',
  'zip': '0794'
}, {
  'label': '南川Nanchuan023',
  'name': '南川',
  'pinyin': 'Nanchuan',
  'zip': '023'
}, {
  'label': '南丰Nanfeng0794',
  'name': '南丰',
  'pinyin': 'Nanfeng',
  'zip': '0794'
}, {
  'label': '南靖Nanjing0596',
  'name': '南靖',
  'pinyin': 'Nanjing',
  'zip': '0596'
}, {
  'label': '南康Nankang0797',
  'name': '南康',
  'pinyin': 'Nankang',
  'zip': '0797'
}, {
  'label': '南陵Nanling0553',
  'name': '南陵',
  'pinyin': 'Nanling',
  'zip': '0553'
}, {
  'label': '南雄Nanxiong0751',
  'name': '南雄',
  'pinyin': 'Nanxiong',
  'zip': '0751'
}, {
  'label': '宁都Ningdu0797',
  'name': '宁都',
  'pinyin': 'Ningdu',
  'zip': '0797'
}, {
  'label': '宁国Ningguo0563',
  'name': '宁国',
  'pinyin': 'Ningguo',
  'zip': '0563'
}, {
  'label': '宁海Ninghai0574',
  'name': '宁海',
  'pinyin': 'Ninghai',
  'zip': '0574'
}, {
  'label': '宁化Ninghua0598',
  'name': '宁化',
  'pinyin': 'Ninghua',
  'zip': '0598'
}, {
  'label': '宁津Ningjin0534',
  'name': '宁津',
  'pinyin': 'Ningjin',
  'zip': '0534'
}, {
  'label': '宁乡Ningxiang0731',
  'name': '宁乡',
  'pinyin': 'Ningxiang',
  'zip': '0731'
}, {
  'label': '宁阳Ningyang0538',
  'name': '宁阳',
  'pinyin': 'Ningyang',
  'zip': '0538'
}, {
  'label': '农安Nongan0431',
  'name': '农安',
  'pinyin': 'Nongan',
  'zip': '0431'
}, {
  'label': '磐安Panan0579',
  'name': '磐安',
  'pinyin': 'Panan',
  'zip': '0579'
}, {
  'label': '磐石Panshi0423',
  'name': '磐石',
  'pinyin': 'Panshi',
  'zip': '0423'
}, {
  'label': '沛县Peixian0516',
  'name': '沛县',
  'pinyin': 'Peixian',
  'zip': '0516'
}, {
  'label': '蓬莱Penglai0535',
  'name': '蓬莱',
  'pinyin': 'Penglai',
  'zip': '0535'
}, {
  'label': '彭水Pengshui023',
  'name': '彭水',
  'pinyin': 'Pengshui',
  'zip': '023'
}, {
  'label': '彭泽Pengze0792',
  'name': '彭泽',
  'pinyin': 'Pengze',
  'zip': '0792'
}, {
  'label': '彭州Pengzhou028',
  'name': '彭州',
  'pinyin': 'Pengzhou',
  'zip': '028'
}, {
  'label': '平度Pingdu0532',
  'name': '平度',
  'pinyin': 'Pingdu',
  'zip': '0532'
}, {
  'label': '平和Pinghe0596',
  'name': '平和',
  'pinyin': 'Pinghe',
  'zip': '0596'
}, {
  'label': '平湖Pinghu0573',
  'name': '平湖',
  'pinyin': 'Pinghu',
  'zip': '0573'
}, {
  'label': '屏南Pingnan0593',
  'name': '屏南',
  'pinyin': 'Pingnan',
  'zip': '0593'
}, {
  'label': '平山Pingshan0311',
  'name': '平山',
  'pinyin': 'Pingshan',
  'zip': '0311'
}, {
  'label': '平潭Pingtan0591',
  'name': '平潭',
  'pinyin': 'Pingtan',
  'zip': '0591'
}, {
  'label': '平阳Pingyang0577',
  'name': '平阳',
  'pinyin': 'Pingyang',
  'zip': '0577'
}, {
  'label': '平阴Pingyin0531',
  'name': '平阴',
  'pinyin': 'Pingyin',
  'zip': '0531'
}, {
  'label': '平邑Pingyi0539',
  'name': '平邑',
  'pinyin': 'Pingyi',
  'zip': '0539'
}, {
  'label': '平原Pingyuan0534',
  'name': '平原',
  'pinyin': 'Pingyuan',
  'zip': '0534'
}, {
  'label': '平远Pingyuan0753',
  'name': '平远',
  'pinyin': 'Pingyuan',
  'zip': '0753'
}, {
  'label': '郫县Pixian028',
  'name': '郫县',
  'pinyin': 'Pixian',
  'zip': '028'
}, {
  'label': '邳州Pizhou0516',
  'name': '邳州',
  'pinyin': 'Pizhou',
  'zip': '0516'
}, {
  'label': '鄱阳Poyang0793',
  'name': '鄱阳',
  'pinyin': 'Poyang',
  'zip': '0793'
}, {
  'label': '浦城Pucheng0599',
  'name': '浦城',
  'pinyin': 'Pucheng',
  'zip': '0599'
}, {
  'label': '浦江Pujiang0579',
  'name': '浦江',
  'pinyin': 'Pujiang',
  'zip': '0579'
}, {
  'label': '蒲江Pujiang028',
  'name': '蒲江',
  'pinyin': 'Pujiang',
  'zip': '028'
}, {
  'label': '普兰店Pulandian0411',
  'name': '普兰店',
  'pinyin': 'Pulandian',
  'zip': '0411'
}, {
  'label': '普宁Puning0663',
  'name': '普宁',
  'pinyin': 'Puning',
  'zip': '0663'
}, {
  'label': '迁安Qianan0315',
  'name': '迁安',
  'pinyin': 'Qianan',
  'zip': '0315'
}, {
  'label': '潜山Qianshan0556',
  'name': '潜山',
  'pinyin': 'Qianshan',
  'zip': '0556'
}, {
  'label': '铅山Qianshan0793',
  'name': '铅山',
  'pinyin': 'Qianshan',
  'zip': '0793'
}, {
  'label': '迁西Qianxi0315',
  'name': '迁西',
  'pinyin': 'Qianxi',
  'zip': '0315'
}, {
  'label': '启东Qidong0513',
  'name': '启东',
  'pinyin': 'Qidong',
  'zip': '0513'
}, {
  'label': '齐河Qihe0534',
  'name': '齐河',
  'pinyin': 'Qihe',
  'zip': '0534'
}, {
  'label': '綦江Qijiang023',
  'name': '綦江',
  'pinyin': 'Qijiang',
  'zip': '023'
}, {
  'label': '祁门Qimen0559',
  'name': '祁门',
  'pinyin': 'Qimen',
  'zip': '0559'
}, {
  'label': '清流Qingliu0598',
  'name': '清流',
  'pinyin': 'Qingliu',
  'zip': '0598'
}, {
  'label': '青田Qingtian0578',
  'name': '青田',
  'pinyin': 'Qingtian',
  'zip': '0578'
}, {
  'label': '清新Qingxin0763',
  'name': '清新',
  'pinyin': 'Qingxin',
  'zip': '0763'
}, {
  'label': '青阳Qingyang0566',
  'name': '青阳',
  'pinyin': 'Qingyang',
  'zip': '0566'
}, {
  'label': '庆元Qingyuan0578',
  'name': '庆元',
  'pinyin': 'Qingyuan',
  'zip': '0578'
}, {
  'label': '庆云Qingyun0534',
  'name': '庆云',
  'pinyin': 'Qingyun',
  'zip': '0534'
}, {
  'label': '清镇Qingzhen0851',
  'name': '清镇',
  'pinyin': 'Qingzhen',
  'zip': '0851'
}, {
  'label': '青州Qingzhou0536',
  'name': '青州',
  'pinyin': 'Qingzhou',
  'zip': '0536'
}, {
  'label': '沁阳Qinyang0391',
  'name': '沁阳',
  'pinyin': 'Qinyang',
  'zip': '0391'
}, {
  'label': '邛崃Qionglai028',
  'name': '邛崃',
  'pinyin': 'Qionglai',
  'zip': '028'
}, {
  'label': '栖霞Qixia0535',
  'name': '栖霞',
  'pinyin': 'Qixia',
  'zip': '0535'
}, {
  'label': '全椒Quanjiao0550',
  'name': '全椒',
  'pinyin': 'Quanjiao',
  'zip': '0550'
}, {
  'label': '全南Quannan0797',
  'name': '全南',
  'pinyin': 'Quannan',
  'zip': '0797'
}, {
  'label': '曲阜Qufu0537',
  'name': '曲阜',
  'pinyin': 'Qufu',
  'zip': '0537'
}, {
  'label': '曲江Qujiang0751',
  'name': '曲江',
  'pinyin': 'Qujiang',
  'zip': '0751'
}, {
  'label': '饶平Raoping0768',
  'name': '饶平',
  'pinyin': 'Raoping',
  'zip': '0768'
}, {
  'label': '仁化Renhua0751',
  'name': '仁化',
  'pinyin': 'Renhua',
  'zip': '0751'
}, {
  'label': '融安Rongan0772',
  'name': '融安',
  'pinyin': 'Rongan',
  'zip': '0772'
}, {
  'label': '荣昌Rongchang023',
  'name': '荣昌',
  'pinyin': 'Rongchang',
  'zip': '023'
}, {
  'label': '荣成Rongcheng0631',
  'name': '荣成',
  'pinyin': 'Rongcheng',
  'zip': '0631'
}, {
  'label': '融水Rongshui0772',
  'name': '融水',
  'pinyin': 'Rongshui',
  'zip': '0772'
}, {
  'label': '如东Rudong0513',
  'name': '如东',
  'pinyin': 'Rudong',
  'zip': '0513'
}, {
  'label': '如皋Rugao0513',
  'name': '如皋',
  'pinyin': 'Rugao',
  'zip': '0513'
}, {
  'label': '瑞安Ruian0577',
  'name': '瑞安',
  'pinyin': 'Ruian',
  'zip': '0577'
}, {
  'label': '瑞昌Ruichang0792',
  'name': '瑞昌',
  'pinyin': 'Ruichang',
  'zip': '0792'
}, {
  'label': '瑞金Ruijin0797',
  'name': '瑞金',
  'pinyin': 'Ruijin',
  'zip': '0797'
}, {
  'label': '乳山Rushan0631',
  'name': '乳山',
  'pinyin': 'Rushan',
  'zip': '0631'
}, {
  'label': '汝阳Ruyang0379',
  'name': '汝阳',
  'pinyin': 'Ruyang',
  'zip': '0379'
}, {
  'label': '乳源Ruyuan0751',
  'name': '乳源',
  'pinyin': 'Ruyuan',
  'zip': '0751'
}, {
  'label': '三江Sanjiang0772',
  'name': '三江',
  'pinyin': 'Sanjiang',
  'zip': '0772'
}, {
  'label': '三门Sanmen0576',
  'name': '三门',
  'pinyin': 'Sanmen',
  'zip': '0576'
}, {
  'label': '诏安Saoan0596',
  'name': '诏安',
  'pinyin': 'Saoan',
  'zip': '0596'
}, {
  'label': '上高Shanggao0795',
  'name': '上高',
  'pinyin': 'Shanggao',
  'zip': '0795'
}, {
  'label': '上杭Shanghang0597',
  'name': '上杭',
  'pinyin': 'Shanghang',
  'zip': '0597'
}, {
  'label': '商河Shanghe0531',
  'name': '商河',
  'pinyin': 'Shanghe',
  'zip': '0531'
}, {
  'label': '上栗Shangli0799',
  'name': '上栗',
  'pinyin': 'Shangli',
  'zip': '0799'
}, {
  'label': '上林Shanglin0771',
  'name': '上林',
  'pinyin': 'Shanglin',
  'zip': '0771'
}, {
  'label': '上饶Shangrao0793',
  'name': '上饶',
  'pinyin': 'Shangrao',
  'zip': '0793'
}, {
  'label': '上犹Shangyou0797',
  'name': '上犹',
  'pinyin': 'Shangyou',
  'zip': '0797'
}, {
  'label': '上虞Shangyu0575',
  'name': '上虞',
  'pinyin': 'Shangyu',
  'zip': '0575'
}, {
  'label': '尚志Shangzhi0451',
  'name': '尚志',
  'pinyin': 'Shangzhi',
  'zip': '0451'
}, {
  'label': '邵武Shaowu0599',
  'name': '邵武',
  'pinyin': 'Shaowu',
  'zip': '0599'
}, {
  'label': '绍兴Shaoxing0575',
  'name': '绍兴',
  'pinyin': 'Shaoxing',
  'zip': '0575'
}, {
  'label': '沙县Shaxian0598',
  'name': '沙县',
  'pinyin': 'Shaxian',
  'zip': '0598'
}, {
  'label': '嵊泗Shengsi0580',
  'name': '嵊泗',
  'pinyin': 'Shengsi',
  'zip': '0580'
}, {
  'label': '嵊州Shengzhou0575',
  'name': '嵊州',
  'pinyin': 'Shengzhou',
  'zip': '0575'
}, {
  'label': '莘县Shenxian0635',
  'name': '莘县',
  'pinyin': 'Shenxian',
  'zip': '0635'
}, {
  'label': '深泽Shenze0311',
  'name': '深泽',
  'pinyin': 'Shenze',
  'zip': '0311'
}, {
  'label': '歙县Shexian0559',
  'name': '歙县',
  'pinyin': 'Shexian',
  'zip': '0559'
}, {
  'label': '射阳Sheyang0515',
  'name': '射阳',
  'pinyin': 'Sheyang',
  'zip': '0515'
}, {
  'label': '石城Shicheng0797',
  'name': '石城',
  'pinyin': 'Shicheng',
  'zip': '0797'
}, {
  'label': '石林Shilin0871',
  'name': '石林',
  'pinyin': 'Shilin',
  'zip': '0871'
}, {
  'label': '石狮Shishi0595',
  'name': '石狮',
  'pinyin': 'Shishi',
  'zip': '0595'
}, {
  'label': '石台Shitai0566',
  'name': '石台',
  'pinyin': 'Shitai',
  'zip': '0566'
}, {
  'label': '始兴Shixing0751',
  'name': '始兴',
  'pinyin': 'Shixing',
  'zip': '0751'
}, {
  'label': '石柱Shizhu023',
  'name': '石柱',
  'pinyin': 'Shizhu',
  'zip': '023'
}, {
  'label': '寿光Shouguang0536',
  'name': '寿光',
  'pinyin': 'Shouguang',
  'zip': '0536'
}, {
  'label': '寿宁Shouning0593',
  'name': '寿宁',
  'pinyin': 'Shouning',
  'zip': '0593'
}, {
  'label': '寿县Shouxian0564',
  'name': '寿县',
  'pinyin': 'Shouxian',
  'zip': '0564'
}, {
  'label': '双城Shuangcheng0451',
  'name': '双城',
  'pinyin': 'Shuangcheng',
  'zip': '0451'
}, {
  'label': '双流Shuangliu028',
  'name': '双流',
  'pinyin': 'Shuangliu',
  'zip': '028'
}, {
  'label': '舒城Shucheng0564',
  'name': '舒城',
  'pinyin': 'Shucheng',
  'zip': '0564'
}, {
  'label': '舒兰Shulan0423',
  'name': '舒兰',
  'pinyin': 'Shulan',
  'zip': '0423'
}, {
  'label': '顺昌Shunchang0599',
  'name': '顺昌',
  'pinyin': 'Shunchang',
  'zip': '0599'
}, {
  'label': '沭阳Shuyang0527',
  'name': '沭阳',
  'pinyin': 'Shuyang',
  'zip': '0527'
}, {
  'label': '泗洪Sihong0527',
  'name': '泗洪',
  'pinyin': 'Sihong',
  'zip': '0527'
}, {
  'label': '四会Sihui0758',
  'name': '四会',
  'pinyin': 'Sihui',
  'zip': '0758'
}, {
  'label': '泗水Sishui0537',
  'name': '泗水',
  'pinyin': 'Sishui',
  'zip': '0537'
}, {
  'label': '泗县Sixian0557',
  'name': '泗县',
  'pinyin': 'Sixian',
  'zip': '0557'
}, {
  'label': '泗阳Siyang0527',
  'name': '泗阳',
  'pinyin': 'Siyang',
  'zip': '0527'
}, {
  'label': '嵩明Songming0871',
  'name': '嵩明',
  'pinyin': 'Songming',
  'zip': '0871'
}, {
  'label': '松溪Songxi0599',
  'name': '松溪',
  'pinyin': 'Songxi',
  'zip': '0599'
}, {
  'label': '嵩县Songxian0379',
  'name': '嵩县',
  'pinyin': 'Songxian',
  'zip': '0379'
}, {
  'label': '松阳Songyang0578',
  'name': '松阳',
  'pinyin': 'Songyang',
  'zip': '0578'
}, {
  'label': '遂昌Suichang0578',
  'name': '遂昌',
  'pinyin': 'Suichang',
  'zip': '0578'
}, {
  'label': '遂川Suichuan0796',
  'name': '遂川',
  'pinyin': 'Suichuan',
  'zip': '0796'
}, {
  'label': '睢宁Suining0516',
  'name': '睢宁',
  'pinyin': 'Suining',
  'zip': '0516'
}, {
  'label': '濉溪Suixi0561',
  'name': '濉溪',
  'pinyin': 'Suixi',
  'zip': '0561'
}, {
  'label': '遂溪Suixi0759',
  'name': '遂溪',
  'pinyin': 'Suixi',
  'zip': '0759'
}, {
  'label': '宿松Susong0556',
  'name': '宿松',
  'pinyin': 'Susong',
  'zip': '0556'
}, {
  'label': '宿豫Suyu0527',
  'name': '宿豫',
  'pinyin': 'Suyu',
  'zip': '0527'
}, {
  'label': '太仓Taicang0512',
  'name': '太仓',
  'pinyin': 'Taicang',
  'zip': '0512'
}, {
  'label': '太和Taihe0558',
  'name': '太和',
  'pinyin': 'Taihe',
  'zip': '0558'
}, {
  'label': '泰和Taihe0796',
  'name': '泰和',
  'pinyin': 'Taihe',
  'zip': '0796'
}, {
  'label': '太湖Taihu0556',
  'name': '太湖',
  'pinyin': 'Taihu',
  'zip': '0556'
}, {
  'label': '泰宁Taining0598',
  'name': '泰宁',
  'pinyin': 'Taining',
  'zip': '0598'
}, {
  'label': '台山Taishan0750',
  'name': '台山',
  'pinyin': 'Taishan',
  'zip': '0750'
}, {
  'label': '泰顺Taishun0577',
  'name': '泰顺',
  'pinyin': 'Taishun',
  'zip': '0577'
}, {
  'label': '泰兴Taixing0523',
  'name': '泰兴',
  'pinyin': 'Taixing',
  'zip': '0523'
}, {
  'label': '郯城Tancheng0539',
  'name': '郯城',
  'pinyin': 'Tancheng',
  'zip': '0539'
}, {
  'label': '唐海Tanghai0315',
  'name': '唐海',
  'pinyin': 'Tanghai',
  'zip': '0315'
}, {
  'label': '滕州Tengzhou0623',
  'name': '滕州',
  'pinyin': 'Tengzhou',
  'zip': '0623'
}, {
  'label': '天长Tianchang0550',
  'name': '天长',
  'pinyin': 'Tianchang',
  'zip': '0550'
}, {
  'label': '天台Tiantai0576',
  'name': '天台',
  'pinyin': 'Tiantai',
  'zip': '0576'
}, {
  'label': '桐城Tongcheng0556',
  'name': '桐城',
  'pinyin': 'Tongcheng',
  'zip': '0556'
}, {
  'label': '铜鼓Tonggu0795',
  'name': '铜鼓',
  'pinyin': 'Tonggu',
  'zip': '0795'
}, {
  'label': '通河Tonghe0451',
  'name': '通河',
  'pinyin': 'Tonghe',
  'zip': '0451'
}, {
  'label': '铜梁Tongliang023',
  'name': '铜梁',
  'pinyin': 'Tongliang',
  'zip': '023'
}, {
  'label': '铜陵Tongling0562',
  'name': '铜陵',
  'pinyin': 'Tongling',
  'zip': '0562'
}, {
  'label': '桐庐Tonglu0571',
  'name': '桐庐',
  'pinyin': 'Tonglu',
  'zip': '0571'
}, {
  'label': '潼南Tongnan023',
  'name': '潼南',
  'pinyin': 'Tongnan',
  'zip': '023'
}, {
  'label': '铜山Tongshan0516',
  'name': '铜山',
  'pinyin': 'Tongshan',
  'zip': '0516'
}, {
  'label': '桐乡Tongxiang0573',
  'name': '桐乡',
  'pinyin': 'Tongxiang',
  'zip': '0573'
}, {
  'label': '通州Tongzhou0513',
  'name': '通州',
  'pinyin': 'Tongzhou',
  'zip': '0513'
}, {
  'label': '瓦房店Wafangdian0411',
  'name': '瓦房店',
  'pinyin': 'Wafangdian',
  'zip': '0411'
}, {
  'label': '万安Wanan0796',
  'name': '万安',
  'pinyin': 'Wanan',
  'zip': '0796'
}, {
  'label': '望城Wangcheng0731',
  'name': '望城',
  'pinyin': 'Wangcheng',
  'zip': '0731'
}, {
  'label': '望江Wangjiang0556',
  'name': '望江',
  'pinyin': 'Wangjiang',
  'zip': '0556'
}, {
  'label': '万年Wannian0793',
  'name': '万年',
  'pinyin': 'Wannian',
  'zip': '0793'
}, {
  'label': '万载Wanzai0795',
  'name': '万载',
  'pinyin': 'Wanzai',
  'zip': '0795'
}, {
  'label': '微山Weishan0537',
  'name': '微山',
  'pinyin': 'Weishan',
  'zip': '0537'
}, {
  'label': '文成Wencheng0577',
  'name': '文成',
  'pinyin': 'Wencheng',
  'zip': '0577'
}, {
  'label': '文登Wendeng0631',
  'name': '文登',
  'pinyin': 'Wendeng',
  'zip': '0631'
}, {
  'label': '翁源Wengyuan0751',
  'name': '翁源',
  'pinyin': 'Wengyuan',
  'zip': '0751'
}, {
  'label': '温岭Wenling0576',
  'name': '温岭',
  'pinyin': 'Wenling',
  'zip': '0576'
}, {
  'label': '汶上Wenshang0537',
  'name': '汶上',
  'pinyin': 'Wenshang',
  'zip': '0537'
}, {
  'label': '温县Wenxian0391',
  'name': '温县',
  'pinyin': 'Wenxian',
  'zip': '0391'
}, {
  'label': '涡阳Woyang0558',
  'name': '涡阳',
  'pinyin': 'Woyang',
  'zip': '0558'
}, {
  'label': '五常Wuchang0451',
  'name': '五常',
  'pinyin': 'Wuchang',
  'zip': '0451'
}, {
  'label': '武城Wucheng0534',
  'name': '武城',
  'pinyin': 'Wucheng',
  'zip': '0534'
}, {
  'label': '吴川Wuchuan0759',
  'name': '吴川',
  'pinyin': 'Wuchuan',
  'zip': '0759'
}, {
  'label': '无棣Wudi0543',
  'name': '无棣',
  'pinyin': 'Wudi',
  'zip': '0543'
}, {
  'label': '五河Wuhe0552',
  'name': '五河',
  'pinyin': 'Wuhe',
  'zip': '0552'
}, {
  'label': '芜湖Wuhu0553',
  'name': '芜湖',
  'pinyin': 'Wuhu',
  'zip': '0553'
}, {
  'label': '五华Wuhua0753',
  'name': '五华',
  'pinyin': 'Wuhua',
  'zip': '0753'
}, {
  'label': '无极Wuji0311',
  'name': '无极',
  'pinyin': 'Wuji',
  'zip': '0311'
}, {
  'label': '吴江Wujiang0512',
  'name': '吴江',
  'pinyin': 'Wujiang',
  'zip': '0512'
}, {
  'label': '五莲Wulian0633',
  'name': '五莲',
  'pinyin': 'Wulian',
  'zip': '0633'
}, {
  'label': '武隆Wulong023',
  'name': '武隆',
  'pinyin': 'Wulong',
  'zip': '023'
}, {
  'label': '武鸣Wuming0771',
  'name': '武鸣',
  'pinyin': 'Wuming',
  'zip': '0771'
}, {
  'label': '武宁Wuning0792',
  'name': '武宁',
  'pinyin': 'Wuning',
  'zip': '0792'
}, {
  'label': '武平Wuping0597',
  'name': '武平',
  'pinyin': 'Wuping',
  'zip': '0597'
}, {
  'label': '巫山Wushan023',
  'name': '巫山',
  'pinyin': 'Wushan',
  'zip': '023'
}, {
  'label': '无为Wuwei0565',
  'name': '无为',
  'pinyin': 'Wuwei',
  'zip': '0565'
}, {
  'label': '巫溪Wuxi023',
  'name': '巫溪',
  'pinyin': 'Wuxi',
  'zip': '023'
}, {
  'label': '武义Wuyi0579',
  'name': '武义',
  'pinyin': 'Wuyi',
  'zip': '0579'
}, {
  'label': '武夷山Wuyishan0599',
  'name': '武夷山',
  'pinyin': 'Wuyishan',
  'zip': '0599'
}, {
  'label': '婺源Wuyuan0793',
  'name': '婺源',
  'pinyin': 'Wuyuan',
  'zip': '0793'
}, {
  'label': '武陟Wuzhi0391',
  'name': '武陟',
  'pinyin': 'Wuzhi',
  'zip': '0391'
}, {
  'label': '峡江Xiajiang0796',
  'name': '峡江',
  'pinyin': 'Xiajiang',
  'zip': '0796'
}, {
  'label': '夏津Xiajin0534',
  'name': '夏津',
  'pinyin': 'Xiajin',
  'zip': '0534'
}, {
  'label': '象山Xiangshan0574',
  'name': '象山',
  'pinyin': 'Xiangshan',
  'zip': '0574'
}, {
  'label': '响水Xiangshui0515',
  'name': '响水',
  'pinyin': 'Xiangshui',
  'zip': '0515'
}, {
  'label': '仙居Xianju0576',
  'name': '仙居',
  'pinyin': 'Xianju',
  'zip': '0576'
}, {
  'label': '仙游Xianyou0594',
  'name': '仙游',
  'pinyin': 'Xianyou',
  'zip': '0594'
}, {
  'label': '萧县Xiaoxian0557',
  'name': '萧县',
  'pinyin': 'Xiaoxian',
  'zip': '0557'
}, {
  'label': '霞浦Xiapu0593',
  'name': '霞浦',
  'pinyin': 'Xiapu',
  'zip': '0593'
}, {
  'label': '息烽Xifeng0851',
  'name': '息烽',
  'pinyin': 'Xifeng',
  'zip': '0851'
}, {
  'label': '新安Xinan0379',
  'name': '新安',
  'pinyin': 'Xinan',
  'zip': '0379'
}, {
  'label': '新昌Xinchang0575',
  'name': '新昌',
  'pinyin': 'Xinchang',
  'zip': '0575'
}, {
  'label': '信丰Xinfeng0797',
  'name': '信丰',
  'pinyin': 'Xinfeng',
  'zip': '0797'
}, {
  'label': '新丰Xinfeng0751',
  'name': '新丰',
  'pinyin': 'Xinfeng',
  'zip': '0751'
}, {
  'label': '新干Xingan0796',
  'name': '新干',
  'pinyin': 'Xingan',
  'zip': '0796'
}, {
  'label': '兴国Xingguo0797',
  'name': '兴国',
  'pinyin': 'Xingguo',
  'zip': '0797'
}, {
  'label': '兴化Xinghua0523',
  'name': '兴化',
  'pinyin': 'Xinghua',
  'zip': '0523'
}, {
  'label': '兴宁Xingning0753',
  'name': '兴宁',
  'pinyin': 'Xingning',
  'zip': '0753'
}, {
  'label': '行唐Xingtang0311',
  'name': '行唐',
  'pinyin': 'Xingtang',
  'zip': '0311'
}, {
  'label': '荥阳Xingyang0371',
  'name': '荥阳',
  'pinyin': 'Xingyang',
  'zip': '0371'
}, {
  'label': '星子Xingzi0792',
  'name': '星子',
  'pinyin': 'Xingzi',
  'zip': '0792'
}, {
  'label': '辛集Xinji0311',
  'name': '辛集',
  'pinyin': 'Xinji',
  'zip': '0311'
}, {
  'label': '新建Xinjian0791',
  'name': '新建',
  'pinyin': 'Xinjian',
  'zip': '0791'
}, {
  'label': '新津Xinjin028',
  'name': '新津',
  'pinyin': 'Xinjin',
  'zip': '028'
}, {
  'label': '新乐Xinle0311',
  'name': '新乐',
  'pinyin': 'Xinle',
  'zip': '0311'
}, {
  'label': '新民Xinmin024',
  'name': '新民',
  'pinyin': 'Xinmin',
  'zip': '024'
}, {
  'label': '新密Xinmi0371',
  'name': '新密',
  'pinyin': 'Xinmi',
  'zip': '0371'
}, {
  'label': '新泰Xintai0538',
  'name': '新泰',
  'pinyin': 'Xintai',
  'zip': '0538'
}, {
  'label': '新兴Xinxing0766',
  'name': '新兴',
  'pinyin': 'Xinxing',
  'zip': '0766'
}, {
  'label': '新沂Xinyi0516',
  'name': '新沂',
  'pinyin': 'Xinyi',
  'zip': '0516'
}, {
  'label': '信宜Xinyi0668',
  'name': '信宜',
  'pinyin': 'Xinyi',
  'zip': '0668'
}, {
  'label': '新郑Xinzheng0371',
  'name': '新郑',
  'pinyin': 'Xinzheng',
  'zip': '0371'
}, {
  'label': '休宁Xiuning0559',
  'name': '休宁',
  'pinyin': 'Xiuning',
  'zip': '0559'
}, {
  'label': '秀山Xiushan023',
  'name': '秀山',
  'pinyin': 'Xiushan',
  'zip': '023'
}, {
  'label': '修水Xiushui0792',
  'name': '修水',
  'pinyin': 'Xiushui',
  'zip': '0792'
}, {
  'label': '修文Xiuwen0851',
  'name': '修文',
  'pinyin': 'Xiuwen',
  'zip': '0851'
}, {
  'label': '修武Xiuwu0391',
  'name': '修武',
  'pinyin': 'Xiuwu',
  'zip': '0391'
}, {
  'label': '寻甸Xundian0871',
  'name': '寻甸',
  'pinyin': 'Xundian',
  'zip': '0871'
}, {
  'label': '寻乌Xunwu0797',
  'name': '寻乌',
  'pinyin': 'Xunwu',
  'zip': '0797'
}, {
  'label': '徐闻Xuwen0759',
  'name': '徐闻',
  'pinyin': 'Xuwen',
  'zip': '0759'
}, {
  'label': '盱眙Xuyi0517',
  'name': '盱眙',
  'pinyin': 'Xuyi',
  'zip': '0517'
}, {
  'label': '阳春Yangchun0662',
  'name': '阳春',
  'pinyin': 'Yangchun',
  'zip': '0662'
}, {
  'label': '阳东Yangdong0662',
  'name': '阳东',
  'pinyin': 'Yangdong',
  'zip': '0662'
}, {
  'label': '阳谷Yanggu0635',
  'name': '阳谷',
  'pinyin': 'Yanggu',
  'zip': '0635'
}, {
  'label': '阳山Yangshan0763',
  'name': '阳山',
  'pinyin': 'Yangshan',
  'zip': '0763'
}, {
  'label': '阳信Yangxin0543',
  'name': '阳信',
  'pinyin': 'Yangxin',
  'zip': '0543'
}, {
  'label': '阳西Yangxi0662',
  'name': '阳西',
  'pinyin': 'Yangxi',
  'zip': '0662'
}, {
  'label': '扬中Yangzhong0511',
  'name': '扬中',
  'pinyin': 'Yangzhong',
  'zip': '0511'
}, {
  'label': '偃师Yanshi0379',
  'name': '偃师',
  'pinyin': 'Yanshi',
  'zip': '0379'
}, {
  'label': '延寿Yanshou0451',
  'name': '延寿',
  'pinyin': 'Yanshou',
  'zip': '0451'
}, {
  'label': '兖州Yanzhou0537',
  'name': '兖州',
  'pinyin': 'Yanzhou',
  'zip': '0537'
}, {
  'label': '伊川Yichuan0379',
  'name': '伊川',
  'pinyin': 'Yichuan',
  'zip': '0379'
}, {
  'label': '宜丰Yifeng0795',
  'name': '宜丰',
  'pinyin': 'Yifeng',
  'zip': '0795'
}, {
  'label': '宜黄Yihuang0794',
  'name': '宜黄',
  'pinyin': 'Yihuang',
  'zip': '0794'
}, {
  'label': '依兰Yilan0451',
  'name': '依兰',
  'pinyin': 'Yilan',
  'zip': '0451'
}, {
  'label': '宜良Yiliang0871',
  'name': '宜良',
  'pinyin': 'Yiliang',
  'zip': '0871'
}, {
  'label': '沂南Yinan0539',
  'name': '沂南',
  'pinyin': 'Yinan',
  'zip': '0539'
}, {
  'label': '英德Yingde0763',
  'name': '英德',
  'pinyin': 'Yingde',
  'zip': '0763'
}, {
  'label': '颍上Yingshang0558',
  'name': '颍上',
  'pinyin': 'Yingshang',
  'zip': '0558'
}, {
  'label': '沂水Yishui0539',
  'name': '沂水',
  'pinyin': 'Yishui',
  'zip': '0539'
}, {
  'label': '义乌Yiwu0579',
  'name': '义乌',
  'pinyin': 'Yiwu',
  'zip': '0579'
}, {
  'label': '黟县Yixian0559',
  'name': '黟县',
  'pinyin': 'Yixian',
  'zip': '0559'
}, {
  'label': '宜兴Yixing0510',
  'name': '宜兴',
  'pinyin': 'Yixing',
  'zip': '0510'
}, {
  'label': '弋阳Yiyang0793',
  'name': '弋阳',
  'pinyin': 'Yiyang',
  'zip': '0793'
}, {
  'label': '宜阳Yiyang0379',
  'name': '宜阳',
  'pinyin': 'Yiyang',
  'zip': '0379'
}, {
  'label': '沂源Yiyuan0533',
  'name': '沂源',
  'pinyin': 'Yiyuan',
  'zip': '0533'
}, {
  'label': '仪征Yizheng0514',
  'name': '仪征',
  'pinyin': 'Yizheng',
  'zip': '0514'
}, {
  'label': '永安Yongan0598',
  'name': '永安',
  'pinyin': 'Yongan',
  'zip': '0598'
}, {
  'label': '永川Yongchuan023',
  'name': '永川',
  'pinyin': 'Yongchuan',
  'zip': '023'
}, {
  'label': '永春Yongchun0595',
  'name': '永春',
  'pinyin': 'Yongchun',
  'zip': '0595'
}, {
  'label': '永登Yongdeng0931',
  'name': '永登',
  'pinyin': 'Yongdeng',
  'zip': '0931'
}, {
  'label': '永定Yongding0597',
  'name': '永定',
  'pinyin': 'Yongding',
  'zip': '0597'
}, {
  'label': '永丰Yongfeng0796',
  'name': '永丰',
  'pinyin': 'Yongfeng',
  'zip': '0796'
}, {
  'label': '永吉Yongji0423',
  'name': '永吉',
  'pinyin': 'Yongji',
  'zip': '0423'
}, {
  'label': '永嘉Yongjia0577',
  'name': '永嘉',
  'pinyin': 'Yongjia',
  'zip': '0577'
}, {
  'label': '永康Yongkang0579',
  'name': '永康',
  'pinyin': 'Yongkang',
  'zip': '0579'
}, {
  'label': '邕宁Yongning0771',
  'name': '邕宁',
  'pinyin': 'Yongning',
  'zip': '0771'
}, {
  'label': '永泰Yongtai0591',
  'name': '永泰',
  'pinyin': 'Yongtai',
  'zip': '0591'
}, {
  'label': '永新Yongxin0796',
  'name': '永新',
  'pinyin': 'Yongxin',
  'zip': '0796'
}, {
  'label': '永修Yongxiu0792',
  'name': '永修',
  'pinyin': 'Yongxiu',
  'zip': '0792'
}, {
  'label': '尤溪Youxi0598',
  'name': '尤溪',
  'pinyin': 'Youxi',
  'zip': '0598'
}, {
  'label': '酉阳Youyang023',
  'name': '酉阳',
  'pinyin': 'Youyang',
  'zip': '023'
}, {
  'label': '元氏Yuanshi0311',
  'name': '元氏',
  'pinyin': 'Yuanshi',
  'zip': '0311'
}, {
  'label': '禹城Yucheng0534',
  'name': '禹城',
  'pinyin': 'Yucheng',
  'zip': '0534'
}, {
  'label': '于都Yudu0797',
  'name': '于都',
  'pinyin': 'Yudu',
  'zip': '0797'
}, {
  'label': '岳西Yuexi0556',
  'name': '岳西',
  'pinyin': 'Yuexi',
  'zip': '0556'
}, {
  'label': '余干Yugan0793',
  'name': '余干',
  'pinyin': 'Yugan',
  'zip': '0793'
}, {
  'label': '玉环Yuhuan0576',
  'name': '玉环',
  'pinyin': 'Yuhuan',
  'zip': '0576'
}, {
  'label': '余江Yujiang0701',
  'name': '余江',
  'pinyin': 'Yujiang',
  'zip': '0701'
}, {
  'label': '郁南Yunan0766',
  'name': '郁南',
  'pinyin': 'Yunan',
  'zip': '0766'
}, {
  'label': '云安Yunan0766',
  'name': '云安',
  'pinyin': 'Yunan',
  'zip': '0766'
}, {
  'label': '郓城Yuncheng0530',
  'name': '郓城',
  'pinyin': 'Yuncheng',
  'zip': '0530'
}, {
  'label': '云和Yunhe0578',
  'name': '云和',
  'pinyin': 'Yunhe',
  'zip': '0578'
}, {
  'label': '云霄Yunxiao0596',
  'name': '云霄',
  'pinyin': 'Yunxiao',
  'zip': '0596'
}, {
  'label': '云阳Yunyang023',
  'name': '云阳',
  'pinyin': 'Yunyang',
  'zip': '023'
}, {
  'label': '玉山Yushan0793',
  'name': '玉山',
  'pinyin': 'Yushan',
  'zip': '0793'
}, {
  'label': '榆树Yushu0431',
  'name': '榆树',
  'pinyin': 'Yushu',
  'zip': '0431'
}, {
  'label': '鱼台Yutai0537',
  'name': '鱼台',
  'pinyin': 'Yutai',
  'zip': '0537'
}, {
  'label': '玉田Yutian0315',
  'name': '玉田',
  'pinyin': 'Yutian',
  'zip': '0315'
}, {
  'label': '余姚Yuyao0574',
  'name': '余姚',
  'pinyin': 'Yuyao',
  'zip': '0574'
}, {
  'label': '榆中Yuzhong0931',
  'name': '榆中',
  'pinyin': 'Yuzhong',
  'zip': '0931'
}, {
  'label': '赞皇Zanhuang0311',
  'name': '赞皇',
  'pinyin': 'Zanhuang',
  'zip': '0311'
}, {
  'label': '增城Zengcheng020',
  'name': '增城',
  'pinyin': 'Zengcheng',
  'zip': '020'
}, {
  'label': '张家港Zhangjiagang0512',
  'name': '张家港',
  'pinyin': 'Zhangjiagang',
  'zip': '0512'
}, {
  'label': '漳平Zhangping0597',
  'name': '漳平',
  'pinyin': 'Zhangping',
  'zip': '0597'
}, {
  'label': '漳浦Zhangpu0596',
  'name': '漳浦',
  'pinyin': 'Zhangpu',
  'zip': '0596'
}, {
  'label': '章丘Zhangqiu0531',
  'name': '章丘',
  'pinyin': 'Zhangqiu',
  'zip': '0531'
}, {
  'label': '樟树Zhangshu0795',
  'name': '樟树',
  'pinyin': 'Zhangshu',
  'zip': '0795'
}, {
  'label': '沾化Zhanhua0543',
  'name': '沾化',
  'pinyin': 'Zhanhua',
  'zip': '0543'
}, {
  'label': '赵县Zhaoxian0311',
  'name': '赵县',
  'pinyin': 'Zhaoxian',
  'zip': '0311'
}, {
  'label': '招远Zhaoyuan0535',
  'name': '招远',
  'pinyin': 'Zhaoyuan',
  'zip': '0535'
}, {
  'label': '正定Zhengding0311',
  'name': '正定',
  'pinyin': 'Zhengding',
  'zip': '0311'
}, {
  'label': '政和Zhenghe0599',
  'name': '政和',
  'pinyin': 'Zhenghe',
  'zip': '0599'
}, {
  'label': '柘荣Zherong0593',
  'name': '柘荣',
  'pinyin': 'Zherong',
  'zip': '0593'
}, {
  'label': '中牟Zhongmou0371',
  'name': '中牟',
  'pinyin': 'Zhongmou',
  'zip': '0371'
}, {
  'label': '忠县Zhongxian023',
  'name': '忠县',
  'pinyin': 'Zhongxian',
  'zip': '023'
}, {
  'label': '周宁Zhouning0593',
  'name': '周宁',
  'pinyin': 'Zhouning',
  'zip': '0593'
}, {
  'label': '周至Zhouzhi029',
  'name': '周至',
  'pinyin': 'Zhouzhi',
  'zip': '029'
}, {
  'label': '庄河Zhuanghe0411',
  'name': '庄河',
  'pinyin': 'Zhuanghe',
  'zip': '0411'
}, {
  'label': '诸城Zhucheng0536',
  'name': '诸城',
  'pinyin': 'Zhucheng',
  'zip': '0536'
}, {
  'label': '诸暨Zhuji0575',
  'name': '诸暨',
  'pinyin': 'Zhuji',
  'zip': '0575'
}, {
  'label': '紫金Zijin0762',
  'name': '紫金',
  'pinyin': 'Zijin',
  'zip': '0762'
}, {
  'label': '资溪Zixi0794',
  'name': '资溪',
  'pinyin': 'Zixi',
  'zip': '0794'
}, {
  'label': '邹城Zoucheng0537',
  'name': '邹城',
  'pinyin': 'Zoucheng',
  'zip': '0537'
}, {
  'label': '邹平Zouping0543',
  'name': '邹平',
  'pinyin': 'Zouping',
  'zip': '0543'
}, {
  'label': '遵化Zunhua0315',
  'name': '遵化',
  'pinyin': 'Zunhua',
  'zip': '0315'
}];

var cityObj = {};
var cityPinYin = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

for (var j = 0; j < cityPinYin.length; j++) {
  cityObj[cityPinYin[j]] = {
    letter: cityPinYin[j],
    content: []
  };
  for (var i = 0; i < city.length; i++) {
    if (cityPinYin[j] === city[i].pinyin[0]) {
      cityObj[cityPinYin[j]].content.push(city[i]);
    }
  }
}

for (var key in cityObj) {
  if (cityObj[key].content && cityObj[key].content.length <= 0) {
    delete cityObj[key];
  }
}
/* harmony default export */ __webpack_exports__["a"] = (cityObj);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_configure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_json_bigint_xk__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk__);







/* harmony default export */ __webpack_exports__["a"] = ({
  makeAnAppointment: function makeAnAppointment(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].appKey,
      'ack': __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].acKey ? __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].acKey : null,
      'passengerId': obj.passengerId,
      'passengerName': obj.passengerName,
      'passengerPhone': obj.passengerPhone,
      'companyId': obj.companyId,
      'channelName': obj.channelName,
      'couponId': obj.couponId,
      'serverTime': obj.serverTime,
      'budgetPay': obj.budgetPay,
      'startAddress': obj.startAddress,
      'startLat': obj.startLat,
      'startLng': obj.startLng,
      'userPhone': obj.userPhone,
      'endAddress': obj.endAddress,
      'endLat': obj.endLat,
      'endLng': obj.endLng,
      'openId': obj.openId
    };
    var url = __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].weixinUrl + '/api/daijia/create';
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(url, params, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  queryOrder: function queryOrder(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].appKey,
      'passengerId ': obj.passengerId
    };
    var url = __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].serverUrl + '/h5/v4/dj/getRunning';
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(url, params).then(function (data) {
      callback(data.body, obj.type);
    });
  },
  budgetCost: function budgetCost(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/getBudgetPrice', params);
    var url = 'v1/getBudgetPrice';
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(url, { params: params }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  coupon: function coupon(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].appKey,
      'passengerId': obj.passengerId
    };
    var url = __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].weixinUrl + '/h5/v4/dj/findCouponV4';
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(url, { params: params }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  cancelOrder: function cancelOrder(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].appKey,
      'orderId': obj.orderId,
      'reson': obj.reson
    };
    var url = __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].weixinUrl + '/h5/v4/dj/cancelOrder';
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(url, params, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  balancePay: function balancePay(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].appKey,
      'orderId': obj.orderId,
      'who': obj.who,
      'payType': obj.payType
    };
    var url = __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].weixinUrl + '/h5/v4/dj/doPay';
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(url, params, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  payInfo: function payInfo(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].appKey,
      'orderId': obj.orderId
    };
    var url = __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].weixinUrl + '/h5/v4/dj/prepay';
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(url, { params: params }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  weixinPay: function weixinPay(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].appKey,
      'orderId': obj.orderId,
      'openId': obj.openid,
      'appId': obj.WXappId
    };
    var url = __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].weixinUrl + '/v5/daijia/doPayForWx';
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(url, params, { emulateJSON: true }).then(function (data) {
      if (data.body.code === 0) {
        var content = data.body.data;

        __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk___default.a.config({
          debug: false,
          appId: window.configure.WXappId,
          timeStamp: content.timestamp,
          nonceStr: content.nonceStr,
          signature: content.signature,
          jsApiList: ['chooseWXPay'] });

        __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk___default.a.ready(function () {
          __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk___default.a.chooseWXPay({
            timestamp: content.timestamp,
            nonceStr: content.nonceStr,
            package: content.package,
            signType: 'MD5',
            paySign: content.paySign,
            success: function success(res) {
              callback('支付成功');
            }
          });
        });
        __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk___default.a.error(function (res) {
          callback('支付失败');
        });
      }
    });
  },
  evaluateOrder: function evaluateOrder(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].appKey,
      'orderId': obj.orderId,
      'phone': obj.phone,
      'score': obj.score,
      'content': obj.content,
      'driverId': obj.driverId
    };
    var url = __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].weixinUrl + '/api/daijia/review';
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(url, params, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  queryReview: function queryReview(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].appKey,
      'passengerId': obj.passengerId,
      'orderId': obj.orderId
    };
    var url = __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].weixinUrl + '/v5/daijia/getReview';
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(url, { params: params }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var getAxios = function getAxios(url, params) {
  var data = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, { params: params }).then(function (config) {
    return config;
  }).catch(function (err) {
    return err;
  });
  return data;
};

var postAxios = function postAxios(url, params) {
  var data = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, params).then(function (config) {
    return config;
  }).catch(function (err) {
    return err;
  });
  return data;
};

var putAxios = function putAxios(url, params) {
  var data = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(url, params).then(function (config) {
    return config;
  }).catch(function (err) {
    return err;
  });
  return data;
};

var deleteAxios = function deleteAxios(url, params) {
  var data = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(url, { params: params }).then(function (config) {
    return config;
  }).catch(function (err) {
    return err;
  });
  return data;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAxios: getAxios,
  postAxios: postAxios,
  putAxios: putAxios,
  deleteAxios: deleteAxios
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_configure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_json_bigint_xk__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk__);







/* harmony default export */ __webpack_exports__["a"] = ({
  inform: function inform(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].appKey,
      'passengerId': obj.passengerId,
      'page': obj.page,
      'rows': obj.rows
    };
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].weixinUrl + '/v5/passenger/getNotice', { params: params }).then(function (data) {
      callback(data.body.data);
    });
  },
  postCustomerPreSave: function postCustomerPreSave(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/customerPreSave', params);
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('/v1/customerPreSave', { params: params }, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  getCustomerPreSaveSerials: function getCustomerPreSaveSerials(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/customerPreSaveSerials', params);
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('/v1/customerPreSaveSerials', { params: params }, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  addCoupon: function addCoupon(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$utils.objKeySort('/api/v1/giftCouponByRandId', params);
    var url = __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].weixinUrl + '/giftCouponByRandId';
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(url, params, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  findNearDrivers: function findNearDrivers(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/getNearDrivers', params);
    var url = __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].serverUrl + '/getNearDrivers';
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(url, { params: params }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  queryCoupons: function queryCoupons(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].appKey,
      'phone': obj.phone,
      'page': obj.page,
      'rows': obj.rows,
      'status': obj.status };
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].weixinUrl + '/v5/passenger/getCoupons', { params: params }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  amendPersonalData: function amendPersonalData(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].appKey,
      'name': obj.name,
      'gender': obj.gender,
      'phone': obj.phone,
      'memberEcn': obj.memberEcn,
      'memberEcp': obj.memberEcp,
      'address': obj.address,
      'lat': obj.lat,
      'lng': obj.lng
    };
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].weixinUrl + '/v5/passenger/update', params, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  qrCode: function qrCode(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].appKey,
      'company_id': obj.company_id,
      'type': 2,
      'id': obj.id
    };
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('/api/v1/shareLink', { params: params }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  recommendRecord: function recommendRecord(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].appKey,
      'passengerId': obj.passengerId,
      'page': obj.page,
      'rows': obj.rows,
      'payType': 'RECHARGE_TYPE_REBATE'
    };
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].weixinUrl + '/v5/passenger/recommendRecord', { params: params }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  invoiceApply: function invoiceApply(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].appKey,
      'phone': obj.phone,
      'money': obj.money,
      'type': obj.type,
      'memo': obj.memo
    };
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].weixinUrl + '/v5/passenger/applyInvoice', params, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  getInvoiceOrders: function getInvoiceOrders(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/invoiceOrders', params);
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('/v1/invoiceOrders', { params: params }, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  imformNum: function imformNum(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].appKey,
      'passengerId': obj.passengerId
    };
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].weixinUrl + '/v5/passenger/getNotReadNotices', { params: params }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  upImformNum: function upImformNum(obj, callback) {
    var params = {
      'app_key': __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].appKey,
      'passengerId': obj.passengerId,
      'noticeIds': obj.noticeIds
    };
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].weixinUrl + '/v5/passenger/updateNoticeRead', params, { emulateJSON: true }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  userSumPay: function userSumPay(obj, callback) {
    var params = {
      'timeStamp': Date.parse(new Date()) / 1000,
      'user_id': window.configure.passengerInfo.id,
      'app_key': window.configure.appKey,
      'open_id': obj.open_id,
      'pay_type': 'weixin',
      'money': obj.money,
      'type': 1
    };
    var url = 'api/v1/recharge';
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put(url, params, { emulateJSON: true }).then(function (data) {
      if (data.body.code === 1) {
        var content = data.body.weixinResult;

        __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk___default.a.config({
          debug: false,
          appId: window.configure.WXappId,
          timeStamp: content.wx_app_ts,
          nonceStr: content.wx_app_nonce,
          signature: content.wx_app_sign,
          jsApiList: ['chooseWXPay'] });

        __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk___default.a.ready(function () {
          __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk___default.a.chooseWXPay({
            timestamp: content.wx_app_ts,
            nonceStr: content.wx_app_nonce,
            package: content.wx_app_pkg,
            signType: 'MD5',
            paySign: content.wx_app_sign,
            success: function success(res) {
              callback('充值成功');
            }
          });
        });
        __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk___default.a.error(function (res) {
          callback('充值失败');
        });
      } else {
        callback(data.body.errorMsg);
      }
    });
  },
  Articlebyalias: function Articlebyalias(obj, callback) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('/v1/articlebyalias', { params: obj }).then(function (data) {
      callback(__WEBPACK_IMPORTED_MODULE_3_json_bigint_xk___default.a.parse(data.bodyText));
    });
  },
  getCouponsApi: function getCouponsApi(params, callback) {
    params = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$utils.objKeySort('/passenger/api/v1/coupons', params);
    if (params.passenger_id) {
      var url = __WEBPACK_IMPORTED_MODULE_1__store_configure__["a" /* default */].weixinUrl + '/coupons';
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(url, { params: params }).then(function (data) {
        callback(data.coupon);
      });
    }
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var dLat = null;
var dLon = null;
var mLat = null;
var mLon = null;
var pLat = null;
var pLon = null;
var wgsLat = null;
var wgsLon = null;
var x = null;
var y = null;
var PI = 3.14159265358979324;
var xPi = 3.14159265358979324 * 3000.0 / 180.0;
var outOfChina = function outOfChina(lat, lon) {
  if (lon < 72.004 || lon > 137.8347) {
    return true;
  }
  if (lat < 0.8293 || lat > 55.8271) {
    return true;
  }
  return false;
};
var transformLat = function transformLat(x, y) {
  var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
  ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0;
  ret += (20.0 * Math.sin(y * PI) + 40.0 * Math.sin(y / 3.0 * PI)) * 2.0 / 3.0;
  ret += (160.0 * Math.sin(y / 12.0 * PI) + 320 * Math.sin(y * PI / 30.0)) * 2.0 / 3.0;
  return ret;
};
var transformLon = function transformLon(x, y) {
  var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
  ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0;
  ret += (20.0 * Math.sin(x * PI) + 40.0 * Math.sin(x / 3.0 * PI)) * 2.0 / 3.0;
  ret += (150.0 * Math.sin(x / 12.0 * PI) + 300.0 * Math.sin(x / 30.0 * PI)) * 2.0 / 3.0;
  return ret;
};
var delta = function delta(lat, lon) {
  var a = 6378245.0;
  var ee = 0.00669342162296594323;
  dLat = transformLat(lon - 105.0, lat - 35.0);
  dLon = transformLon(lon - 105.0, lat - 35.0);
  var radLat = lat / 180.0 * PI;
  var magic = Math.sin(radLat);
  magic = 1 - ee * magic * magic;
  var sqrtMagic = Math.sqrt(magic);
  dLat = dLat * 180.0 / (a * (1 - ee) / (magic * sqrtMagic) * PI);
  dLon = dLon * 180.0 / (a / sqrtMagic * Math.cos(radLat) * PI);
  return { 'lat': dLat, 'lng': dLon };
};
var gps = {
  gcj_encrypt: function gcj_encrypt(wgsLat, wgsLon) {
    console.log(this);
    if (outOfChina(wgsLat, wgsLon)) {
      return { 'lat': wgsLat, 'lng': wgsLon };
    }

    var d = delta(wgsLat, wgsLon);
    return { 'lat': wgsLat + d.lat, 'lng': wgsLon + d.lon };
  },

  gcj_decrypt: function gcj_decrypt(gcjLat, gcjLon) {
    if (outOfChina(gcjLat, gcjLon)) {
      return { 'lat': gcjLat, 'lng': gcjLon };
    }

    var d = delta(gcjLat, gcjLon);
    return { 'lat': gcjLat - d.lat, 'lng': gcjLon - d.lon };
  },

  gcj_decrypt_exact: function gcj_decrypt_exact(gcjLat, gcjLon) {
    var initDelta = 0.01;
    var threshold = 0.000000001;
    dLat = initDelta;
    dLon = initDelta;
    mLat = gcjLat - dLat;
    mLon = gcjLon - dLon;
    pLat = gcjLat + dLat;
    pLon = gcjLon + dLon;
    var i = 0;
    while (1) {
      wgsLat = (mLat + pLat) / 2;
      wgsLon = (mLon + pLon) / 2;
      var tmp = this.gcj_encrypt(wgsLat, wgsLon);
      dLat = tmp.lat - gcjLat;
      dLon = tmp.lon - gcjLon;
      if (Math.abs(dLat) < threshold && Math.abs(dLon) < threshold) {
        break;
      }

      if (dLat > 0) {
        pLat = wgsLat;
      } else {
        mLat = wgsLat;
      }
      if (dLon > 0) {
        pLon = wgsLon;
      } else {
        mLon = wgsLon;
      }

      if (++i > 10000) {
        break;
      }
    }

    return { 'lat': wgsLat, 'lng': wgsLon };
  },

  bd_encrypt: function bd_encrypt(gcjLat, gcjLon) {
    x = gcjLon;
    y = gcjLat;
    var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * xPi);
    var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * xPi);
    var bdLon = z * Math.cos(theta) + 0.0065;
    var bdLat = z * Math.sin(theta) + 0.006;
    return { 'lat': bdLat, 'lng': bdLon };
  },

  bd_decrypt: function bd_decrypt(bdLat, bdLon) {
    x = bdLon - 0.0065;
    y = bdLat - 0.006;
    var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * xPi);
    var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * xPi);
    var gcjLon = z * Math.cos(theta);
    var gcjLat = z * Math.sin(theta);
    return { 'lat': gcjLat, 'lng': gcjLon };
  },
  distance: function distance(latA, logA, latB, logB) {
    var earthR = 6371000;
    x = Math.cos(latA * Math.PI / 180) * Math.cos(latB * Math.PI / 180) * Math.cos((logA - logB) * Math.PI / 180);
    y = Math.sin(latA * Math.PI / 180) * Math.sin(latB * Math.PI / 180);
    var s = x + y;
    if (s > 1) {
      s = 1;
    }
    if (s < -1) {
      s = -1;
    }
    var alpha = Math.acos(s);
    var distance = alpha * earthR;
    return distance;
  }
};


/* harmony default export */ __webpack_exports__["a"] = (gps);

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_add_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_add_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_add_vue__);


__WEBPACK_IMPORTED_MODULE_0__src_add_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_add_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_add_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_add_vue___default.a);

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_alertBox_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_alertBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_alertBox_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_alertBox_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_alertBox_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_alertBox_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_alertBox_vue___default.a);

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_badge_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_badge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_badge_vue__);




__WEBPACK_IMPORTED_MODULE_0__src_badge_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_badge_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_badge_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_badge_vue___default.a);

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_capitalRecordList_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_capitalRecordList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_capitalRecordList_vue__);




__WEBPACK_IMPORTED_MODULE_0__src_capitalRecordList_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_capitalRecordList_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_capitalRecordList_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_capitalRecordList_vue___default.a);

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_carType_vue__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_carType_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_carType_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_carType_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_carType_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_carType_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_carType_vue___default.a);

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_carTypeScroll_vue__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_carTypeScroll_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_carTypeScroll_vue__);


__WEBPACK_IMPORTED_MODULE_0__src_carTypeScroll_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_carTypeScroll_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_carTypeScroll_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_carTypeScroll_vue___default.a);

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_checkInput_vue__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_checkInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_checkInput_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_checkInput_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_checkInput_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_checkInput_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_checkInput_vue___default.a);

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_circuitMod_vue__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_circuitMod_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_circuitMod_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_circuitMod_vue___default.a.intall = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_circuitMod_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_circuitMod_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_circuitMod_vue___default.a);

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_couponMod__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_couponMod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_couponMod__);



__WEBPACK_IMPORTED_MODULE_0__src_couponMod___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_couponMod___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_couponMod___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_couponMod___default.a);

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_couponNav_vue__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_couponNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_couponNav_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_couponNav_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_couponNav_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_couponNav_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_couponNav_vue___default.a);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_couponSelect_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_couponSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_couponSelect_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_couponSelect_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_couponSelect_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_couponSelect_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_couponSelect_vue___default.a);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_datePickerMod_vue__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_datePickerMod_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_datePickerMod_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_datePickerMod_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_datePickerMod_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_datePickerMod_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_datePickerMod_vue___default.a);

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_detailsBox_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_detailsBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_detailsBox_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_detailsBox_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_detailsBox_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_detailsBox_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_detailsBox_vue___default.a);

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_hintBox_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_hintBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_hintBox_vue__);


__WEBPACK_IMPORTED_MODULE_0__src_hintBox_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_hintBox_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_hintBox_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_hintBox_vue___default.a);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_homeBut_vue__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_homeBut_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_homeBut_vue__);


__WEBPACK_IMPORTED_MODULE_0__src_homeBut_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_homeBut_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_homeBut_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_homeBut_vue___default.a);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_imgCode_vue__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_imgCode_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_imgCode_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_imgCode_vue___default.a.intall = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_imgCode_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_imgCode_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_imgCode_vue___default.a);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_informTimeMod_vue__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_informTimeMod_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_informTimeMod_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_informTimeMod_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_informTimeMod_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_informTimeMod_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_informTimeMod_vue___default.a);

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_input_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_input_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_input_vue___default.a.intall = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_input_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_input_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_input_vue___default.a);

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_inputBox_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_inputBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_inputBox_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_inputBox_vue___default.a.intall = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_inputBox_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_inputBox_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_inputBox_vue___default.a);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_invoiceRecordMod_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_invoiceRecordMod_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_invoiceRecordMod_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_invoiceRecordMod_vue___default.a.intall = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_invoiceRecordMod_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_invoiceRecordMod_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_invoiceRecordMod_vue___default.a);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_lineSelect_vue__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_lineSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_lineSelect_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_lineSelect_vue___default.a.intall = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_lineSelect_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_lineSelect_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_lineSelect_vue___default.a);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_modalMod_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_modalMod_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_modalMod_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_modalMod_vue___default.a.intall = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_modalMod_vue___default.a.anme, __WEBPACK_IMPORTED_MODULE_0__src_modalMod_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_modalMod_vue___default.a);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_navTabs_vue__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_navTabs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_navTabs_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_navTabs_vue___default.a.intall = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_navTabs_vue___default.a.anme, __WEBPACK_IMPORTED_MODULE_0__src_navTabs_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_navTabs_vue___default.a);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_numberSelect_vue__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_numberSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_numberSelect_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_numberSelect_vue___default.a.intall = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_numberSelect_vue___default.a.anme, __WEBPACK_IMPORTED_MODULE_0__src_numberSelect_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_numberSelect_vue___default.a);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_recordOrderMod_vue__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_recordOrderMod_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_recordOrderMod_vue__);




__WEBPACK_IMPORTED_MODULE_0__src_recordOrderMod_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_recordOrderMod_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_recordOrderMod_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_recordOrderMod_vue___default.a);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_rollBanner_vue__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_rollBanner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_rollBanner_vue__);




__WEBPACK_IMPORTED_MODULE_0__src_rollBanner_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_rollBanner_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_rollBanner_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_rollBanner_vue___default.a);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_sideMenus_vue__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_sideMenus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_sideMenus_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_sideMenus_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_sideMenus_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_sideMenus_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_sideMenus_vue___default.a);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_siteInput_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_siteInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_siteInput_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_siteInput_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_siteInput_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_siteInput_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_siteInput_vue___default.a);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_star_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_star_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_star_vue__);


__WEBPACK_IMPORTED_MODULE_0__src_star_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_star_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_star_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_star_vue___default.a);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_tabs__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_tabs__);



__WEBPACK_IMPORTED_MODULE_0__src_tabs___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_tabs___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_tabs___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_tabs___default.a);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_tagitem_vue__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_tagitem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_tagitem_vue__);


__WEBPACK_IMPORTED_MODULE_0__src_tagitem_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_tagitem_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_tagitem_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_tagitem_vue___default.a);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_textarea_vue__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_textarea_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_textarea_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_textarea_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_textarea_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_textarea_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_textarea_vue___default.a);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_typeTabs_vue__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_typeTabs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_typeTabs_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_typeTabs_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_typeTabs_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_typeTabs_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_typeTabs_vue___default.a);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_unfilledOrderMod_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_unfilledOrderMod_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_unfilledOrderMod_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_unfilledOrderMod_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_unfilledOrderMod_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_unfilledOrderMod_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_unfilledOrderMod_vue___default.a);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_upAvatar_vue__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_upAvatar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_upAvatar_vue__);




__WEBPACK_IMPORTED_MODULE_0__src_upAvatar_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_upAvatar_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_upAvatar_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_upAvatar_vue___default.a);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_upImg_vue__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_upImg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_upImg_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_upImg_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_upImg_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_upImg_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_upImg_vue___default.a);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_uploadMod_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_uploadMod_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_uploadMod_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_uploadMod_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_uploadMod_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_uploadMod_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_uploadMod_vue___default.a);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_waiter_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_waiter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_waiter_vue__);



__WEBPACK_IMPORTED_MODULE_0__src_waiter_vue___default.a.install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_waiter_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__src_waiter_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_waiter_vue___default.a);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__xiaoka__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_amap__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_amap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_amap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__axios__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_js_cookie__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_js_method_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_js_util_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__filter__ = __webpack_require__(140);















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__xiaoka__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_mint_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_amap___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$Cookie = __WEBPACK_IMPORTED_MODULE_9_js_cookie___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$Tool = __WEBPACK_IMPORTED_MODULE_10__assets_js_method_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$Util = __WEBPACK_IMPORTED_MODULE_11__assets_js_util_js__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
  if (request.method == 'POST') {
    next(function (response) {
      return response;
    });
  };
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_daijia_daijia__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_initdata__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(7);





var state = {
  waiterList: null,
  orderNum: null,
  budgetCost: null,
  couponList: [],
  orderDetails: null,
  payInfo: null,
  AllOrder: {
    state: true,
    total: true,
    val: []
  },
  orderFee: {},
  queryReview: null
};

var mutations = {
  DJMakeAnAppointment: function DJMakeAnAppointment(state, data) {},
  queryOrder: function queryOrder(state, data) {
    state.orderNum = data;
  },
  DjBudgetCost: function DjBudgetCost(state, data) {
    state.budgetCost = data;
  },
  DjOrderInfo: function DjOrderInfo(state, data) {
    if (data.code === 1) {
      if (data.order.book_time) {
        data.order.book_time = data.order && data.order.book_time ? __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$utils.TimestampDate(data.order.book_time) : '';
      } else {
        data.order.book_time = '';
      }
      state.orderDetails = data.order;
      data.orderFee['total_fee'] = data.orderFee.total_fee || 0;
      state.orderFee = data.orderFee;
    }
  },
  DjPayInfo: function DjPayInfo(state, data) {
    state.payInfo = data.data;
  },
  DjQueryAllOrder: function DjQueryAllOrder(state, obj) {
    var type = obj.type;
    var data = obj.data;
    if (data && data.code === 1) {
      state.AllOrder.total = (data.finnishTotal || 0) + (data.runTotal || 0);
      state.AllOrder.state = false;
      if (type === 'upData') {
        state.AllOrder.val = [];
      }
      if (data.runOrders) {
        data.runOrders.forEach(function (row) {
          state.AllOrder.val.push(row);
        });
      }
      if (data.finishOrders) {
        data.finishOrders.forEach(function (row) {
          state.AllOrder.val.push(row);
        });
      }
    }
  },
  DjQueryReview: function DjQueryReview(state, data) {
    if (data && data.data && data.data.content !== '') {
      var tabs = data.data.content.substring(0, data.data.content.lastIndexOf('&*&'));
      tabs = tabs !== '' ? tabs.split('&|&') : [];
      state.queryReview = {
        reviewContent: data.data.content.substring(data.data.content.lastIndexOf('&*&')).replace('&*&', ''),
        tabs: tabs.length > 0 ? tabs : null,
        score: data.data.starLevel
      };
    }
  }
};

var getters = {
  DjQueryOrder: function DjQueryOrder(state) {
    return state.orderNum;
  },
  DjBudgetCost: function DjBudgetCost(state) {
    return state.budgetCost;
  },
  DjOrderInfo: function DjOrderInfo(state) {
    return state.orderDetails;
  },
  DjPayInfo: function DjPayInfo(state) {
    return state.payInfo;
  },
  DjQueryAllOrder: function DjQueryAllOrder(state) {
    return state.AllOrder;
  },
  DjQueryReview: function DjQueryReview(state) {
    return state.queryReview;
  },
  DJOrderFee: function DJOrderFee(state) {
    return state.orderFee;
  } };

var actions = {
  DJMakeAnAppointment: function DJMakeAnAppointment(_ref, obj) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_daijia_daijia__["a" /* default */].makeAnAppointment(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
      commit('DJMakeAnAppointment', data);
    });
  },
  queryOrder: function queryOrder(_ref2, obj) {
    var commit = _ref2.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_daijia_daijia__["a" /* default */].queryOrder(obj, function (data) {
      commit('queryOrder', data);
    });
  },
  DjBudgetCost: function DjBudgetCost(_ref3, obj) {
    var commit = _ref3.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_daijia_daijia__["a" /* default */].budgetCost(obj, function (data) {
      commit('DjBudgetCost', data);
    });
  },
  DjOrderInfo: function DjOrderInfo(_ref4, obj) {
    var commit = _ref4.commit;

    __WEBPACK_IMPORTED_MODULE_1__api_initdata__["a" /* default */].getOrderFindOne(obj, function (data) {
      commit('DjOrderInfo', data);
    });
  },
  putCancelOrder: function putCancelOrder(_ref5, obj) {
    var commit = _ref5.commit;

    __WEBPACK_IMPORTED_MODULE_1__api_initdata__["a" /* default */].putCancelOrder(obj, function (state) {
      if (state && obj.fn) {
        obj.fn(state);
      }
    });
  },
  DjBalancePay: function DjBalancePay(_ref6, obj) {
    var commit = _ref6.commit;

    console.log(2);
    __WEBPACK_IMPORTED_MODULE_1__api_initdata__["a" /* default */].putFinishOrder(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  DjPayInfo: function DjPayInfo(_ref7, obj) {
    var commit = _ref7.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_daijia_daijia__["a" /* default */].payInfo(obj, function (data) {
      commit('DjPayInfo', data);
    });
  },
  DjEvaluateOrder: function DjEvaluateOrder(_ref8, obj) {
    var commit = _ref8.commit;

    __WEBPACK_IMPORTED_MODULE_1__api_initdata__["a" /* default */].putRateOrder(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  DjQueryReview: function DjQueryReview(_ref9, obj) {
    var commit = _ref9.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_daijia_daijia__["a" /* default */].queryReview(obj, function (data) {
      commit('DjQueryReview', data);
    });
  },
  DjWXPay: function DjWXPay(_ref10, obj) {
    var commit = _ref10.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_daijia_daijia__["a" /* default */].weixinPay(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_mc__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_initdata__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_method_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_json_bigint_xk__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_json_bigint_xk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_json_bigint_xk__);







var Tool = __WEBPACK_IMPORTED_MODULE_3__assets_js_method_js__["a" /* default */];
var state = {
  phoneNo: '',
  loginState: true,
  loginData: {
    openId: null,
    passenger: null,
    token: null
  },
  wxState: null,
  imgUrl: null
};

var mutations = {
  loginAction: function loginAction(state, obj) {
    state.loginState = obj.state;
  },
  accredit: function accredit(state, obj) {
    state.wxState = obj.wxState;
  },
  checkLogin: function checkLogin(state, fn) {
    var passengerkey = window.configure.passengerKey;
    var passenger = __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get(passengerkey) ? __WEBPACK_IMPORTED_MODULE_5_json_bigint_xk___default.a.parse(Tool.aesDecryptCode(__WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get(passengerkey))) : null;

    if (passenger) {
      window.configure.passengerInfo = passenger.passenger;
      if (!state.wxState) {
        console.log('检查登录--非微信环境', passenger);
        state.loginState = true;
        state.loginData = passenger;

        state.phoneNo = passenger.passenger.phone;
        if (fn) {
          fn(true);
        }
        return true;
      } else if (state.wxState && passenger.openId) {
        console.log('检查登录--微信环境');
        state.loginState = true;
        state.loginData = passenger;
        state.phoneNo = passenger.passenger.phone;
        if (fn) {
          fn(true);
        }
        return true;
      } else if (state.wxState && !passenger.openId) {
        console.log('检查登录--微信环境，但没有openid');
        state.loginState = false;
        if (fn) {
          fn(false);
        }
        return false;
      }
    } else {
      console.log('检查登录--cookie信息不存在');
      state.loginState = false;
      if (fn) {
        fn(false);
      }
      return false;
    }
  },
  updateLoginData: function updateLoginData(state, data) {
    if (data.data.code === 1) {
      state.loginData.passenger = data.data.passenger;
      state.loginData.token = data.data.token;
      state.loginData.grade = data.data.grade;
      var passengerkey = window.configure.passengerKey;
      __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.remove(passengerkey);
      __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set(passengerkey, Tool.aesEncryptCode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.loginData)));
      if (data.fn) {
        data.fn(data);
      }
    }
  },
  getOpenId: function getOpenId(state, data) {
    if (data && data.code === 1) {
      __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set('open_id', data.wechat.open_id);
      window.configure.open_id = data.wechat.open_id;
    } else {
      window.configure.open_id = __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('open_id');
    }
  },
  logoutUser: function logoutUser(state, fn) {
    var passengerkey = window.configure.passengerKey;
    Tool.delCookie(passengerkey);
    var passanger = __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get(passengerkey);
    if (passanger) {
      __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.remove(passengerkey);
    }
    Tool.delCookie('easyminaddressrecord');
    state.loginState = false;
  },
  setPassengerInfo: function setPassengerInfo(state, passInfo) {
    if (passInfo.passenger.code === 1) {
      state.loginData.passenger = passInfo.passenger.passenger;
      window.configure.passengerInfo = passInfo.passenger.passenger;
      state.loginData.openId = passInfo.passenger.passenger.open_id;
      var appKey = passInfo.passenger.passenger.app_key;
      window.configure.passengerKey = 'passenger' + appKey;
      window.configure.appKey = appKey;
      var passengerkey = window.configure.passengerKey;
      Tool.setCookie(passengerkey, Tool.aesEncryptCode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.loginData)));
      state.loginState = true;
      console.log('loginState1111111111111', state.loginState);
      console.log('passengerkey', passengerkey, Tool.aesEncryptCode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.loginData)));

      if (passInfo.fn) {
        passInfo.fn(true);
      }
    } else {
      passInfo.fn(false, passInfo.passenger.code);
    }
  },
  loginOpenId: function loginOpenId(state, obj) {
    if (obj.code === 1) {
      state.loginData.passenger = obj.passenger;
      window.configure.passengerInfo = obj.passenger;
      state.loginData.openId = obj.passenger.open_id;
      var appKey = obj.passenger.app_key;
      window.configure.passengerKey = 'passenger' + appKey;
      window.configure.appKey = appKey;
      var passengerkey = window.configure.passengerKey;
      Tool.setCookie(passengerkey, Tool.aesEncryptCode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.loginData)));

      state.loginState = true;
      if (obj.fn) {
        obj.fn(true);
      }
    } else {
      var appkey = window.configure.appKey;
      var key = 'passenger' + appkey;
      Tool.delCookie(key);
      state.loginState = false;
      if (obj.fn) {
        obj.fn(false);
      }
    }
  },
  checkWX: function checkWX(state, data) {
    state.wxState = data;
  }
};

var getters = {
  login: function login(state) {
    return state.loginState;
  },
  loginData: function loginData(state) {
    window.configure['passengerInfo'] = state.loginData.passenger;
    return state.loginData;
  },
  wxState: function wxState(state) {
    return state.wxState;
  }
};

var actions = {
  loginAction: function loginAction(_ref, obj) {
    var commit = _ref.commit;

    commit('loginAction', obj);
  },
  accredit: function accredit(_ref2, fn) {
    var commit = _ref2.commit;

    __WEBPACK_IMPORTED_MODULE_2__api_initdata__["a" /* default */].accredit(fn, function (data) {
      if (data && fn) {
        fn(data);
      }
      commit('accredit', data);
    });
  },
  getWeChatToken: function getWeChatToken(_ref3, obj) {
    var commit = _ref3.commit;

    __WEBPACK_IMPORTED_MODULE_1__api_mc__["a" /* default */].getWeChatToken(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  checkLogin: function checkLogin(_ref4, fn) {
    var commit = _ref4.commit;

    commit('checkLogin', fn);
  },
  updateLoginData: function updateLoginData(_ref5, obj) {
    var commit = _ref5.commit;

    __WEBPACK_IMPORTED_MODULE_1__api_mc__["a" /* default */].updateLoginData(obj, function (data) {
      commit('updateLoginData', {
        data: data,
        fn: function fn() {
          if (data && obj.fn) {
            obj.fn(data);
          }
        }
      });
    });
  },
  logoutUser: function logoutUser(_ref6, obj) {
    var commit = _ref6.commit;

    if (obj.fn) {
      obj.fn(true);
    }
    commit('logoutUser');
  },
  getOpenId: function getOpenId(_ref7, obj) {
    var commit = _ref7.commit;

    __WEBPACK_IMPORTED_MODULE_1__api_mc__["a" /* default */].getOpenId(obj, function (data) {
      commit('getOpenId', data);
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  postloginOpenId: function postloginOpenId(_ref8, obj) {
    var commit = _ref8.commit;

    __WEBPACK_IMPORTED_MODULE_1__api_mc__["a" /* default */].postloginOpenId(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
      commit('loginOpenId', data);
    });
  },
  checkWX: function checkWX(_ref9, obj) {
    var commit = _ref9.commit;

    __WEBPACK_IMPORTED_MODULE_2__api_initdata__["a" /* default */].checkWX(obj, function (state) {
      if (obj.fn) {
        obj.fn(state);
      }
      commit('checkWX', state);
    });
  },
  getCheckUser: function getCheckUser(_ref10, obj) {
    var commit = _ref10.commit;

    __WEBPACK_IMPORTED_MODULE_1__api_mc__["a" /* default */].getCheckUser(obj, function (state) {
      if (obj.fn) {
        obj.fn(state);
      }
    });
  },
  getImgCode: function getImgCode(_ref11, obj) {
    var commit = _ref11.commit;

    __WEBPACK_IMPORTED_MODULE_1__api_mc__["a" /* default */].getImgCode(obj, function (state) {
      if (obj.fn) {
        obj.fn(state);
      }
    });
  },
  postCheckCode: function postCheckCode(_ref12, obj) {
    var commit = _ref12.commit;

    __WEBPACK_IMPORTED_MODULE_1__api_mc__["a" /* default */].postCheckCode(obj, function (state) {
      if (obj.fn) {
        obj.fn(state);
      }
    });
  },
  getSmsCode: function getSmsCode(_ref13, obj) {
    var commit = _ref13.commit;

    __WEBPACK_IMPORTED_MODULE_1__api_mc__["a" /* default */].getSmsCode(obj, function (state) {
      if (obj.fn) {
        obj.fn(state);
      }
    });
  },
  postLogin: function postLogin(_ref14, obj) {
    var commit = _ref14.commit;

    __WEBPACK_IMPORTED_MODULE_1__api_mc__["a" /* default */].postLogin(obj, function (passenger) {
      commit('setPassengerInfo', { passenger: passenger, fn: obj.fn });
    });
  },
  passengerWithOutLogin: function passengerWithOutLogin(_ref15, obj) {
    var commit = _ref15.commit;

    __WEBPACK_IMPORTED_MODULE_1__api_mc__["a" /* default */].passengerWithOutLogin(obj, function (passenger) {
      commit('setPassengerInfo', { passenger: passenger, fn: obj.fn });
    });
  },
  getPassenger: function getPassenger(_ref16, obj) {
    var commit = _ref16.commit;

    __WEBPACK_IMPORTED_MODULE_1__api_mc__["a" /* default */].getPassenger(obj, function (data) {
      commit('updateLoginData', { data: data, fn: obj.fn });
    });
  },
  putPassenger: function putPassenger(_ref17, obj) {
    var commit = _ref17.commit;

    __WEBPACK_IMPORTED_MODULE_1__api_mc__["a" /* default */].putPassenger(obj, function (data) {
      if (obj.fn) {
        obj.fn(data);
      }
    });
  },
  postRegister: function postRegister(_ref18, obj) {
    var commit = _ref18.commit;

    __WEBPACK_IMPORTED_MODULE_1__api_mc__["a" /* default */].postRegister(obj, function (passenger) {
      commit('setPassengerInfo', { passenger: passenger, fn: obj.fn });
      if (obj.fn) {
        obj.fn(passenger);
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_userCenter__ = __webpack_require__(240);


var state = {
  informData: {
    state: true,
    totalElements: 0,
    content: []
  },
  capitalRecords: {
    state: true,
    totalElements: 0,
    content: []
  },
  usedCoupons: {
    state: true,
    totalElements: 0,
    content: []
  },
  unusedCoupons: {
    state: true,
    totalElements: 0,
    content: []
  },
  expireCoupons: {
    state: true,
    totalElements: 0,
    content: []
  },
  queryQrCode: null,
  recommendRecord: {
    state: true,
    totalElements: 0,
    content: []
  },
  invoiceRecord: {
    state: true,
    totalElements: 0,
    content: []
  },
  imformNum: {
    num: 0,
    content: ''
  },
  customerPreSave: {},
  infoData: '',
  djCoupns: [],
  zcCoupons: [],
  allCoupons: [],
  unUsedCoupon: [],
  usedCoupon: [],
  expireCoupon: [] };

var mutations = {
  getInform: function getInform(state, data) {
    state.informData.state = false;
    if (data.type === 'upData') {
      state.informData.content = [];
    }
    var Data = data.data;
    if (Data) {
      state.informData.totalElements = Data.totalElements;
      for (var i = 0; i < Data.content.length; i++) {
        state.informData.content.push(Data.content[i]);
      }
    }
  },
  v5getCouponsMutations: function v5getCouponsMutations(state, data) {
    if (data && data.code === 1) {
      var allCoupon = data.coupon;
      var zcCoupon = [];
      var djCoupn = [];
      var unUsedCoupon = [];
      var usedCoupon = [];
      var expireCoupon = [];
      if (allCoupon && allCoupon.length > 0) {
        allCoupon.forEach(function (row) {
          if (row.main_service_type === 'zhuanche') {
            zcCoupon.push(row);
          }
          if (row.main_service_type === 'daijia') {
            djCoupn.push(row);
          }

          if (row.state === 1) {
            unUsedCoupon.push(row);
          }
          if (row.state === 2) {
            usedCoupon.push(row);
          }
          if (row.state === 3) {
            expireCoupon.push(row);
          }
        });
      }
      state.djCoupns = djCoupn;
      state.zcCoupons = zcCoupon;
      state.unUsedCoupon = unUsedCoupon;
      state.usedCoupon = usedCoupon;
      state.expireCoupon = expireCoupon;
      state.allCoupons = allCoupon;
    } else {}
  },
  capitalRecords: function capitalRecords(state, data) {
    var Data = data.data;
    state.capitalRecords.totalElements = Data.totalElements;
    if (data.type === 'upData') {
      state.capitalRecords.content = [];
    }
    state.capitalRecords.content = Data.content.reduce(function (callback, item) {
      callback.push(item);
      return callback;
    }, state.capitalRecords.content);
    state.capitalRecords.state = false;
  },
  queryQrCode: function queryQrCode(state, data) {
    state.queryQrCode = data;
  },
  queryRecommendRecord: function queryRecommendRecord(state, data) {
    var Data = data.data;
    state.recommendRecord.totalElements = Data.totalElements;
    if (data.type === 'upData') {
      state.recommendRecord.content = [];
    }
    state.recommendRecord.content = Data.content.reduce(function (callback, item) {
      callback.push(item);
      return callback;
    }, state.recommendRecord.content);
  },
  invoiceRecord: function invoiceRecord(state, data) {
    if (data.type === 'upData') {
      state.invoiceRecord.content = [];
    }
    var Data = data.data.data;
    state.invoiceRecord.totalElements = Data.totalElements;
    state.invoiceRecord.content = Data.content.reduce(function (callback, item) {
      callback.push(item);
      return callback;
    }, state.invoiceRecord.content);
  },
  imformNum: function imformNum(state, data) {
    var dataNum = data.data;
    if (dataNum && dataNum.replace(',').length > 99) {
      state.imformNum.num = '99+';
    } else {
      state.imformNum.num = dataNum.split(',').length;
    }
    state.imformNum.content = dataNum;
    if (data.fn) {
      data.fn();
    }
  },
  postCustomerPreSave: function postCustomerPreSave(state, data) {
    if (data.data.code === 1) {
      state.customerPreSave = data.data.customerPreSave;
      if (data.fn) {
        data.fn(data.data.customerPreSave);
      }
    }
  }
};

var getters = {
  getInform: function getInform(state) {
    return state.informData;
  },
  djCoupnsGetter: function djCoupnsGetter(state) {
    return state.djCoupns;
  },
  zcCouponsGetter: function zcCouponsGetter(state) {
    return state.zcCoupons;
  },
  unUsedCouponGetter: function unUsedCouponGetter(state) {
    return state.unUsedCoupon;
  },
  usedCouponGetter: function usedCouponGetter(state) {
    return state.usedCoupon;
  },
  expireCouponGetter: function expireCouponGetter(state) {
    return state.expireCoupon;
  },
  capitalRecords: function capitalRecords(state) {
    return state.capitalRecords;
  },
  usedCoupons: function usedCoupons(state) {
    return state.usedCoupons;
  },
  unusedCoupons: function unusedCoupons(state) {
    return state.unusedCoupons;
  },
  expireCoupons: function expireCoupons(state) {
    return state.expireCoupons;
  },
  allCouponsGetter: function allCouponsGetter(state) {
    return state.allCoupons;
  },
  queryQrCode: function queryQrCode(state) {
    return state.queryQrCode;
  },
  queryRecommendRecord: function queryRecommendRecord(state) {
    return state.recommendRecord;
  },
  invoiceRecord: function invoiceRecord(state) {
    return state.invoiceRecord;
  },
  imformNum: function imformNum(state) {
    return state.imformNum;
  },
  postCustomerPreSave: function postCustomerPreSave(state) {
    return state.customerPreSave;
  } };

var actions = {
  getInform: function getInform(_ref, obj) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_userCenter__["a" /* default */].inform(obj, function (data) {
      commit('getInform', { type: obj.type, data: data });
    });
  },
  v5getCoupons: function v5getCoupons(_ref2, obj) {
    var commit = _ref2.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_userCenter__["a" /* default */].getCouponsApi(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
      commit('v5getCouponsMutations', data);
    });
  },
  postCustomerPreSave: function postCustomerPreSave(_ref3, obj) {
    var commit = _ref3.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_userCenter__["a" /* default */].postCustomerPreSave(obj, function (data) {
      commit('postCustomerPreSave', { type: obj.type, data: data });
    });
  },
  getCustomerPreSaveSerials: function getCustomerPreSaveSerials(_ref4, obj) {
    var commit = _ref4.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_userCenter__["a" /* default */].getCustomerPreSaveSerials(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  addCoupon: function addCoupon(_ref5, obj) {
    var commit = _ref5.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_userCenter__["a" /* default */].addCoupon(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  queryCoupons: function queryCoupons(_ref6, obj) {
    var commit = _ref6.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_userCenter__["a" /* default */].queryCoupons(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
      commit(obj.type, { typeFn: obj.typeFn, data: data.data });
    });
  },
  findNearDrivers: function findNearDrivers(_ref7, obj) {
    var commit = _ref7.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_userCenter__["a" /* default */].findNearDrivers(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  amendPersonalData: function amendPersonalData(_ref8, obj) {
    var commit = _ref8.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_userCenter__["a" /* default */].amendPersonalData(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  queryQrCode: function queryQrCode(_ref9, obj) {
    var commit = _ref9.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_userCenter__["a" /* default */].qrCode(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
      commit('queryQrCode', data.data);
    });
  },
  queryRecommendRecord: function queryRecommendRecord(_ref10, obj) {
    var commit = _ref10.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_userCenter__["a" /* default */].recommendRecord(obj, function (data) {
      commit('queryRecommendRecord', { type: obj.type, data: data.data });
    });
  },
  invoiceApply: function invoiceApply(_ref11, obj) {
    var commit = _ref11.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_userCenter__["a" /* default */].invoiceApply(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  getInvoiceOrders: function getInvoiceOrders(_ref12, obj) {
    var commit = _ref12.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_userCenter__["a" /* default */].getInvoiceOrders(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  imformNum: function imformNum(_ref13, obj) {
    var commit = _ref13.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_userCenter__["a" /* default */].imformNum(obj, function (data) {
      commit('imformNum', { fn: obj.fn, data: data.data });
    });
  },
  upImformNum: function upImformNum(_ref14, obj) {
    var commit = _ref14.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_userCenter__["a" /* default */].upImformNum(obj, function (data) {});
  },
  userSumPay: function userSumPay(_ref15, obj) {
    var commit = _ref15.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_userCenter__["a" /* default */].userSumPay(obj, function (data) {
      if (data && obj.fn) {
        obj.fn(data);
      }
    });
  },
  Articlebyalias: function Articlebyalias(_ref16, obj) {
    var commit = _ref16.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_userCenter__["a" /* default */].Articlebyalias(obj, function (data) {
      obj.fn(data);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAJJJREFUGBljfJUS8J+BGECMQpAaJmIMA6lhwaXwS36k+LevPy4ATYr+x/CfAauJ/xsamL5/+7GckYlxpsic9ftQTHydGmj//z/DWkZGhuA3Ty44ACUZRaT1mxgY1oEthZsoOnv9QZCi////HwAGQwMnN2cEY0PDP7AqIIHiRpBikEkwSWQabiKyIDY2IzHhCNIIAASJMEdib+/0AAAAAElFTkSuQmCC"

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAAAXNSR0IArs4c6QAAAOBJREFUKBVjnD17dvi/f//6GRgYJIEYBN4zMjIu////vx6QbQMSAPJ/AKn1QLF4FqDi6UDOFyA+BMQgyT9Q+iVQAVgMyOcAsiOB9HoWICHIxMSUmZqauhKkEBeYOXPmR6A6QSZcCrCI/weJkaIBbMaoBixBiSFESigxgnSDYpoBmDzagDGZBGLjABxAcT6QHEjDdyBWgmJQWvrMzMys8efPnzagWDwQwwEwPX0HOakHqAgc7SAZoCAvVLETXCWEcQ2YlraC3TV37lwpoLNgyRtNHQMD0MbvioqKtxwdHf8AABbLR/fqJbHLAAAAAElFTkSuQmCC"

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAANJJREFUKBWNkDEKwkAURLMbb6KeIYVHCAipLSwU0tlb2mgTxDaNjeABxJzBzgsIFtYeQAhkfROMJILGgcn/+//MbBKTpunR87wQ/oPMovpXrMBQhjZcEIygqtdqMMac4jjeq8pg+AanpgVK70tTv6EgZc3srsUHSrFmlaGw1k4532AEZVLAjLqAb5QGFlfn3ABu2CQwImBM7cIHnMMSpQFhD05es4Ca+L5/Zqa/syJQOGhfvZL6OoI8z7eIdhpiXMKh+o4eXxAg0m0N6IasMfl9yJ4CcDzNyWkQ9AAAAABJRU5ErkJggg=="

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAL1JREFUKBVjnD17dva/f/86GBgYeIAYH/jCxMRUwUSkYpBBPCC1LCAGIyPjQyC9CSSKB/j9//9fngmPAqxSIBsYgDpfA23ZjlUFVBCoxhLIlAdrADK0gHgSVA4XJQWSgGk4AwyBZHSVQFPtgR6dgywO02D39+/f28gSuNggT//BJYlF/A8T0LPrsEhgFQKpZQS6k2nWrFlWQA4vSBWQ7wikSqE6uoHi+6Hin9PS0o5BxVGpmTNnNoAwqiiEBwBS8UBW1tWesQAAAABJRU5ErkJggg=="

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/timg-loading.e399318.png";

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAACNJREFUGBljnDlz5n8GYgAxCkFqmIgxDKRmZCpkJCYcQcEDAIDJCzk4JG2YAAAAAElFTkSuQmCC"

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAeCAYAAAA/xX6fAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjgzNTc3MzdENzM5NDExRTc5MjAwOEI4QUEyOUFBNTFCIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjgzNTc3MzdFNzM5NDExRTc5MjAwOEI4QUEyOUFBNTFCIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6ODM1NzczN0I3Mzk0MTFFNzkyMDA4QjhBQTI5QUE1MUIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6ODM1NzczN0M3Mzk0MTFFNzkyMDA4QjhBQTI5QUE1MUIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4MevCnAAAAx0lEQVR42mL8//8/Az0BEwOdwfC3kOXMmTMgWhWIO4DYBYj5qGDuJyDeA8QVQHzbxMQExYfqQHwEiA8CsSIQM1IBK0LNOwI1H+FDIG6D4klUDLl3UPM4oWYHI/sQFIyLaRRls4HYDT3R8EFdRAsAMpdnNB+OWjhq4aiFoxaOWjhq4SCwENTCEqKR+SBzv6BbCGrOxdLIwhQg3oXeaquGNun+QxtT76lgkSDUE8VAbI/uwxtAbAeVeAi1mFL8EGqeHdR8OAAIMABcKzQxwzCEbAAAAABJRU5ErkJggg=="

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAeCAYAAAA/xX6fAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjhCOTUyMTlENzM5NDExRTdCNzBDRjIwOTNGMUNEM0NGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjhCOTUyMTlFNzM5NDExRTdCNzBDRjIwOTNGMUNEM0NGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OEI5NTIxOUI3Mzk0MTFFN0I3MENGMjA5M0YxQ0QzQ0YiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OEI5NTIxOUM3Mzk0MTFFN0I3MENGMjA5M0YxQ0QzQ0YiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5NiDwsAAACJ0lEQVR42mL8//8/Az0BC4zxMS2E1nZxAHErC508pg7E24BYieXMmTNgEVXaWeYOxJuBmBWIPzOePn0aZl8HELsAMR8VLPkExHtk1y88zvH6eTeS+GcWqHcPgcIXiFNVZ3W8o9S222kVQqLH9/ajWQYGIB+uBVkItGgiFYPRF4g3YRH/zAQNxsVUtMwYh2VgwASNs3dUsowfiPfjU8BE5RS5F4h58cjzUtPCdmhw4gNfmagYbxUE1CwEYn1qlTQ4E8l/JmYGxn9/Q4HMNdSKQ1Bek8Ihd+9RSDIDzDJCFsoA8XognopHDciiEhxy50FB+EtACHttgSZWBcSV0BIeBJ5BSyJ0MBeHZUeA2AGI/+KsnoBAHIiDgLgUiBXR1LWAUhgQT0ASMwdiDyyWHQNiW4L1IRDEQuMDF+gH4u9APBPKn4RFzWUgtiE244MMcIW6EBeYAcR6QMwDxGZocq+A2BKUMIm18BeoSgFiayAuAOJ/eOLnBBZxG2iwM5BTtIFqDi1oSsMonoBYG03MB1QrEZOH8GWLm0BsBMSrCJhRD8Rbic20xGT8cCCejUPuJBA3kVJKEFvSpAHxSjSxv9CKloEWFoJABBCfQeKnAPFrWloIa4HBSp4F5DaEQS0sISJr/XfQIu8GsY0pIPUFayMKmhWoDcqgRWCwiYkJ3IfVQHwQWkKAGlPvqWCRILSoLAZie/Q4BAWPHVTiIdRiSvFDqHl26MEPEGAAS3OKpIKs4p4AAAAASUVORK5CYII="

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/orderImg.fbb8f80.png";

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 455 */,
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(408)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(552),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(367)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(511),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(373)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(517),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(406)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(550),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(417)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(561),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-adaf5fc2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(363)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(507),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(390)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(534),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(379)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(523),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(388)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(532),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(391)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(535),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(423)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(567),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(405)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(549),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(396)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(540),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(410)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(554),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(359)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(503),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(395)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(539),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(409)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(553),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(370)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(514),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(362)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(506),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(413)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(557),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(369)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(513),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(392)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(536),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(401)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(545),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(385)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(529),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(394)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(538),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(418)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(562),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(357)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(501),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(374)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(518),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(386)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(530),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(393)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(537),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(407)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(551),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(398)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(542),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(412)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(556),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(420)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(564),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(353)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(497),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(368)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(512),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(383)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(527),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(372)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(516),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(375)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(519),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(355)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(499),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(360)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(504),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Settlement"
  }, [_c('div', {
    staticClass: "Settlementcont"
  }, [_c('div', {
    staticClass: "feiyong"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "sum"
  }, [_c('span', {
    staticClass: "daxie"
  }, [_vm._v(_vm._s(_vm.DJOrderFee && _vm.DJOrderFee.real_pay ? _vm.DJOrderFee.real_pay.toFixed(1) : 0))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detailed"
  }, [_c('span', {
    on: {
      "click": _vm.detailsBoxFn
    }
  }, [_vm._v("费用详情"), _c('i', {
    staticClass: "iconfont icon-iconfontyiwen"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "payType"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "payTypeContent"
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.payTypeFn(1)
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "iconfont icon-yue Icon"
  }), _vm._v("\n              余额支付\n              "), _c('span', {
    staticClass: "select",
    class: _vm.data.payType == 1 ? 'selectAction' : ''
  }, [_c('i', {
    staticClass: "iconfont icon-chenggong"
  })])])]), _vm._v(" "), (_vm.wxState) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.payTypeFn(2)
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "iconfont icon-weixin Icon"
  }), _vm._v("\n          微信支付\n          "), _c('span', {
    staticClass: "select",
    class: _vm.data.payType == 2 ? 'selectAction' : ''
  }, [_c('i', {
    staticClass: "iconfont icon-chenggong"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.loginData.passenger && _vm.loginData.passenger.allowOverdraw) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.payTypeFn(3)
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "iconfont icon-qiandan-copy Icon"
  }), _vm._v("\n              签单支付\n              "), _c('span', {
    staticClass: "select",
    class: _vm.data.payType == 3 ? 'selectAction' : ''
  }, [_c('i', {
    staticClass: "iconfont icon-chenggong"
  })])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "submitBut",
    on: {
      "click": _vm.payFn
    }
  }, [_c('span', [_vm._v("立即支付")])])]), _vm._v(" "), _c('Xk-detailsBox', {
    ref: "detailsBox",
    staticClass: "costBox",
    attrs: {
      "title": '费用详情'
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', _vm._l((_vm.orderFeeDetail), function(item) {
    return _c('li', {
      staticClass: "clear"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "val"
    }, [_c('span', {
      staticClass: "sum"
    }, [_vm._v(_vm._s(item.cost))]), _c('span', {
      staticClass: "unit"
    }, [_vm._v("元")])])])
  }), 0)])]), _vm._v(" "), _c('xk-upload-mod', {
    attrs: {
      "state": _vm.loadState
    }
  }), _vm._v(" "), (_vm.hintBox.stateShow) ? _c('xk-hint-box', {
    attrs: {
      "state": _vm.hintBox.state,
      "content": _vm.hintBox.content
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("支付费用")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("支付方式")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])
}]}

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "siteInput"
  }, [_vm._v("\n  " + _vm._s(_vm.nameFn) + "\n  "), (_vm.name) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "siteInputShow",
    attrs: {
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "click": _vm.queryShowFn,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }) : _c('span', {
    staticClass: "siteInputShow placeholder",
    on: {
      "click": _vm.queryShowFn
    }
  }, [_vm._v(_vm._s(_vm.placeholder))]), _vm._v(" "), _c('div', {
    staticClass: "result",
    class: _vm.resultState ? 'showResult' : '',
    on: {
      "touchstart": _vm.resultFn
    }
  }, [_c('div', {
    staticClass: "Title"
  }, [_c('div', {
    staticClass: "selectCity",
    class: _vm.acCityState ? 'selectCityShow' : '',
    on: {
      "click": _vm.cityAcFn
    }
  }, [_c('span', {
    staticClass: "city"
  }, [_vm._v(_vm._s(_vm.cityShow))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    ref: "queryInput",
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }, function($event) {
        return _vm.mapFn(_vm.query, 'input')
      }],
      "click": function($event) {
        $event.stopPropagation();
        return _vm.mapFn(_vm.query)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "closeBut",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.moduleFn.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        取消\n      ")])]), _vm._v(" "), (!_vm.acCityState) ? _c('div', {
    staticClass: "shortcut clear"
  }, _vm._l((_vm.shortcutData), function(item, index) {
    return _c('div', {
      staticClass: "shortcut-row",
      class: {
        'shortcut-row-ac': _vm.shortcutAc === item
      },
      on: {
        "click": function($event) {
          return _vm.shortcutClickFn(item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item) + "\n      ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.acCityState) ? _c('div', {
    ref: "cityMod",
    staticClass: "cityMod"
  }, [_c('div', {
    staticClass: "hotCity"
  }, [_c('div', {
    staticClass: "cityRow"
  }, [_c('div', {
    staticClass: "title clear"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "Right",
    on: {
      "click": function($event) {
        return _vm.acCityFn(_vm.positioning.city)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dingwei"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.positioning.name !== '获取定位失败' && _vm.positioning.city ? _vm.positioning.city : '定位失败'))])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.hotCity), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.acCityFn(item)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item) + "\n              ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "cityList"
  }, [_vm._v("\n        " + _vm._s(_vm.getCityFn) + "\n        "), _vm._l((_vm.getCity), function(item, index) {
    return _c('div', {
      ref: "cityRow",
      refInFor: true,
      staticClass: "cityRow"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n            " + _vm._s(item.letter) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('ul', _vm._l((item.content), function(key, index) {
      return _c('li', {
        on: {
          "click": function($event) {
            return _vm.acCityFn(key.name)
          }
        }
      }, [_vm._v("\n                " + _vm._s(key.name) + "\n              ")])
    }), 0)])])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.acCityState) ? _c('div', {
    staticClass: "replaceCityList"
  }, [_c('ul', {
    on: {
      "touchmove": _vm.replaceCityListFn
    }
  }, _vm._l((_vm.getCity), function(item, num, index) {
    return _c('li', {
      ref: "replaceCityItem",
      refInFor: true,
      class: _vm.acCityIndex === index ? 'ac' : '',
      on: {
        "click": function($event) {
          return _vm.vibrationFn(index)
        }
      }
    }, [_c('span', {}, [_vm._v("\n            " + _vm._s(item.letter) + "\n            ")])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "searchMod"
  }, [(_vm.query === '' && _vm.addressrecord && _vm.addressrecord.length > 0) ? _c('div', {
    staticClass: "resultCont addressRecord"
  }, [_c('ul', _vm._l((_vm.addressrecord), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.actionFn(item.address)
        }
      }
    }, [_c('h3', [_vm._v(_vm._s(item.address.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.address.detailedAddress))])])
  }), 0)]) : _vm._e(), _vm._v(" "), ((_vm.query !== '' || _vm.shortcutAc !== '') && _vm.result.length > 0) ? _c('div', {
    staticClass: "resultCont"
  }, [_c('ul', _vm._l((_vm.result), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.actionFn(item)
        }
      }
    }, [_c('h3', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.detailedAddress))])])
  }), 0)]) : (_vm.query !== '' && _vm.result.length <= 0) ? _c('div', {
    staticClass: "without"
  }, [_vm._v("\n        没有信息\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "module",
    class: _vm.resultState ? 'moduleShow' : '',
    on: {
      "click": _vm.moduleFn
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "iconfont icon-jiantou"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Left"
  }, [_c('i', {
    staticClass: "iconfont icon-xing"
  }), _vm._v(" "), _c('span', [_vm._v("热门城市")])])
}]}

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "content": "servicePrice"
    }
  }, [_c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.infoData)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modelBox BoxSave",
    class: {
      'showModelBox': _vm.states
    }
  }, [_c('div', {
    staticClass: "Box"
  }, [_c('div', {
    staticClass: "modelBoxContent"
  }, [_c('span', {
    staticClass: "Icon"
  }, [(_vm.state === 'yes') ? _c('i', {
    staticClass: "iconfont icon-chenggong"
  }) : _vm._e(), _vm._v(" "), (_vm.state === 'no') ? _c('i', {
    staticClass: "iconfont icon-iconfontclosesmall"
  }) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.content))])])]), _vm._v(" "), (_vm.states) ? _c('div', {
    staticClass: "model"
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "typeTabs clear"
  }, [_c('div', {
    ref: "TabsContent",
    staticClass: "TabsContent",
    style: ({
      background: _vm.bacColor
    })
  }, [_c('ul', {
    staticClass: "clear",
    style: ({
      width: _vm.ulWidth
    })
  }, _vm._l((_vm.cardata.data), function(item, index) {
    return _c('li', {
      ref: "lis",
      refInFor: true,
      class: _vm.acNum == index ? 'AcLi' : '',
      on: {
        "click": function($event) {
          return _vm.clickFn(item, index)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])
  }), 0)]), _vm._v(" "), _c('div', {
    ref: "menusBut",
    staticClass: "menusBut",
    class: _vm.menusState ? 'menusAc' : '',
    on: {
      "click": _vm.menusFn
    }
  }, [_c('i', {
    staticClass: "iconfont icon-caidan"
  })]), _vm._v(" "), _c('div', {
    staticClass: "allTabs",
    class: _vm.menusState ? 'allTabsShow' : ''
  }, [_c('h2', [_vm._v("全部服务")]), _vm._v(" "), _c('div', {
    staticClass: "allTabsContent clear"
  }, _vm._l((_vm.cardata.data), function(itme, index) {
    return _c('span', {
      staticClass: "allTabsContentList",
      class: itme.icon ? 'allTabsContentListIcon' : '',
      on: {
        "click": function($event) {
          return _vm.clickFn(itme, index)
        }
      }
    }, [(itme.icon) ? _c('div', {
      staticClass: "Icon"
    }, [_c('img', {
      attrs: {
        "src": itme.icon
      }
    })]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "text"
    }, [_vm._v(_vm._s(itme.name))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: _vm.menusState ? 'modalShow' : '',
    on: {
      "click": _vm.menusFn
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hideState) ? _c('div', {
    staticClass: "homeBut"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(449)
    },
    on: {
      "click": function($event) {
        return _vm.imgButFn()
      }
    }
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoiceRecord"
  }, [_c('pull-to', {
    attrs: {
      "top-load-method": _vm.topRefreshFn,
      "bottom-load-method": _vm.bottomRefreshFn
    }
  }, _vm._l((_vm.content), function(item, index) {
    return _c('xk-invoice-record-mod', {
      key: index,
      attrs: {
        "time": '2017.01 08:20',
        "sum": '529.00',
        "memo": '专车',
        "type": '纸质发票',
        "state": 1
      }
    })
  }), 1), _vm._v(" "), _c('xk-upload-mod', {
    attrs: {
      "state": _vm.loadState
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('div', {
    staticClass: "page1 page"
  }, [_c('ul', {
    staticClass: "pageItme"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": '/servicePrice'
    }
  }, [_vm._v("\n          服务价格\n          "), _c('i', {
    staticClass: "iconfont icon-jiantou"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/serviceAgreement'
    }
  }, [_vm._v("\n          服务协议\n          "), _c('i', {
    staticClass: "iconfont icon-jiantou"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "page2 page"
  }, [_c('ul', {
    staticClass: "pageItme"
  }, [_c('li', [_vm._v("\n        服务热线\n        "), _c('span', [_c('a', {
    attrs: {
      "href": 'tel:' + (_vm.infoData.companyinfo ? _vm.infoData.companyinfo.telephone : '')
    }
  }, [_vm._v(_vm._s(_vm.infoData.companyinfo ? _vm.infoData.companyinfo.telephone : ''))])])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "logoutBut"
  }, [_c('span', {
    staticClass: "But",
    on: {
      "click": function($event) {
        return _vm.BoxLogoutFn("show")
      }
    }
  }, [_vm._v("\n      注销账户\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "modelBox BoxLogout",
    class: {
      'showModelBox': _vm.BoxLogout
    }
  }, [_c('div', {
    staticClass: "Box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modelBoxBottom clear"
  }, [_c('span', {
    staticClass: "ActionBut NoBut",
    on: {
      "click": function($event) {
        return _vm.BoxLogoutFn('on')
      }
    }
  }, [_vm._v("留下")]), _vm._v(" "), _c('span', {
    staticClass: "ActionBut OKBut",
    on: {
      "click": function($event) {
        return _vm.BoxLogoutFn('ok')
      }
    }
  }, [_vm._v("确认")])])]), _vm._v(" "), (_vm.BoxLogout) ? _c('div', {
    staticClass: "modelBoxModel"
  }) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("\n        当前版本\n        "), _c('span', [_vm._v("V5.1.12.003")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modelBoxContent"
  }, [_c('span', {
    staticClass: "Icon"
  }, [_c('i', {
    staticClass: "iconfont icon-yy03"
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("你确定要注销吗？")])])
}]}

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detailsBox",
    class: {
      'showDetailsBox': _vm.state
    }
  }, [_c('div', {
    staticClass: "detailsBoxContent"
  }, [_c('div', {
    staticClass: "Title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "BoxContent"
  }, [_vm._t("content")], 2), _vm._v(" "), _c('div', {
    staticClass: "closeBut",
    on: {
      "click": _vm.switchFn
    }
  }, [_c('span', [_vm._v("X")])])]), _vm._v(" "), _c('div', {
    staticClass: "Module"
  })])
},staticRenderFns: []}

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkInput clear",
    on: {
      "click": function($event) {
        return _vm.checkInputAcFn(_vm.val)
      }
    }
  }, [(!_vm.stateFn) ? _c('span', {
    staticClass: "inputImg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(450)
    }
  })]) : _c('span', {
    staticClass: "inputImg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(451)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "loginContent"
  }, [_c('div', {
    staticClass: "cancle",
    on: {
      "click": _vm.cancleFn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(119),
      "alt": "取消"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("登录")]), _vm._v(" "), _c('div', {
    staticClass: "row row1 clear"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "phone"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNo),
      expression: "phoneNo"
    }],
    attrs: {
      "placeholder": "手机号",
      "type": "tel",
      "maxlength": _vm.phoneLength
    },
    domProps: {
      "value": (_vm.phoneNo)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNo = $event.target.value
      }, function($event) {
        return _vm.loginStateFn(1)
      }]
    }
  })])])]), _vm._v(" "), (_vm.step === 1) ? _c('div', {
    staticClass: "row row3 clear"
  }, [_c('div', {
    staticClass: "top clear"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "imgCode"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imgCode),
      expression: "imgCode"
    }],
    attrs: {
      "placeholder": "图形验证码",
      "maxlength": 4
    },
    domProps: {
      "value": (_vm.imgCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.imgCode = $event.target.value
      }, function($event) {
        return _vm.loginStateFn(2)
      }]
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "img",
    on: {
      "click": _vm.getImgCodeFn
    }
  }, [_c('xk-img-code', {
    attrs: {
      "code": _vm.imgCodeUrl
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', {
    staticClass: "row row2 clear"
  }, [_c('div', {
    staticClass: "sms"
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "numCode"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.smsCode),
      expression: "smsCode"
    }],
    attrs: {
      "placeholder": "短信验证码",
      "type": "tel",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.smsCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.smsCode = $event.target.value
      }, function($event) {
        return _vm.loginStateFn(3)
      }]
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "numCodeBut",
    class: _vm.phoneCodeText === '获取短信验证码' ? 'numCodeButShow' : '',
    on: {
      "click": _vm.getSmsCodeFn
    }
  }, [_vm._v("\n          " + _vm._s(_vm.phoneCodeText) + "\n        ")])])]) : _vm._e(), _vm._v(" "), (_vm.step === 4) ? _c('div', {
    staticClass: "row row5 clear"
  }, [_c('div', {
    staticClass: "icon-input"
  }, [_vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "password"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "placeholder": "重置密码",
      "type": "password",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        return _vm.loginStateFn(4)
      }]
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.step === 5) ? _c('div', {
    staticClass: "row row5 clear"
  }, [_c('div', {
    staticClass: "icon-input"
  }, [_vm._m(4), _vm._v(" "), _c('span', {
    staticClass: "password"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "placeholder": "设置6-10位密码",
      "type": "password",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        return _vm.loginStateFn(5)
      }]
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('div', {
    staticClass: "row row5 clear",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "icon-input"
  }, [_vm._m(5), _vm._v(" "), _c('span', {
    staticClass: "password"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "placeholder": "登录密码",
      "type": "password",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        return _vm.loginStateFn(4)
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "textBtn",
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "forget",
    on: {
      "click": _vm.forgetFn
    }
  }, [_vm._v("\n          忘记密码\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "nextStep",
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("\n          下一步\n        ")])])]) : _vm._e(), _vm._v(" "), (_vm.step === 6) ? _c('div', {
    staticClass: "row row5 clear",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "icon-input"
  }, [_vm._m(6), _vm._v(" "), _c('span', {
    staticClass: "password"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "placeholder": "登录密码",
      "type": "password",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        return _vm.loginStateFn(6)
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "textBtn",
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "forget",
    on: {
      "click": _vm.forgetFn
    }
  }, [_vm._v("\n          忘记密码\n        ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "loginBut",
    class: _vm.loginState && _vm.agree ? 'loginButShow' : '',
    on: {
      "click": _vm.loginButFn
    }
  }, [_vm._v("\n      " + _vm._s(_vm.forgetState ? '确认' : '登录') + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row row4"
  }, [(_vm.agree) ? _c('img', {
    attrs: {
      "src": __webpack_require__(442),
      "alt": "已同意"
    },
    on: {
      "click": _vm.changeToUnAgreeFn
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.agree) ? _c('img', {
    attrs: {
      "src": __webpack_require__(448),
      "alt": "未同意"
    },
    on: {
      "click": _vm.changeToAgreenFn
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("已阅读并已同意"), _c('span', {
    staticClass: "protocol",
    on: {
      "click": _vm.userxieyiFn
    }
  }, [_vm._v("《用户协议》")])])])]), _vm._v(" "), (_vm.alertText) ? _c('xk-alert-box', {
    attrs: {
      "text": _vm.alertText
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hintBox.stateShow) ? _c('xk-hint-box', {
    attrs: {
      "state": _vm.hintBox.state,
      "content": _vm.hintBox.content
    }
  }) : _vm._e(), _vm._v(" "), (_vm.visible) ? _c('div', [_c('slideVerify', {
    ref: "slideVerify",
    attrs: {
      "loading": _vm.loading,
      "phone": _vm.phoneNo,
      "visible": _vm.visible
    },
    on: {
      "dragEnd": _vm.getSmsCodeFn,
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(443),
      "alt": "电话号码"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(444),
      "alt": "图形验证码"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(446),
      "alt": "短信验证码"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(45),
      "alt": "重置密码"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(45),
      "alt": "重置密码"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(45),
      "alt": "重置密码"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(45),
      "alt": "重置密码"
    }
  })])
}]}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rollBanner"
  }, [_c('ul', {
    staticClass: "imgList"
  }, _vm._l((_vm.data), function(itme, index) {
    return _c('li', {
      class: index == _vm.imgAcNum ? 'liAc' : '',
      on: {
        "click": function($event) {
          return _vm.imgListAcFn(itme)
        }
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": itme.imgUrl
      }
    })])])
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "Buttons"
  }, _vm._l((_vm.data), function(itme, index) {
    return _c('li', [_c('span', {
      staticClass: "but",
      class: index == _vm.imgAcNum ? 'butAc' : '',
      on: {
        "click": function($event) {
          return _vm.butFn(index)
        }
      }
    })])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "couponSelect",
    class: _vm.state ? 'couponSelectShow' : ''
  }, [_c('span', {
    staticClass: "couponSelectCont",
    on: {
      "click": function($event) {
        return _vm.stateFn(_vm.showState, 'show')
      }
    }
  }, [(_vm.counponDataFn.length > 0 && _vm.showStateType === '') ? _c('p', [_vm._v("选择优惠券")]) : (_vm.counponDataFn.length > 0 && _vm.showStateType === 'di') ? _c('p', [_vm._v("优惠券已抵扣"), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.showState))]), _vm._v("元")]) : (_vm.counponDataFn.length > 0 && _vm.showStateType === 'zhe') ? _c('p', [_vm._v("优惠券已折扣"), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.showState / 10))]), _vm._v("折")]) : _c('p', [_vm._v("暂无优惠券")])]), _vm._v(" "), _c('div', {
    staticClass: "couponSelectList"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "Content"
  }, [(_vm.counponDataFn.length <= 0) ? _c('div', [_c('p', [_vm._v("暂无优惠券")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/coupon/nused',
        query: {
          addState: true
        }
      }
    }
  }, [_vm._v("点击前往添加")])], 1) : (_vm.counponDataFn.length > 0) ? _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', [_c('span', {
    staticClass: "nonuseBut",
    on: {
      "click": function($event) {
        return _vm.stateFn('', 'nonuse')
      }
    }
  }, [_vm._v("不使用优惠券")])]), _vm._v(" "), _c('ul', _vm._l((_vm.counponDataFn), function(item, index) {
    return _c('li', {
      staticClass: "clear",
      class: _vm.acNum === index ? 'acLi' : '',
      on: {
        "click": function($event) {
          return _vm.stateFn(item, 'action', index)
        }
      }
    }, [(item.deductible) ? _c('div', {
      staticClass: "name"
    }, [_c('span', {
      staticClass: "badge deduction"
    }, [_vm._v("抵")]), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.title))])]) : _vm._e(), _vm._v(" "), (item.discount) ? _c('div', {
      staticClass: "name"
    }, [_c('span', {
      staticClass: "badge discount"
    }, [_vm._v("折")]), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.title))])]) : _vm._e(), _vm._v(" "), (item.end_time) ? _c('div', {
      staticClass: "time"
    }, [_vm._v("\n              " + _vm._s(item.end_time.split(' ')[0]) + "\n              "), _c('span', [_vm._v("到期")])]) : _c('div', {
      staticClass: "time"
    }, [_vm._v("\n              永久\n              "), _c('span', [_vm._v("使用")])]), _vm._v(" "), (item.deductible) ? _c('div', {
      staticClass: "val"
    }, [_c('span', {
      staticClass: "red"
    }, [_vm._v(_vm._s(item.deductible))]), _vm._v("元")]) : _vm._e(), _vm._v(" "), (item.discount) ? _c('div', {
      staticClass: "val"
    }, [_c('span', {
      staticClass: "red"
    }, [_vm._v(_vm._s(item.discount / 10))]), _vm._v("折\n            ")]) : _vm._e()])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "closeBut",
    on: {
      "click": _vm.stateFn
    }
  }, [_c('span', [_vm._v("X")])])]), _vm._v(" "), (_vm.state) ? _c('div', {
    staticClass: "module",
    on: {
      "click": _vm.stateFn
    }
  }) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Title"
  }, [_c('h2', [_vm._v("选择优惠券")])])
}]}

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "TagItem",
    class: _vm.acState ? 'TagItemAc' : '',
    on: {
      "click": function($event) {
        return _vm.acStateFn(_vm.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.name))])
},staticRenderFns: []}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tabs"
    }
  }, [_c('div', {
    staticClass: "tabs-active-style",
    style: ({
      'width': _vm.width + 'px'
    }),
    attrs: {
      "id": "tabs-active-style"
    }
  }, [_c('span')]), _vm._v(" "), _c('ul', {
    staticClass: "boss-tabs"
  }, _vm._l((_vm.tabs), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "boss-tabs-item",
      class: {
        'tabs-item-active': _vm.value === item.active
      },
      on: {
        "touchstart": function($event) {
          return _vm.touchstartFn(item.active, index)
        },
        "click": function($event) {
          return _vm.touchstartFn(item.active, index)
        }
      }
    }, [(item.icon) ? _c('i', {
      staticClass: "boss",
      class: item.icon
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "boss-tabs-item-span"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project"
  }, [_c('xk-side-menus', {
    ref: "sideMenus"
  }), _vm._v(" "), _c('div', {
    staticClass: "topNav"
  }, [_c('span', {
    staticClass: "menuBut",
    on: {
      "click": _vm.menuFn
    }
  }, [_c('i', {
    staticClass: "iconfont icon-man"
  })]), _vm._v(" "), _c('div', {
    staticClass: "yewu"
  }, [_c('xk-tabs', {
    attrs: {
      "acNum": 0
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "projectContent"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xk-img-code",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "canvas-img-code",
      "width": "100",
      "height": "50"
    }
  })])
}]}

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carTypeScroll"
  }, [_c('div', {
    staticClass: "Content"
  }, [_c('div', {
    staticClass: "arrows arrowsLeft",
    on: {
      "click": function($event) {
        return _vm.clickFn('left')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jiantou"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ScrollCont"
  }, [_c('ul', _vm._l((_vm.carTypeDataFn.data), function(item, index) {
    return _c('li', {
      staticClass: "ScrollContLi",
      class: _vm.action === item.index ? 'ScrollContLiShow' : ''
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "arrows arrowsRight",
    on: {
      "click": function($event) {
        return _vm.clickFn('right')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jiantou"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.state) ? _c('div', {
    staticClass: "inputBox",
    class: _vm.state ? 'inputBoxShow' : ''
  }, [_c('div', {
    staticClass: "inputBoxCont"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "inputBoxContent"
  }, [_vm._t("content")], 2), _vm._v(" "), _c('div', {
    staticClass: "inputBoxBottom clear"
  }, [_c('button', {
    staticClass: "but affirmBut",
    class: {
      'affirmButAc': _vm.affState,
      'disabled': _vm.disabled
    },
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.butFn('affirm')
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('span', {
    staticClass: "but cancelBut",
    on: {
      "click": function($event) {
        return _vm.butFn('cancel')
      }
    }
  }, [_vm._v("取消")])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recharge"
  }, [_c('div', {
    staticClass: "inform clear"
  }, [_c('div', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("账户")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.data.userNo))])]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.data.userName))])])]), _vm._v(" "), _c('div', {
    staticClass: "selectSum"
  }, [_c('h2', [_vm._v("\n      账户余额：\n      "), _c('span', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.postCustomerPreSave.present_balance ? _vm.postCustomerPreSave.present_balance.toFixed(1) : '00.0'))]), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v("元")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "default clear"
  }, _vm._l((_vm.seletSum), function(itme, index) {
    return _c('span', {
      staticClass: "tab",
      class: _vm.seletSumNum == index ? 'tabAc' : '',
      on: {
        "click": function($event) {
          return _vm.selectSumFn(index, itme.val)
        }
      }
    }, [_vm._v(_vm._s(itme.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "customSum"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credit),
      expression: "credit"
    }],
    attrs: {
      "placeholder": "自定义充值金额（≥100元）"
    },
    domProps: {
      "value": (_vm.credit)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.credit = $event.target.value
      }, _vm.customSumFn]
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "payType"
  }, [_c('h2', [_vm._v("支付方式")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row",
    on: {
      "click": function($event) {
        return _vm.payTypeFn(0)
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("微信支付")]), _vm._v(" "), _c('span', {
    staticClass: "select",
    class: _vm.payTypeNum == 0 ? 'selectAc' : ''
  }, [_c('i', {
    staticClass: "iconfont icon-chenggong"
  })])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "row",
    on: {
      "click": function($event) {
        return _vm.payTypeFn(1)
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("银联支付")]), _vm._v(" "), _c('span', {
    staticClass: "select",
    class: _vm.payTypeNum == 1 ? 'selectAc' : ''
  }, [_c('i', {
    staticClass: "iconfont icon-chenggong"
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "rechargeBut",
    class: _vm.credit !== '' && Number(_vm.credit) > 0 ? 'rechargeButShow' : '',
    on: {
      "click": _vm.userSumPayFn
    }
  }, [_c('span', [_vm._v("立即充值")])]), _vm._v(" "), (_vm.hintBox.stateShow) ? _c('xk-hint-box', {
    attrs: {
      "state": _vm.hintBox.state,
      "content": _vm.hintBox.content
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "friendOrder"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("您成功推荐了"), _c('span', [_vm._v(_vm._s(_vm.total))]), _vm._v("位好友")]), _vm._v(" "), _c('p', {
    staticClass: "content-divide"
  }, [_vm._v("返利明细")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.content.length > 0),
      expression: "content.length > 0"
    }],
    staticClass: "content-inner",
    on: {
      "scroll": _vm.scrollFn
    }
  }, _vm._l((_vm.content), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "content-item"
    }, [_c('div', {
      staticClass: "content-item-text"
    }, [_c('span', {
      staticClass: "phone"
    }, [_vm._v(_vm._s(item.phone))]), _vm._v(" "), _c('span', {
      staticClass: "money"
    }, [_vm._v("￥" + _vm._s(item.money))])]), _vm._v(" "), _c('div', {
      staticClass: "content-item-text"
    }, [_c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("time")(item.created)))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "100px",
      "color": "#cccccc"
    }
  }, [_vm._v("暂无数据")])])])
},staticRenderFns: []}

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recordDaiJia"
  }, [_c('v5-mirco-tabs', {
    attrs: {
      "tabs": _vm.tabs,
      "active": _vm.active
    },
    on: {
      "update:active": function($event) {
        _vm.active = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "daijiaContent"
  }, [(_vm.orderList && _vm.orderList.length > 0) ? _c('div', {
    staticClass: "contentList"
  }, _vm._l((_vm.orderList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "ListItem",
      on: {
        "click": function($event) {
          return _vm.clickFn(item)
        }
      }
    }, [_c('div', {
      staticClass: "itemContent"
    }, [_c('div', {
      staticClass: "item-row"
    }, [_c('div', {
      staticClass: "itemTime"
    }, [_vm._v(_vm._s(item.orderTypeName))]), _vm._v(" "), _c('div', {
      staticClass: "itemStatus"
    }, [_c('i', {
      staticClass: "iconfont icon-jiantou"
    }), _vm._v(" "), _c('span', {
      staticClass: "text",
      class: item.status === 1 ? 'textRed' : 'textAsh'
    }, [_vm._v(_vm._s(_vm._f("orderStatusFilter")(item.status)))])])]), _vm._v(" "), _c('div', {
      staticClass: "item-time"
    }, [_c('i', {
      staticClass: "iconfont icon-shijian1"
    }), _vm._v(" "), _c('span', {
      staticClass: "site"
    }, [_vm._v(_vm._s(_vm._f("time")(item.book_time)))])]), _vm._v(" "), _c('div', {
      staticClass: "item-address"
    }, [_c('i', {
      staticClass: "yuan"
    }), _vm._v(" "), _c('span', {
      staticClass: "site"
    }, [_vm._v(_vm._s(item.book_address))])]), _vm._v(" "), _c('div', {
      staticClass: "item-address"
    }, [_c('i', {
      staticClass: "yuan color-red"
    }), _vm._v(" "), _c('span', {
      staticClass: "site"
    }, [_vm._v(_vm._s(item.destination))])]), _vm._v(" "), (item.order_no) ? _c('div', {
      staticClass: "item-order"
    }, [_c('span', {
      staticClass: "site"
    }, [_vm._v("订单号：" + _vm._s(item.order_no))])]) : _vm._e()])])
  }), 0) : _c('div', {
    staticClass: "NullOrder"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(452)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "imgBut"
  }, [_c('router-link', {
    attrs: {
      "to": "/daijia"
    }
  }, [_vm._v("去下单")])], 1)])]), _vm._v(" "), (_vm.orderList && _vm.orderList.length < _vm.total && _vm.orderList.length > 0) ? _c('div', {
    staticClass: "loadDataBut"
  }, [_c('span', {
    on: {
      "click": _vm.loadDataButFn
    }
  }, [_vm._v("点击加载更多")])]) : _vm._e()]), _vm._v(" "), _c('xk-upload-mod', {
    attrs: {
      "state": _vm.loadState
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "serviceAgreement"
  }, [_c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.infoData)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navTabs"
  }, [_c('div', {
    staticClass: "Content"
  }, [_c('ul', {
    staticClass: "clear",
    style: ([_vm.ulWidth])
  }, _vm._l((_vm.data && _vm.data.length > 0 ? _vm.data : null), function(item, index) {
    return _c('li', {
      ref: "navTabsLi",
      refInFor: true,
      staticClass: "navTabsLi",
      class: _vm.pathFn === item.url ? 'navTabsLiAc' : '',
      style: ([_vm.liWidth]),
      on: {
        "click": function($event) {
          return _vm.actionFn(item)
        }
      }
    }, [_c('span', {
      staticClass: "val"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sideMenus",
    class: {
      'showSideMenus': _vm.sideMenusState
    }
  }, [_c('div', {
    staticClass: "sideMenusContent"
  }, [_c('div', {
    staticClass: "personInfo",
    on: {
      "click": _vm.compileNomFn
    }
  }, [_c('div', {
    staticClass: "personInfo-inner"
  }, [_c('div', {
    staticClass: "headImg"
  }, [(_vm.upImgFn) ? _c('img', {
    attrs: {
      "src": _vm.upImgFn,
      "alt": "头像"
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/img/default_pic.png",
      "alt": "头像"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "vipRank"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/star.png",
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.loginData && _vm.loginData.grade ? _vm.loginData.grade.grade_name : '') + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h2', {
    staticClass: "infoName"
  }, [_vm._v(_vm._s(_vm.loginData && _vm.loginData.passenger ? _vm.loginData.passenger.name : ''))]), _vm._v(" "), _c('p', {
    staticClass: "infoName"
  }, [_vm._v(_vm._s(_vm.loginData && _vm.loginData.passenger ? _vm.loginData.passenger.enterprise_name : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "menusOption"
  }, [_c('ul', [_c('li', {
    on: {
      "click": _vm.sideMenusFn
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/orderRecord"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": "/static/img/order.png",
      "alt": ""
    }
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v("我的订单")])]), _vm._v(" "), _c('img', {
    staticClass: "arrows",
    attrs: {
      "src": "/static/img/arrows.png",
      "alt": ""
    }
  })], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.sideMenusFn
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mewallet'
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": "/static/img/wallet.png",
      "alt": ""
    }
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v("我的钱包")])]), _vm._v(" "), _c('img', {
    staticClass: "arrows",
    attrs: {
      "src": "/static/img/arrows.png",
      "alt": ""
    }
  })], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.sideMenusFn
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/qrCode'
    }
  }, [_c('i', {
    staticClass: "iconfont icon-erweima"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v("我的二维码")])]), _vm._v(" "), _c('img', {
    staticClass: "arrows",
    attrs: {
      "src": "/static/img/arrows.png",
      "alt": ""
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "bottomMeuns"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "informBut",
    on: {
      "click": _vm.sideMenusFn
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/inform"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-tongzhi"
  })]), _vm._v(" "), (_vm.imformNum.content !== '') ? _c('xk-badge-mod', {
    attrs: {
      "text": _vm.imformNum.num
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "shareBut",
    on: {
      "click": _vm.sideMenusFn
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/friend"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-fenxiang"
  })])], 1), _vm._v(" "), _c('span', {
    staticClass: "setBut",
    on: {
      "click": _vm.sideMenusFn
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shezhi"
  })])], 1), _vm._v(" "), _c('span', {
    staticClass: "contentText"
  }, [_vm._v("邀请好友")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    on: {
      "click": _vm.sideMenusFn
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "couponMod",
    class: _vm.status == 1 ? 'useCouponMod' : ''
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "left"
  }, [(_vm.couponType === 'deduction') ? _c('span', {
    staticClass: "content"
  }, [_c('h2', [_c('span', [_vm._v("￥")]), _vm._v(" "), _c('span', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.sum.split('.')[0]))]), _c('span', [_vm._v("." + _vm._s(_vm.sum.split('.')[1]))])]), _vm._v(" "), _c('p', [_vm._v("优惠券")])]) : _c('span', {
    staticClass: "content"
  }, [_c('h2', [_c('span', {
    staticClass: "sum"
  }, [_vm._v(_vm._s((_vm.sum / 10).toFixed(1)))]), _vm._v("折")]), _vm._v(" "), _c('p', [_vm._v("打折券")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: _vm.backgroundFn
  }, [_c('div', {
    staticClass: "business"
  }, [_vm._v("\n        " + _vm._s(_vm.serviceType) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._v("有效时间\n          "), _c('span', [_vm._v(_vm._s(_vm.startTime))]), _vm._v("\n          ~\n          "), _c('span', [_vm._v(_vm._s(_vm.endTime))])])])])]), _vm._v(" "), (_vm.useState === 1) ? _c('div', {
    staticClass: "bottom"
  }, [(_vm.overdueTime !== '') ? _c('span', [_vm._v(_vm._s(_vm.overdueTime !== '永久有效' ? _vm.overdueTime : '永久'))]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.overdueTime !== '永久有效' ? (_vm.overdueTime && _vm.overdueTime !== '' ? '后过期' : '已过期') : '有效') + "\n  ")]) : (_vm.useState === 2) ? _c('div', {
    staticClass: "bottom"
  }, [_vm._v("\n    已使用\n  ")]) : (_vm.useState === 3) ? _c('div', {
    staticClass: "bottom"
  }, [_vm._v("\n    已失效\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coupon"
  }, [_c('xk-coupon-nav', {
    attrs: {
      "data": _vm.navDataFn
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "couponContent"
  }, [_c('router-view')], 1), _vm._v("\n  " + _vm._s(_vm.v5zcCoupon) + "\n")], 1)
},staticRenderFns: []}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoiceRecordMod"
  }, [_c('div', {
    staticClass: "page clear page1"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "val",
    staticStyle: {
      "color": "#333",
      "font-size": "1.1rem"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.timeFn) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "status",
    class: _vm.stateFn === '待开' ? 'statusShow' : ''
  }, [_vm._v("\n      " + _vm._s(_vm.stateFn) + "\n      "), _c('span', {
    staticClass: "iconfont icon-jiantou"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "page clear page2"
  }, [_c('div', {
    staticClass: "title"
  }), _vm._v(" "), _c('div', {
    staticClass: "val",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.type) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "page clear page3"
  }, [_c('div', {
    staticClass: "title"
  }), _vm._v(" "), _c('div', {
    staticClass: "val",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.memo) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "sum"
  }, [_vm._v("\n      " + _vm._s(_vm.sum)), _c('span', {
    staticStyle: {
      "font-size": "1rem",
      "margin-left": ".2rem"
    }
  }, [_vm._v("元")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "iconfont icon-shijian1"
  })])
}]}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modalMod",
    style: ({
      'z-index': _vm.modalModState ? _vm.zIndex : '-100',
      'opacity': _vm.modalModState ? (_vm.opacity ? _vm.opacity : '0') : '0'
    }),
    on: {
      "click": _vm.modalModFn
    }
  })
},staticRenderFns: []}

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upAvatar"
  }, [(_vm.mobileState.iPhone) ? _c('input', {
    ref: "inputImg",
    staticClass: "inputImg",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.fileFn1
    }
  }) : (_vm.mobileState.Android) ? _c('input', {
    ref: "inputImg",
    staticClass: "inputImg",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.fileFn1
    }
  }) : _c('input', {
    ref: "inputImg",
    staticClass: "inputImg",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.fileFn1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "img"
  }, [(_vm.imgUrls && _vm.imgUrls.length > 0) ? _c('img', {
    attrs: {
      "src": _vm.imgUrlFn
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(66)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "replaceBut",
    on: {
      "click": _vm.AddFn
    }
  }, [_vm._v("\n      上传头像\n    ")])]), _vm._v(" "), (_vm.loadSate) ? _c('xk-upload-mod', {
    attrs: {
      "state": _vm.loadSate
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal",
    on: {
      "click": _vm.modalFn
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "share-qrcode"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "bottom-code"
  }, [_c('xk-qr-code', {
    attrs: {
      "val": _vm.url
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("扫码分享，即刻下单")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "QrCode"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/qr_bg.png",
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score"
  }, [_vm._v("\n  " + _vm._s(_vm.stateShowFn) + "\n  "), _c('ul', {
    staticClass: "clear"
  }, _vm._l((_vm.stars), function(item) {
    return _c('li', [_c('span', {
      staticClass: "star",
      class: _vm.score >= item.score ? 'starAc' : '',
      on: {
        "click": function($event) {
          return _vm.starsFn(item.score)
        }
      }
    })])
  }), 0), _vm._v(" "), (_vm.isShow) ? _c('div', {
    staticClass: "text"
  }, [_c('p', {
    class: _vm.score <= 0 ? 'textAsh' : ''
  }, [_vm._v(_vm._s(_vm.msg))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "numberSelect"
  })
},staticRenderFns: []}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "bannerContent",
    staticClass: "bannerContent",
    domProps: {
      "innerHTML": _vm._s(_vm.bannerContentFn)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "couponNav"
  }, [_c('ul', {
    staticClass: "clear"
  }, _vm._l((_vm.data), function(item, index) {
    return _c('li', {
      class: _vm.actionFn === index ? 'actionLi' : ''
    }, [_c('router-link', {
      attrs: {
        "to": item.router
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stale"
  }, [_c('div', {
    staticClass: "staleContent"
  }, [(_vm.couponsFn && _vm.couponsFn.length) ? _c('div', _vm._l((_vm.couponsFn), function(item, index) {
    return _c('xk-couponMod', {
      key: index,
      attrs: {
        "type": item.type,
        "sum": item.sum,
        "title": item.title,
        "startTime": item.startTime,
        "endTime": item.endTime,
        "overdueTime": item.overdueTime,
        "couponType": item.couponType,
        "status": 1,
        "useState": 3,
        "serviceType": item.serviceType
      }
    })
  }), 1) : _c('div', {
    staticClass: "shixiao"
  }, [_c('h2', [_vm._v("\n        暂无失效优惠券记录\n      ")])])]), _vm._v(" "), (_vm.hintBox.stateShow) ? _c('xk-hint-box', {
    attrs: {
      "state": _vm.hintBox.state,
      "content": _vm.hintBox.content
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Add"
  }, [_c('div', {
    staticClass: "row row1 clear"
  }, [_c('i', {
    staticClass: "iconfont icon-shijian"
  }), _vm._v(" "), _c('span', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.time))])]), _vm._v(" "), _c('div', {
    staticClass: "row row2 clear"
  }, [_c('i', {
    staticClass: "iconfont icon-yuan"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.origin))])]), _vm._v(" "), _c('div', {
    staticClass: "waypoint"
  }, _vm._l((_vm.waypoint), function(item, index) {
    return _c('div', {
      staticClass: "row clear",
      class: item.arrive ? 'arrive' : ''
    }, [_c('i', {
      staticClass: "iconfont icon-yuan1"
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.address))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row row3 clear"
  }, [_c('i', {
    staticClass: "iconfont icon-yuan"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.endPoint))])])])
},staticRenderFns: []}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "capitalRecord"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.customerPreSaveSerials && _vm.customerPreSaveSerials.length > 0) ? _c('div', [_vm._l((_vm.customerPreSaveSerials), function(item, index) {
    return _c('xk-capital-record-list', {
      key: index,
      attrs: {
        "time": _vm.$utils.TimestampDate(item.time),
        "sum": item.cost ? item.cost.toFixed(1) : 0,
        "type": item.style
      },
      on: {
        "click": function($event) {
          return _vm.actionFn(item.memo)
        }
      }
    })
  }), _vm._v(" "), (_vm.capitalRecords.content.length < _vm.capitalRecords.totalElements) ? _c('div', {
    staticClass: "queryList",
    on: {
      "click": _vm.loadButFn
    }
  }, [_c('span', [_vm._v("加载更多信息")])]) : _vm._e()], 2) : _c('div', {
    staticClass: "zanwujilv"
  }, [_c('h2', [_vm._v("暂无资金流水记录")])])]), _vm._v(" "), _c('xk-upload-mod', {
    attrs: {
      "state": _vm.loadState
    }
  }), _vm._v(" "), (_vm.text !== '') ? _c('xk-alert-box', {
    attrs: {
      "text": _vm.text
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "unused",
    staticClass: "unused"
  }, [(_vm.couponsFn.length > 0) ? _c('div', {
    ref: "Content",
    staticClass: "unusedContent",
    class: _vm.addStateBut ? 'unusedContentFixe' : ''
  }, _vm._l((_vm.couponsFn), function(item, index) {
    return _c('xk-couponMod', {
      key: index,
      attrs: {
        "type": item.type,
        "sum": item.sum,
        "title": item.title,
        "startTime": item.startTime,
        "endTime": item.endTime,
        "overdueTime": item.overdueTime,
        "useState": 1,
        "couponType": item.couponType,
        "serviceType": item.servicetype
      }
    })
  }), 1) : _c('div', {
    staticClass: "wuyouhuiquan"
  }, [_c('h2', [_vm._v("暂无优惠券")])]), _vm._v(" "), _c('div', {
    staticClass: "addCoupon",
    class: _vm.addStateBut ? 'fixe' : '',
    on: {
      "click": _vm.addCouponFn
    }
  }, [_c('span', [_vm._v("添加优惠券")])]), _vm._v(" "), (_vm.addState) ? _c('xk-input-box', {
    attrs: {
      "title": '添加优惠券',
      "closeState": true
    },
    on: {
      "click": _vm.addCouponFn
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.couponNum),
      expression: "couponNum"
    }],
    attrs: {
      "placeholder": "请输入优惠券编码"
    },
    domProps: {
      "value": (_vm.couponNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.couponNum = $event.target.value
      }, _vm.couponNumFn]
    }
  })])]) : _vm._e(), _vm._v(" "), _c('xk-upload-mod', {
    attrs: {
      "state": _vm.loadState
    }
  }), _vm._v(" "), (_vm.hintBox.stateShow) ? _c('xk-hintBox', {
    attrs: {
      "time": 1500,
      "state": _vm.hintBox.state,
      "content": _vm.hintBox.content
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lineSelect"
  })
},staticRenderFns: []}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "affirm"
  }, [_c('div', {
    staticClass: "grade"
  }, [_c('div', {
    staticClass: "grade-text"
  }, [_vm._v("您的评价会让司机做的更好")]), _vm._v(" "), _c('div', {
    staticClass: "grade-star"
  }, [_c('xk-star', {
    attrs: {
      "defScore": 5,
      "isShow": _vm.isShow,
      "disabled": _vm.disabled
    },
    on: {
      "clickChange": _vm.starFn
    }
  })], 1), _vm._v(" "), (_vm.status !== 40 || _vm.remark) ? _c('div', {
    staticClass: "remark"
  }, [_c('div', {
    staticClass: "remark-text"
  }, [_vm._v("您的意见")]), _vm._v(" "), (!_vm.disabled) ? _c('div', {
    staticClass: "textarea"
  }, [_vm._v(_vm._s(_vm.remark))]) : _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remark),
      expression: "remark"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "请输入您宝贵的意见或建议，以便于帮助我们改善服务 质量",
      "maxlength": "60"
    },
    domProps: {
      "value": (_vm.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remark = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.status !== 40) ? _c('div', {
    staticClass: "submit"
  }, [_c('span', {
    on: {
      "click": _vm.submitFn
    }
  }, [_vm._v("提交评价")])]) : _vm._e(), _vm._v(" "), (_vm.hintBox.state) ? _c('xk-hint-Box', {
    attrs: {
      "time": 1500,
      "state": _vm.hintBox.showState,
      "content": _vm.hintBox.content
    }
  }) : _vm._e(), _vm._v(" "), _c('xk-upload-mod', {
    attrs: {
      "state": _vm.loadState
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrCodeScan"
  }, [_c('canvas', {
    ref: "qr",
    style: ({
      height: _vm.size + '%',
      width: _vm.size + '%'
    }),
    attrs: {
      "height": _vm.size,
      "width": _vm.size,
      "val": _vm.val
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meWallet"
  }, [_c('div', {
    staticClass: "balance"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("账户余额（元）")]), _vm._v(" "), _c('h2', [_vm._v("\n        " + _vm._s(((_vm.postCustomerPreSave.present_balance || 0) + (_vm.postCustomerPreSave.non_present_balance || 0)).toFixed(2)))]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), (_vm.wxState) ? _c('div', {
    staticClass: "balanceBut"
  }, [_c('span', {
    staticClass: "But"
  }, [_c('router-link', {
    attrs: {
      "to": "/recharge"
    }
  }, [_vm._v("充值")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page1 page"
  }, [_c('ul', {
    staticClass: "pageItme"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": '/capitalRecord'
    }
  }, [_c('span', {
    staticClass: "Icon"
  }, [_c('i', {
    staticClass: "iconfont icon-zijinmingxi"
  })]), _vm._v("\n          资金流水\n          "), _c('i', {
    staticClass: "iconfont icon-jiantou"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/coupon/nused'
    }
  }, [_c('span', {
    staticClass: "Icon"
  }, [_c('i', {
    staticClass: "iconfont icon-youhuiquanicon"
  })]), _vm._v("\n          优惠券\n          "), _c('i', {
    staticClass: "iconfont icon-jiantou"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.couponData.length) + "张")])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "iconfont icon-gth"
  }), _vm._v("支付费用时优先使用")])
}]}

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoiceApply"
  }, [_c('div', {
    staticClass: "row row1"
  }, [_c('div', {
    staticClass: "row-title"
  }, [_vm._v("\n      请选择发票类型\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row-val"
  }, [_c('div', {
    staticClass: "val-col",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "col-val"
  }, [_c('div', {
    staticClass: "radio-but",
    attrs: {
      "ac": _vm.form.invoices_type == 1
    },
    on: {
      "click": function($event) {
        _vm.form.invoices_type = 1
      }
    }
  }, [_vm._v("\n            电子发票\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "radio-but",
    attrs: {
      "ac": _vm.form.invoices_type == 2
    },
    on: {
      "click": function($event) {
        _vm.form.invoices_type = 2
      }
    }
  }, [_vm._v("\n            纸质发票\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row row2"
  }, [_c('div', {
    staticClass: "row-title"
  }, [_vm._v("\n      发票详情\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row-val"
  }, [_c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          抬头类型\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.form.title_type = 1
      }
    }
  }, [_c('div', {
    staticClass: "radio-round-but",
    attrs: {
      "ac": _vm.form.title_type == 1
    }
  }, [_c('i', {
    staticClass: "iconfont icon-chenggong"
  })]), _vm._v("\n            企业抬头\n          ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "1rem"
    },
    on: {
      "click": function($event) {
        _vm.form.title_type = 2
      }
    }
  }, [_c('div', {
    staticClass: "radio-round-but",
    attrs: {
      "ac": _vm.form.title_type == 2
    }
  }, [_c('i', {
    staticClass: "iconfont icon-chenggong"
  })]), _vm._v("\n            个人/非企业单位\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          发票抬头\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.title),
      expression: "form.title"
    }],
    attrs: {
      "placeholder": "请输入公司全称"
    },
    domProps: {
      "value": (_vm.form.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          纳税人识别号\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.taxpayer_number),
      expression: "form.taxpayer_number"
    }],
    attrs: {
      "placeholder": "请输入纳税人识别号"
    },
    domProps: {
      "value": (_vm.form.taxpayer_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "taxpayer_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          发票内容\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.invoices_memo),
      expression: "form.invoices_memo"
    }],
    attrs: {
      "placeholder": "请输入发票内容"
    },
    domProps: {
      "value": (_vm.form.invoices_memo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "invoices_memo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          开票金额\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.invoices_amount),
      expression: "form.invoices_amount"
    }],
    attrs: {
      "placeholder": "可开票额度998.0元"
    },
    domProps: {
      "value": (_vm.form.invoices_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "invoices_amount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          更多信息\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.more_info),
      expression: "form.more_info"
    }],
    attrs: {
      "placeholder": "请输入备注，开户行信息等"
    },
    domProps: {
      "value": (_vm.form.more_info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "more_info", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row row3"
  }, [_c('div', {
    staticClass: "row-title"
  }, [_vm._v("\n      收件信息\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row-val"
  }, [(_vm.form.invoices_type == 2) ? _c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          收件人\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.addressee),
      expression: "form.addressee"
    }],
    attrs: {
      "placeholder": "请输入收件人"
    },
    domProps: {
      "value": (_vm.form.addressee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "addressee", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.form.invoices_type == 2) ? _c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          联系电话\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.telephone),
      expression: "form.telephone"
    }],
    attrs: {
      "placeholder": "请输入联系电话"
    },
    domProps: {
      "value": (_vm.form.telephone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "telephone", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.form.invoices_type == 2) ? _c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          所在地区\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.area),
      expression: "form.area"
    }],
    attrs: {
      "placeholder": "请输入所在地区"
    },
    domProps: {
      "value": (_vm.form.area)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "area", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.form.invoices_type == 2) ? _c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          详细地址\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.address),
      expression: "form.address"
    }],
    attrs: {
      "placeholder": "请输入详细地址"
    },
    domProps: {
      "value": (_vm.form.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "address", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.form.invoices_type == 1) ? _c('div', {
    staticClass: "val-col"
  }, [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n          电子邮件\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    attrs: {
      "placeholder": "请输入电子邮件"
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  })])]) : _vm._e()])]), _vm._v(" "), (_vm.form.invoices_type == 2) ? _c('div', {
    staticClass: "row row5"
  }, [_c('div', {
    staticClass: "row-title"
  }, [_vm._v("\n      支付方式\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row-val"
  }, [_c('div', {
    staticClass: "val-col"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-val",
    staticStyle: {
      "text-align": "right"
    },
    on: {
      "click": function($event) {
        _vm.form.postage_pay_way = 1
      }
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("（全国8元，邮费发票会一同邮寄）")]), _vm._v(" "), _c('div', {
    staticClass: "radio-round-but",
    attrs: {
      "ac": _vm.form.postage_pay_way == 1
    }
  }, [_c('i', {
    staticClass: "iconfont icon-chenggong"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "val-col"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-val",
    staticStyle: {
      "text-align": "right"
    },
    on: {
      "click": function($event) {
        _vm.form.postage_pay_way = 2
      }
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("（全国8元，邮费发票会一同邮寄）")]), _vm._v(" "), _c('div', {
    staticClass: "radio-round-but",
    attrs: {
      "ac": _vm.form.postage_pay_way == 2
    }
  }, [_c('i', {
    staticClass: "iconfont icon-chenggong"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "val-col"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-val",
    staticStyle: {
      "text-align": "right"
    },
    on: {
      "click": function($event) {
        _vm.form.postage_pay_way = 3
      }
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("（全国10元，邮费发票会一同邮寄）")]), _vm._v(" "), _c('div', {
    staticClass: "radio-round-but",
    attrs: {
      "ac": _vm.form.postage_pay_way == 3
    }
  }, [_c('i', {
    staticClass: "iconfont icon-chenggong"
  })])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "but"
  }, [_vm._v("申请开票")]), _vm._v(" "), (_vm.hintBox.stateShow) ? _c('xk-hint-box', {
    attrs: {
      "state": _vm.hintBox.state,
      "content": _vm.hintBox.content
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-label"
  }, [_c('i', {
    staticClass: "iconfont icon-weixinzhifu",
    staticStyle: {
      "color": "#51b234"
    }
  }), _vm._v("微信支付\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-label"
  }, [_c('i', {
    staticClass: "iconfont icon-yuezhifu",
    staticStyle: {
      "color": "#4394d5"
    }
  }), _vm._v("余额支付\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-label"
  }, [_c('i', {
    staticClass: "iconfont icon-huodaofukuan",
    staticStyle: {
      "color": "#4394d5"
    }
  }), _vm._v("货到付款\n        ")])
}]}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "badgeMod"
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkOrder"
  }, [_c('xk-waiter', {
    attrs: {
      "src": '../../../../assets/img/yonghu/touxiang.jpg',
      "name": _vm.DjOrderInfo ? _vm.DjOrderInfo.driverName : '',
      "headImg": _vm.DjOrderInfo ? _vm.DjOrderInfo.driverPhoto : ''
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "money"
  }, [_c('h2', [_c('span', {
    staticClass: "max"
  }, [_vm._v(_vm._s(_vm.DjPayInfo ? _vm.DjPayInfo.payMoney.toFixed(1).split('.')[0] : '0'))]), _vm._v(" "), _c('span', [_vm._v("." + _vm._s(_vm.DjPayInfo && _vm.DjPayInfo.payMoney ? _vm.DjPayInfo.payMoney.toFixed(1).split('.')[1] : '0') + "元")])]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', {
    on: {
      "click": _vm.detailsBoxFn
    }
  }, [_c('i', {
    staticClass: "iconfont icon-iconfontyiwen"
  }), _vm._v("查看明细")])]), _vm._v(" "), _c('xk-star', {
    attrs: {
      "defScore": _vm.DjQueryReview ? _vm.DjQueryReview.score : 5,
      "state": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, _vm._l((_vm.DjQueryReview ? _vm.DjQueryReview.tabs : null), function(item, index) {
    return _c('xk-tag-item', {
      key: index,
      attrs: {
        "name": item,
        "AcState": false
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "reviewContent"
  }, [_vm._v("\n      " + _vm._s(_vm.DjQueryReview && _vm.DjQueryReview.reviewContent && _vm.DjQueryReview.reviewContent !== '' ? _vm.DjQueryReview.reviewContent : '暂无评价') + "\n    ")])], 1), _vm._v(" "), _c('Xk-detailsBox', {
    ref: "detailsBox",
    staticClass: "costBox",
    attrs: {
      "title": '费用详情'
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', _vm._l((_vm.payDataFn), function(itme) {
    return (itme.val !== 0) ? _c('li', {
      staticClass: "clear"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(itme.name))]), _vm._v(" "), _c('span', {
      staticClass: "val"
    }, [_c('span', {
      staticClass: "sum"
    }, [_vm._v(_vm._s(itme.val))]), _c('span', {
      staticClass: "unit"
    }, [_vm._v("元")])]), _vm._v(" "), (itme.time) ? _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(itme.time)), _c('span', {
      staticClass: "unit"
    }, [_vm._v("分钟")])]) : _vm._e()]) : _vm._e()
  }), 0)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.state) ? _c('div', {
    staticClass: "alertBox",
    class: _vm.state ? 'alertBoxShow' : ''
  }, [_c('div', {
    staticClass: "alertBoxCont"
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.state) ? _c('div', {
    staticClass: "uploadMod"
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "uploadIcon"
  }, [_c('div', {
    staticClass: "rect1 rect"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect2 rect"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect3 rect"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect4 rect"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect5 rect"
  })])
}]}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showPicker) ? _c('div', {
    attrs: {
      "id": "myPicker"
    }
  }, [_c('div', {
    staticClass: "moda"
  }), _vm._v(" "), _c('div', {
    staticClass: "pickerContainer"
  }, [_c('div', {
    staticClass: "bar"
  }, [_c('span', {
    staticClass: "cancelBtn",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "sureBtn",
    on: {
      "click": _vm.sure
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('div', {
    staticClass: "lines"
  }), _vm._v(" "), _c('mt-picker', {
    ref: "picker",
    attrs: {
      "slots": _vm.slots,
      "value-key": "name"
    },
    on: {
      "change": _vm.onValuesChange
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "waiter clear"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "TitleImg"
  }, [(_vm.headImg && _vm.headImg !== '') ? _c('img', {
    attrs: {
      "src": _vm.imgShowAddressFront + _vm.headImg + _vm.imgShowAddressEndFirst + "/w/50/h/50" + _vm.imgShowAddressEndSecond,
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(66)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "row row1"
  }, [_c('span', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.sex))])]), _vm._v(" "), (_vm.carName) ? _c('div', {
    staticClass: "row row3"
  }, [_c('span', {
    staticClass: "carName"
  }, [_vm._v("\n        " + _vm._s(_vm.carName) + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "carColor"
  }, [_vm._v("\n        " + _vm._s(_vm.carColor) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.location) ? _c('div', {
    staticClass: "row row2"
  }, [_vm._v("\n      " + _vm._s(_vm.location) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.carNo) ? _c('div', {
    staticClass: "row row3"
  }, [_c('span', {
    staticClass: "carNo"
  }, [_vm._v("\n          " + _vm._s(_vm.carNo) + "\n        ")]), _vm._v(" "), (_vm.carType) ? _c('span', {
    staticClass: "waiterCarType"
  }, [_vm._v("\n          " + _vm._s(_vm.carType) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.paotuiType) ? _c('div', {
    staticClass: "row row3"
  }, [_c('span', {
    staticClass: "paotuiType"
  }, [_vm._v("\n          " + _vm._s(_vm.paotuiType) + "\n        ")])]) : _vm._e()]), _vm._v(" "), (_vm.phone) ? _c('span', {
    staticClass: "waiterPhone"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.phone
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dianhua1"
  })])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "capitalRecordList",
    on: {
      "click": _vm.clickFn
    }
  }, [_c('div', {
    staticClass: "rows time"
  }, [_c('span', {
    staticClass: "time"
  }, [_vm._v("\n      " + _vm._s(_vm.time) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "rows clear"
  }, [_c('span', {
    staticClass: "Type"
  }, [_vm._v("\n      " + _vm._s(_vm.type) + "\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "Sum",
    class: _vm.sum < 0 ? 'SumRed' : ''
  }, [_vm._v("\n      " + _vm._s(_vm.sum) + "元\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoice"
  }, [_c('div', {
    staticClass: "invoice-type"
  }, [_c('div', {
    staticClass: "type-row"
  }, [(_vm.servesTypeNav.length > 1) ? _c('span', {
    staticClass: "row-col",
    attrs: {
      "ac": _vm.allState
    },
    on: {
      "click": _vm.typeColAllAcFn
    }
  }, [_vm._v("全部")]) : _vm._e(), _vm._v(" "), _vm._l(((_vm.servesTypeNav || [])), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "row-col",
      attrs: {
        "ac": _vm.ids.includes(item.business)
      },
      on: {
        "click": function($event) {
          return _vm.typeColAcFn(item.business)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "type-but",
    attrs: {
      "ac": Boolean(_vm.ids)
    },
    on: {
      "click": _vm.invoicePayFn
    }
  }, [_vm._v("去开票")])]), _vm._v(" "), _c('div', {
    staticClass: "operating"
  }, [_c('div', {
    staticClass: "opt-row",
    on: {
      "click": function($event) {
        return _vm.routerAcFn('/invoiceRecord')
      }
    }
  }, [_vm._v("\n      开票记录\n      "), _c('i', {
    staticClass: "iconfont icon-jiantou"
  })]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opt-row"
  }, [_vm._v("\n      开票规则\n      "), _c('i', {
    staticClass: "iconfont icon-jiantou"
  })])
}]}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inform"
  }, [_c('div', {
    staticClass: "informContent"
  }, [(_vm.content.length > 0) ? _c('pull-to', {
    attrs: {
      "bottom-load-method": _vm.bottomChangeFn,
      "top-load-method": _vm.topChangeFn
    }
  }, [_c('ul', _vm._l((_vm.content), function(item, index) {
    return _c('xk-inform-time-mod', {
      key: index,
      attrs: {
        "time": item ? item.created : null,
        "content": item ? item.content : null
      }
    })
  }), 1)]) : _c('div', {
    staticClass: "wujilv"
  }, [_c('h2', [_vm._v("暂无消息通知")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "daijiaAwait"
  }, [_c('div', {
    staticClass: "AwaitContent"
  }, [_c('div', {
    staticClass: "page page1"
  }, [_c('div', {
    staticClass: "upload"
  }, [_c('div', {
    staticClass: "imgCircle"
  }, [_c('img', {
    style: ({
      transform: 'rotate(' + _vm.rotateVal + 'deg)'
    }),
    attrs: {
      "src": __webpack_require__(453)
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "awaitText"
  }, [_vm._v("等待中")])]), _vm._v(" "), _c('h2', [_vm._v("\n        请稍等正在为您联络司机\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "cancelBut",
    on: {
      "click": _vm.cancelOrderFn
    }
  }, [_vm._v("取消订单")])]), _vm._v(" "), _c('xk-Add', {
    attrs: {
      "time": _vm.DjOrderInfo ? _vm.DjOrderInfo.book_time : '',
      "origin": _vm.DjOrderInfo ? _vm.DjOrderInfo.book_address : '',
      "endPoint": _vm.DjOrderInfo ? _vm.DjOrderInfo.destination : ''
    }
  })], 1), _vm._v(" "), (_vm.reson.state) ? _c('xk-input-box', {
    attrs: {
      "title": "取消订单理由",
      "closeState": true,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.cancelOrderFn
    }
  }, [_c('div', {
    staticClass: "DjCancelOrder",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reson.val),
      expression: "reson.val"
    }],
    attrs: {
      "maxlength": "50",
      "placeholder": "请输入取消订单理由"
    },
    domProps: {
      "value": (_vm.reson.val)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reson, "val", $event.target.value)
      }, _vm.inputContentFn]
    }
  })])]) : _vm._e(), _vm._v(" "), _c('xk-upload-mod', {
    attrs: {
      "state": _vm.loadState
    }
  }), _vm._v(" "), (_vm.hintBox.stateShow) ? _c('xk-hint-box', {
    attrs: {
      "state": _vm.hintBox.state,
      "content": _vm.hintBox.content
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "imgMan"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(454)
    }
  })])
}]}

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compileNom"
  }, [_c('div', {
    staticClass: "page1 page"
  }, [_c('div', {
    staticClass: "pageItem clear headItme"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('span', {
    staticClass: "headImg",
    on: {
      "click": _vm.upAvatarStateFn
    }
  }, [(_vm.avatar && _vm.avatar.length > 0) ? _c('img', {
    attrs: {
      "src": _vm.avatarFn
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(66)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "pageItem clear"
  }, [_c('div', {
    staticClass: "pageItemTitle"
  }, [_vm._v("\n        名字\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pageItemContent"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "placeholder": "请输入您的昵称"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pageItem clear"
  }, [_c('div', {
    staticClass: "pageItemTitle"
  }, [_vm._v("\n        性别\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pageItemContent"
  }, [_c('span', {
    staticClass: "genderSelect genderMan",
    class: _vm.gender ? 'ShowGenderSelect' : '',
    on: {
      "click": function($event) {
        return _vm.genderFn('男')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-nan"
  }), _vm._v("\n          男\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "genderSelect genderWoman",
    class: !_vm.gender ? 'ShowGenderSelect' : '',
    on: {
      "click": function($event) {
        return _vm.genderFn('女')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-xiangxiziliaonv"
  }), _vm._v("\n          女\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "pageItem clear"
  }, [_c('div', {
    staticClass: "pageItemTitle"
  }, [_vm._v("\n        手机号\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pageItemContent"
  }, [_c('input', {
    attrs: {
      "placeholder": "请输入您的手机号",
      "readonly": ""
    },
    domProps: {
      "value": _vm.phone && _vm.phone !== '' ? _vm.phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3') : ''
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "page2 page"
  }, [_c('div', {
    staticClass: "pageItem clear"
  }, [_c('div', {
    staticClass: "pageItemTitle"
  }, [_vm._v("\n        紧急联系人姓名\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pageItemContent"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.memberEcn),
      expression: "memberEcn"
    }],
    attrs: {
      "placeholder": "请输入您的紧急联系人姓名"
    },
    domProps: {
      "value": (_vm.memberEcn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.memberEcn = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pageItem clear"
  }, [_c('div', {
    staticClass: "pageItemTitle"
  }, [_vm._v("\n        紧急联系人电话\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pageItemContent"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.memberEcp),
      expression: "memberEcp"
    }],
    attrs: {
      "placeholder": "请输入您的紧急联系人电话"
    },
    domProps: {
      "value": (_vm.memberEcp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.memberEcp = $event.target.value
      }
    }
  })])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "pageItem clear"
  }, [_c('div', {
    staticClass: "pageItemTitle"
  }, [_vm._v("\n        常用目的地\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pageItemContent"
  }, [_c('xk-site-input', {
    attrs: {
      "placeholder": '请输入常用地',
      "name": _vm.alwaysAddShowFn
    },
    on: {
      "onClick": _vm.alwaysAddFn
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "saveItem",
    on: {
      "click": _vm.SaveButFn
    }
  }, [_c('span', {
    staticClass: "saveBut"
  }, [_vm._v("保存")])]), _vm._v(" "), (_vm.hintBox.stateShow) ? _c('xk-hint-box', {
    attrs: {
      "state": _vm.hintBox.state,
      "content": _vm.hintBox.content
    }
  }) : _vm._e(), _vm._v(" "), (_vm.upAvatarState) ? _c('xk-up-avatar', {
    attrs: {
      "phone": _vm.loginData.passenger ? _vm.loginData.passenger.phone : '',
      "imgUrl": _vm.avatar
    },
    on: {
      "change": _vm.upAvatarFn
    }
  }) : _vm._e(), _vm._v(" "), _c('xk-upload-mod', {
    attrs: {
      "state": _vm.BoxSave
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carType",
    class: _vm.state ? 'carTypeShow' : ''
  }, [_c('div', {
    staticClass: "carTypeCont"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      已选择\n      "), _c('span', {
    staticClass: "allNum"
  }, [_vm._v(_vm._s(_vm.ZcQueryCar.allNum))]), _vm._v("\n      辆\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.ZcQueryCar && _vm.ZcQueryCar.data && _vm.ZcQueryCar.data.length > 0) ? _c('div', _vm._l((_vm.ZcQueryCar.data), function(item, index) {
    return _c('div', {
      staticClass: "row clear",
      on: {
        "click": function($event) {
          return _vm.radioFn({
            type: 'radio',
            name: item.name,
            id: item.id,
            radio: _vm.radio,
            index: index,
            num: item.num
          })
        }
      }
    }, [(_vm.acNum === index && _vm.ZcQueryCar.allNum > 1 && item.num >= 1 && !_vm.radio) ? _c('span', {
      staticClass: "remove",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectFn({
            type: 'minus',
            name: item.name,
            id: item.id
          })
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-jian"
    })]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "val"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")]), _vm._v(" "), (item.num > 0) ? _c('span', {
      staticClass: "num"
    }, [_c('b', [_vm._v(_vm._s(item.num))]), _vm._v("\n          辆\n        ")]) : _vm._e()]), _vm._v(" "), (_vm.acNum === index && item.num < _vm.ZcQueryCar.maxNum && _vm.ZcQueryCar.allNum < 10 && !_vm.radio) ? _c('span', {
      staticClass: "push",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectFn({
            type: 'plus',
            name: item.name,
            id: item.id,
            radio: _vm.radio
          })
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-jia"
    })]) : _vm._e()])
  }), 0) : _c('div', {
    staticClass: "wucheliang"
  }, [_c('h2', [_vm._v("该公司暂无车辆")])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom clear"
  }, [_c('span', {
    staticClass: "but reset",
    class: _vm.ZcQueryCar.allNum > 0 ? 'resetShow' : '',
    on: {
      "click": function($event) {
        return _vm.selectFn({
          type: 'reset'
        })
      }
    }
  }, [_vm._v("\n        重置\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "but affirm",
    on: {
      "click": _vm.affirmFn
    }
  }, [_vm._v("\n        确定选择\n      ")])])]), _vm._v(" "), (_vm.state) ? _c('div', {
    staticClass: "modal",
    on: {
      "click": _vm.affirmFn
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoiceOrderRecord"
  }, [_c('pull-to', {
    attrs: {
      "top-load-method": _vm.topRefreshFn,
      "bottom-load-method": _vm.content.length >= _vm.total ? null : _vm.bottomRefreshFn
    }
  }, _vm._l((_vm.content), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "invoiceOrderRecord-row",
      attrs: {
        "ac": _vm.ids.includes(String(item.id))
      },
      on: {
        "click": function($event) {
          return _vm.orderClickFn(item)
        }
      }
    }, [_c('div', {
      staticClass: "row-cont"
    }, [_c('span', {
      staticClass: "row-check"
    }, [_c('i', {
      staticClass: "iconfont icon-chenggong"
    })]), _vm._v(" "), _c('div', {
      staticClass: "row-col"
    }, [_c('span', {
      staticClass: "iconfont icon-shijian1"
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.book_time))])]), _vm._v(" "), _c('div', {
      staticClass: "row-col"
    }, [_c('span', {
      staticClass: "iconfont icon-yuan",
      staticStyle: {
        "color": "#3cafb9"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.book_address))])]), _vm._v(" "), _c('div', {
      staticClass: "row-col"
    }, [_c('span', {
      staticClass: "iconfont icon-yuan",
      staticStyle: {
        "color": "#f06553"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.end_address))])])]), _vm._v(" "), _c('div', {
      staticClass: "row-money"
    }, [_c('span', {
      staticStyle: {
        "font-size": "2rem"
      }
    }, [_vm._v(_vm._s(item.total))]), _vm._v("元\n      ")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-top"
  }, [_c('span', {
    staticStyle: {
      "color": "#f06553"
    }
  }, [_vm._v(_vm._s(_vm.ids.split(',').length - 1))]), _vm._v("\n      个订单，共\n      "), _c('span', {
    staticStyle: {
      "color": "#f06553"
    }
  }, [_vm._v(_vm._s(_vm.moneys))]), _vm._v("\n      元\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-bottom"
  }, [_c('span', {
    on: {
      "click": _vm.allCheckFn
    }
  }, [_c('span', {
    staticClass: "all-check",
    attrs: {
      "ac": _vm.allButState
    }
  }, [_c('i', {
    staticClass: "iconfont icon-chenggong"
  })]), _vm._v("\n      全选\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "next",
    attrs: {
      "ac": _vm.nextButState
    },
    on: {
      "click": _vm.nextClickFn
    }
  }, [_vm._v("下一步")])])]), _vm._v(" "), _c('xk-upload-mod', {
    attrs: {
      "state": _vm.loadState
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unfilledOrderMod"
  }, [_c('div', {
    staticClass: "Content"
  }, [_c('div', {
    staticClass: "Title"
  }, [_c('h2', [_vm._v("您有未完成的" + _vm._s(_vm.title) + "订单")])]), _vm._v(" "), _c('div', {
    staticClass: "List"
  }, [_c('div', _vm._l((_vm.data ? _vm.data : null), function(time, index) {
    return _c('xk-record-order-mod', {
      key: index,
      attrs: {
        "startAddress": time.startAddress,
        "endAddress": time.endAddress,
        "serverTime": time.serverTime,
        "status": time.status,
        "orderId": time.orderId
      },
      on: {
        "recordOrderModClick": _vm.actionFn
      }
    })
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "closeBut",
    on: {
      "click": _vm.modalFn
    }
  }, [_c('span', [_vm._v("X")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    on: {
      "click": _vm.modalFn
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DaiJia"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.daijiaBanner && _vm.daijiaBanner.length > 0) ? _c('div', {
    staticClass: "banner"
  }, [_c('xk-roll-banner', {
    attrs: {
      "data": _vm.daijiaBanner
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "setSite"
  }, [_c('div', {
    staticClass: "typeNav"
  }, [(_vm.typeAll.data.length > 0) ? _c('xk-type-tabs', {
    attrs: {
      "cardata": _vm.typeAll,
      "defaultmum": 0
    },
    on: {
      "click": _vm.typeTabFn
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        “附近有 "), _c('span', {
    staticStyle: {
      "color": "#f06553"
    }
  }, [_vm._v(_vm._s(_vm.getNearDrivers.length || 0))]), _vm._v(" 位司机候驾”\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "row row1 clear"
  }, [_c('i', {
    staticClass: "iconfont icon-yuan"
  }), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_c('xk-site-input', {
    attrs: {
      "placeholder": "请输入起点位置",
      "name": _vm.positioning ? _vm.positioning.name : '',
      "state": true
    },
    on: {
      "onClick": _vm.startCityFn
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row row2 clear"
  }, [_c('i', {
    staticClass: "iconfont icon-yuan"
  }), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_c('xk-site-input', {
    attrs: {
      "placeholder": "请输入终点位置",
      "checkedlogin": "",
      "name": _vm.adds.endAdd.endAddress,
      "addressrecord": _vm.addressRecordFn,
      "state": true
    },
    on: {
      "onClick": _vm.endCityFn
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row row3 clear"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span', {
    staticClass: "list",
    class: _vm.others.othersPhone !== '' ? 'listAc' : '',
    staticStyle: {
      "display": "inline-flex",
      "vertical-align": "top",
      "justify-content": "center"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-mine"
  }), _vm._v(" "), _c('div', {
    staticClass: "listVal",
    on: {
      "click": function($event) {
        return _vm.othersPhoneFn('show')
      }
    }
  }, [(_vm.others.state) ? _c('p', [_vm._v("为别人叫")]) : _c('p', [_vm._v(_vm._s(_vm.others.recordPhone))])])]), _vm._v(" "), _c('span', {
    staticClass: "list listAc",
    staticStyle: {
      "display": "inline-flex",
      "vertical-align": "top",
      "justify-content": "center"
    },
    on: {
      "click": _vm.selectTimeFn
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shijian1"
  }), _c('p', [_vm._v(_vm._s(_vm.startTime.name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "totalNum clear"
  }, [_c('div', {
    staticClass: "row",
    on: {
      "click": _vm.chooseDriverFn
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', [_vm._v("选择")]), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.driverNumber))]), _c('span', [_vm._v("位司机")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('xk-coupon-select', {
    attrs: {
      "type": 'daijia',
      "data": _vm.djCoupnsGetter
    },
    on: {
      "click": _vm.couponSlelectFn
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "totalNum"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "line-height": "4.5rem"
    },
    on: {
      "click": _vm.detailsBoxFn
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.budgetFee) ? _c('span', [_vm._v(_vm._s(_vm.loginData && _vm.loginData.passenger ? '约' : '起步价'))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.budgetFee))]), _vm._v(" "), (_vm.budgetFee) ? _c('span', [_vm._v("元")]) : _vm._e(), _vm._v(" "), (_vm.budgetFee) ? _c('i', {
    staticClass: "iconfont icon-iconfontyiwen"
  }) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "callOutBut"
  }, [(!_vm.enterprise_id) ? _c('button', {
    class: {
      disable: _vm.loadState
    },
    attrs: {
      "disabled": _vm.loadState
    },
    on: {
      "click": function($event) {
        return _vm.callCarFn('private')
      }
    }
  }, [_vm._v("\n        一键下单\n      ")]) : _vm._e(), _vm._v(" "), (_vm.enterprise_id) ? _c('button', {
    class: {
      disable: _vm.loadState
    },
    attrs: {
      "disabled": _vm.loadState
    },
    on: {
      "click": function($event) {
        return _vm.callCarFn('private')
      }
    }
  }, [_vm._v("\n        个人出行\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.adds.endAdd.endLat && _vm.enterprise_id && _vm.ygcx && (_vm.is_fixed_price == 1)) ? _c('button', {
    class: {
      disable: _vm.loadState || _vm.enterpriseDisabled
    },
    attrs: {
      "disabled": _vm.loadState || _vm.enterpriseDisabled
    },
    on: {
      "click": function($event) {
        return _vm.callCarFn('official')
      }
    }
  }, [_vm._v("因公出行(一口价0元)\n      ")]) : _vm._e(), _vm._v(" "), (_vm.adds.endAdd.endLat && _vm.enterprise_id && _vm.ygcx && (_vm.is_fixed_price == 1)) ? _c('button', {
    class: {
      disable: _vm.loadState || _vm.enterpriseDisabled
    },
    attrs: {
      "disabled": _vm.loadState || _vm.enterpriseDisabled
    },
    on: {
      "click": function($event) {
        return _vm.callCarFn('official')
      }
    }
  }, [_vm._v("因公出行(一口价" + _vm._s(_vm.money) + "元)\n      ")]) : _vm._e(), _vm._v(" "), (_vm.adds.endAdd.endLat && _vm.enterprise_id && _vm.ygcx && (_vm.is_fixed_price !== 1)) ? _c('button', {
    class: {
      disable: _vm.loadState || _vm.enterpriseDisabled
    },
    attrs: {
      "disabled": _vm.loadState || _vm.enterpriseDisabled
    },
    on: {
      "click": function($event) {
        return _vm.callCarFn('official')
      }
    }
  }, [_vm._v("因公出行(可抵扣)\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.adds.endAdd.endLat && _vm.enterprise_id && _vm.ygcx && (_vm.is_fixed_price !== 1)) ? _c('button', {
    class: {
      disable: _vm.loadState || _vm.enterpriseDisabled
    },
    attrs: {
      "disabled": _vm.loadState || _vm.enterpriseDisabled
    },
    on: {
      "click": function($event) {
        return _vm.callCarFn('official')
      }
    }
  }, [_vm._v("因公出行(可抵扣)\n      ")]) : _vm._e(), _vm._v(" "), (_vm.is_deduction === 2) ? _c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#999",
      "font-size": "12px"
    }
  }, [_vm._v("\n        您尚未开启企业优惠抵扣权限，请联系管理员")]) : _vm._e()]), _vm._v(" "), (_vm.others.showState) ? _c('xk-input-box', {
    ref: "othersPhone",
    attrs: {
      "title": "乘车人电话"
    },
    on: {
      "click": _vm.othersPhoneFn
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.others.othersPhone),
      expression: "others.othersPhone"
    }],
    staticClass: "othersPhoneInput",
    attrs: {
      "placeholder": "输入乘车人电话"
    },
    domProps: {
      "value": (_vm.others.othersPhone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.others, "othersPhone", $event.target.value)
      }, _vm.othersPhoneCheck]
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.datePickerState) ? _c('xk-date-picker-mod', {
    ref: "DatePicker",
    on: {
      "click": _vm.DatePickerFn
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.unfilledOrderState && _vm.unfilledOrderState.daijia && _vm.unfilledOrderFn.length > 0) ? _c('xk-unfilled-order-mod', {
    attrs: {
      "data": _vm.unfilledOrderFn ? _vm.unfilledOrderFn : null,
      "title": '代驾'
    },
    on: {
      "close": _vm.unfilledOrdercCloseFn
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hintBox.stateShow) ? _c('xk-hint-box', {
    attrs: {
      "state": _vm.hintBox.state,
      "content": _vm.hintBox.content
    }
  }) : _vm._e(), _vm._v(" "), (_vm.feeObj) ? _c('Xk-detailsBox', {
    ref: "detailsBox",
    staticClass: "costBox",
    attrs: {
      "title": '费用详情'
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "List"
  }, [_c('ul', [_c('li', {
    staticClass: "clear"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("总价")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_c('span', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.feeObj.total_fee / 100))]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("元")])])]), _vm._v(" "), (_vm.feeObj.distance_fee) ? _c('li', {
    staticClass: "clear"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("里程费")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_c('span', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.feeObj.distance_fee / 100))]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("元")])])]) : _vm._e(), _vm._v(" "), (_vm.feeObj.time_fee) ? _c('li', {
    staticClass: "clear"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("时间费")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_c('span', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.feeObj.time_fee / 100))]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("元")])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "clear"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("起步价")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_c('span', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.feeObj.start_price / 100))]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("元")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "introduce",
    staticStyle: {
      "max-height": "40vh",
      "overflow-y": "auto"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.budgetFeeRemark)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('xk-my-picker', {
    attrs: {
      "showMyPicker": _vm.visible,
      "pickItem": _vm.slots,
      "title": "选择司机人数"
    },
    on: {
      "sureAction": _vm.sureSelectCar,
      "cancelAction": _vm.cancleSelectCar
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circuitMod",
    on: {
      "click": _vm.clickFn
    }
  }, [_c('div', {
    staticClass: "circuitModcontent"
  }, [_c('div', {
    staticClass: "city"
  }, [_c('span', {
    staticClass: "startCity cityItem"
  }, [_c('h3', [_vm._v(_vm._s(_vm.circuitData.startCity.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.circuitData.startCity.add))])]), _vm._v(" "), _c('span', {
    staticClass: "endCity cityItem"
  }, [_c('h3', [_vm._v(_vm._s(_vm.circuitData.endCity.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.circuitData.endCity.add))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "charges"
  }, [_c('span', {
    staticClass: "chargesItem"
  }, [_c('h2', [_vm._v(_vm._s(_vm.circuitData.carpool.name))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.circuitData.carpool.sum))]), _vm._v("元/人")])]), _vm._v(" "), _c('span', {
    staticClass: "chargesItem"
  }, [_c('h2', [_vm._v(_vm._s(_vm.circuitData.chartered.name))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.circuitData.chartered.sum))]), _vm._v("元/辆")])]), _vm._v(" "), _c('span', {
    staticClass: "chargesItem"
  }, [_c('h2', [_vm._v(_vm._s(_vm.circuitData.sendGoods.name))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.circuitData.sendGoods.sum))]), _vm._v("元/件")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "inverse"
  }, [_c('i', {
    staticClass: "iconfont icon-zhuanhuan1"
  })])
}]}

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "XK-input"
  }, [(_vm.type == 'number') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    attrs: {
      "type": "number",
      "placeholder": _vm.placeholder,
      "autofocus": "autofocus"
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "blur": _vm.blurFn,
      "change": _vm.changeFn,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }, _vm.inputFn]
    }
  }) : (_vm.type == 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    attrs: {
      "type": "number",
      "placeholder": _vm.placeholder,
      "autofocus": "autofocus"
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "blur": _vm.blurFn,
      "change": _vm.changeFn,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }, _vm.inputFn]
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    attrs: {
      "type": "number",
      "placeholder": _vm.placeholder,
      "autofocus": "autofocus"
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "blur": _vm.blurFn,
      "change": _vm.changeFn,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }, _vm.inputFn]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "closeButDiv",
    on: {
      "click": _vm.closeFn
    }
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "closeBut"
  }, [_c('i', {
    staticClass: "iconfont icon-iconfontclosesmall"
  })])
}]}

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recordOrderMod",
    on: {
      "click": _vm.actionFn
    }
  }, [_c('div', {
    staticClass: "ListItem"
  }, [_c('div', {
    staticClass: "itemContent"
  }, [_c('div', {
    staticClass: "item-row"
  }, [_c('div', {
    staticClass: "itemTime"
  }, [_vm._v("酒后代驾")]), _vm._v(" "), _c('div', {
    staticClass: "itemStatus"
  }, [(_vm.status.status !== 40) ? _c('i', {
    staticClass: "iconfont icon-jiantou"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "text",
    class: _vm.status.name === '新单' ? 'textRed' : _vm.status.name === 5 || _vm.status.name === 6 ? 'textAsh' : ''
  }, [_vm._v("\n                " + _vm._s(_vm.status.name) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "item-time"
  }, [_c('i', {
    staticClass: "iconfont icon-shijian1"
  }), _vm._v(" "), _c('span', {
    staticClass: "site"
  }, [_vm._v(_vm._s(_vm.serverTime))])]), _vm._v(" "), _c('div', {
    staticClass: "item-address"
  }, [_c('i', {
    staticClass: "yuan"
  }), _vm._v(" "), _c('span', {
    staticClass: "site"
  }, [_vm._v(_vm._s(_vm.startAddress))])]), _vm._v(" "), _c('div', {
    staticClass: "item-address"
  }, [_c('i', {
    staticClass: "yuan color-red"
  }), _vm._v(" "), _c('span', {
    staticClass: "site"
  }, [_vm._v(_vm._s(_vm.endAddress))])])])])])
},staticRenderFns: []}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "informTimeMod"
  }, [_c('div', {
    staticClass: "dialogueModContent"
  }, [_c('div', {
    staticClass: "contentTime"
  }, [_c('span', {
    staticClass: "time"
  }, [_vm._v("\n        " + _vm._s(_vm.timeFn) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "ContentMid clear"
  }, [_c('div', {
    staticClass: "midLeft"
  }, [_c('span', {
    staticClass: "leftImg"
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "alt": "LOGO"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "midRight"
  }, [_c('span', {
    staticClass: "rightArrows"
  }), _vm._v(" "), _c('div', {
    staticClass: "rightContent"
  }, [_vm._v("\n          " + _vm._s(_vm.content) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showModle) ? _c('div', {
    staticClass: "slideVerify"
  }, [_c('div', {
    staticClass: "popup-modal",
    on: {
      "click": _vm.outModel
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "20px",
      "top": "20px"
    },
    on: {
      "click": _vm.outModel
    }
  }, [_c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px"
    },
    attrs: {
      "src": __webpack_require__(119)
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "12px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-content-title",
    staticStyle: {
      "color": "#666666"
    }
  }, [_vm._v("安全验证")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#333333",
      "font-size": "18px",
      "font-weight": "bold"
    }
  }, [_vm._v("拖动下方滑动完成拼图")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "12px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sliderImg"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.url + '/' + _vm.imgObj.background,
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "sliderImgBtn",
    style: ({
      'top': ((1 - _vm.imgObj.height) * 100) + '%',
      'left': _vm.progressValue + 'px'
    }),
    attrs: {
      "src": _vm.url + '/' + _vm.imgObj.bloke,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "12px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "movable-area"
  }, [_c('div', {
    staticClass: "movable-view",
    style: ({
      'left': _vm.progressValue + 'px'
    }),
    on: {
      "mousedown": _vm.sliderDown,
      "touchstart": _vm.touchStartEvent,
      "touchmove": _vm.handleMoveEvent,
      "touchend": _vm.handleMoveEndEvent
    }
  }, [(_vm.loading) ? _c('img', {
    attrs: {
      "src": __webpack_require__(447),
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(445),
      "alt": ""
    }
  })])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "textarea"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.values),
      expression: "values"
    }],
    attrs: {
      "placeholder": _vm.defaulttext,
      "maxlength": "60"
    },
    domProps: {
      "value": (_vm.values)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.values = $event.target.value
      }, _vm.inputFn]
    }
  }, [_vm._v(_vm._s(_vm.values))])])
},staticRenderFns: []}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upImgDom"
  }, [_c('div', {
    staticClass: "showImgList"
  }, _vm._l((_vm.imgs), function(item, index) {
    return _c('div', {
      staticClass: "showImgItem frame",
      on: {
        "click": function($event) {
          return _vm.showImgFn(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.weixinUrl + item
      }
    })])
  }), 0), _vm._v(" "), (_vm.imgs.length < _vm.maxNum) ? _c('div', {
    staticClass: "AddImg frame",
    on: {
      "click": _vm.AddFn
    }
  }, [_c('b', {}, [_vm._v("+")])]) : _vm._e(), _vm._v(" "), (_vm.mobileState.iPhone) ? _c('input', {
    ref: "inFile",
    attrs: {
      "type": "file",
      "name": "photo",
      "accept": "image/*"
    },
    on: {
      "change": _vm.fileFn1
    }
  }) : (_vm.mobileState.Android) ? _c('input', {
    ref: "inFile",
    attrs: {
      "type": "file",
      "name": "photo",
      "accept": "image/*"
    },
    on: {
      "change": _vm.fileFn1
    }
  }) : _c('input', {
    ref: "inFile",
    attrs: {
      "type": "file",
      "name": "photo",
      "accept": "image/*"
    },
    on: {
      "change": _vm.fileFn1
    }
  }), _vm._v(" "), (_vm.showMaxImgState) ? _c('div', {
    staticClass: "showMaxImg",
    class: _vm.showMaxImgState ? 'showMaxImgAction' : '',
    on: {
      "click": _vm.showMaxImgFn
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.weixinUrl + _vm.showImgUrl
    }
  }), _vm._v(" "), (_vm.showMaxImgState) ? _c('div', {
    staticClass: "modal"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('xk-upload-mod', {
    attrs: {
      "state": _vm.loadState
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Service"
  }, [_c('div', {
    staticClass: "Content"
  }, [_c('div', {
    staticClass: "describe"
  }, [_c('div', {
    staticClass: "describeContent"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.titleCont))])]), _vm._v(" "), (_vm.cancelState) ? _c('h4', {
    staticClass: "cancelBut",
    on: {
      "click": _vm.cancelOrderFn
    }
  }, [_vm._v("取消订单")]) : _vm._e()]), _vm._v(" "), _c('xk-waiter', {
    attrs: {
      "src": '../../../../assets/img/yonghu/touxiang.jpg',
      "name": _vm.DjOrderInfo ? _vm.DjOrderInfo.employ_name : '',
      "location": _vm.DjOrderInfo ? _vm.DjOrderInfo.book_address : '',
      "phone": _vm.DjOrderInfo ? _vm.DjOrderInfo.employ_phone : '',
      "headImg": _vm.DjOrderInfo ? _vm.DjOrderInfo.employ_head_path : ''
    }
  }), _vm._v(" "), _c('xk-Add', {
    attrs: {
      "time": _vm.DjOrderInfo ? _vm.DjOrderInfo.book_time : '',
      "origin": _vm.DjOrderInfo ? _vm.DjOrderInfo.book_address : '',
      "endPoint": _vm.DjOrderInfo ? _vm.DjOrderInfo.destination : ''
    }
  })], 1), _vm._v(" "), (_vm.reson.state) ? _c('xk-input-box', {
    attrs: {
      "title": "取消订单理由",
      "closeState": true
    },
    on: {
      "click": _vm.cancelOrderFn
    }
  }, [_c('div', {
    staticClass: "DjCancelOrder",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reson.val),
      expression: "reson.val"
    }],
    attrs: {
      "maxlength": "50",
      "placeholder": "请输入取消订单理由"
    },
    domProps: {
      "value": (_vm.reson.val)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reson, "val", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hintBox.stateShow) ? _c('xk-hint-box', {
    attrs: {
      "state": _vm.hintBox.state,
      "content": _vm.hintBox.content
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(!_vm.loadState) ? _c('xk-home-but') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "MidContent"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "XKTabs clear"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    ref: "XKTabsContent",
    staticClass: "XKTabsContent"
  }, [_c('ul', {
    staticClass: "clear",
    style: ({
      width: _vm.ulWidth
    })
  }, _vm._l((_vm.servesTypeNav), function(itme, index) {
    return _c('li', {
      ref: "lis",
      refInFor: true,
      class: itme.url == _vm.fullPath ? 'tabAction' : '',
      style: ({
        width: _vm.liWidth
      }),
      on: {
        "click": function($event) {
          return _vm.clickFn(index)
        }
      }
    }, [_c('span', {
      staticClass: "tab"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: itme.url
        }
      }
    }, [_vm._v(_vm._s(itme ? itme.name : ''))])], 1)])
  }), 0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "gengduo",
    class: _vm.AllState ? 'gengduoShow' : '',
    on: {
      "click": _vm.allBusinessButFn
    }
  }, [_c('i', {
    staticClass: "iconfont icon-yingyong",
    style: (_vm.ulScroll)
  })]), _vm._v(" "), _c('div', {
    staticClass: "allBusiness",
    class: _vm.AllState ? 'allBusinessShow' : ''
  }, [_c('h2', [_vm._v("全部服务")]), _vm._v(" "), _c('div', {
    staticClass: "Content"
  }, _vm._l((_vm.servesTypeNav), function(itme, index) {
    return _c('span', {
      staticClass: "row",
      on: {
        "click": function($event) {
          return _vm.allBusinessButFn(true, index)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: itme.url
        }
      }
    }, [_vm._v(_vm._s(itme ? itme.name : ''))])], 1)
  }), 0)]), _vm._v(" "), (_vm.AllState) ? _c('div', {
    staticClass: "modal",
    on: {
      "click": _vm.allBusinessButFn
    }
  }) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shade shadeLeft"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(118)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shade shadeRight"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(118)
    }
  })])
}]}

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "used"
  }, [_c('div', {
    staticClass: "usedContent"
  }, [(_vm.couponsFn && _vm.couponsFn.length) ? _c('div', _vm._l((_vm.couponsFn), function(item, index) {
    return _c('xk-couponMod', {
      key: index,
      attrs: {
        "type": item.type,
        "sum": item.sum,
        "title": item.title,
        "startTime": item.startTime,
        "endTime": item.endTime,
        "overdueTime": item.overdueTime,
        "status": 1,
        "useState": 2,
        "couponType": item.couponType,
        "serviceType": item.serviceType
      }
    })
  }), 1) : _c('div', {
    staticClass: "jilv"
  }, [_c('h2', [_vm._v("暂无使用记录")])])])])
},staticRenderFns: []}

/***/ }),
/* 568 */,
/* 569 */,
/* 570 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[280]);


// WEBPACK FOOTER //
// static/js/app.d93fa86ea16952b2f6fe.js